import { Hymn } from './hymn';

export const hymnsDetailed: Hymn[] = [
  {
    "hymnNumber": 1,
    "reference": "SDAH001",
    "title": "Praise to the Lord",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>Praise <1:2>to <1:3>the <1:4>Lord, <1:5>the <1:6>Al<1:7>might<1:8>y, <1:9>the <1:10>King <1:11>of <1:12>cre<1:13>a<1:14>tion!",
          "<1:15>O <1:16>my <1:17>soul, <1:18>praise <1:19>Him, <1:20>for <1:21>He <1:22>is <1:23>thy <1:24>health <1:25>and <1:26>sal<1:27>va<1:28>tion!",
          "<1:29>All <1:30>ye <1:31>who <1:32>hear,",
          "<1:33>Now <1:34>to <1:35>His <1:36>tem<1:37>ple <1:38>draw <1:39>near;",
          "<1:40>Join <1:41>ye <1:42>in <1:43>glad <1:44>ad<1:45>o<1:46>ra<1:47>tion!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>Praise <1:2>to <1:3>the <1:4>Lord, <1:5>who <1:6>o'er <1:7>all <1:8>things <1:9>so <1:10>won<1:11>drous<1:12>ly <1:13>reign<1:14>eth,",
          "<1:15>Shield<1:16>eth <1:17>thee <1:18>un<1:19>der <1:20>His <1:21>wings, <1:22>yea, <1:23>so <1:24>gent<1:25>ly <1:26>sus<1:27>tain<1:28>eth!",
          "<1:29>Hast <1:30>thou <1:31>not <1:32>seen",
          "<1:33>How <1:34>thy <1:35>de<1:36>sires <1:37>e'er <1:38>have <1:39>been",
          "<1:40>Grant<1:41>ed <1:42>in <1:43>what <1:44>He <1:45>or<1:46>dain<1:47>eth?"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>Praise <1:2>to <1:3>the <1:4>Lord, <1:5>who <1:6>doth <1:7>pros<1:8>per <1:9>thy <1:10>work <1:11>and <1:12>de<1:13>fend <1:14>thee;",
          "<1:15>Sure<1:16>ly <1:17>His <1:18>good<1:19>ness <1:20>and <1:21>mer<1:22>cy <1:23>here <1:24>dai<1:25>ly <1:26>at<1:27>tend <1:28>thee.",
          "<1:29>Pon<1:30>der <1:31>a<1:32>new",
          "<1:33>What <1:34>the <1:35>Al<1:36>might<1:37>y <1:38>can <1:39>do",
          "<1:40>If <1:41>with <1:42>His <1:43>love <1:44>He <1:45>be<1:46>friend <1:47>thee."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 2,
    "reference": "SDAH002",
    "title": "All Creatures of Our God and King",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>All <1:2>crea<1:3>tures <1:4>of <1:5>our <1:6>God <1:7>and <1:8,9>King,",
          "<1:10>Lift <1:11>up <1:12>your <1:13>voice <1:14>with <1:15>us <1:16>and <1:17,18>sing:",
          "<1:19>Al<1:20>le<1:21,22>lu<1:23>ia! <1:24>Al<1:25>le<1:26,27>lu<1:28>ia!",
          "<1:29,30>O <1:31>burn<1:32>ing <1:33>sun <1:34>with <1:35>gold<1:36>en <1:37,38>beam",
          "<1:39,40>And <1:41>sil<1:42>ver <1:43>moon <1:44>with <1:45>soft<1:46>er <1:47,48>gleam:"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>O <1:2>rush<1:3>ing <1:4>wind <1:5>and <1:6>breez<1:7>es <1:8,9>soft,",
          "<1:10>O <1:11>clouds <1:12>that <1:13>ride <1:14>the <1:15>winds <1:16>a<1:17,18>loft:",
          "<1:19,20>Oh, <1:21,22>praise <1:23>Him! <1:24>Al<1:25>le<1:26,27>lu<1:28>ia!",
          "<1:29,30>O <1:31>ris<1:32>ing <1:33>morn, <1:34>in <1:35>praise <1:36>re<1:37,38>joice,",
          "<1:39,40>O <1:41>lights <1:42>of <1:43>eve<1:44>ning, <1:45>find <1:46>a <1:47,48>voice."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>O <1:2>flow<1:3>ing <1:4>wa<1:5>ters, <1:6>pure <1:7>and <1:8,9>clear,",
          "<1:10>Make <1:11>mu<1:12>sic <1:13>for <1:14>your <1:15>Lord <1:16>to <1:17,18>hear.",
          "<1:19,20>Oh, <1:21,22>praise <1:23>Him! <1:24>Al<1:25>le<1:26,27>lu<1:28>ia!",
          "<1:29,30>O <1:31>fire <1:32>so <1:33>mas<1:34>ter<1:35>ful <1:36>and <1:37,38>bright,",
          "<1:39,40>Pro<1:41>vid<1:42>ing <1:43>us <1:44>with <1:45>warmth <1:46>and <1:47,48>light,"
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "<1:1>Let <1:2>all <1:3>things <1:4>their <1:5>Cre<1:6>a<1:7>tor <1:8,9>bless,",
          "<1:10>And <1:11>wor<1:12>ship <1:13>Him <1:14>in <1:15>hum<1:16>ble<1:17,18>ness,",
          "<1:19,20>Oh, <1:21,22>praise <1:23>Him! <1:24>Al<1:25>le<1:26,27>lu<1:28>ia!",
          "<1:29,30>Oh, <1:31>praise <1:32>the <1:33>Fa<1:34>ther, <1:35>praise <1:36>the <1:37,38>Son,",
          "<1:39,40>And <1:41>praise <1:42>the <1:43>Spir<1:44>it, <1:45>three <1:46>in <1:47,48>One!"
        ]
      }
    ],
    "chorus": [
      "<1:1,2>Oh, <1:3,4>praise <1:5>Him!",
      "<1:6,7>Oh, <1:8,9>praise <1:10>Him!",
      "<1:11>Al<1:12>le<1:13,14>lu<1:15>ia, <1:16>al<1:17>le<1:18,19>lu<1:20,21>ia, <1:22>al<1:23>le<1:24,25>lu<1:26>ia!"
    ],
    "chorusMarker": {
      "track": 1,
      "index": 51
    }
  },
  {
    "hymnNumber": 3,
    "reference": "SDAH003",
    "title": "God Himself Is With Us",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>God <1:2>Him<1:3>self <1:4>is <1:5,6>with <1:7>us;",
          "<1:8>Let <1:9>us <1:10>all <1:11>a<1:12,13>dore <1:14>Him,",
          "<1:15>And <1:16>with <1:17>awe <1:18>ap<1:19>pear <1:20>be<1:21,22>fore <1:23>Him.",
          "<1:24>God <1:25>is <1:26>here <1:27>with<1:28,29>in <1:30>us;",
          "<1:31>Soul, <1:32>in <1:33>si<1:34>lence <1:35,36>fear <1:37>Him,",
          "<1:38>Hum<1:39>bly, <1:40>fer<1:41>vent<1:42>ly <1:43>draw <1:44,45>near <1:46>Him.",
          "<1:47>Now <1:48>His <1:49>own <1:50>who <1:51>have <1:52>known",
          "<1:53>God, <1:54>in <1:55>wor<1:56>ship <1:57,58>low<1:59>ly,",
          "<1:60>Yield <1:61>their <1:62>spir<1:63>its <1:64,65>who<1:66>lly."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>Come, <1:2>a<1:3>bide <1:4>with<1:5,6>in <1:7>me;",
          "<1:8>Let <1:9>my <1:10>soul, <1:11>like <1:12,13>Ma<1:14>ry,",
          "<1:15>Be <1:16>Thine <1:17>earth<1:18>ly <1:19>sanc<1:20>tu<1:21,22>a<1:23>ry.",
          "<1:24>Come, <1:25>in<1:26>dwell<1:27>ing <1:28,29>Spir<1:30>it,",
          "<1:31>With <1:32>trans<1:33>fig<1:34>ured <1:35,36>splen<1:37>dor;",
          "<1:38>Love <1:39>and <1:40>hon<1:41>or <1:42>will <1:43>I <1:44,45>ren<1:46>der.",
          "<1:47>Where <1:48>I <1:49>go <1:50>here <1:51>be<1:52>low,",
          "<1:53>Let <1:54>me <1:55>bow <1:56>be<1:57,58>fore <1:59>Thee,",
          "<1:60>Know <1:61>Thee <1:62>and <1:63>a<1:64,65>dore <1:66>Thee."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>Glad<1:2>ly <1:3>we <1:4>sur<1:5,6>ren<1:7>der",
          "<1:8>Earth's <1:9>de<1:10>ceit<1:11>ful <1:12,13>trea<1:14>sures,",
          "<1:15>Pride <1:16>of <1:17>life, <1:18>and <1:19>sin<1:20>ful <1:21,22>plea<1:23>sures:",
          "<1:24>Glad<1:25>ly, <1:26>Lord, <1:27>we <1:28,29>of<1:30>fer",
          "<1:31>Thine <1:32>to <1:33>be <1:34>for<1:35,36>ev<1:37>er,",
          "<1:38>Soul <1:39>and <1:40>life <1:41>and <1:42>each <1:43>en<1:44,45>deav<1:46>or.",
          "<1:47>Thou <1:48>a<1:49>lone <1:50>shalt <1:51>be <1:52>known",
          "<1:53>Lord <1:54>of <1:55>all <1:56>our <1:57,58>be<1:59>ing,",
          "<1:60>Life's <1:61>true <1:62>way <1:63>de<1:64,65>cree<1:66>ing."
        ]
      }
    ]
  },
  {
    "hymnNumber": 4,
    "reference": "SDAH004",
    "title": "Praise My Soul the King of Heaven",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>Praise, <1:2>my <1:3>soul, <1:4>the <1:5>King <1:6>of <1:7>heav<1:8>en;",
          "<1:9>To <1:10>His <1:11>feet <1:12>thy <1:13>trib<1:14>ute <1:15>bring;",
          "<1:16>Ran<1:17>somed, <1:18>healed, <1:19>re<1:20>stored, <1:21>for<1:22>giv<1:23>en,",
          "<1:24>Who <1:25>like <1:26>thee <1:27>His <1:28>praise <1:29>should <1:30>sing?"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>Praise <1:2>Him <1:3>for <1:4>His <1:5>grace <1:6>and <1:7>fa<1:8>vor",
          "<1:9>To <1:10>our <1:11>fa<1:12>thers <1:13>in <1:14>dis<1:15>tress.",
          "<1:16>Praise <1:17>Him, <1:18>still <1:19>the <1:20>same <1:21>for <1:22>ev<1:23>er,",
          "<1:24>Slow <1:25>to <1:26>chide <1:27>and <1:28>swift <1:29>to <1:30>bless;"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>Ten<1:2>der<1:3>ly <1:4>He <1:5>shields <1:6>and <1:7>spares <1:8>us;",
          "<1:9>Well <1:10>our <1:11>fee<1:12>ble <1:13>frame <1:14>He <1:15>knows.",
          "<1:16>In <1:17>His <1:18>hands <1:19>He <1:20>gen<1:21>tly <1:22>bears <1:23>us,",
          "<1:24>Res<1:25>cues <1:26>us <1:27>from <1:28>all <1:29>our <1:30>foes."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "<1:1>An<1:2>gels, <1:3>help <1:4>us <1:5>to <1:6>a<1:7>dore <1:8>Him:",
          "<1:9>Ye <1:10>be<1:11>hold <1:12>Him <1:13>face <1:14>to <1:15>face;",
          "<1:16>Sun <1:17>and <1:18>moon, <1:19>bow <1:20>down <1:21>be<1:22>fore <1:23>Him:",
          "<1:24>Dwell<1:25>ers <1:26>all <1:27>in <1:28>time <1:29>and <1:30>space."
        ]
      }
    ],
    "chorusMarker": {
      "track": 1,
      "index": 31
    },
    "chorus": [
      "<1:1>Praise <1:2>Him, <1:3>praise <1:4>Him, <1:5>Al<1:6>le<1:7>lu<1:8>ia,",
      "<1:9>Praise <1:10>the <1:11>ev<1:12>er<1:13>last<1:14>ing <1:15>King."
    ]
  },
  {
    "hymnNumber": 5,
    "reference": "SDAH005",
    "title": "All My Hope On God Is Founded",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>All <1:2>my <1:3>hope <1:4>on <1:5,6>God <1:7,8>is <1:9,10>found<1:11>ed;",
          "<1:12>He <1:13>doth <1:14>still <1:15>my <1:16,17>trust <1:18>re<1:19>new,",
          "<1:20>Me <1:21>through <1:22,23>change <1:24>and <1:25>chance <1:26>He <1:27>guid<1:28>eth,",
          "<1:29>On<1:30>ly <1:31,32>good <1:33>and <1:34>on<1:35>ly <1:36>true.",
          "<1:37>God <1:38>un<1:39>unknown, <1:40>He <1:41,42>a<1:43>lone",
          "<1:44>Calls <1:45>my <1:46,47,48,49>heart <1:50>to <1:51>be <1:52,53>His <1:54>own."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>Pride <1:2>of <1:3>man <1:4>and <1:5,6>earth<1:7,8>ly <1:9,10>glo<1:11>ry,",
          "<1:12>Sword <1:13>and <1:14>crown <1:15>be<1:16,17>tray <1:18>His <1:19>trust;",
          "<1:20>What <1:21>with <1:22,23>care <1:24>and <1:25>toil <1:26>he <1:27>build<1:28>eth,",
          "<1:29>Tower <1:30>and <1:31,32>tem<1:33>ple <1:34>fall <1:35>to <1:36>dust.",
          "<1:37>But <1:38>God's <1:39>power <1:40>hour <1:41,42>by <1:43>hour,",
          "<1:44>Is <1:45>my <1:46,47,48,49>tem<1:50>ple <1:51>and <1:52,53>my <1:54>tower"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>God's <1:2>great <1:3>good<1:4>ness <1:5,6>aye <1:7,8>en<1:9,10>dur<1:11>eth,",
          "<1:12>Deep <1:13>His <1:14>wis<1:15>dom, <1:16,17>pass<1:18>ing <1:19>thought:",
          "<1:20>Splen<1:21>dor, <1:22,23>light, <1:24>and <1:25>life <1:26>at<1:27>tend <1:28>Him,",
          "<1:29>Beau<1:30>ty <1:31,32>spring<1:33>eth <1:34>out <1:35>of <1:36>naught.",
          "<1:37>Love <1:38>doth <1:39>stand <1:40>at <1:41,42>His <1:43>hand;",
          "<1:44>Joy <1:45>doth <1:46,47,48,49>wait <1:50>on <1:51>His <1:52,53>com<1:54>mand."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "<1:1>Still <1:2>from <1:3>man <1:4>to <1:5,6>God <1:7,8>e<1:9,10>ter<1:11>nal",
          "<1:12>Sac<1:13>ri<1:14>fice <1:15>of <1:16,17>praise <1:18>be <1:19>done,",
          "<1:20>High <1:21>a<1:22,23>bove <1:24>all <1:25>prais<1:26>es <1:27>prais<1:28>ing",
          "<1:29>For <1:30>the <1:31,32>gift <1:33>of <1:34>Christ <1:35>His <1:36>Son.",
          "<1:37>Christ <1:38>doth <1:39>call <1:40>one <1:41,42>and <1:43>all:",
          "<1:44>Ye <1:45>who <1:46,47,48,49>fol<1:50>low <1:51>shall <1:52,53>not <1:54>fall."
        ]
      }
    ]
  },
  {
    "hymnNumber": 6,
    "reference": "SDAH006",
    "title": "O Worship the Lord",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>O <1:2>wor<1:3>ship <1:4>the <1:5>Lord <1:6>in <1:7>the <1:8>beau<1:9>ty <1:10>of <1:11>ho<1:12>li<1:13>ness,",
          "<1:14>Bow <1:15>down <1:16>be<1:17>fore <1:18>Him, <1:19>His <1:20>glo<1:21>ry <1:22>pro<1:23>claim;",
          "<1:24>With <1:25>gold <1:26>of <1:27>o<1:28>be<1:29,30>dience, <1:31>and <1:32>in<1:33>cense <1:34>of <1:35>low<1:36>li<1:37>ness,",
          "<1:38>Kneel <1:39>and <1:40>a<1:41>dore <1:42>Him; <1:43>the <1:44>Lord <1:45>is <1:46>His <1:47>name."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:2>Low <1:3>at <1:4>His <1:5>feet <1:6>lay <1:7>thy <1:8>bur<1:9>den <1:10>of <1:11>care<1:12>ful<1:13>ness;",
          "<1:14>High <1:15>on <1:16>His <1:17>heart <1:18>He <1:19>will <1:20>bear <1:21>it <1:22>for <1:23>thee,",
          "<1:25>Com<1:26>fort <1:27>thy <1:28>sor<1:29,30>rows <1:31>and <1:32>an<1:33>swer <1:34>thy <1:35>prayer<1:36>ful<1:37>ness,",
          "<1:38>Guid<1:39>ing <1:40>thy <1:41>steps <1:42>as <1:43>may <1:44>best <1:45>for <1:46>thee <1:47>be."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:2>Fear <1:3>not <1:4>to <1:5>en<1:6>ter <1:7>His <1:8>courts <1:9>in <1:10>the <1:11>slen<1:12>der<1:13>ness",
          "<1:14>Of <1:15>the <1:16>poor <1:17>wealth <1:18>thou <1:19>wouldst <1:20>reck<1:21>on <1:22>as <1:23>thine.",
          "<1:25>Truth <1:26>in <1:27>its <1:28>beau<1:29,30>ty <1:31>and <1:32>love <1:33>in <1:34>its <1:35>ten<1:36>der<1:37>ness,",
          "<1:38>These <1:39>are <1:40>the <1:41>of<1:42>ferings <1:43>to <1:44>lay <1:45>on <1:46>His <1:47>shrine."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "<1:2>These, <1:3>though <1:4>we <1:5>bring <1:6>them <1:7>in <1:8>trem<1:9>bling <1:10>and <1:11>fear<1:12>ful<1:13>ness,",
          "<1:14>He <1:15>will <1:16>ac<1:17>cept <1:18>for <1:19>the <1:20>name <1:21>that <1:22>is <1:23>dear;",
          "<1:25>Morn<1:26>ings <1:27>of <1:28>joy <1:29,30>give <1:31>for <1:32>eve<1:33>nings <1:34>of <1:35>tear<1:36>ful<1:37>ness,",
          "<1:38>Trust <1:39>for <1:40>our <1:41>trem<1:42>bling, <1:43>and <1:44>hope <1:45>for <1:46>our <1:47>fear."
        ]
      }
    ]
  },
  {
    "hymnNumber": 7,
    "reference": "SDAH007",
    "title": "The Lord in Zion Reigneth",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>The <1:2>Lord <1:3>in <1:4>Zi<1:5>on <1:6>reign<1:7>eth,",
          "<1:8>let <1:9>all <1:10>the <1:11>world <1:12>re<1:13>joice,",
          "<1:14>And <1:15>come <1:16>be<1:17>fore <1:18>His <1:19>throne <1:20>of <1:21>grace",
          "<1:22>with <1:23>tune<1:24>ful <1:25>heart <1:26>and <1:27>voice;",
          "<1:28>The <1:29>Lord <1:30>in <1:31>Zi<1:32>on <1:33,34>reign<1:35>eth,",
          "<1:36>and <1:37>there <1:38>His <1:39>praise <1:40>shall <1:41,42,43>ring,",
          "<1:44>To <1:45>Him <1:46>shall <1:47>princ<1:48>es <1:49>bend <1:50>the <1:51>knee",
          "<1:52>and <1:53>kings <1:54>their <1:55,56>glo<1:57>ry <1:58>bring."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>The <1:2>Lord <1:3>in <1:4>Zi<1:5>on <1:6>reign<1:7>eth,",
          "<1:8>and <1:9>who <1:10>so <1:11>great <1:12>as <1:13>He?",
          "<1:14>The <1:15>depths <1:16>of <1:17>earth <1:18>are <1:19>in <1:20>His <1:21>hands;",
          "<1:22>He <1:23>rules <1:24>the <1:25>might<1:26>y <1:27>sea.",
          "<1:28>O <1:29>crown <1:30>His <1:31>Name <1:32>with <1:33,34>hon<1:35>or,",
          "<1:36>and <1:37>let <1:38>His <1:39>stand<1:40>ard <1:41,42,43>wave,",
          "<1:44>Till <1:45>dis<1:46>tant <1:47>isles <1:48>be<1:49>yond <1:50>the <1:51>deep",
          "<1:52>shall <1:53>own <1:54>His <1:55,56>power <1:57>to <1:58>save."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>The <1:2>Lord <1:3>in <1:4>Zi<1:5>on <1:6>reign<1:7>eth,",
          "<1:8>these <1:9>hours <1:10>to <1:11>Him <1:12>be<1:13>long;",
          "<1:14>O <1:15>en<1:16>ter <1:17>now <1:18>His <1:19>tem<1:20>ple <1:21>gates,",
          "<1:22>and <1:23>fill <1:24>His <1:25>courts <1:26>with <1:27>song;",
          "<1:28>Be<1:29>neath <1:30>His <1:31>roy<1:32>al <1:33,34>ban<1:35>ner",
          "<1:36>let <1:37>ev<1:38>ery <1:39>crea<1:40>ture <1:41,42,43>fall,",
          "<1:44>Ex<1:45>alt <1:46>the <1:47>King <1:48>of <1:49>heaven <1:50>and <1:51>earth,",
          "<1:52>And <1:53>crown <1:54>Him <1:55,56>Lord <1:57>of <1:58>all."
        ]
      }
    ]
  },
  {
    "hymnNumber": 8,
    "reference": "SDAH008",
    "title": "We Gather Together",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>We <1:2>gath<1:3>er <1:4>to<1:5>geth<1:6>er <1:7>to <1:8>ask <1:9>the <1:10>Lord’s <1:11>bless<1:12>ing;",
          "<1:13>He <1:14>chas<1:15>tens <1:16>and <1:17,18>has<1:19>tens <1:20>His <1:21>will <1:22>to <1:23>make <1:24>known;",
          "<1:25>The <1:26>wick<1:27>ed <1:28>op<1:29>press<1:30>ing <1:31>now <1:32,33>cease <1:34>from <1:35>dis<1:36>tress<1:37>ing;",
          "<1:38>Sing <1:39>prais<1:40>es <1:41>to <1:42>His <1:43>Name; <1:44>He <1:45>for<1:46>gets <1:47>not <1:48>His <1:49>own."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>Be<1:2>side <1:3>us <1:4>to <1:5>guide <1:6>us, <1:7>our <1:8>God <1:9>with <1:10>us <1:11>join<1:12>ing,",
          "<1:13>Or<1:14>dain<1:15>ing, <1:16>main<1:17,18>tain<1:19>ing <1:20>His <1:21>king<1:22>dom <1:23>di<1:24>vine;",
          "<1:25>So <1:26>from <1:27>the <1:28>be<1:29>gin<1:30>ning <1:31>the <1:32,33>fight <1:34>we <1:35>were <1:36>win<1:37>ning;",
          "<1:38>Thou, <1:39>Lord, <1:40>were <1:41>at <1:42>our <1:43>side; <1:44,45>all <1:46>glo<1:47>ry <1:48>be <1:49>Thine!"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>We <1:2>all <1:3>do <1:4>ex<1:5>tol <1:6>Thee, <1:7>Thou <1:8>Lead<1:9>er <1:10>tri<1:11>um<1:12>phant,",
          "<1:13>And <1:14>pray <1:15>that <1:16>Thou <1:17,18>still <1:19>our <1:20>De<1:21>fend<1:22>er <1:23>will <1:24>be;",
          "<1:25>Let <1:26>Thy <1:27>con<1:28>gre<1:29>ga<1:30>tion <1:31>es<1:32,33>cape <1:34>trib<1:35>u<1:36>la<1:37>tion;",
          "<1:38>Thy <1:39>Name <1:40>be <1:41>ev<1:42>er <1:43>praised! <1:44,45>O <1:46>Lord, <1:47>make <1:48>us <1:49>free!"
        ]
      }
    ]
  },
  {
    "hymnNumber": 9,
    "reference": "SDAH009",
    "title": "Let All the World in Every Corner Sing",
    "hasMidi": true,
    "numberOfVerses": 2,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>Let <1:2>all <1:3>the <1:4>world <1:5>in <1:6>ev<1:7>ery <1:8>cor<1:9>ner <1:10>sing,",
          "<1:11>My <1:12>God <1:13>and <1:14>King!",
          "<1:15>The <1:16>heavens <1:17>are <1:18>not <1:19>too <1:20>high,",
          "<1:21>His <1:22>praise <1:23>may <1:24>thith<1:25>er <1:26>fly;",
          "<1:27>The <1:28>earth <1:29>is <1:30>not <1:31>too <1:32>low,",
          "<1:33>His <1:34>prais<1:35>es <1:36>there <1:37>may <1:38>grow.",
          "<1:39>Let <1:40>all <1:41>the <1:42>world <1:43>in <1:44>ev<1:45>ery <1:46>cor<1:47>ner <1:48>sing,",
          "<1:49>My <1:50>God <1:51>and <1:52>King!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>Let <1:2>all <1:3>the <1:4>world <1:5>in <1:6>ev<1:7>ery <1:8>cor<1:9>ner <1:10>sing,",
          "<1:11>My <1:12>God <1:13>and <1:14>King!",
          "<1:15>The <1:16>church <1:17>with <1:18>psalms <1:19>must <1:20>shout,",
          "<1:21>No <1:22>door <1:23>can <1:24>keep <1:25>them <1:26>out;",
          "<1:27>But, <1:28>a<1:29>bove <1:30>all, <1:31>the <1:32>heart",
          "<1:33>Must <1:34>bear <1:35>the <1:36>long<1:37>est <1:38>part.",
          "<1:39>Let <1:40>all <1:41>the <1:42>world <1:43>in <1:44>ev<1:45>ery <1:46>cor<1:47>ner <1:48>sing,",
          "<1:49>My <1:50>God <1:51>and <1:52>King!"
        ]
      }
    ]
  },
  {
    "hymnNumber": 10,
    "reference": "SDAH010",
    "title": "Come, Christians, Join to Sing",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>Come, <1:2>Chris<1:3>tians, <1:4>join <1:5>to <1:6>sing,",
          "<1:7>Al<1:8>le<1:9>lu<1:10>ia! <1:11,12>A<1:13>men!",
          "<1:14>Loud <1:15>praise <1:16>to <1:17>Christ <1:18>our <1:19>King;",
          "<1:20>Al<1:21>le<1:22>lu<1:23>ia! <1:24,25>A<1:26>men!",
          "<1:27>Let <1:28>all, <1:29>with <1:30>heart <1:31>and <1:32>voice,",
          "<1:33>Be<1:34>fore <1:35>His <1:36>throne <1:37>re<1:38>joice;",
          "<1:39,40>Praise <1:41>is <1:42>His <1:43>gra<1:44>cious <1:45>choice:",
          "<1:46>Al<1:47>le<1:48>lu<1:49>ia! <1:50,51>A<1:52>men!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>Come, <1:2>lift <1:3>your <1:4>hearts <1:5>on <1:6>high;",
          "<1:7>Al<1:8>le<1:9>lu<1:10>ia! <1:11,12>A<1:13>men!",
          "<1:14>Let <1:15>prais<1:16>es <1:17>fill <1:18>the <1:19>sky;",
          "<1:20>Al<1:21>le<1:22>lu<1:23>ia! <1:24,25>A<1:26>men!",
          "<1:27>He <1:28>is <1:29>our <1:30>Guide <1:31>and <1:32>Friend;",
          "<1:33>To <1:34>us <1:35>He'll <1:36>con<1:37>de<1:38>scend;",
          "<1:39,40>His <1:41>love <1:42>shall <1:43>nev<1:44>er <1:45>end:",
          "<1:46>Al<1:47>le<1:48>lu<1:49>ia! <1:50,51>A<1:52>men!"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>Praise <1:2>yet <1:3>our <1:4>Christ <1:5>a<1:6>gain;",
          "<1:7>Al<1:8>le<1:9>lu<1:10>ia! <1:11,12>A<1:13>men!",
          "<1:14>Life <1:15>shall <1:16>not <1:17>end <1:18>the <1:19>strain;",
          "<1:20>Al<1:21>le<1:22>lu<1:23>ia! <1:24,25>A<1:26>men!",
          "<1:27>On <1:28>heav<1:29>en's <1:30>bliss<1:31>ful <1:32>shore",
          "<1:33>His <1:34>good<1:35>ness <1:36>we'll <1:37>a<1:38>dore,",
          "<1:39,40>Sing<1:41>ing <1:42>for<1:43>ev<1:44>er<1:45>more,",
          "<1:46>Al<1:47>le<1:48>lu<1:49>ia! <1:50,51>A<1:52>men!"
        ]
      }
    ]
  },
  {
    "hymnNumber": 11,
    "reference": "SDAH011",
    "title": "The God of Abraham Praise",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>The <1:2>God <1:3>of <1:4>A<1:5>braham <1:6>praise,",
          "<1:7>Who <1:8>reigns <1:9>en<1:10>throned <1:11>a<1:12>bove;",
          "<1:13>An<1:14>cient <1:15>of <1:16>ev<1:17>er<1:18>last<1:19>ing <1:20>days,",
          "<1:21>And <1:22>God <1:23>of <1:24>love;",
          "<1:25>Je<1:26>ho<1:27>vah! <1:28>Great <1:29>I <1:30>AM!",
          "<1:31,32>By <1:33,34>earth <1:35,36>and <1:37>heaven <1:38>con<1:39>fessed;",
          "<1:40>I <1:41>bow <1:42>and <1:43>bless <1:44>the <1:45>sa<1:46,47>cred <1:48>name",
          "<1:49,50>For <1:51>ev<1:52>er <1:53>blest."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>The <1:2>God <1:3>of <1:4>A<1:5>braham <1:6>praise,",
          "<1:7>At <1:8>whose <1:9>su<1:10>preme <1:11>com<1:12>mand",
          "<1:13>From <1:14>earth <1:15>I <1:16>rise, <1:17>and <1:18>seek <1:19>the <1:20>joys",
          "<1:21>At <1:22>His <1:23>right <1:24>hand;",
          "<1:25>I <1:26>all <1:27>on <1:28>earth <1:29>for<1:30>sake,",
          "<1:31,32>Its <1:33,34>wis<1:35,36>dom, <1:37>fame <1:38>and <1:39>power;",
          "<1:40>And <1:41>Him <1:42>my <1:43>on<1:44>ly <1:45>por<1:46,47>tion <1:48>make,",
          "<1:49,50>My <1:51>shield <1:52>and <1:53>tower."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>The <1:2>whole <1:3>tri<1:4>um<1:5>phant <1:6>host",
          "<1:7>Give <1:8>thanks <1:9>to <1:10>God <1:11>on <1:12>high;",
          "<1:13>\"Hail, <1:14>Fa<1:15>ther, <1:16>Son, <1:17>and <1:18>Ho<1:19>ly <1:20>Ghost!\"",
          "<1:21>They <1:22>ev<1:23>er <1:24>cry;",
          "<1:25>Hail, <1:26>A<1:27>braham's <1:28>God <1:29>and <1:30>mine!",
          "<1:31,32>I <1:33,34>join <1:35,36>the <1:37>heaven<1:38>ly <1:39>lays;",
          "<1:40>All <1:41>might <1:42>and <1:43>ma<1:44>jes<1:45>ty <1:46,47>are <1:48>Thine,",
          "<1:49,50>And <1:51>end<1:52>less <1:53>praise."
        ]
      }
    ]
  },
  {
    "hymnNumber": 12,
    "reference": "SDAH012",
    "title": "Joyful, Joyful, We Adore Thee",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>Joy<1:2>ful, <1:3>joy<1:4>ful, <1:5>we <1:6>a<1:7>dore <1:8>Thee,",
          "<1:9>God <1:10>of <1:11>glo<1:12>ry, <1:13>Lord <1:14>of <1:15>love;",
          "<1:16>Hearts <1:17>un<1:18>fold <1:19>like <1:20>flow'rs <1:21>be<1:22>fore <1:23>Thee,",
          "<1:24>Hail <1:25>Thee <1:26>as <1:27>the <1:28>sun <1:29>a<1:30>bove.",
          "<1:31>Melt <1:32>the <1:33>clouds <1:34>of <1:35>sin <1:36,37>and <1:38>sad<1:39>ness,",
          "<1:40>Drive <1:41,42>the <1:43>dark <1:44>of <1:45>doubt <1:46>a<1:47>way;",
          "<1:48>Giv<1:49>er <1:50>of <1:51>im<1:52>mor<1:53>tal <1:54>glad<1:55>ness,",
          "<1:56>Fill <1:57>us <1:58>with <1:59>the <1:60>light <1:61>of <1:62>day!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>All <1:2>Thy <1:3>works <1:4>with <1:5>joy <1:6>sur<1:7>round <1:8>Thee,",
          "<1:9>Earth <1:10>and <1:11>heav'n <1:12>re<1:13>flect <1:14>Thy <1:15>rays,",
          "<1:16>Stars <1:17>and <1:18>an<1:19>gels <1:20>sing <1:21>a<1:22>round <1:23>Thee,",
          "<1:24>Cen<1:25>ter <1:26>of <1:27>un<1:28>bro<1:29>ken <1:30>praise;",
          "<1:31>Field <1:32>and <1:33>for<1:34>est, <1:35>vale <1:36,37>and <1:38>moun<1:39>tain,",
          "<1:40>Bloss'<1:41,42>ming <1:43>mead<1:44>ow, <1:45>flash<1:46>ing <1:47>sea,",
          "<1:48>Chant<1:49>ing <1:50>bird <1:51>and <1:52>flow<1:53>ing <1:54>foun<1:55>tain",
          "<1:56>Call <1:57>us <1:58>to <1:59>re<1:60>joice <1:61>in <1:62>Thee."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>Thou <1:2>art <1:3>giv<1:4>ing <1:5>and <1:6>for<1:7>giv<1:8>ing,",
          "<1:9>Ev<1:10>er <1:11>bless<1:12>ing, <1:13>ev<1:14>er <1:15>blest,",
          "<1:16>Well<1:17>spring <1:18>of <1:19>the <1:20>joy <1:21>of <1:22>liv<1:23>ing,",
          "<1:24>O<1:25>cean-<1:26>depth <1:27>of <1:28>hap<1:29>py <1:30>rest!",
          "<1:31>Thou <1:32>the <1:33>Fa<1:34>ther, <1:35>Christ <1:36,37>our <1:38>Broth<1:39>er;",
          "<1:40>All <1:41,42>who <1:43>live <1:44>in <1:45>love <1:46>are <1:47>Thine:",
          "<1:48>Teach <1:49>us <1:50>how <1:51>to <1:52>love <1:53>each <1:54>oth<1:55>er,",
          "<1:56>Lift <1:57>us <1:58>to <1:59>the <1:60>joy <1:61>di<1:62>vine."
        ]
      }
    ]
  },
  {
    "hymnNumber": 13,
    "reference": "SDAH013",
    "title": "New Songs of Celebration Render",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1,2>New <1:3>songs <1:4>of <1:5>cel<1:6>e<1:7>bra<1:8>tion <1:9>ren<1:10>der",
          "<1:11>To <1:12>Him <1:13>who <1:14>has <1:15>great <1:16>won<1:17>ders <1:18>done.",
          "<1:19>Love <1:20>sits <1:21>en<1:22>throned <1:23>in <1:24>age<1:25>less <1:26>splen<1:27>dor:",
          "<1:28,29>Come, <1:30>and <1:31>a<1:32>dore <1:33>the <1:34>might<1:35>y <1:36>One.",
          "<1:37>He <1:38>has <1:39>made <1:40,41>known <1:42>His <1:43>great <1:44>sal<1:45,46>va<1:47>tion",
          "<1:48>Which <1:49>all <1:50>His <1:51>friends <1:52>with <1:53>joy <1:54>con<1:55>fess:",
          "<1:56>He <1:57>has <1:58>re<1:59>vealed <1:60>to <1:61>eve<1:62,63>ry <1:64>na<1:65,66>tion",
          "<1:67>His <1:68>ev<1:69>er<1:70>last<1:71>ing <1:72>right<1:73>eous<1:74>ness."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1,2>Joy<1:3>ful<1:4>ly, <1:5>heart<1:6>i<1:7>ly <1:8>re<1:9>sound<1:10>ing,",
          "<1:11>Let <1:12>eve<1:13>ry <1:14>in<1:15>stru<1:16>ment <1:17>and <1:18>voice",
          "<1:19>Peal <1:20>out <1:21>the <1:22>praise <1:23>of <1:24>grace <1:25>a<1:26>bound<1:27>ing,",
          "<1:28,29>Call<1:30>ing <1:31>the <1:32>whole <1:33>world <1:34>to <1:35>re<1:36>joice.",
          "<1:37>Trum<1:38>pets <1:39>and <1:40,41>or<1:42>gans, <1:43>set <1:44>in <1:45,46>mo<1:47>tion",
          "<1:48>Such <1:49>sounds <1:50>as <1:51>make <1:52>the <1:53>heav<1:54>ens <1:55>ring;",
          "<1:56>All <1:57>things <1:58>that <1:59>live <1:60>in <1:61>earth <1:62,63>and <1:64>o<1:65,66>cean,",
          "<1:67>Make <1:68>mu<1:69>sic <1:70>for <1:71>your <1:72>might<1:73>y <1:74>King."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1,2>Riv<1:3>ers <1:4>and <1:5>seas <1:6>and <1:7>tor<1:8>rents <1:9>roar<1:10>ing,",
          "<1:11>Hon<1:12>or <1:13>the <1:14>Lord <1:15>with <1:16>wild <1:17>ac<1:18>claim;",
          "<1:19>Moun<1:20>tains <1:21>and <1:22>stones <1:23>look <1:24>up <1:25>a<1:26>dor<1:27>ing,",
          "<1:28,29>And <1:30>find <1:31>a <1:32>voice <1:33>to <1:34>praise <1:35>His <1:36>name.",
          "<1:37>Right<1:38>eous, <1:39>com<1:40,41>mand<1:42>ing, <1:43>ev<1:44>er <1:45,46>glo<1:47>rious,",
          "<1:48>Prais<1:49>es <1:50>be <1:51>His <1:52>that <1:53>nev<1:54>er <1:55>cease:",
          "<1:56>Just <1:57>is <1:58>our <1:59>God, <1:60>whose <1:61>truth <1:62,63>vic<1:64>to<1:65,66>rious,",
          "<1:67>Es<1:68>tab<1:69>lish<1:70>es <1:71>the <1:72>world <1:73>in <1:74>peace."
        ]
      }
    ]
  },
  {
    "hymnNumber": 14,
    "reference": "SDAH014",
    "title": "Let Us Praise the Name of the Lord",
    "hasMidi": true,
    "numberOfVerses": 2,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>Let <1:2>us <1:3>praise <1:4>the <1:5>name <1:6>of <1:7>the <1:8>Lord!",
          "<1:9>Give <1:10>Him <1:11>glo<1:12>ry, <1:13,14,15>A<1:16>men.",
          "<1:17>A<1:18>men, <1:19,20,21,22,23,24>a<1:25>men, <1:26>A<1:27>men, <1:28,29,30,31,32>a<1:33>men."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>Go <1:2>ye <1:3>in<1:4>to <1:5>all <1:6,7>the <1:8>world,",
          "<1:9>A<1:10>le<1:11>lu<1:12>ia, <1:13,14,15>A<1:16>men.",
          "<1:17>A<1:18>men, <1:19,20,21,22,23,24>a<1:25>men, <1:26>A<1:27>men, <1:28,29,30,31,32>a<1:33>men."
        ]
      }
    ]
  },
  {
    "hymnNumber": 15,
    "reference": "SDAH015",
    "title": "My Maker and My King",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>My <1:2>Mak<1:3>er <1:4>and <1:5>my <1:6>King,",
          "<1:7>To <1:8>Thee <1:9>my <1:10>all <1:11>I <1:12>owe;",
          "<1:13>Thy <1:14>sov<1:15>ereign <1:16>boun<1:17>ty <1:18>is <1:19>the <1:20>spring",
          "<1:21>Whence <1:22>all <1:23>my <1:24>bless<1:25>ings <1:26>flow;",
          "<1:27>Thy <1:28>sov<1:29>ereign <1:30>boun<1:31>ty <1:32>is <1:33>the <1:34>spring",
          "<1:35>Whence <1:36>all <1:37>my <1:38>bless<1:39,40>ings <1:41>flow."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>The <1:2>crea<1:3>ture <1:4>of <1:5>Thy <1:6>hand,",
          "<1:7>On <1:8>Thee <1:9>a<1:10>lone <1:11>I <1:12>live;",
          "<1:13>My <1:14>God, <1:15>Thy <1:16>ben<1:17>e<1:18>fits <1:19>de<1:20>mand",
          "<1:21>More <1:22>praise <1:23>than <1:24>I <1:25>can <1:26>give.",
          "<1:27>My <1:28>God, <1:29>Thy <1:30>ben<1:31>e<1:32>fits <1:33>de<1:34>mand",
          "<1:35>More <1:36>praise <1:37>than <1:38>I <1:39,40>can <1:41>give."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>Lord, <1:2>what <1:3>can <1:4>I <1:5>im<1:6>part",
          "<1:7>When <1:8>all <1:9>is <1:10>Thine <1:11>be<1:12>fore?",
          "<1:13>Thy <1:14>love <1:15>de<1:16>mands <1:17>a <1:18>thank<1:19>ful <1:20>heart;",
          "<1:21>The <1:22>gift, <1:23>a<1:24>las! <1:25>how <1:26>poor.",
          "<1:27>Thy <1:28>love <1:29>de<1:30>mands <1:31>a <1:32>thank<1:33>ful <1:34>heart;",
          "<1:35>The <1:36>gift, <1:37>a<1:38>las! <1:39,40>how <1:41>poor."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "<1:1>O! <1:2>let <1:3>Thy <1:4>grace <1:5>in<1:6>spire",
          "<1:7>My <1:8>soul <1:9>with <1:10>strength <1:11>di<1:12>vine;",
          "<1:13>Let <1:14>ev<1:15>ery <1:16>word <1:17>and <1:18>each <1:19>de<1:20>sire",
          "<1:21>And <1:22>all <1:23>my <1:24>days <1:25>be <1:26>Thine.",
          "<1:27>Let <1:28>ev<1:29>ery <1:30>word <1:31>and <1:32>each <1:33>de<1:34>sire",
          "<1:35>And <1:36>all <1:37>my <1:38>days <1:39,40>be <1:41>Thine."
        ]
      }
    ]
  },
  {
    "hymnNumber": 16,
    "reference": "SDAH016",
    "title": "All People That on Earth Do Dwell",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>All <1:2>peo<1:3>ple <1:4>that <1:5>on <1:6>earth <1:7>do <1:8>dwell,",
          "<1:9>Sing <1:10>to <1:11>the <1:12>Lord <1:13>with <1:14>cheer<1:15>ful <1:16>voice;",
          "<1:17>Him <1:18>serve <1:19>with <1:20>mirth, <1:21>His <1:22>praise <1:23>forth <1:24>tell,",
          "<1:25>Come <1:26>ye <1:27>be<1:28>fore <1:29>Him <1:30>and <1:31>re<1:32>joice."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>Know <1:2>that <1:3>the <1:4>Lord <1:5>is <1:6>God <1:7>in<1:8>deed;",
          "<1:9>With<1:10>out <1:11>our <1:12>aid <1:13>He <1:14>did <1:15>us <1:16>make;",
          "<1:17>We <1:18>are <1:19>His <1:20>folk, <1:21>He <1:22>doth <1:23>us <1:24>feed,",
          "<1:25>And <1:26>for <1:27>His <1:28>sheep <1:29>He <1:30>doth <1:31>us <1:32>take."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>O <1:2>en<1:3>ter <1:4>then <1:5>His <1:6>gates <1:7>with <1:8>praise,",
          "<1:9>Ap<1:10>proach <1:11>with <1:12>joy <1:13>His <1:14>courts <1:15>un<1:16>to;",
          "<1:17>Praise, <1:18>laud, <1:19>and <1:20>bless <1:21>His <1:22>name <1:23>al<1:24>ways,",
          "<1:25>For <1:26>it <1:27>is <1:28>seem<1:29>ly <1:30>so <1:31>to <1:32>do."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "<1:1>For <1:2>why <1:3>the <1:4>Lord <1:5>our <1:6>God <1:7>is <1:8>good,",
          "<1:9>His <1:10>mer<1:11>cy <1:12>is <1:13>for<1:14>ev<1:15>er <1:16>sure;",
          "<1:17>His <1:18>truth <1:19>at <1:20>all <1:21>times <1:22>firm<1:23>ly <1:24>stood,",
          "<1:25>And <1:26>shall <1:27>from <1:28>age <1:29>to <1:30>age <1:31>en<1:32>dure."
        ]
      }
    ]
  },
  {
    "hymnNumber": 17,
    "reference": "SDAH017",
    "title": "Lord of All Being, Throned Afar",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>Lord <1:2>of <1:3>all <1:4,5>be<1:6>ing, <1:7,8>throned <1:9>a<1:10>far,",
          "<1:11>Thy <1:12>glo<1:13>ry <1:14,15>flames <1:16>from <1:17,18>sun <1:19,20>and <1:21>star;",
          "<1:22>Cen<1:23>ter <1:24>and <1:25>soul <1:26>of <1:27>ev<1:28>ery <1:29>sphere,",
          "<1:30>Yet <1:31>to <1:32>each <1:33>lov<1:34>ing <1:35,36>heart <1:37>how <1:38>near!",
          "<1:39>Yet <1:40>to <1:41>each <1:42,43>lov<1:44>ing <1:45,46>heart <1:47>how <1:48>near!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>Sun <1:2>of <1:3>our <1:4,5>life, <1:6>Thy <1:7,8>quick<1:9>ening <1:10>ray",
          "<1:11>Sheds <1:12>on <1:13>our <1:14,15>path <1:16>the <1:17,18>glow <1:19,20>of <1:21>day;",
          "<1:22>Star <1:23>of <1:24>our <1:25>hope, <1:26>Thy <1:27>soft<1:28>ened <1:29>light",
          "<1:30>Cheers <1:31>the <1:32>long <1:33>watch<1:34>es <1:35,36>of <1:37>the <1:38>night,",
          "<1:39>Cheers <1:40>the <1:41>long <1:42,43>watch<1:44>es <1:45,46>of <1:47>the <1:48>night."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>Our <1:2>mid<1:3>night <1:4,5>is <1:6>Thy <1:7,8>smile <1:9>with<1:10>drawn;",
          "<1:11>Our <1:12>noon<1:13>tide <1:14,15>is <1:16>Thy <1:17,18>gra<1:19,20>cious <1:21>dawn;",
          "<1:22>Our <1:23>rain<1:24>bow <1:25>arch, <1:26>Thy <1:27>mer<1:28>cy's <1:29>sign;",
          "<1:30>All, <1:31>save <1:32>the <1:33>clouds <1:34>of <1:35,36>sin, <1:37>are <1:38>Thine,",
          "<1:39>All, <1:40>save <1:41>the <1:42,43>clouds <1:44>of <1:45,46>sin, <1:47>are <1:48>Thine."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "<1:1>Lord <1:2>of <1:3>all <1:4,5>life, <1:6>be<1:7,8>low, <1:9>a<1:10>bove,",
          "<1:11>Whose <1:12>light <1:13>is <1:14,15>truth, <1:16>whose <1:17,18>warmth <1:19,20>is <1:21>love,",
          "<1:22>Be<1:23>fore <1:24>Thy <1:25>ev<1:26>er<1:27>blaz<1:28>ing <1:29>throne",
          "<1:30>We <1:31>ask <1:32>no <1:33>lus<1:34>ter <1:35,36>of <1:37>our <1:38>own,",
          "<1:39>We <1:40>ask <1:41>no <1:42,43>lus<1:44>ter <1:45,46>of <1:47>our <1:48>own."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "<1:1>Grant <1:2>us <1:3>Thy <1:4,5>truth <1:6>to <1:7,8>make <1:9>us <1:10>free,",
          "<1:11>And <1:12>kin<1:13>dling <1:14,15>hearts <1:16>that <1:17,18>burn <1:19,20>for <1:21>Thee;",
          "<1:22>Till <1:23>all <1:24>Thy <1:25>liv<1:26>ing <1:27>al<1:28>tars <1:29>claim",
          "<1:30>One <1:31>ho<1:32>ly <1:33>light, <1:34>one <1:35,36>heaven<1:37>ly <1:38>flame!",
          "<1:39>One <1:40>ho<1:41>ly <1:42,43>light, <1:44>one <1:45,46>heaven<1:47>ly <1:48>flame."
        ]
      }
    ]
  },
  {
    "hymnNumber": 18,
    "reference": "SDAH018",
    "title": "O Morning Star How Fair and Bright",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>O <1:2>Morn<1:3>ing <1:4>Star, <1:5>how <1:6>fair <1:7>and <1:8>bright! ",
          "<1:9>You <1:10>shine <1:11>with <1:12>God's <1:13>own <1:14>truth <1:15>and <1:16>light, ",
          "<1:17>A<1:18>glow <1:19>with <1:20>grace <1:21>and <1:22>mer<1:23>cy! ",
          "<1:24>Of <1:25>Ja<1:26>cob's <1:27>race, <1:28>King <1:29>Da<1:30>vid's <1:31>Son, ",
          "<1:32>Our <1:33>Lord <1:34>and <1:35>Mas<1:36>ter, <1:37>You <1:38>have <1:39>won ",
          "<1:40>Our <1:41>hearts <1:42>to <1:43>serve <1:44>You <1:45>on<1:46>ly! ",
          "<1:47>Low<1:48>ly, <1:49>Ho<1:50>ly! ",
          "<1:51>Great <1:52>and <1:53>glo<1:54>rious, ",
          "<1:55>all <1:56>vic<1:57>to<1:58>rious, ",
          "<1:59>Rich <1:60>in <1:61>bless<1:62>ing! ",
          "<1:63>Rule <1:64>and <1:65>might <1:66>o'er <1:67>all <1:68>pos<1:69>sess<1:70>ing!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>Lord, <1:2>when <1:3>You <1:4>look <1:5>on <1:6>us <1:7>in <1:8>love, ",
          "<1:9>At <1:10>once <1:11>there <1:12>falls <1:13>from <1:14>God <1:15>a<1:16>bove ",
          "<1:17>A <1:18>ray <1:19>of <1:20>pur<1:21>est <1:22>plea<1:23>sure. ",
          "<1:24>Your <1:25>Word <1:26>and <1:27>Spir<1:28>it, <1:29>flesh <1:30>and <1:31>blood ",
          "<1:32>Re<1:33>fresh <1:34>our <1:35>souls <1:36>with <1:37>heav'n<1:38>ly <1:39>food. ",
          "<1:40>You <1:41>are <1:42>our <1:43>dear<1:44>est <1:45>trea<1:46>sure! ",
          "<1:47>Let <1:48>Your <1:49>mer<1:50>cy ",
          "<1:51>Warm <1:52>and <1:53>cheer <1:54>us! ",
          "<1:55>O <1:56>draw <1:57>near <1:58>us! ",
          "<1:59>For <1:60>You <1:61>teach <1:62>us ",
          "<1:63>God's <1:64>own <1:65>love <1:66>through <1:67>You <1:68>has <1:69>reached <1:70>us."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>Al<1:2>migh<1:3>ty <1:4>Fa<1:5>ther, <1:6>in <1:7>Your <1:8>Son ",
          "<1:9>You <1:10>loved <1:11>us, <1:12>when <1:13>not <1:14>yet <1:15>be<1:16>gun ",
          "<1:17>Was <1:18>this <1:19>old <1:20>earth's <1:21>foun<1:22>da<1:23>tion! ",
          "<1:24>Your <1:25>Son <1:26>has <1:27>ran<1:28>somed <1:29>us <1:30>in <1:31>love ",
          "<1:32>To <1:33>live <1:34>in <1:35>Him <1:36>here <1:37>and <1:38>a<1:39>bove: ",
          "<1:40>This <1:41>is <1:42>Your <1:43>great <1:44>sal<1:45>va<1:46>tion. ",
          "<1:47>Al<1:48>le<1:49>lu<1:50>ia! <1:51>Christ <1:52>the <1:53>liv<1:54>ing, ",
          "<1:55>to <1:56>us <1:57>giv<1:58>ing ",
          "<1:59>Life <1:60>for<1:61>ev<1:62>er, ",
          "<1:63>Keeps <1:64>us <1:65>Yours <1:66>and <1:67>fails <1:68>us <1:69>nev<1:70>er!"
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "<1:1>O <1:2>let <1:3>the <1:4>harps <1:5>break <1:6>forth <1:7>in <1:8>sound! ",
          "<1:9>Our <1:10>joy <1:11>be <1:12>all <1:13>with <1:14>mu<1:15>sic <1:16>crowned, ",
          "<1:17>Our <1:18>voic<1:19>es <1:20>gai<1:21>ly <1:22>blend<1:23>ing! ",
          "<1:24>For <1:25>Christ <1:26>goes <1:27>with <1:28>us <1:29>all <1:30>the <1:31>way- ",
          "<1:32>To<1:33>day, <1:34>to<1:35>mor<1:36>row, <1:37>ev<1:38>ery <1:39>day! ",
          "<1:40>His <1:41>love <1:42>is <1:43>nev<1:44>er <1:45>end<1:46>ing! ",
          "<1:47>Sing <1:48>out! <1:49>ring <1:50>out! ",
          "<1:51>Ju<1:52>bi<1:53>la<1:54>tion! ",
          "<1:55>ex<1:56>ul<1:57>ta<1:58>tion! ",
          "<1:59>Tell <1:60>the <1:61>sto<1:62>ry! ",
          "<1:63>Great <1:64>is <1:65>He, <1:66>the <1:67>King <1:68>of <1:69>glo<1:70>ry!"
        ]
      }
    ]
  },
  {
    "hymnNumber": 19,
    "reference": "SDAH019",
    "title": "O Sing a New Song to the Lord",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>O <1:2>sing <1:3>a <1:4>new <1:5>song <1:6>to <1:7>the <1:8>Lord",
          "<1:9>For <1:10>mar<1:11>vels <1:12>He <1:13>has <1:14>done;",
          "<1:15>His <1:16>right <1:17>hand <1:18>and <1:19>His <1:20>ho<1:21>ly <1:22>arm",
          "<1:23>The <1:24>vic<1:25,26>to<1:27>ry <1:28>have <1:29>won."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>With <1:2>harp, <1:3>with <1:4>harp <1:5>and <1:6>voice <1:7>of <1:8>psalms",
          "<1:9>Un<1:10>to <1:11>Je<1:12>ho<1:13>vah <1:14>sing;",
          "<1:15>Let <1:16>trum<1:17>pets <1:18>and <1:19>the <1:20>ech<1:21>oing <1:22>horn",
          "<1:23>Ac<1:24>claim <1:25,26>the <1:27>Lord <1:28>our <1:29>King!"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>Let <1:2>seas <1:3>with <1:4>all <1:5>their <1:6>crea<1:7>tures <1:8>roar,",
          "<1:9>The <1:10>world <1:11>and <1:12>dwell<1:13>ers <1:14>there,",
          "<1:15>And <1:16>let <1:17>the <1:18>riv<1:19>ers <1:20>clap <1:21>their <1:22>hands,",
          "<1:23>The <1:24>hills <1:25,26>their <1:27>joy <1:28>de<1:29>clare."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "<1:1>Be<1:2>fore <1:3>the <1:4>Lord: <1:5>be<1:6>cause <1:7>He <1:8>comes,",
          "<1:9>To <1:10>judge <1:11>the <1:12>earth <1:13>comes <1:14>He;",
          "<1:15>He'll <1:16>judge <1:17>the <1:18>world <1:19>with <1:20>righ<1:21>teous<1:22>ness,",
          "<1:23>His <1:24>folk <1:25,26>with <1:27>eq<1:28>ui<1:29>ty."
        ]
      }
    ]
  },
  {
    "hymnNumber": 20,
    "reference": "SDAH020",
    "title": "O Praise Ye the Lord",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>O <1:2>praise <1:3>ye <1:4>the <1:5>Lord! ",
          "<1:6>Praise <1:7>Him <1:8>in <1:9>the <1:10>height; ",
          "<1:11>Re<1:12>joice <1:13>in <1:14>His <1:15>word, ",
          "<1:16>Ye <1:17>an<1:18>gels <1:19>of <1:20>light; ",
          "<1:21>Ye <1:22>hea<1:23>vens, <1:24>a<1:25>dore <1:26,27>Him ",
          "<1:28,29>By <1:30>whom <1:31>ye <1:32>were <1:33>made, ",
          "<1:34>And <1:35>wor<1:36>ship <1:37>be<1:38,39>fore <1:40>Him, ",
          "<1:41>In <1:42>bright<1:43>ness <1:44>ar<1:45>rayed."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>O <1:2>praise <1:3>ye <1:4>the <1:5>Lord! ",
          "<1:6>Praise <1:7>Him <1:8>up<1:9>on <1:10>earth, ",
          "<1:11>In <1:12>tune<1:13>ful <1:14>ac<1:15>cord: ",
          "<1:16>Ye <1:17>sons <1:18>of <1:19>new <1:20>birth; ",
          "<1:21>Praise <1:22>Him <1:23>who <1:24>hath <1:25>brought <1:26,27>you ",
          "<1:28,29>His <1:30>grace <1:31>from <1:32>a<1:33>bove, ",
          "<1:34>Praise <1:35>Him <1:36>who <1:37>hath <1:38,39>taught <1:40>you ",
          "<1:41>To <1:42>sing <1:43>of <1:44>His <1:45>love."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>O <1:2>praise <1:3>ye <1:4>the <1:5>Lord, ",
          "<1:6>All <1:7>things <1:8>that <1:9>give <1:10>sound; ",
          "<1:11>Each <1:12>ju<1:13>bi<1:14>lant <1:15>chord, ",
          "<1:16>Re-<1:17>e<1:18>cho <1:19>a<1:20>round; ",
          "<1:21>Loud <1:22>or<1:23>gans <1:24>His <1:25>glo<1:26,27>ry ",
          "<1:28,29>Forth <1:30>tell <1:31>in <1:32>deep <1:33>tone, ",
          "<1:34>And <1:35>sweet <1:36>harp, <1:37>the <1:38,39>sto<1:40>ry ",
          "<1:41>Of <1:42>what <1:43>He <1:44>hath <1:45>done."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "<1:1>O <1:2>praise <1:3>ye <1:4>the <1:5>Lord! ",
          "<1:6>Thanks<1:7>giv<1:8>ing <1:9>and <1:10>song ",
          "<1:11>To <1:12>Him <1:13>be <1:14>out-<1:15>poured ",
          "<1:16>All <1:17>a<1:18>ges <1:19>a<1:20>long: ",
          "<1:21>For <1:22>love <1:23>in <1:24>cre<1:25>a<1:26,27>tion, ",
          "<1:28,29>For <1:30>hea<1:31>ven <1:32>re<1:33>stored. ",
          "<1:34>For <1:35>grace <1:36>of <1:37>sal<1:38,39>va<1:40>tion, ",
          "<1:41>O <1:42>praise <1:43>ye <1:44>the <1:45>Lord!"
        ]
      }
    ]
  },
  {
    "hymnNumber": 21,
    "reference": "SDAH021",
    "title": "Immortal, Invisible, God Only Wise",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>Im<1:2>mor<1:3>tal, <1:4>in<1:5>vis<1:6>i<1:7>ble, <1:8>God <1:9>on<1:10,11>ly <1:12>wise,",
          "<1:13>In <1:14>light <1:15>in<1:16>ac<1:17>ces<1:18>si<1:19>ble <1:20>hid <1:21>from <1:22,23>our <1:24>eyes.",
          "<1:25>Most <1:26>bless<1:27>ed, <1:28>most <1:29>glo<1:30>rious, <1:31>the <1:32>An<1:33>cient <1:34>of <1:35>Days,",
          "<1:36>Al<1:37>might<1:38>y, <1:39>vic<1:40>to<1:41>rious, <1:42>Thy <1:43>great <1:44>name <1:45>we <1:46>praise."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>Un<1:2>rest<1:3>ing, <1:4>un<1:5>hast<1:6>ing, <1:7>and <1:8>si<1:9>lent <1:10,11>as <1:12>light,",
          "<1:13>Nor <1:14>want<1:15>ing, <1:16>nor <1:17>wast<1:18>ing, <1:19>Thou <1:20>rul<1:21>est <1:22,23>in <1:24>might;",
          "<1:25>Thy <1:26>jus<1:27>tice, <1:28>like <1:29>moun<1:30>tains, <1:31>high <1:32>soar<1:33>ing <1:34>a<1:35>bove",
          "<1:36>Thy <1:37>clouds, <1:38>which <1:39>are <1:40>foun<1:41>tains <1:42>of <1:43>good<1:44>ness <1:45>and <1:46>love."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>To <1:2>all <1:3>life <1:4>Thou <1:5>giv<1:6>est <1:7>to <1:8>both <1:9>great <1:10,11>and <1:12>small;",
          "<1:13>In <1:14>all <1:15>life <1:16>Thou <1:17>liv<1:18>est, <1:19>the <1:20>true <1:21>life <1:22,23>of <1:24>all;",
          "<1:25>We <1:26>blos<1:27>som <1:28>and <1:29>flour<1:30>ish, <1:31>like <1:32>leaves <1:33>on <1:34>the <1:35>tree,",
          "<1:36>Then <1:37>with<1:38>er <1:39>and <1:40>per<1:41>ish; <1:42>but <1:43>naught <1:44>chang<1:45>eth <1:46>Thee."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "<1:1>Great <1:2>Fa<1:3>ther <1:4>of <1:5>glo<1:6>ry, <1:7>pure <1:8>Fa<1:9>ther <1:10,11>of <1:12>light,",
          "<1:13>Thine <1:14>an<1:15>gels <1:16>a<1:17>dore <1:18>Thee, <1:19>all <1:20>veil<1:21>ing <1:22,23>their <1:24>sight;",
          "<1:25>All <1:26>laud <1:27>we <1:28>would <1:29>ren<1:30>der; <1:31>O <1:32>help <1:33>us <1:34>to <1:35>see",
          "<1:36>'Tis <1:37>on<1:38>ly <1:39>the <1:40>splen<1:41>dor <1:42>of <1:43>light <1:44>hid<1:45>eth <1:46>Thee."
        ]
      }
    ]
  },
  {
    "hymnNumber": 22,
    "reference": "SDAH022",
    "title": "God Is Our Song",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>God <1:2>is <1:3>our <1:4>Song, <1:5>and <1:6>ev<1:7>ery <1:8>sing<1:9>er <1:10>blest",
          "<1:11>Who <1:12>prais<1:13>ing <1:14>Him <1:15>finds <1:16>en<1:17>er<1:18>gy <1:19>and <1:20>rest.",
          "<1:21>All <1:22>who <1:23>praise <1:24>God <1:25>with <1:26>un<1:27>af<1:28>fect<1:29>ed <1:30>joy",
          "<1:31>Give <1:32>back <1:33>to <1:34>us <1:35>the <1:36>wis<1:37>dom <1:38>we <1:39>de<1:40>stroy,",
          "<1:41>Give <1:42>back <1:43>to <1:44>us <1:45>the <1:46>wis<1:47>dom <1:48,49>we <1:50,51>de<1:52>stroy."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>God <1:2>is <1:3>our <1:4>Song, <1:5>for <1:6>Je<1:7>sus <1:8>comes <1:9>to <1:10>save;",
          "<1:11>While <1:12>prais<1:13>ing <1:14>Him <1:15>we <1:16>of<1:17>fer <1:18>all <1:19>we <1:20>have.",
          "<1:21>New <1:22>songs <1:23>we <1:24>sing, <1:25>in <1:26>ven<1:27>tures <1:28>new <1:29>u<1:30>nite,",
          "<1:31>When <1:32>Je<1:33>sus <1:34>leads <1:35>us <1:36>up<1:37>ward <1:38>in<1:39>to <1:40>light,",
          "<1:41>When <1:42>Je<1:43>sus <1:44>leads <1:45>us <1:46>up<1:47>ward <1:48,49>in<1:50,51>to <1:52>light."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>This <1:2>is <1:3>the <1:4>Song <1:5>no <1:6>con<1:7>flict <1:8>ev<1:9>er <1:10>drowns;",
          "<1:11>Who <1:12>prais<1:13>es <1:14>God <1:15>our <1:16>hu<1:17>man <1:18>wrath <1:19>dis<1:20>owns.",
          "<1:21>Love <1:22>knows <1:23>what <1:24>rich <1:25>com<1:26>plex<1:27>i<1:28>ties <1:29>of <1:30>sound",
          "<1:31>God <1:32>builds <1:33>up<1:34>on <1:35>a <1:36>sim<1:37>ple <1:38>com<1:39>mon <1:40>ground,",
          "<1:41>God <1:42>builds <1:43>up<1:44>on <1:45>a <1:46>sim<1:47>ple <1:48,49>com<1:50,51>mon <1:52>ground."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "<1:1>God <1:2>is <1:3>our <1:4>Si<1:5>lence <1:6>when <1:7>no <1:8>songs <1:9>are <1:10>sung,",
          "<1:11>When <1:12>ec<1:13>sta<1:14>sy <1:15>or <1:16>sor<1:17>row <1:18>stills <1:19>the <1:20>tongue.",
          "<1:21>Glo<1:22>rious <1:23>the <1:24>faith <1:25>which <1:26>si<1:27>lent<1:28>ly <1:29>o<1:30>beys",
          "<1:31>Un<1:32>til <1:33>we <1:34>find <1:35>a<1:36>gain <1:37>the <1:38>voice <1:39>of <1:40>praise,",
          "<1:41>Un<1:42>til <1:43>we <1:44>find <1:45>a<1:46>gain <1:47>the <1:48,49>voice <1:50,51>of <1:52>praise."
        ]
      }
    ]
  },
  {
    "hymnNumber": 23,
    "reference": "SDAH023",
    "title": "Now the Joyful Bells A-Ringing",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>Now <1:2>the <1:3>joy<1:4>ful <1:5>bells <1:6>a-<1:7>ring<1:8>ing, ",
          "<1:9,10>All <1:11,12>ye <1:13>moun<1:14>tains <1:15>of <1:16>the <1:17>Lord!",
          "<1:18>Lift <1:19>our <1:20>hearts <1:21>like <1:22>birds <1:23>a-<1:24>wing<1:25>ing, ",
          "<1:26,27>All <1:28,29>ye <1:30>moun<1:31>tains, <1:32>praise <1:33>the <1:34>Lord!",
          "<1:35>Now <1:36>our <1:37>fes<1:38>tal <1:39>sea<1:40>son <1:41>bring<1:42>ing ",
          "<1:43,44>Kins<1:45>men <1:46,47>all <1:48>to <1:49>bide <1:50>and <1:51>board,",
          "<1:52>Sets <1:53>our <1:54>cheer<1:55>y <1:56>voic<1:57,58>es <1:59>sing<1:60>ing: ",
          "<1:61>All <1:62>ye <1:63>moun<1:64>tains, <1:65>praise <1:66>the <1:67>Lord!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>Dear <1:2>our <1:3>home <1:4>as <1:5>dear <1:6>none <1:7>oth<1:8>er; ",
          "<1:9,10>Where <1:11,12>the <1:13>moun<1:14>tains <1:15>praise <1:16>the <1:17>Lord!",
          "<1:18>Glad<1:19>ly <1:20>here <1:21>our <1:22>care <1:23>we <1:24>smoth<1:25>er; ",
          "<1:26,27>Where <1:28,29>the <1:30>moun<1:31>tains <1:32>praise <1:33>the <1:34>Lord!",
          "<1:35>Here <1:36>we <1:37>know <1:38>that <1:39>Christ <1:40>our <1:41>broth<1:42>er ",
          "<1:43,44>Binds <1:45>us <1:46,47>all <1:48>as <1:49>by <1:50>a <1:51>cord:",
          "<1:52>He <1:53>was <1:54>born <1:55>of <1:56>Ma<1:57,58>ry <1:59>moth<1:60>er ",
          "<1:61>Where <1:62>the <1:63>moun<1:64>tains <1:65>praise <1:66>the <1:67>Lord!"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>Cold <1:2>the <1:3>year, <1:4>new <1:5>white<1:6>ness <1:7>wear<1:8>ing, ",
          "<1:9,10>All <1:11,12>ye <1:13>moun<1:14>tains, <1:15>praise <1:16>the <1:17>Lord!",
          "<1:18>Peace, <1:19>good <1:20>will <1:21>to <1:22>us <1:23>a-<1:24>bear<1:25>ing, ",
          "<1:26,27>All <1:28,29>ye <1:30>moun<1:31>tains <1:32>praise <1:33>the <1:34>Lord!",
          "<1:35>Now <1:36>we <1:37>all <1:38>God's <1:39>good<1:40>ness <1:41>shar<1:42>ing ",
          "<1:43,44>Break <1:45>the <1:46,47>bread <1:48>and <1:49>sheath <1:50>the <1:51>sword:",
          "<1:52>Bright <1:53>our <1:54>hearts <1:55>the <1:56>sig<1:57,58>nal <1:59>flar<1:60>ing, ",
          "<1:61>All <1:62>ye <1:63>moun<1:64>tains, <1:65>praise <1:66>the <1:67>Lord!"
        ]
      }
    ]
  },
  {
    "hymnNumber": 24,
    "reference": "SDAH024",
    "title": "Every Star Shall Sing A Carol",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>Ev<1:2>ery <1:3>star <1:4>shall <1:5>sing <1:6>a <1:7>car<1:8>ol;",
          "<1:9>Ev<1:10>ery <1:11>crea<1:12,13>ture, <1:14>high <1:15,16>or <1:17>low,",
          "<1:18>Come <1:19>and <1:20>praise <1:21>the <1:22>King <1:23>of <1:24>heav<1:25>en",
          "<1:26>By <1:27>what<1:28>ev<1:29,30>er <1:31>name <1:32>you <1:33>know."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>When <1:2>the <1:3>King <1:4>of <1:5>all <1:6>cre<1:7>a<1:8>tion",
          "<1:9>Had <1:10>a <1:11>cra<1:12,13>dle <1:14>on <1:15,16>the <1:17>earth,",
          "<1:18>Ho<1:19>ly <1:20>was <1:21>the <1:22>hu<1:23>man <1:24>bod<1:25>y,",
          "<1:26>Ho<1:27>ly <1:28>was <1:29,30>the <1:31>hu<1:32>man <1:33>birth."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>Ev<1:2>ery <1:3>star <1:4>and <1:5>ev<1:6>ery <1:7>plan<1:8>et,",
          "<1:9>Ev<1:10>ery <1:11>crea<1:12,13>ture, <1:14>high <1:15,16>or <1:17>low,",
          "<1:18>Come <1:19>and <1:20>praise <1:21>the <1:22>King <1:23>of <1:24>heav<1:25>en",
          "<1:26>By <1:27>what<1:28>ev<1:29,30>er <1:31>name <1:32>you <1:33>know."
        ]
      }
    ],
    "chorus": [
      "<1:1>God <1:2>a<1:3>bove,",
      "<1:4>Man <1:5>be<1:6>low,",
      "<1:7>Ho<1:8>ly <1:9>is <1:10,11>the <1:12>name <1:13,14>I <1:15>know."
    ],
    "timestamps": {
      "chorus": 19.6035
    },
    "chorusMarker": {
      "track": 1,
      "index": 34
    }
  },
  {
    "hymnNumber": 25,
    "reference": "SDAH025",
    "title": "Praise the Lord, His Glories Show",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>Praise <1:2>the <1:3>Lord, <1:4>His <1:5>glo<1:6,7>ries <1:8>show,",
          "<1:9,10,11>Al<1:12,13>le<1:14>lu<1:15>ia!",
          "<1:16>Saints <1:17>with<1:18>in <1:19>His <1:20>courts <1:21,22>be<1:23>low,",
          "<1:24,25,26>Al<1:27,28>le<1:29>lu<1:30>ia!",
          "<1:31>An<1:32>gels <1:33>'round <1:34>His <1:35,36>throne <1:37,38>a<1:39>bove,",
          "<1:40,41,42>Al<1:43>le<1:44>lu<1:45>ia!",
          "<1:46>All <1:47>that <1:48>see <1:49>and <1:50>share <1:51,52>His <1:53>love.",
          "<1:54,55,56>Al<1:57,58>le<1:59>lu<1:60>ia!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>Earth <1:2>to <1:3>heaven <1:4>and <1:5>heaven <1:6,7>to <1:8>earth,",
          "<1:9,10,11>Al<1:12,13>le<1:14>lu<1:15>ia!",
          "<1:16>Tell <1:17>His <1:18>won<1:19>ders, <1:20>sing <1:21,22>His <1:23>worth,",
          "<1:24,25,26>Al<1:27,28>le<1:29>lu<1:30>ia!",
          "<1:31>Age <1:32>to <1:33>age <1:34>and <1:35,36>shore <1:37,38>to <1:39>shore,",
          "<1:40,41,42>Al<1:43>le<1:44>lu<1:45>ia!",
          "<1:46>Praise <1:47>Him, <1:48>praise <1:49>Him <1:50>ev<1:51,52>er<1:53>more!",
          "<1:54,55,56>Al<1:57,58>le<1:59>lu<1:60>ia!"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>Praise <1:2>the <1:3>Lord, <1:4>His <1:5>mer<1:6,7>cies <1:8>trace,",
          "<1:9,10,11>Al<1:12,13>le<1:14>lu<1:15>ia!",
          "<1:16>Praise <1:17>His <1:18>prov<1:19>i<1:20>dence <1:21,22>and <1:23>grace,",
          "<1:24,25,26>Al<1:27,28>le<1:29>lu<1:30>ia!",
          "<1:31>All <1:32>that <1:33>He <1:34>for <1:35,36>man <1:37,38>hath <1:39>done,",
          "<1:40,41,42>Al<1:43>le<1:44>lu<1:45>ia!",
          "<1:46>All <1:47>He <1:48>sends <1:49>us <1:50>through <1:51,52>His <1:53>Son.",
          "<1:54,55,56>Al<1:57,58>le<1:59>lu<1:60>ia!"
        ]
      }
    ]
  },
  {
    "hymnNumber": 26,
    "reference": "SDAH026",
    "title": "Praise the Lord! You Heavens Adore Him",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>Praise <1:2>the <1:3>Lord! <1:4>you <1:5>heavens <1:6>a<1:7,8>dore <1:9>Him;",
          "<1:10>Praise <1:11>Him, <1:12,13>an<1:14,15>gels <1:16>in <1:17>the <1:18>height;",
          "<1:19>Sun <1:20>and <1:21>moon, <1:22>re<1:23>joice <1:24>be<1:25,26>fore <1:27>Him,",
          "<1:28>Praise <1:29>Him, <1:30,31>all <1:32,33>you <1:34>stars <1:35>of <1:36>light.",
          "<1:37>Praise <1:38>the <1:39>Lord, <1:40>for <1:41>He <1:42>has <1:43,44>spo<1:45>ken;",
          "<1:46>Worlds <1:47>His <1:48>might<1:49>y <1:50>voice <1:51>o<1:52>beyed;",
          "<1:53>Laws <1:54>which <1:55>nev<1:56>er <1:57>shall <1:58>be <1:59,60>bro<1:61>ken",
          "<1:62>For <1:63>their <1:64,65>guid<1:66,67>ance <1:68>He <1:69>has <1:70>made."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>Praise <1:2>the <1:3>Lord! <1:4>for <1:5>He <1:6>is <1:7,8>glo<1:9>rious;",
          "<1:10>Nev<1:11>er <1:12,13>shall <1:14,15>His <1:16>prom<1:17>ise <1:18>fail.",
          "<1:19>God <1:20>has <1:21>made <1:22>His <1:23>saints <1:24>vic<1:25,26>to<1:27>rious;",
          "<1:28>Sin <1:29>and <1:30,31>death <1:32,33>shall <1:34>not <1:35>pre<1:36>vail.",
          "<1:37>Praise <1:38>the <1:39>God <1:40>of <1:41>our <1:42>sal<1:43,44>va<1:45>tion!",
          "<1:46>Hosts <1:47>on <1:48>high, <1:49>His <1:50>power <1:51>pro<1:52>claim;",
          "<1:53>Heaven <1:54>and <1:55>earth <1:56>and <1:57>all <1:58>cre<1:59,60>a<1:61>tion,",
          "<1:62>Laud <1:63>and <1:64,65>mag<1:66,67>ni<1:68>fy <1:69>His <1:70>name."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>Wor<1:2>ship, <1:3>hon<1:4>or, <1:5>glo<1:6>ry, <1:7,8>bless<1:9>ing,",
          "<1:10>Lord, <1:11>we <1:12,13>of<1:14,15>fer <1:16>as <1:17>our <1:18>gift.",
          "<1:19>Young <1:20>and <1:21>old, <1:22>Your <1:23>praise <1:24>ex<1:25,26>press<1:27>ing,",
          "<1:28>Our <1:29>glad <1:30,31>songs <1:32,33>to <1:34>You <1:35>we <1:36>lift.",
          "<1:37>All <1:38>the <1:39>saints <1:40>in <1:41>heav<1:42>en a<1:43,44>dore <1:45>You,",
          "<1:46>We <1:47>would <1:48>join <1:49>their <1:50>glad <1:51>ac<1:52>claim;",
          "<1:53>As <1:54>Your <1:55>an<1:56>gels <1:57>serve <1:58>be<1:59,60>fore <1:61>You,",
          "<1:62>So <1:63>on <1:64,65>earth <1:66,67>we <1:68>praise <1:69>Your <1:70>name."
        ]
      }
    ]
  },
  {
    "hymnNumber": 27,
    "reference": "SDAH027",
    "title": "Rejoice, Ye Pure in Heart!",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>Re<1:2>joice, <1:3,4>ye <1:5>pure <1:6>in <1:7>heart! ",
          "<1:8>Re<1:9>joice, <1:10,11>give <1:12>thanks, <1:13>and <1:14>sing; ",
          "<1:15>Your <1:16>fes<1:17,18>tal <1:19>ban<1:20>ner <1:21,22>wave <1:23,24>on <1:25>high, ",
          "<1:26>The <1:27>cross <1:28>of <1:29>Christ <1:30>your <1:31>King."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>With <1:2>voice <1:3,4>as <1:5>full <1:6>and <1:7>strong ",
          "<1:8>As <1:9>o<1:10,11>cean's <1:12>surg<1:13>ing <1:14>praise, ",
          "<1:15>Send <1:16>forth <1:17,18>the <1:19>stur<1:20>dy <1:21,22>hymns <1:23,24>of <1:25>old, ",
          "<1:26>The <1:27>psalms <1:28>of <1:29>an<1:30>cient <1:31>days."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>With <1:2>all <1:3,4>the <1:5>an<1:6>gel <1:7>choirs, ",
          "<1:8>With <1:9>all <1:10,11>the <1:12>saints <1:13>on <1:14>earth ",
          "<1:15>Pour <1:16>out <1:17,18>the <1:19>strains <1:20>of <1:21,22>joy <1:23,24>and <1:25>bliss, ",
          "<1:26>True <1:27>rap<1:28>ture, <1:29>no<1:30>blest <1:31>mirth."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "<1:1>Yes, <1:2>on <1:3,4>through <1:5>life's <1:6>long <1:7>path, ",
          "<1:8>Still <1:9>chant<1:10,11>ing <1:12>as <1:13>ye <1:14>go; ",
          "<1:15>From <1:16>youth <1:17,18>to <1:19>age, <1:20>by <1:21,22>night <1:23,24>and <1:25>day, ",
          "<1:26>In <1:27>glad<1:28>ness <1:29>and <1:30>in <1:31>woe."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "<1:1>Praise <1:2>Him <1:3,4>who <1:5>reigns <1:6>on <1:7>high, ",
          "<1:8>The <1:9>Lord <1:10,11>whom <1:12>we <1:13>a<1:14>dore ",
          "<1:15>The <1:16>Fa<1:17,18>ther, <1:19>Son, <1:20>and <1:21,22>Ho<1:23,24>ly <1:25>Ghost, ",
          "<1:26>One <1:27>God <1:28>for<1:29>ev<1:30>er<1:31>more."
        ]
      }
    ],
    "chorus": [
      "<1:1>Re<1:2>joice! ",
      "<1:3>Re<1:4>joice! ",
      "<1:5>Re<1:6>joice, <1:7,8>give <1:9>thanks, <1:10>and <1:11>sing!"
    ],
    "timestamps": {
      "chorus": 19.2423
    },
    "chorusMarker": {
      "track": 1,
      "index": 32
    }
  },
  {
    "hymnNumber": 28,
    "reference": "SDAH028",
    "title": "Praise We the Lord",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>Praise <1:2>we <1:3>the <1:4>Lord, <1:5>who <1:6>made <1:7>all <1:8,9>beau<1:10>ty",
          "<1:11>For <1:12>all <1:13>our <1:14>sens<1:15>es <1:16>to <1:17>en<1:18>joy;",
          "<1:19>Owe <1:20>we <1:21>our <1:22>hum<1:23>ble <1:24>thanks <1:25>and <1:26>du<1:27>ty",
          "<1:28>That <1:29>sim<1:30>ple <1:31>plea<1:32>sures <1:33>nev<1:34>er <1:35>cloy;",
          "<1:36>Praise <1:37>we <1:38>the <1:39>Lord, <1:40>who <1:41>made <1:42>all <1:43,44>beau<1:45>ty",
          "<1:46>For <1:47>all <1:48>our <1:49>sens<1:50>es <1:51>to <1:52>en<1:53>joy."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>Praise <1:2>Him <1:3>who <1:4>loves <1:5>to <1:6>see <1:7>young <1:8,9>lov<1:10>ers,",
          "<1:11>Fresh <1:12>hearts <1:13>that <1:14>swell <1:15>with <1:16>youth<1:17>ful <1:18>pride;",
          "<1:19>Thank <1:20>Him <1:21>who <1:22>sends <1:23>the <1:24>sun <1:25>a<1:26>bove <1:27>us,",
          "<1:28>As <1:29>bride<1:30>groom <1:31>fit <1:32>to <1:33>meet <1:34>his <1:35>bride;",
          "<1:36>Praise <1:37>Him <1:38>who <1:39>loves <1:40>to <1:41>see <1:42>young <1:43,44>lov<1:45>ers,",
          "<1:46>Fresh <1:47>hearts <1:48>that <1:49>swell <1:50>with <1:51>youth<1:52>ful <1:53>pride."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>Praise <1:2>Him <1:3>who <1:4>by <1:5>a <1:6>sim<1:7>ple <1:8,9>flow<1:10>er",
          "<1:11>Lifts <1:12>up <1:13>our <1:14>hearts <1:15>to <1:16>things <1:17>a<1:18>bove;",
          "<1:19>Thank <1:20>Him <1:21>who <1:22>gives <1:23>to <1:24>each <1:25>one <1:26>pow<1:27>er",
          "<1:28>To <1:29>find <1:30>a <1:31>friend <1:32>to <1:33>know <1:34>and <1:35>love;",
          "<1:36>Praise <1:37>Him <1:38>who <1:39>by <1:40>a <1:41>sim<1:42>ple <1:43,44>flow<1:45>er",
          "<1:46>Lifts <1:47>up <1:48>our <1:49>hearts <1:50>to <1:51>things <1:52>a<1:53>bove."
        ]
      }
    ]
  },
  {
    "hymnNumber": 29,
    "reference": "SDAH029",
    "title": "Sing Praise to God",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>Sing <1:2>praise <1:3>to <1:4>God <1:5>who <1:6>reigns <1:7>a<1:8>bove, ",
          "<1:9,10>The <1:11>God <1:12>of <1:13>all <1:14>cre<1:15,16>a<1:17>tion, ",
          "<1:18>The <1:19>God <1:20>of <1:21>power, <1:22>the <1:23>God <1:24>of <1:25>love, ",
          "<1:26,27>The <1:28>God <1:29>of <1:30>our <1:31,32>sal<1:33>va<1:34>tion ",
          "<1:35>With <1:36>heal<1:37>ing <1:38>balm <1:39>my <1:40>soul <1:41>He <1:42>fills, ",
          "<1:43>And <1:44>ev<1:45>ery <1:46>faith<1:47>less <1:48>mur<1:49>mur <1:50>stills; ",
          "<1:51>To <1:52>God <1:53>all <1:54>praise <1:55,56>and <1:57>glo<1:58>ry!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>What <1:2>God's <1:3>al<1:4>migh<1:5>ty <1:6>power <1:7>hath <1:8>made ",
          "<1:9,10>His <1:11>gra<1:12>cious <1:13>mer<1:14>cy <1:15,16>keep<1:17>eth; ",
          "<1:18>By <1:19>morn<1:20>ing <1:21>glow <1:22>or <1:23>eve<1:24>ning <1:25>shade, ",
          "<1:26,27>His <1:28>watch<1:29>ful <1:30>eye <1:31,32>ne'er <1:33>sleep<1:34>eth, ",
          "<1:35>With<1:36>in <1:37>the <1:38>king<1:39>dom <1:40>of <1:41>His <1:42>might, ",
          "<1:43>Lo! <1:44>all <1:45>is <1:46>just, <1:47>and <1:48>all <1:49>is <1:50>right: ",
          "<1:51>To <1:52>God <1:53>all <1:54>praise <1:55,56>and <1:57>glo<1:58>ry!"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>The <1:2>Lord <1:3>is <1:4>nev<1:5>er <1:6>far <1:7>a<1:8>way, ",
          "<1:9,10>Through<1:11>out <1:12>all <1:13>grief <1:14>dis<1:15,16>tress<1:17>ing ",
          "<1:18>An <1:19>ev<1:20>er<1:21>pres<1:22>ent <1:23>help <1:24>and <1:25>stay, ",
          "<1:26,27>Our <1:28>peace, <1:29>and <1:30>joy, <1:31,32>and <1:33>bless<1:34>ing. ",
          "<1:35>As <1:36>with <1:37>a <1:38>moth<1:39>er's <1:40>ten<1:41>der <1:42>hand, ",
          "<1:43>He <1:44>leads <1:45>His <1:46>own, <1:47>His <1:48>cho<1:49>sen <1:50>band; ",
          "<1:51>To <1:52>God <1:53>all <1:54>praise <1:55,56>and <1:57>glo<1:58>ry!"
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "<1:1>Then <1:2>all <1:3>my <1:4>glad<1:5>some <1:6>way <1:7>a<1:8>long, ",
          "<1:9,10>I <1:11>sing <1:12>a<1:13>loud <1:14>Thy <1:15,16>prais<1:17>es, ",
          "<1:18>That <1:19>men <1:20>may <1:21>hear <1:22>the <1:23>grate<1:24>ful <1:25>song ",
          "<1:26,27>My <1:28>voice <1:29>un<1:30>wea<1:31,32>ried <1:33>rais<1:34>es: ",
          "<1:35>Be <1:36>joy<1:37>ful <1:38>in <1:39>the <1:40>Lord, <1:41>my <1:42>heart! ",
          "<1:43>Both <1:44>soul <1:45>and <1:46>bod<1:47>y <1:48>bear <1:49>your <1:50>part! ",
          "<1:51>To <1:52>God <1:53>all <1:54>praise <1:55,56>and <1:57>glo<1:58>ry!"
        ]
      }
    ]
  },
  {
    "hymnNumber": 30,
    "reference": "SDAH030",
    "title": "Holy God, We Praise Your Name",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>Ho<1:2>ly <1:3,4>God, <1:5>we <1:6,7>praise <1:8>Your <1:9>name;",
          "<1:10>Lord <1:11>of <1:12,13>all, <1:14>we <1:15,16>bow <1:17>be<1:18>fore <1:19>You!",
          "<1:20>All <1:21>on <1:22,23>earth <1:24>Your <1:25,26>scep<1:27>ter <1:28>claim,",
          "<1:29>All <1:30>in <1:31>heav<1:32>en <1:33>a<1:34,35>bove <1:36>a<1:37>dore <1:38>You;",
          "<1:39>In<1:40>fi<1:41,42>nite <1:43>Your <1:44>vast <1:45>do<1:46>main.",
          "<1:47>Ev<1:48>er<1:49,50>la<1:51>sting <1:52,53>is <1:54>Your <1:55>reign."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>Hark! <1:2>the <1:3,4>loud <1:5>ce<1:6,7>les<1:8>tial <1:9>hymn",
          "<1:10>An<1:11>gel <1:12>choi<1:13>rs <1:14>a<1:15,16>bove <1:17>are <1:18>rais<1:19>ing,",
          "<1:20>Che<1:21>ru<1:22,23>bim <1:24>and <1:25,26>se<1:27>ra<1:28>phim,",
          "<1:29>In <1:30>un<1:31,32>ceas<1:33>ing <1:34,35>cho<1:36>rus <1:37>prais<1:38>ing;",
          "<1:39>Fill <1:40>the <1:41,42>heavens <1:43>with <1:44>sweet <1:45>ac<1:46>cord:",
          "<1:47>Ho<1:48>ly, <1:49,50>ho<1:51>ly, <1:52,53>ho<1:54>ly, <1:55>Lord."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>Ho<1:2>ly <1:3,4>Fa<1:5>ther, <1:6,7>Ho<1:8>ly <1:9>Son,",
          "<1:10>Ho<1:11>ly <1:12,13>Spi<1:14>rit, <1:15,16>three <1:17>we <1:18>name <1:19>You;",
          "<1:20>While <1:21>in <1:22,23>es<1:24>sence <1:25,26>on<1:27>ly <1:28>one,",
          "<1:29>Un<1:30>di<1:31,32>vi<1:33>ded <1:34,35>God <1:36>we <1:37>claim <1:38>You;",
          "<1:39>And <1:40>a<1:41,42>dor<1:43>ing <1:44>bend <1:45>the <1:46>knee,",
          "<1:47>While <1:48>we <1:49,50>own <1:51>the <1:52,53>mys<1:54>te<1:55>ry."
        ]
      }
    ]
  },
  {
    "hymnNumber": 31,
    "reference": "SDAH031",
    "title": "Tell Out My Soul",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>Tell <1:2>out, <1:3>my <1:4,5>soul, <1:6,7>the <1:8>great<1:9>ness <1:10>of <1:11>the <1:12>Lord:",
          "<1:13>Un<1:14>num<1:15>bered <1:16,17,18>bless<1:19>ings <1:20>give <1:21>my <1:22>spir<1:23>it <1:24>voice;",
          "<1:25>Ten<1:26>der <1:27>to <1:28>me <1:29>the <1:30>prom<1:31>ise <1:32>of <1:33,34>His <1:35>word;",
          "<1:36>In <1:37>God <1:38,39>my <1:40>Sav<1:41>ior <1:42>shall <1:43>my <1:44,45>heart <1:46>re<1:47>joice."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>Tell <1:2>out, <1:3>my <1:4,5>soul, <1:6,7>the <1:8>great<1:9>ness <1:10>of <1:11>His <1:12>name:",
          "<1:13>Make <1:14>known <1:15>His <1:16,17,18>might, <1:19>the <1:20>deeds <1:21>His <1:22>arm <1:23>has <1:24>done;",
          "<1:25>His <1:26>mer<1:27>cy <1:28>sure, <1:29>from <1:30>age <1:31>to <1:32>age <1:33,34>the <1:35>same;",
          "<1:36>His <1:37>ho<1:38,39>ly <1:40>name, <1:41>the <1:42>Lord, <1:43>the <1:44,45>Might<1:46>y <1:47>One."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>Tell <1:2>out, <1:3>my <1:4,5>soul, <1:6,7>the <1:8>great<1:9>ness <1:10>of <1:11>His <1:12>might:",
          "<1:13>Pow'rs <1:14>and <1:15>do<1:16,17,18>min<1:19>ions <1:20>lay <1:21>their <1:22>glo<1:23>ry <1:24>by;",
          "<1:25>Proud <1:26>hearts <1:27>and <1:28>stub<1:29>born <1:30>wills <1:31>are <1:32>put <1:33,34>to <1:35>flight,",
          "<1:36>The <1:37>hun<1:38,39>gry <1:40>fed, <1:41>the <1:42>hum<1:43>ble <1:44,45>lift<1:46>ed <1:47>high."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "<1:1>Tell <1:2>out, <1:3>my <1:4,5>soul, <1:6,7>the <1:8>glo<1:9>ries <1:10>of <1:11>His <1:12>word:",
          "<1:13>Firm <1:14>is <1:15>His <1:16,17,18>prom<1:19>ise, <1:20>and <1:21>His <1:22>mer<1:23>cy <1:24>sure.",
          "<1:25>Tell <1:26>out, <1:27>my <1:28>soul, <1:29>the <1:30>great<1:31>ness <1:32>of <1:33,34>the <1:35>Lord",
          "<1:36>To <1:37>chil<1:38,39>dren's <1:40>chil<1:41>dren <1:42>and <1:43>for<1:44,45>ev<1:46>er <1:47>more."
        ]
      }
    ]
  },
  {
    "hymnNumber": 32,
    "reference": "SDAH032",
    "title": "When in Our Music God Is Glorified",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1,2>When <1:3>in <1:4>our <1:5>mu<1:6>sic <1:7>God <1:8>is <1:9>glo<1:10>ri<1:11,12,13>fied,",
          "<1:14>And <1:15>ad<1:16>o<1:17>ra<1:18,19>tion <1:20>leaves <1:21>no <1:22>room <1:23>for <1:24>pride,",
          "<1:25>It <1:26>is <1:27>as <1:28>though <1:29>the <1:30>whole <1:31>cre<1:32>a<1:33>tion <1:34>cried:",
          "<1:35,36,37,38>Al<1:39>le<1:40,41>lu<1:42>ia!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1,2>How <1:3>oft, <1:4>in <1:5>mak<1:6>ing <1:7>mu<1:8>sic, <1:9>we <1:10>have <1:11,12,13>found",
          "<1:14>A <1:15>new <1:16>di<1:17>men<1:18,19>sion <1:20>in <1:21>the <1:22>world <1:23>of <1:24>sound,",
          "<1:25>As <1:26>wor<1:27>ship <1:28>moved <1:29>us <1:30>to <1:31>a <1:32>more <1:33>pro<1:34>found",
          "<1:35,36,37,38>Al<1:39>le<1:40,41>lu<1:42>ia!"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1,2>And <1:3>did <1:4>not <1:5>Je<1:6>sus <1:7>sing <1:8>a <1:9>psalm <1:10>that <1:11,12,13>night",
          "<1:14>When <1:15>ut<1:16>most <1:17>e<1:18,19>vil <1:20>strove <1:21>a<1:22>gainst <1:23>the <1:24>light?",
          "<1:25>Then <1:26>let <1:27>us <1:28>sing <1:29>for <1:30>whom <1:31>He <1:32>won <1:33>the <1:34>fight:",
          "<1:35,36,37,38>Al<1:39>le<1:40,41>lu<1:42>ia!"
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "<1:1,2>Let <1:3>ev<1:4>ery <1:5>in<1:6>stru<1:7>ment <1:8>be <1:9>used <1:10>for <1:11,12,13>praise;",
          "<1:14>Let <1:15>all <1:16>re<1:17>joice <1:18,19>who <1:20>have <1:21>a <1:22>voice <1:23>to <1:24>raise;",
          "<1:25>And <1:26>may <1:27>God <1:28>give <1:29>us <1:30>faith <1:31>to <1:32>sing <1:33>al<1:34>ways:",
          "<1:35,36,37,38>Al<1:39>le<1:40,41>lu<1:42>ia!"
        ]
      }
    ]
  },
  {
    "hymnNumber": 33,
    "reference": "SDAH033",
    "title": "Sing A New Song to the Lord",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>Sing <1:2>a <1:3>new <1:4>song <1:5>to <1:6>the <1:7,8>Lord,",
          "<1:9>He <1:10>to <1:11>whom <1:12>won<1:13>ders <1:14>be<1:15,16>long.",
          "<1:17>Re<1:18,19>joice <1:20>in <1:21>His <1:22>tri<1:23>umph <1:24>and <1:25,26>tell <1:27>of <1:28>His <1:29,30>power.",
          "<1:31>O <1:32,33>sing <1:34>a <1:35>new <1:36,37>song <1:38>to <1:39>the <1:40,41>Lord."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>Now <1:2>to <1:3>the <1:4>ends <1:5>of <1:6>the <1:7,8>earth",
          "<1:9>See <1:10>His <1:11>sal<1:12>va<1:13>tion <1:14>is <1:15,16>shown.",
          "<1:17>And <1:18,19>still <1:20>He <1:21>re<1:22>mem<1:23>bers <1:24>His <1:25,26>mer<1:27>cy <1:28>and <1:29,30>truth,",
          "<1:31>Un<1:32,33>chang<1:34>ing <1:35>in <1:36,37>love <1:38>to <1:39>His <1:40,41>own."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>Sing <1:2>a <1:3>new <1:4>song <1:5>and <1:6>re<1:7,8>joice.",
          "<1:9>Pub<1:10>lish <1:11>His <1:12>prais<1:13>es <1:14>a<1:15,16>broad.",
          "<1:17>Let <1:18,19>voic<1:20>es <1:21>in <1:22>cho<1:23>rus <1:24>with <1:25,26>trum<1:27>pet <1:28>and <1:29,30>horn,",
          "<1:31>Re<1:32,33>sound <1:34>for <1:35>the <1:36,37>joy <1:38>of <1:39>the <1:40,41>Lord."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "<1:1>Join <1:2>with <1:3>the <1:4>hills <1:5>and <1:6>the <1:7,8>sea,",
          "<1:9>Thun<1:10>ders <1:11>of <1:12>praise <1:13>to <1:14>pro<1:15,16>long.",
          "<1:17>In <1:18,19>judg<1:20>ment <1:21>and <1:22>jus<1:23>tice",
          "<1:24>He <1:25,26>comes <1:27>to <1:28>the <1:29,30>earth.",
          "<1:31>O <1:32,33>sing <1:34>a <1:35>new <1:36,37>song <1:38>to <1:39>the <1:40,41>Lord."
        ]
      }
    ]
  },
  {
    "hymnNumber": 34,
    "reference": "SDAH034",
    "title": "Wake the Song",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>Wake <1:2>the <1:3>song <1:4>of <1:5>joy <1:6>and <1:7,8>glad<1:9>ness;",
          "<1:10>Hith<1:11>er <1:12>bring <1:13>your <1:14>no<1:15>blest <1:16>lays;",
          "<1:17>Ban<1:18>ish <1:19>ev<1:20>ery <1:21>thought <1:22>of <1:23,24>sad<1:25>ness,",
          "<1:26>Pour<1:27>ing <1:28>forth <1:29>your <1:30>high<1:31>est <1:32>praise.",
          "<1:33>Sing <1:34>to <1:35>Him <1:36>whose <1:37>care <1:38>has <1:39>brought <1:40>us",
          "<1:41>Once <1:42>a<1:43>gain <1:44>with <1:45>friends <1:46>to <1:47>meet,",
          "<1:48>And <1:49>whose <1:50>lov<1:51>ing <1:52>voice <1:53>has <1:54>taught <1:55>us",
          "<1:56>Of <1:57>the <1:58>way <1:59>to <1:60>Je<1:61>sus' <1:62>feet."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>Joy<1:2>ful<1:3>ly <1:4>with <1:5>songs <1:6>and <1:7,8>ban<1:9>ners,",
          "<1:10>We <1:11>will <1:12>greet <1:13>the <1:14>fes<1:15>tal <1:16>day;",
          "<1:17>Shout <1:18>a<1:19>loud <1:20>our <1:21>glad <1:22>ho<1:23,24>san<1:25>nas,",
          "<1:26>And <1:27>our <1:28>grate<1:29>ful <1:30>hom<1:31>age <1:32>pay.",
          "<1:33>We <1:34>will <1:35>chant <1:36>our <1:37>Sav<1:38>ior's <1:39>glo<1:40>ry",
          "<1:41>While <1:42>our <1:43>thoughts <1:44>we <1:45>raise <1:46>a<1:47>bove,",
          "<1:48>Tell<1:49>ing <1:50>still <1:51>\"the <1:52>old, <1:53>old <1:54>sto<1:55>ry,\"",
          "<1:56>Pre<1:57>cious <1:58>theme <1:59>re<1:60>deem<1:61>ing <1:62>love!"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>Thanks <1:2>to <1:3>Thee, <1:4>O <1:5>ho<1:6>ly <1:7,8>Fa<1:9>ther,",
          "<1:10>For <1:11>the <1:12>mer<1:13>cies <1:14>of <1:15>the <1:16>year;",
          "<1:17>May <1:18>each <1:19>heart, <1:20>as <1:21>here <1:22>we <1:23,24>gath<1:25>er,",
          "<1:26>Swell <1:27>with <1:28>grat<1:29>i<1:30>tude <1:31>sin<1:32>cere.",
          "<1:33>Thanks <1:34>to <1:35>Thee, <1:36>O <1:37>lov<1:38>ing <1:39>Sav<1:40>ior,",
          "<1:41>For <1:42>re<1:43>demp<1:44>tion <1:45>through <1:46>Thy <1:47>blood.",
          "<1:48>Breathe <1:49>up<1:50>on <1:51>us, <1:52>Ho<1:53>ly <1:54>Spir<1:55>it,",
          "<1:56>Sweet<1:57>ly <1:58>draw <1:59>us <1:60>near <1:61>to <1:62>God."
        ]
      }
    ],
    "chorus": [
      "<1:1>Wake <1:2>the <1:3>song, <1:7>wake <1:8>the <1:9>song,",
      "<1:10>The <1:11>song <1:12>of <1:13>joy <1:14>and <1:15>glad<1:16>ness,",
      "<1:17>Wake <1:18>the <1:19>song, <1:20>wake <1:21>the <1:22>song,",
      "<1:23>The <1:24>song <1:25>of <1:26>Ju<1:27>bi<1:28>lee."
    ],
    "timestamps": {
      "chorus": 39.6866
    },
    "chorusMarker": {
      "track": 1,
      "index": 63
    }
  },
  {
    "hymnNumber": 35,
    "reference": "SDAH035",
    "title": "With Songs and Honors",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>With <1:2>songs <1:3>and <1:4>hon<1:5>ors <1:6,7>sound<1:8>ing <1:9>loud, ",
          "<1:10>Ad<1:11>dress <1:12>the <1:13>Lord <1:14,15>on <1:16>high; ",
          "<1:17>O<1:18>ver <1:19>the <1:20>heavens <1:21>He <1:22,23>spreads <1:24>His <1:25>cloud, ",
          "<1:26>And <1:27>wa<1:28>ters <1:29>veil <1:30>the <1:31>sky."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>He <1:2>sends <1:3>His <1:4>showers <1:5>of <1:6,7>bless<1:8>ing <1:9>down ",
          "<1:10>To <1:11>cheer <1:12>the <1:13>plains <1:14,15>be<1:16>low; ",
          "<1:17>He <1:18>makes <1:19>the <1:20>grass <1:21>the <1:22,23>moun<1:24>tains <1:25>crown, ",
          "<1:26>And <1:27>corn <1:28>in <1:29>val<1:30>leys <1:31>grow."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>His <1:2>stead<1:3>y <1:4>coun<1:5>sels <1:6,7>change <1:8>the <1:9>face ",
          "<1:10>Of <1:11>the <1:12>de<1:13>clin<1:14,15>ing <1:16>year; ",
          "<1:17>He <1:18>bids <1:19>the <1:20>sun <1:21>cut <1:22,23>short <1:24>his <1:25>race, ",
          "<1:26>And <1:27>win<1:28>try <1:29>days <1:30>ap<1:31>pear."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "<1:1>He <1:2>sends <1:3>His <1:4>word, <1:5>and <1:6,7>melts <1:8>the <1:9>snow; ",
          "<1:10>The <1:11>fields <1:12>no <1:13>lon<1:14,15>ger <1:16>mourn; ",
          "<1:17>He <1:18>calls <1:19>the <1:20>warm<1:21>er <1:22,23>gales <1:24>to <1:25>blow, ",
          "<1:26>And <1:27>bids <1:28>the <1:29>spring <1:30>re<1:31>turn."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "<1:1>The <1:2>chang<1:3>ing <1:4>wind, <1:5>the <1:6,7>fly<1:8>ing <1:9>cloud, ",
          "<1:10>O<1:11>bey <1:12>His <1:13>might<1:14,15>y <1:16>word: ",
          "<1:17>With <1:18>songs <1:19>and <1:20>hon<1:21>ors <1:22,23>sound<1:24>ing <1:25>loud ",
          "<1:26>Praise <1:27>ye <1:28>the <1:29>sov<1:30>ereign <1:31>Lord!"
        ]
      }
    ]
  },
  {
    "hymnNumber": 36,
    "reference": "SDAH036",
    "title": "O Thou in Whose Presence",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>O <1:2,3>Thou <1:4>in <1:5>whose <1:6,7>pres<1:8>ence <1:9>my <1:10>soul <1:11>takes <1:12>de<1:13>light,",
          "<1:14>On <1:15>whom <1:16>in <1:17>af<1:18>flic<1:19>tion <1:20>I <1:21>call,",
          "<1:22>My <1:23>com<1:24>fort <1:25>by <1:26>day <1:27>and <1:28>my <1:29>song <1:30>in <1:31>the <1:32>night,",
          "<1:33,34>My <1:35,36>hope, <1:37>my <1:38>sal<1:39>va<1:40>tion, <1:41>my <1:42>all!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>His <1:2,3>voice, <1:4>as <1:5>the <1:6,7>sound <1:8>of <1:9>the <1:10>dul<1:11>ci<1:12>mer <1:13>sweet,",
          "<1:14>Is <1:15>heard <1:16>through <1:17>the <1:18>shad<1:19>ows <1:20>of <1:21>death;",
          "<1:22>The <1:23>ce<1:24>dars <1:25>of <1:26>Leb<1:27>a<1:28>non <1:29>bow <1:30>at <1:31>His <1:32>feet,",
          "<1:33,34>The <1:35,36>air <1:37>is <1:38>per<1:39>fumed <1:40>with <1:41>His <1:42>breath."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>His <1:2,3>lips, <1:4>as <1:5>a <1:6,7>foun<1:8>tain <1:9>of <1:10>righ<1:11>teous<1:12>ness <1:13>flow,",
          "<1:14>To <1:15>wa<1:16>ter <1:17>the <1:18>gar<1:19>dens <1:20>of <1:21>grace;",
          "<1:22>From <1:23>which <1:24>their <1:25>sal<1:26>va<1:27>tion <1:28>the <1:29>Gen<1:30>tiles <1:31>shall <1:32>know,",
          "<1:33,34>And <1:35,36>bask <1:37>in <1:38>the <1:39>smiles <1:40>of <1:41>His <1:42>face."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "<1:1>He <1:2,3>looks, <1:4>and <1:5>ten <1:6,7>thou<1:8>sands <1:9>of <1:10>an<1:11>gels <1:12>re<1:13>joice,",
          "<1:14>And <1:15>myr<1:16>i<1:17>ads <1:18>wait <1:19>for <1:20>His <1:21>word;",
          "<1:22>He <1:23>speaks, <1:24>and <1:25>e<1:26>ter<1:27>ni<1:28>ty, <1:29>filled <1:30>with <1:31>His <1:32>voice,",
          "<1:33,34>Re<1:35,36>-ech<1:37>oes <1:38>the <1:39>praise <1:40>of <1:41>the <1:42>Lord."
        ]
      }
    ]
  },
  {
    "hymnNumber": 37,
    "reference": "SDAH037",
    "title": "O Sing, My Soul, Your Maker's Praise",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>O <1:2>sing <1:3>my <1:4>soul, <1:5,6>your <1:7,8>Ma<1:9>ker's <1:10>praise",
          "<1:11>In <1:12>grate<1:13>ful <1:14>hymns <1:15>as<1:16>cend<1:17>ing;",
          "<1:18>Whose <1:19>stead<1:20>fast <1:21>love <1:22,23>has <1:24,25>crowned <1:26>your <1:27>days",
          "<1:28>With <1:29>heav'n<1:30>ly <1:31>gifts <1:32>un<1:33>end<1:34>ing.",
          "<1:35>I <1:36>sought <1:37>the <1:38,39>Lord, <1:40>He <1:41,42>heard <1:43>my <1:44>cry; ",
          "<1:45>His <1:46>ho<1:47>ly <1:48>an<1:49>gels <1:50>hov<1:51>er <1:52>nigh ",
          "<1:53>The <1:54>tents <1:55>of <1:56>those <1:57>who <1:58>love <1:59>Him."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>The <1:2>Lord <1:3>is <1:4>good <1:5,6>to <1:7,8>those <1:9>who <1:10>seek",
          "<1:11>His <1:12>face <1:13>in <1:14>time <1:15>of <1:16>sor<1:17>row,",
          "<1:18>Pro<1:19>vid<1:20>ing <1:21>com<1:22,23>fort <1:24,25>to <1:26>the <1:27>weak",
          "<1:28>And <1:29>grace <1:30>for <1:31>each <1:32>to<1:33>mor<1:34>row.",
          "<1:35>Though <1:36>grief <1:37>may <1:38,39>tar<1:40>ry <1:41,42>for <1:43>a <1:44>night, ",
          "<1:45>The <1:46>morn <1:47>shall <1:48>break <1:49>in <1:50>joy <1:51>and <1:52>light ",
          "<1:53>With <1:54>bless<1:55>ings <1:56>from <1:57>His <1:58>pres<1:59>ence."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>The <1:2>Lord <1:3>will <1:4>turn <1:5,6>His <1:7,8>face <1:9>in <1:10>peace",
          "<1:11>When <1:12>trou<1:13>bled <1:14>souls <1:15>draw <1:16>near <1:17>Him;",
          "<1:18>His <1:19>lov<1:20>ing<1:21>kind<1:22,23>ness <1:24,25>shall <1:26>not <1:27>cease",
          "<1:28>To <1:29>those <1:30>who <1:31>trust <1:32>and <1:33>fear <1:34>Him.",
          "<1:35>Our <1:36>God <1:37>will <1:38,39>not <1:40>for<1:41,42>sake <1:43>His <1:44>own; ",
          "<1:45>E<1:46>ter<1:47>nal <1:48>is <1:49>His <1:50>heav'n<1:51>ly <1:52>throne; ",
          "<1:53>His <1:54>king<1:55>dom <1:56>stands <1:57>for<1:58>ev<1:59>er."
        ]
      }
    ]
  },
  {
    "hymnNumber": 38,
    "reference": "SDAH038",
    "title": "Arise My Soul Arise",
    "hasMidi": true,
    "numberOfVerses": 2,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>A<1:2>rise, <1:3>my <1:4>soul, <1:5>a<1:6>rise! ",
          "<1:7>Stretch <1:8>forth <1:9>to <1:10>things <1:11>e<1:12>ter<1:13>nal ",
          "<1:14,15>And <1:16>has<1:17>ten <1:18>to <1:19>the <1:20>feet <1:21>of <1:22>your <1:23>Re<1:24>deem<1:25>er <1:26>God. ",
          "<1:27>Though <1:28>hid <1:29>from <1:30>mor<1:31>tal <1:32>eyes, ",
          "<1:33>He <1:34>dwells <1:35>in <1:36>light <1:37>su<1:38>per<1:39>nal; ",
          "<1:40,41>Yet <1:42>wor<1:43>ship <1:44>Him <1:45>in <1:46>hum<1:47>ble<1:48>ness <1:49>and <1:50>call <1:51>Him <1:52>Lord. ",
          "<1:53,54>His <1:55>ban<1:56>quet <1:57>of <1:58>love ",
          "<1:59>A<1:60>waits <1:61>you <1:62>a<1:63>bove; ",
          "<1:64,65>Yet <1:66>here <1:67>He <1:68>grants <1:69>a <1:70>fore<1:71>taste <1:72>of <1:73>the <1:74>feast <1:75>to <1:76>come! ",
          "<1:77>Re<1:78>joice, <1:79>my <1:80>soul, <1:81>re<1:82>joice, ",
          "<1:83>To <1:84>heav'n <1:85>lift <1:86>up <1:87>your <1:88>voice: ",
          "<1:89>Al<1:90>le<1:91>lu<1:92>ia, <1:93>al<1:94>le<1:95>lu<1:96>ia, <1:97>al<1:98>le<1:99,100>lu<1:101>ia!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>Now <1:2>hear <1:3>the <1:4>harps <1:5>of <1:6>heav'n! ",
          "<1:7>Oh, <1:8>hear <1:9>the <1:10>song <1:11>vic<1:12>to<1:13>rious, ",
          "<1:14,15>The <1:16>nev<1:17>er-<1:18>end<1:19>ing <1:20>an<1:21>them <1:22>sound<1:23>ing <1:24>through <1:25>the <1:26>sky! ",
          "<1:27>To <1:28>mor<1:29>tals <1:30>is <1:31>not <1:32>giv'n ",
          "<1:33>To <1:34>join <1:35>in <1:36>strains <1:37>so <1:38>glo<1:39>rious; ",
          "<1:40,41>Yet <1:42>here <1:43>on <1:44>earth <1:45>we <1:46>too <1:47>can <1:48>sing <1:49>our <1:50>prais<1:51>es <1:52>high! ",
          "<1:53,54>He <1:55>bought <1:56>with <1:57>His <1:58>blood ",
          "<1:59>The <1:60>ran<1:61>somed <1:62>of <1:63>God; ",
          "<1:64,65>To <1:66>Him <1:67>be <1:68>ev<1:69>er <1:70>last<1:71>ing <1:72>pow'r <1:73>and <1:74>vic<1:75>to<1:76>ry. ",
          "<1:77>And <1:78>let <1:79>the <1:80>great <1:81>a<1:82>men ",
          "<1:83>Re<1:84>sound <1:85>through <1:86>heav'n <1:87>a<1:88>gain. ",
          "<1:89>Al<1:90>le<1:91>lu<1:92>ia, <1:93>al<1:94>le<1:95>lu<1:96>ia, <1:97>al<1:98>le<1:99,100>lu<1:101>ia!"
        ]
      }
    ]
  },
  {
    "hymnNumber": 39,
    "reference": "SDAH039",
    "title": "Lord, in the Morning",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>Lord, <1:2>in <1:3>the <1:4>morn<1:5>ing <1:6>Thou <1:7>shalt <1:8>hear",
          "<1:9>My <1:10>voice <1:11>as<1:12>cend<1:13>ing <1:14>high;",
          "<1:15>To <1:16>Thee <1:17>will <1:18>I <1:19>di<1:20>rect <1:21>my <1:22>prayer,",
          "<1:23>To <1:24>Thee <1:25>lift <1:26>up <1:27>mine <1:28>eye;"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>Up <1:2>to <1:3>the <1:4>hills <1:5>where <1:6>Christ <1:7>is <1:8>gone",
          "<1:9>To <1:10>plead <1:11>for <1:12>all <1:13>His <1:14>saints,",
          "<1:15>Pre<1:16>sent<1:17>ing <1:18>at <1:19>His <1:20>Fa<1:21>ther's <1:22>throne",
          "<1:23>Our <1:24>songs <1:25>and <1:26>our <1:27>com<1:28>plaints."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>O <1:2>may <1:3>Thy <1:4>Spir<1:5>it <1:6>guide <1:7>my <1:8>feet",
          "<1:9>In <1:10>ways <1:11>of <1:12>righ<1:13>teous<1:14>ness;",
          "<1:15>Make <1:16>ev<1:17>ery <1:18>path <1:19>of <1:20>du<1:21>ty <1:22>straight",
          "<1:23>And <1:24>plain <1:25>be<1:26>fore <1:27>my <1:28>face."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "<1:1>The <1:2>men <1:3>that <1:4>love <1:5>and <1:6>fear <1:7>Thy <1:8>name",
          "<1:9>Shall <1:10>see <1:11>their <1:12>hopes <1:13>ful<1:14>filled;",
          "<1:15>The <1:16>might<1:17>y <1:18>God <1:19>will <1:20>com<1:21>pass <1:22>them",
          "<1:23>With <1:24>fa<1:25>vor <1:26>as <1:27>a <1:28>shield."
        ]
      }
    ]
  },
  {
    "hymnNumber": 40,
    "reference": "SDAH040",
    "title": "The  Dawn of God's Dear Sabbath",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>The <1:2>dawn <1:3>of <1:4>God's <1:5>dear <1:6>Sab<1:7>bath",
          "<1:8>Breaks <1:9>o'er <1:10>the <1:11>earth <1:12>a<1:13>gain,",
          "<1:14>As <1:15>some <1:16>sweet <1:17>sum<1:18>mer <1:19>morn<1:20>ing",
          "<1:21>Af<1:22>ter <1:23>a <1:24>night <1:25>of <1:26>pain;",
          "<1:27>It <1:28>comes <1:29>as <1:30>cool<1:31>ing <1:32>show<1:33>ers",
          "<1:34>To <1:35>some <1:36>ex<1:37>haust<1:38>ed <1:39>land,",
          "<1:40>As <1:41>shade <1:42>of <1:43>clus<1:44>tered <1:45>palm <1:46>trees",
          "<1:47>'Mid <1:48>wea<1:49>ry <1:50>wastes <1:51>of <1:52>sand."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>Lord, <1:2>we <1:3>would <1:4>bring <1:5>for <1:6>of<1:7>fering,",
          "<1:8>Though <1:9>marred <1:10>with <1:11>earth<1:12>ly <1:13>soil,",
          "<1:14>A <1:15>week <1:16>of <1:17>ear<1:18>nest <1:19>la<1:20>bor,",
          "<1:21>Of <1:22>stead<1:23>y, <1:24>faith<1:25>ful <1:26>toil,",
          "<1:27>Fair <1:28>fruits <1:29>of <1:30>self-<1:31>de<1:32>ni<1:33>al,",
          "<1:34>Of <1:35>strong, <1:36>deep <1:37>love <1:38>to <1:39>Thee,",
          "<1:40>Fos<1:41>tered <1:42>by <1:43>Thine <1:44>own <1:45>Spir<1:46>it,",
          "<1:47>In <1:48>true <1:49>hu<1:50>mil<1:51>i<1:52>ty."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>And <1:2>we <1:3>would <1:4>bring <1:5>our <1:6>bur<1:7>den",
          "<1:8>Of <1:9>sin<1:10>ful <1:11>thought <1:12>and <1:13>deed,",
          "<1:14>In <1:15>Thy <1:16>pure <1:17>pres<1:18>ence <1:19>kneel<1:20>ing,",
          "<1:21>From <1:22>bond<1:23>age <1:24>to <1:25>be <1:26>freed,",
          "<1:27>Our <1:28>heart's <1:29>most <1:30>bit<1:31>ter <1:32>sor<1:33>row",
          "<1:34>For <1:35>all <1:36>Thy <1:37>work <1:38>un<1:39>done;",
          "<1:40>So <1:41>ma<1:42>ny <1:43>tal<1:44>ents <1:45>wast<1:46>ed!",
          "<1:47>So <1:48>few <1:49>bright <1:50>lau<1:51>rels <1:52>won!"
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "<1:1>And <1:2>with <1:3>that <1:4>sor<1:5>row <1:6>min<1:7>gling,",
          "<1:8>A <1:9>stead<1:10>fast <1:11>faith, <1:12>and <1:13>sure,",
          "<1:14>And <1:15>love <1:16>so <1:17>deep <1:18>and <1:19>fer<1:20>vent,",
          "<1:21>For <1:22>Thee <1:23>to <1:24>make <1:25>it <1:26>pure,",
          "<1:27>In <1:28>Thy <1:29>dear <1:30>pres<1:31>ence <1:32>find<1:33>ing",
          "<1:34>The <1:35>par<1:36>don <1:37>that <1:38>we <1:39>need,",
          "<1:40>And <1:41>then <1:42>the <1:43>peace <1:44>so <1:45>last<1:46>ing",
          "<1:47>Ce<1:48>les<1:49>tial <1:50>peace <1:51>in<1:52>deed."
        ]
      }
    ]
  },
  {
    "hymnNumber": 41,
    "reference": "SDAH041",
    "title": "O Splendor of God's Glory Bright",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>O <1:2>splen<1:3>dor <1:4>of <1:5,6>God's <1:7>glo<1:8>ry <1:9,10,11>bright,",
          "<1:12>From <1:13>light <1:14>e<1:15>ter<1:16>nal <1:17,18>bring<1:19,20>ing <1:21>light;",
          "<1:22>O <1:23>Light <1:24>of <1:25>life, <1:26>light's <1:27>liv<1:28>ing <1:29>spring,",
          "<1:30,31>True <1:32,33>day, <1:34,35>all <1:36>days <1:37>il<1:38>lu<1:39>min<1:40>ing."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>O <1:2>Thou <1:3>true <1:4>Sun, <1:5,6>on <1:7>us <1:8>Thy <1:9,10,11>glance",
          "<1:12>Let <1:13>fall <1:14>in <1:15>roy<1:16>al <1:17,18>ra<1:19,20>di<1:21>ance;",
          "<1:22>The <1:23>Spir<1:24>it's <1:25>sanc<1:26>ti<1:27>fy<1:28>ing <1:29>beam",
          "<1:30,31>Up<1:32,33>on <1:34,35>our <1:36>earth<1:37>ly <1:38>sens<1:39>es <1:40>stream."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>O <1:2>joy<1:3>ful <1:4>be <1:5,6>the <1:7>pass<1:8>ing <1:9,10,11>day",
          "<1:12>With <1:13>thoughts <1:14>as <1:15>clear <1:16>as <1:17,18>morn<1:19,20>ing's <1:21>ray,",
          "<1:22>With <1:23>faith <1:24>like <1:25>noon<1:26>tide <1:27>shin<1:28>ing <1:29>bright,",
          "<1:30,31>Our <1:32,33>souls <1:34,35>un<1:36>shad<1:37>owed <1:38>by <1:39>the <1:40>night."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "<1:1>Dawn's <1:2>glo<1:3>ry <1:4>gilds <1:5,6>the <1:7>earth <1:8>and <1:9,10,11>skies;",
          "<1:12>Let <1:13>Him, <1:14>our <1:15>per<1:16>fect <1:17,18>morn, <1:19,20>a<1:21>rise;",
          "<1:22>The <1:23>Fa<1:24>ther's <1:25>help <1:26>His <1:27>chil<1:28>dren <1:29>claim,",
          "<1:30,31>And <1:32,33>sing <1:34,35>the <1:36>Fa<1:37>ther's <1:38>glo<1:39>rious <1:40>name. <1:41,42,43,44,45,46>A<1:47>men."
        ]
      }
    ]
  },
  {
    "hymnNumber": 42,
    "reference": "SDAH042",
    "title": "Now That the Daylight Fills the Sky",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1,2>Now <1:3>that <1:4>the <1:5>day<1:6,7>light <1:8>fills <1:9>the <1:10>sky,",
          "<1:11,12>We <1:13>lift <1:14>our <1:15>hearts <1:16,17>to <1:18>God <1:19>on <1:20>high,",
          "<1:21>That <1:22>He, <1:23>in <1:24>all <1:25>we <1:26>do <1:27>or <1:28>say,",
          "<1:29,30>Would <1:31>keep <1:32>us <1:33>free <1:34>from <1:35>harm <1:36>to<1:37>day;"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1,2>Would <1:3>guard <1:4>our <1:5>hearts <1:6,7>and <1:8>tongues <1:9>from <1:10>strife;",
          "<1:11,12>From <1:13>an<1:14>ger's <1:15>din <1:16,17>would <1:18>shield <1:19>our <1:20>life;",
          "<1:21>From <1:22>e<1:23>vil <1:24>sights <1:25>would <1:26>turn <1:27>our <1:28>eyes,",
          "<1:29,30>And <1:31>close <1:32>our <1:33>ears <1:34>to <1:35>van<1:36>i<1:37>ties;"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1,2>So <1:3>we, <1:4>when <1:5>this <1:6,7>new <1:8>day <1:9>is <1:10>gone",
          "<1:11,12>And <1:13>night <1:14>in <1:15>turn <1:16,17>is <1:18>draw<1:19>ing <1:20>on,",
          "<1:21>With <1:22>con<1:23>science <1:24>by <1:25>the <1:26>world <1:27>un<1:28>stained",
          "<1:29,30>Shall <1:31>praise <1:32>His <1:33>name <1:34>for <1:35>vic<1:36>t'ry <1:37>gained."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "<1:1,2>\"All <1:3>praise <1:4>to <1:5>You, <1:6,7>cre<1:8>a<1:9>tor <1:10>Lord!",
          "<1:11,12>All <1:13>praise <1:14>to <1:15>You, <1:16,17>e<1:18>ter<1:19>nal <1:20>Word!",
          "<1:21>All <1:22>praise <1:23>to <1:24>You, <1:25>O <1:26>Spir<1:27>it <1:28>wise!\"",
          "<1:29,30>We <1:31>sing <1:32>as <1:33>day<1:34>light <1:35>fills <1:36>the <1:37>skies."
        ]
      }
    ]
  },
  {
    "hymnNumber": 43,
    "reference": "SDAH043",
    "title": "When Morning Gilds the Skies",
    "hasMidi": true,
    "numberOfVerses": 6,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>When <1:2>morn<1:3>ing <1:4>gilds <1:5>the <1:6,7>skies,",
          "<1:8>My <1:9>heart <1:10>a<1:11>wak<1:12>ing <1:13>cries,",
          "<1:14>May <1:15>Je<1:16>sus <1:17>Christ <1:18>be <1:19>praised!",
          "<1:20>A<1:21>like <1:22>at <1:23>work <1:24>and <1:25>prayer,",
          "<1:26>To <1:27>Je<1:28>sus <1:29>I <1:30>re<1:31>pair;",
          "<1:32>May <1:33>Je<1:34>sus <1:35>Christ <1:36>be <1:37>praised!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>When<1:2>e'er <1:3>the <1:4>sweet <1:5>church <1:6,7>bell",
          "<1:8>Peals <1:9>o<1:10>ver <1:11>hill <1:12>and <1:13>dell,",
          "<1:14>May <1:15>Je<1:16>sus <1:17>Christ <1:18>be <1:19>praised!",
          "<1:20>O <1:21>hark <1:22>to <1:23>what <1:24>it <1:25>sings,",
          "<1:26>As <1:27>joy<1:28>ous<1:29>ly <1:30>it <1:31>rings,",
          "<1:32>May <1:33>Je<1:34>sus <1:35>Christ <1:36>be <1:37>praised!"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>The <1:2>night <1:3>be<1:4>comes <1:5>as <1:6,7>day,",
          "<1:8>When <1:9>from <1:10>the <1:11>heart <1:12>we <1:13>say,",
          "<1:14>May <1:15>Je<1:16>sus <1:17>Christ <1:18>be <1:19>praised!",
          "<1:20>The <1:21>pow'rs <1:22>of <1:23>dark<1:24>ness <1:25>fear,",
          "<1:26>When <1:27>this <1:28>sweet <1:29>chant <1:30>they <1:31>hear,",
          "<1:32>May <1:33>Je<1:34>sus <1:35>Christ <1:36>be <1:37>praised!"
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "<1:1>Ye <1:2>na<1:3>tions <1:4>of <1:5>man<1:6,7>kind,",
          "<1:8>In <1:9>this <1:10>your <1:11>con<1:12>cord <1:13>find,",
          "<1:14>May <1:15>Je<1:16>sus <1:17>Christ <1:18>be <1:19>praised!",
          "<1:20>Let <1:21>all <1:22>the <1:23>earth <1:24>a<1:25>round",
          "<1:26>Ring <1:27>joy<1:28>ous <1:29>with <1:30>the <1:31>sound,",
          "<1:32>May <1:33>Je<1:34>sus <1:35>Christ <1:36>be <1:37>praised!"
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "<1:1>In <1:2>heaven's <1:3>e<1:4>ter<1:5>nal <1:6,7>bliss",
          "<1:8>The <1:9>love<1:10>liest <1:11>strain <1:12>is <1:13>this,",
          "<1:14>May <1:15>Je<1:16>sus <1:17>Christ <1:18>be <1:19>praised!",
          "<1:20>Let <1:21>earth, <1:22>and <1:23>sea, <1:24>and <1:25>sky",
          "<1:26>From <1:27>depth <1:28>to <1:29>height <1:30>re<1:31>ply,",
          "<1:32>May <1:33>Je<1:34>sus <1:35>Christ <1:36>be <1:37>praised!"
        ]
      },
      {
        "verseNumber": 6,
        "content": [
          "<1:1>Be <1:2>this, <1:3>while <1:4>life <1:5>is <1:6,7>mine,",
          "<1:8>My <1:9>can<1:10>ti<1:11>cle <1:12>di<1:13>vine,",
          "<1:14>May <1:15>Je<1:16>sus <1:17>Christ <1:18>be <1:19>praised!",
          "<1:20>Be <1:21>this <1:22>th'e<1:23>ter<1:24>nal <1:25>song",
          "<1:26>Through <1:27>all <1:28>the <1:29>a<1:30>ges <1:31>long,",
          "<1:32>May <1:33>Je<1:34>sus <1:35>Christ <1:36>be <1:37>praised!"
        ]
      }
    ]
  },
  {
    "hymnNumber": 44,
    "reference": "SDAH044",
    "title": "Morning Has Broken",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>Morn<1:2>ing <1:3>has <1:4>bro<1:5>ken <1:6>like <1:7>the <1:8>first <1:9>morn<1:10>ing,",
          "<1:11>Black<1:12>bird <1:13>has <1:14>spo<1:15>ken <1:16>like <1:17>the <1:18>first <1:19>bird.",
          "<1:20>Praise <1:21>for <1:22>the <1:23>sing<1:24>ing! <1:25>Praise <1:26>for <1:27>the <1:28>morn<1:29>ing!",
          "<1:30>Praise <1:31>for <1:32>them <1:33>spring<1:34>ing <1:35>fresh <1:36>from <1:37>the <1:38>Word!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>Sweet <1:2>the <1:3>rain's <1:4>new <1:5>fall <1:6>sun<1:7>lit <1:8>from <1:9>heav<1:10>en,",
          "<1:11>Like <1:12>the <1:13>first <1:14>dew <1:15>fall <1:16>on <1:17>the <1:18>first <1:19>grass.",
          "<1:20>Praise <1:21>for <1:22>the <1:23>sweet<1:24>ness <1:25>of <1:26>the <1:27>wet <1:28>gar<1:29>den,",
          "<1:30>Sprung <1:31>in <1:32>com<1:33>plete<1:34>ness <1:35>where <1:36>His <1:37>feet <1:38>pass."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>Mine <1:2>is <1:3>the <1:4>sun<1:5>light! <1:6>Mine <1:7>is <1:8>the <1:9>morn<1:10>ing",
          "<1:11>Born <1:12>of <1:13>the <1:14>one <1:15>light <1:16>E<1:17>den <1:18>saw <1:19>play!",
          "<1:20>Praise <1:21>with <1:22>e<1:23>la<1:24>tion, <1:25>Praise <1:26>ev<1:27>ery <1:28>morn<1:29>ing,",
          "<1:30>God's <1:31>re<1:32>cre<1:33>a<1:34>tion <1:35>of <1:36>the <1:37>new <1:38>day!"
        ]
      }
    ]
  },
  {
    "hymnNumber": 45,
    "reference": "SDAH045",
    "title": "Open Now Thy Gates of Beauty",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>O<1:2>pen <1:3>now <1:4>Thy <1:5>gates <1:6>of <1:7>beau<1:8>ty,",
          "<1:9>Zi<1:10,11>on, <1:12>let <1:13>me <1:14>en<1:15>ter <1:16>there,",
          "<1:17>Where <1:18>my <1:19>soul <1:20>in <1:21>joy<1:22>ful <1:23>du<1:24>ty",
          "<1:25>Waits <1:26,27>for <1:28>God <1:29>who <1:30>an<1:31>swers <1:32>prayer.",
          "<1:33>Oh, <1:34>how <1:35>bless<1:36>ed <1:37>is <1:38>this <1:39>place,",
          "<1:40>Filled <1:41>with <1:42>so<1:43>lace, <1:44>light, <1:45>and <1:46>grace!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>Gra<1:2>cious <1:3>God, <1:4>I <1:5>come <1:6>be<1:7>fore <1:8>Thee;",
          "<1:9>Come <1:10,11>Thou <1:12>al<1:13>so <1:14>un<1:15>to <1:16>me;",
          "<1:17>Where <1:18>we <1:19>find <1:20>Thee <1:21>and <1:22>a<1:23>dore <1:24>Thee,",
          "<1:25>There <1:26,27>a <1:28>heav'n <1:29>on <1:30>earth <1:31>must <1:32>be.",
          "<1:33>To <1:34>my <1:35>heart, <1:36>oh, <1:37>en<1:38>ter <1:39>Thou,",
          "<1:40>Let <1:41>it <1:42>be <1:43>Thy <1:44>tem<1:45>ple <1:46>now!"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>Here <1:2>Thy <1:3>praise <1:4>is <1:5>glad<1:6>ly <1:7>chant<1:8>ed,",
          "<1:9>Here <1:10,11>Thy <1:12>seed <1:13>is <1:14>du<1:15>ly <1:16>sown;",
          "<1:17>Let <1:18>my <1:19>soul, <1:20>where <1:21>it <1:22>is <1:23>plant<1:24>ed,",
          "<1:25>Bring <1:26,27>forth <1:28>pre<1:29>cious <1:30>sheaves <1:31>a<1:32>lone.",
          "<1:33>So <1:34>that <1:35>all <1:36>I <1:37>hear <1:38>may <1:39>be",
          "<1:40>Fruit<1:41>ful <1:42>un<1:43>to <1:44>life <1:45>in <1:46>me."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "<1:1>Thou <1:2>my <1:3>faith <1:4>in<1:5>crease <1:6>and <1:7>quick<1:8>en,",
          "<1:9>Let <1:10,11>me <1:12>keep <1:13>Thy <1:14>gift <1:15>di<1:16>vine;",
          "<1:17>How<1:18>so<1:19>e'er <1:20>temp<1:21>ta<1:22>tions <1:23>thick<1:24>en,",
          "<1:25>May <1:26,27>Thy <1:28>Word <1:29>still <1:30>o'er <1:31>me <1:32>shine",
          "<1:33>As <1:34>my <1:35>guid<1:36>ing <1:37>star <1:38>through <1:39>life,",
          "<1:40>As <1:41>my <1:42>com<1:43>fort <1:44>in <1:45>all <1:46>strife."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "<1:1>Speak, <1:2>O <1:3>God, <1:4>and <1:5>I <1:6>will <1:7>hear <1:8>Thee,",
          "<1:9>Let <1:10,11>Thy <1:12>will <1:13>be <1:14>done <1:15>in<1:16>deed;",
          "<1:17>May <1:18>I, <1:19>un<1:20>dis<1:21>turbed, <1:22>draw <1:23>near <1:24>Thee",
          "<1:25>While <1:26,27>Thou <1:28>dost <1:29>Thy <1:30>peo<1:31>ple <1:32>feed",
          "<1:33>Here <1:34>of <1:35>life <1:36>the <1:37>foun<1:38>tain <1:39>flows;",
          "<1:40>Here <1:41>is <1:42>balm <1:43>for <1:44>all <1:45>our <1:46>woes."
        ]
      }
    ]
  },
  {
    "hymnNumber": 46,
    "reference": "SDAH046",
    "title": "Abide With Me, 'Tis Eventide",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>A<1:2>bide <1:3>with <1:4>me, <1:5>'tis <1:6>e<1:7>ven<1:8>tide! ",
          "<1:9>The <1:10>day <1:11>is <1:12>past <1:13>and <1:14>gone; ",
          "<1:15>The <1:16>shad<1:17>ows <1:18>of <1:19>the <1:20>eve<1:21>ning <1:22>fall; ",
          "<1:23>The <1:24>night <1:25>is <1:26>com<1:27>ing <1:28>on! ",
          "<1:29>With<1:30>in <1:31>my <1:32>heart <1:33>a <1:34>wel<1:35>come <1:36>guest, ",
          "<1:37>With<1:38>in <1:39>my <1:40>home <1:41>a<1:42>bide;"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>A<1:2>bide <1:3>with <1:4>me, <1:5>'tis <1:6>e<1:7>ven<1:8>tide! ",
          "<1:9>Thy <1:10>walk <1:11>to<1:12>day <1:13>with <1:14>me ",
          "<1:15>Has <1:16>made <1:17>my <1:18>heart <1:19>with<1:20>in <1:21>me <1:22>burn, ",
          "<1:23>As <1:24>I <1:25>com<1:26>muned <1:27>with <1:28>Thee. ",
          "<1:29>Thy <1:30>ear<1:31>nest <1:32>words <1:33>have <1:34>filled <1:35>my <1:36>soul ",
          "<1:37>And <1:38>kept <1:39>me <1:40>near <1:41>Thy <1:42>side;"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>A<1:2>bide <1:3>with <1:4>me, <1:5>'tis <1:6>e<1:7>ven<1:8>tide! ",
          "<1:9>And <1:10>lone <1:11>will <1:12>be <1:13>the <1:14>night, ",
          "<1:15>If <1:16>I <1:17>can<1:18>not <1:19>com<1:20>mune <1:21>with <1:22>Thee, ",
          "<1:23>Nor <1:24>find <1:25>in <1:26>Thee <1:27>my <1:28>light. ",
          "<1:29>The <1:30>dark<1:31>ness <1:32>of <1:33>the <1:34>world, <1:35>I <1:36>fear, ",
          "<1:37>Would <1:38>in <1:39>my <1:40>home <1:41>a<1:42>bide;"
        ]
      }
    ],
    "chorus": [
      "<1:1>O <1:2>Sav<1:3>ior, <1:4>stay <1:5>this <1:6>night <1:7>with <1:8>me; ",
      "<1:9>Be<1:10>hold, <1:11>'tis <1:12>e<1:13>ven<1:14>tide! ",
      "<1:15>O <1:16>Sav<1:17>ior, <1:18>stay <1:19>this <1:20>night <1:21>with <1:22>me; ",
      "<1:23>Be<1:24>hold, <1:25>'tis <1:26>e<1:27>ven<1:28>tide."
    ],
    "timestamps": {
      "chorus": 26.7187
    },
    "chorusMarker": {
      "track": 1,
      "index": 43
    }
  },
  {
    "hymnNumber": 47,
    "reference": "SDAH047",
    "title": "God, Who Made the Earth and Heaven",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1,2>God, <1:3>who <1:4>made <1:5>the <1:6,7>earth <1:8>and <1:9>heav<1:10>en,",
          "<1:11>Dark<1:12,13>ness <1:14>and <1:15>light:",
          "<1:16,17>You <1:18>the <1:19>day <1:20>for <1:21,22>work <1:23>have <1:24>giv<1:25>en,",
          "<1:26>For <1:27,28>rest <1:29>the <1:30>night.",
          "<1:31>May <1:32>Your <1:33>an<1:34>gel <1:35>guards <1:36>de<1:37>fend <1:38>us,",
          "<1:39>Slum<1:40>ber <1:41>sweet <1:42>Your <1:43>mer<1:44>cy <1:45>send <1:46>us,",
          "<1:47>Ho<1:48>ly <1:49>dreams <1:50>and <1:51,52>hopes <1:53>at<1:54>tend <1:55>us",
          "<1:56>All <1:57,58>through <1:59>the <1:60>night."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1,2>And <1:3>when <1:4>morn <1:5>a<1:6,7>gain <1:8>shall <1:9>call <1:10>us",
          "<1:11>To <1:12,13>run <1:14>life's <1:15>way,",
          "<1:16,17>May <1:18>we <1:19>still, <1:20>what<1:21,22>e'er <1:23>be<1:24>fall <1:25>us,",
          "<1:26>Your <1:27,28>will <1:29>o<1:30>bey.",
          "<1:31>From <1:32>the <1:33>pow'r <1:34>of <1:35>e<1:36>vil <1:37>hide <1:38>us,",
          "<1:39>In <1:40>the <1:41>nar<1:42>row <1:43>path<1:44>way <1:45>guide <1:46>us,",
          "<1:47>Nev<1:48>er <1:49>be <1:50>Your <1:51,52>smile <1:53>de<1:54>nied <1:55>us",
          "<1:56>All <1:57,58>through <1:59>the <1:60>day."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1,2>Guard <1:3>us <1:4>wak<1:5>ing, <1:6,7>guard <1:8>us <1:9>sleep<1:10>ing,",
          "<1:11>And, <1:12,13>when <1:14>we <1:15>die,",
          "<1:16,17>May <1:18>we <1:19>in <1:20>Your <1:21,22>might<1:23>y <1:24>keep<1:25>ing",
          "<1:26>All <1:27,28>peace<1:29>ful <1:30>lie.",
          "<1:31>When <1:32>the <1:33>trum<1:34>pet <1:35>call <1:36>shall <1:37>wake <1:38>us,",
          "<1:39>Then, <1:40>O <1:41>Lord, <1:42>do <1:43>not <1:44>for<1:45>sake <1:46>us,",
          "<1:47>But <1:48>to <1:49>reign <1:50>in <1:51,52>glo<1:53>ry <1:54>take <1:55>us",
          "<1:56>With <1:57,58>You <1:59>on <1:60>high."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "<1:1,2>Ho<1:3>ly <1:4>Fa<1:5>ther, <1:6,7>throned <1:8>in <1:9>heav<1:10>en,",
          "<1:11>All<1:12,13>ho<1:14>ly <1:15>Son,",
          "<1:16,17>Ho<1:18>ly <1:19>Spir<1:20>it, <1:21,22>free<1:23>ly <1:24>giv<1:25>en,",
          "<1:26>Blest <1:27,28>Three <1:29>in <1:30>One:",
          "<1:31>Grant <1:32>us <1:33>grace, <1:34>we <1:35>now <1:36>im<1:37>plore <1:38>You,",
          "<1:39>Till <1:40>we <1:41>lay <1:42>our <1:43>crowns <1:44>be<1:45>fore <1:46>You",
          "<1:47>And <1:48>in <1:49>wor<1:50>thier <1:51,52>strains <1:53>a<1:54>dore <1:55>You",
          "<1:56>While <1:57,58>a<1:59>ges <1:60>run."
        ]
      }
    ]
  },
  {
    "hymnNumber": 48,
    "reference": "SDAH048",
    "title": "Softly Now the Light of Day",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>Soft<1:2>ly <1:3>now <1:4>the <1:5>light <1:6,7>of <1:8>day",
          "<1:9>Fades <1:10>up<1:11>on <1:12>our <1:13>sight <1:14>a<1:15>way;",
          "<1:16>Free <1:17>from <1:18>care, <1:19>from <1:20>la<1:21,22>bor <1:23>free,",
          "<1:24>Lord, <1:25>we <1:26,27>would <1:28,29>com<1:30>mune <1:31>with <1:32>Thee."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>Thou, <1:2>whose <1:3>all-<1:4>per<1:5>vad<1:6,7>ing <1:8>eye",
          "<1:9>Nought <1:10>es<1:11>capes, <1:12>with<1:13>out, <1:14>with<1:15>in,",
          "<1:16>Par<1:17>don <1:18>each <1:19>in<1:20>fir<1:21,22>mi<1:23>ty,",
          "<1:24>O<1:25>pen <1:26,27>fault, <1:28,29>and <1:30>se<1:31>cret <1:32>sin."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>Soon <1:2>from <1:3>us <1:4>the <1:5>light <1:6,7>of <1:8>day",
          "<1:9>Shall <1:10>for<1:11>ev<1:12>er <1:13>pass <1:14>a<1:15>way;",
          "<1:16>Then, <1:17>from <1:18>sin <1:19>and <1:20>sor<1:21,22>row <1:23>free,",
          "<1:24>Take <1:25>us, <1:26,27>Lord, <1:28,29>to <1:30>dwell <1:31>with <1:32>Thee."
        ]
      }
    ]
  },
  {
    "hymnNumber": 49,
    "reference": "SDAH049",
    "title": "Savior, Breathe an Evening Blessing",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>Sav<1:2>ior, <1:3>breathe <1:4>an <1:5>eve<1:6>ning <1:7>bless<1:8>ing,",
          "<1:9>Ere <1:10>re<1:11>pose <1:12,13>our <1:14>spir<1:15>its <1:16,17>seal;",
          "<1:18>Sin <1:19>and <1:20>want <1:21>we <1:22>come <1:23>con<1:24>fess<1:25>ing;",
          "<1:26>Thou <1:27>canst <1:28>save, <1:29>and <1:30>Thou <1:31,32>canst <1:33>heal."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>Though <1:2>the <1:3>night <1:4>be <1:5>dark <1:6>and <1:7>drear<1:8>y,",
          "<1:9>Dark<1:10>ness <1:11>can<1:12,13>not <1:14>hide <1:15>from <1:16,17>Thee;",
          "<1:18>Thou <1:19>art <1:20>He <1:21>who, <1:22>nev<1:23>er <1:24>wea<1:25>ry,",
          "<1:26>Watch<1:27>est <1:28>where <1:29>Thy <1:30>peo<1:31,32>ple <1:33>be."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>Though <1:2>de<1:3>struc<1:4>tion <1:5>walk <1:6>a<1:7>round <1:8>us,",
          "<1:9>Though <1:10>the <1:11>ar<1:12,13>row <1:14>past <1:15>us <1:16,17>fly,",
          "<1:18>An<1:19>gel <1:20>guards <1:21>from <1:22>Thee <1:23>sur<1:24>round <1:25>us,",
          "<1:26>We <1:27>are <1:28>safe <1:29>if <1:30>Thou <1:31,32>art <1:33>nigh."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "<1:1>Should <1:2>swift <1:3>death <1:4>this <1:5>night <1:6>o'er<1:7>take <1:8>us,",
          "<1:9>And <1:10>our <1:11>couch <1:12,13>be<1:14>come <1:15>our <1:16,17>tomb,",
          "<1:18>May <1:19>the <1:20>morn <1:21>of <1:22>glo<1:23>ry <1:24>wake <1:25>us,",
          "<1:26>Clad <1:27>in <1:28>light <1:29>and <1:30>death<1:31,32>less <1:33>bloom."
        ]
      }
    ]
  },
  {
    "hymnNumber": 50,
    "reference": "SDAH050",
    "title": "Abide With Me",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>A<1:2>bide <1:3>with <1:4>me; <1:5>fast <1:6>falls <1:7>the <1:8>e<1:9>ven<1:10>tide;",
          "<1:11>The <1:12>dark<1:13>ness <1:14>deep<1:15>ens; <1:16>Lord, <1:17>with <1:18>me <1:19>a<1:20>bide!",
          "<1:21>When <1:22>oth<1:23>er <1:24>help<1:25>ers <1:26>fail, <1:27>and <1:28>com<1:29>forts <1:30>flee,",
          "<1:31>Help <1:32>of <1:33>the <1:34>help<1:35>less, <1:36>O <1:37>a<1:38>bide <1:39>with <1:40>me!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>Swift <1:2>to <1:3>its <1:4>close <1:5>ebbs <1:6>out <1:7>life's <1:8>lit<1:9>tle <1:10>day;",
          "<1:11>Earth's <1:12>joys <1:13>grow <1:14>dim, <1:15>its <1:16>glo<1:17>ries <1:18>pass <1:19>a<1:20>way;",
          "<1:21>Change <1:22>and <1:23>de<1:24>cay <1:25>in <1:26>all <1:27>a<1:28>round <1:29>I <1:30>see;",
          "<1:31>O <1:32>Thou, <1:33>who <1:34>chang<1:35>est <1:36>not, <1:37>a<1:38>bide <1:39>with <1:40>me!"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>I <1:2>need <1:3>Thy <1:4>pres<1:5>ence <1:6>ev<1:7>ery <1:8>pass<1:9>ing <1:10>hour;",
          "<1:11>What <1:12>but <1:13>Thy <1:14>grace <1:15>can <1:16>foil <1:17>the <1:18>temp<1:19>ter's <1:20>power?",
          "<1:21>Who <1:22>like <1:23>Thy<1:24>self <1:25>my <1:26>guide <1:27>and <1:28>stay <1:29>can <1:30>be?",
          "<1:31>Through <1:32>cloud <1:33>and <1:34>sun<1:35>shine, <1:36>O <1:37>a<1:38>bide <1:39>with <1:40>me!"
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "<1:1>I <1:2>fear <1:3>no <1:4>foe, <1:5>with <1:6>Thee <1:7>at <1:8>hand <1:9>to <1:10>bless;",
          "<1:11>Ills <1:12>have <1:13>no <1:14>weight, <1:15>and <1:16>tears <1:17>no <1:18>bit<1:19>ter<1:20>ness:",
          "<1:21>Where <1:22>is <1:23>death's <1:24>sting? <1:25>where, <1:26>grave, <1:27>thy <1:28>vic<1:29>to<1:30>ry?",
          "<1:31>I <1:32>tri<1:33>umph <1:34>still <1:35>if <1:36>Thou <1:37>a<1:38>bide <1:39>with <1:40>me!"
        ]
      }
    ]
  },
  {
    "hymnNumber": 51,
    "reference": "SDAH051",
    "title": "Day Is Dying in the West",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>Day <1:2>is <1:3>dy<1:4>ing <1:5>in <1:6>the <1:7>west;",
          "<1:8>Heaven <1:9>is <1:10>touch<1:11>ing <1:12>earth <1:13>with <1:14>rest;",
          "<1:15>Wait <1:16>and <1:17>wor<1:18>ship <1:19,20>while <1:21>the <1:22>night",
          "<1:23>Sets <1:24>the <1:25>eve<1:26>ning <1:27,28>lamps <1:29>a<1:30>light",
          "<1:31>Through <1:32>all <1:33>the <1:34>sky."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>Lord <1:2>of <1:3>life, <1:4>be<1:5>neath <1:6>the <1:7>dome",
          "<1:8>Of <1:9>the <1:10>u<1:11>ni<1:12>verse, <1:13>Thy <1:14>home,",
          "<1:15>Ga<1:16>ther <1:17>us <1:18>who <1:19,20>seek <1:21>Thy <1:22>face",
          "<1:23>To <1:24>the <1:25>fold <1:26>of <1:27,28>Thy <1:29>em<1:30>brace,",
          "<1:31>For <1:32>Thou <1:33>art <1:34>nigh."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>While <1:2>the <1:3>deep<1:4>ening <1:5>shad<1:6>ows <1:7>fall,",
          "<1:8>Heart <1:9>of <1:10>love <1:11>en<1:12>fold<1:13>ing <1:14>all,",
          "<1:15>Thro' <1:16>the <1:17>glo<1:18>ry <1:19,20>and <1:21>the <1:22>grace",
          "<1:23>Of <1:24>the <1:25>stars <1:26>that <1:27,28>veil <1:29>Thy <1:30>face,",
          "<1:31>Our <1:32>hearts <1:33>as<1:34>cend."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "<1:1>When <1:2>for<1:3>ev<1:4>er <1:5>from <1:6>our <1:7>sight",
          "<1:8>Pass <1:9>the <1:10>stars, <1:11>the <1:12>day, <1:13>the <1:14>night,",
          "<1:15>Lord <1:16>of <1:17>an<1:18>gels, <1:19,20>on <1:21>our <1:22>eyes",
          "<1:23>Let <1:24>e<1:25>ter<1:26>nal <1:27,28>morn<1:29>ing <1:30>rise",
          "<1:31>And <1:32>shad<1:33>ows <1:34>end."
        ]
      }
    ],
    "chorus": [
      "<1:1>Ho<1:2>ly, <1:3>ho<1:4>ly, <1:5>ho<1:6>ly,",
      "<1:7>Lord <1:8>God <1:9>of <1:10>Hosts!",
      "<1:11>Heaven <1:12>and <1:13>earth <1:14>are <1:15>full <1:16>of <1:17>Thee;",
      "<1:18>Heaven <1:19>and <1:20>earth <1:21>are <1:22>prais<1:23>ing <1:24>Thee,",
      "<1:25>O <1:26>Lord <1:27>most <1:28>high!"
    ],
    "timestamps": {
      "chorus": 24.3455
    },
    "chorusMarker": {
      "track": 1,
      "index": 35
    }
  },
  {
    "hymnNumber": 52,
    "reference": "SDAH052",
    "title": "Now the Day Is Over",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>Now <1:2>the <1:3>day <1:4,5>is <1:6>o<1:7>ver;",
          "<1:8>Night <1:9>is <1:10>draw<1:11,12>ing <1:13,14>nigh,",
          "<1:15>Shad<1:16>ows <1:17>of <1:18>the <1:19>eve<1:20>ning",
          "<1:21>Steal <1:22>a<1:23>cross <1:24>the <1:25>sky."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>Fa<1:2>ther, <1:3>give <1:4,5>the <1:6>wea<1:7>ry",
          "<1:8>Calm <1:9>and <1:10>sweet <1:11,12>re<1:13,14>pose;",
          "<1:15>With <1:16>your <1:17>ten<1:18>derest <1:19>bless<1:20>ing",
          "<1:21>May <1:22>our <1:23>eye<1:24>lids <1:25>close."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>Through <1:2>the <1:3>long <1:4,5>night-<1:6>watch<1:7>es,",
          "<1:8>May <1:9>your <1:10>an<1:11,12>gels <1:13,14>spread",
          "<1:15>Their <1:16>white <1:17>wings <1:18>a<1:19>bove <1:20>me,",
          "<1:21>Watch<1:22>ing <1:23>round <1:24>my <1:25>bed."
        ]
      }
    ]
  },
  {
    "hymnNumber": 53,
    "reference": "SDAH053",
    "title": "All Praise to Thee",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>All <1:2>praise <1:3>to <1:4>Thee, <1:5>my <1:6>God, <1:7>this <1:8>night,",
          "<1:9>For <1:10>all <1:11>the <1:12>bless<1:13>ings <1:14>of <1:15>the <1:16>light!",
          "<1:17>Keep <1:18>me, <1:19>O <1:20>keep <1:21>me, <1:22>King <1:23>of <1:24>kings,",
          "<1:25>Be<1:26>neath <1:27>Thine <1:28>own <1:29>al<1:30>might<1:31>y <1:32>wings."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>For<1:2>give <1:3>me, <1:4>Lord, <1:5>for <1:6>Thy <1:7>dear <1:8>Son,",
          "<1:9>The <1:10>ill <1:11>that <1:12>I <1:13>this <1:14>day <1:15>have <1:16>done,",
          "<1:17>That <1:18>with <1:19>the <1:20>world, <1:21>my<1:22>self, <1:23>and <1:24>Thee,",
          "<1:25>I, <1:26>ere <1:27>I <1:28>sleep, <1:29>at <1:30>peace <1:31>may <1:32>be."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>O <1:2>may <1:3>my <1:4>soul <1:5>on <1:6>Thee <1:7>re<1:8>pose;",
          "<1:9>And <1:10>with <1:11>sweet <1:12>sleep <1:13>mine <1:14>eye<1:15>lids <1:16>close,",
          "<1:17>Sleep, <1:18>that <1:19>may <1:20>me <1:21>more <1:22>vig<1:23>orous <1:24>make",
          "<1:25>To <1:26>serve <1:27>my <1:28>God <1:29>when <1:30>I <1:31>a<1:32>wake."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "<1:1>Praise <1:2>God, <1:3>from <1:4>whom <1:5>all <1:6>bless<1:7>ings <1:8>flow;",
          "<1:9>Praise <1:10>Him, <1:11>all <1:12>crea<1:13>tures <1:14>here <1:15>be<1:16>low;",
          "<1:17>Praise <1:18>Him <1:19>a<1:20>bove, <1:21>ye <1:22>heav<1:23>enly <1:24>host;",
          "<1:25>Praise <1:26>Fa<1:27>ther, <1:28>Son, <1:29>and <1:30>Ho<1:31>ly <1:32>Ghost."
        ]
      }
    ]
  },
  {
    "hymnNumber": 54,
    "reference": "SDAH054",
    "title": "O Gladsome Light",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>O <1:2>glad<1:3>some <1:4>light <1:5>O <1:6,7>grace ",
          "<1:8>of <1:9>God <1:10>the <1:11>Fa<1:12>ther's <1:13,14>face,",
          "<1:15>The <1:16>e<1:17>ter<1:18,19>nal <1:20>splen<1:21>dor <1:22>wear<1:23>ing; ",
          "<1:24>Ce<1:25>les<1:26>tial, <1:27>ho<1:28>ly, <1:29,30>blest,",
          "<1:31>Our <1:32>Sav<1:33>ior, <1:34>Je<1:35>sus <1:36,37>Christ,",
          "<1:38>Joy<1:39>ful <1:40>in <1:41>Thine <1:42>ap<1:43,44>pear<1:45>ing."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>Now <1:2>e'er <1:3>day <1:4>fad<1:5>eth <1:6,7>quite,",
          "<1:8>We <1:9>see <1:10>the <1:11>ev'<1:12>ning <1:13,14>light,",
          "<1:15,16>Our <1:17>wont<1:18,19>ed <1:20>hymn <1:21>our<1:22>pour<1:23>ing;",
          "<1:24>Fa<1:25>ther <1:26>of <1:27>might <1:28>un<1:29,30>known,",
          "<1:31>Thee <1:32>His <1:33>in<1:34>car<1:35>nate <1:36,37>Son,",
          "<1:38>And <1:39>Ho<1:40>ly <1:41>Spirit <1:42>a<1:43,44>dor<1:45>ing."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>To <1:2>Thee <1:3>of <1:4>right <1:5>be<1:6,7>longs",
          "<1:8>All <1:9>praise <1:10>of <1:11>ho<1:12>ly <1:13,14>songs,",
          "<1:15,16>O <1:17>Son <1:18,19>of <1:20>God, <1:21>life<1:22>giv<1:23>er;",
          "<1:24>Thee <1:25>there<1:26>fore, <1:27>O <1:28>most <1:29,30>high,",
          "<1:31>The <1:32>world <1:33>doth <1:34>glo<1:35>ri<1:36,37>fy",
          "<1:38>And <1:39>shall <1:40>ex<1:41>alt <1:42>for <1:43,44>ev<1:45>er."
        ]
      }
    ]
  },
  {
    "hymnNumber": 55,
    "reference": "SDAH055",
    "title": "Jesus Tender Shepherd Hear Me",
    "hasMidi": true,
    "numberOfVerses": 2,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>Je<1:2>sus, <1:3>ten<1:4>der <1:5,6>Shep<1:7,8>herd, <1:9>hear <1:10>me,",
          "<1:11>Bless <1:12>Thy <1:13>lit<1:14>tle <1:15,16>lamb <1:17,18>to<1:19>night;",
          "<1:20>Through <1:21,22>the <1:23>dark<1:24>ness <1:25>be <1:26,27>Thou <1:28>near <1:29>me;",
          "<1:30>Watch <1:31>my <1:32>sleep <1:33,34>till <1:35>morn<1:36>ing <1:37>light."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>All <1:2>this <1:3>day <1:4>Thy <1:5,6>hand <1:7,8>has <1:9>led <1:10>me,",
          "<1:11>And <1:12>I <1:13>thank <1:14>Thee <1:15,16>for <1:17,18>Thy <1:19>care;",
          "<1:20>Thou <1:21,22>hast <1:23>clothed <1:24>me, <1:25>warmed <1:26,27>and <1:28>fed <1:29>me;",
          "<1:30>Lis<1:31>ten <1:32>to <1:33,34>my <1:35>eve<1:36>ning <1:37>prayer."
        ]
      }
    ]
  },
  {
    "hymnNumber": 56,
    "reference": "SDAH056",
    "title": "The Day Thou Gavest",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>The <1:2,3>day <1:4>Thou <1:5,6>gav<1:7>est, <1:8,9>Lord, <1:10>is <1:11>end<1:12>ed,",
          "<1:13>The <1:14>dark<1:15>ness <1:16,17>falls <1:18>at <1:19>Thy <1:20>be<1:21>hest;",
          "<1:22>To <1:23,24>Thee <1:25>our <1:26,27>morn<1:28>ing <1:29,30>hymns <1:31>as<1:32>cend<1:33>ed,",
          "<1:34>Thy <1:35,36>praise <1:37>shall <1:38,39>hal<1:40>low <1:41,42>now <1:43>our <1:44>rest."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>We <1:2,3>thank <1:4>Thee <1:5,6>that <1:7>Thy <1:8,9>church, <1:10>un<1:11>sleep<1:12>ing,",
          "<1:13>While <1:14>earth <1:15>rolls <1:16,17>on<1:18>ward <1:19>in<1:20>to <1:21>light,",
          "<1:22>Through <1:23,24>all <1:25>the <1:26,27>world <1:28>her <1:29,30>watch <1:31>is <1:32>keep<1:33>ing,",
          "<1:34>And <1:35,36>rests <1:37>not <1:38,39>now <1:40>by <1:41,42>day <1:43>or <1:44>night."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>As <1:2,3>o'er <1:4>each <1:5,6>con<1:7>ti<1:8,9>nent <1:10>and <1:11>is<1:12>land",
          "<1:13>The <1:14>dawn <1:15>leads <1:16,17>on <1:18>an<1:19>oth<1:20>er <1:21>day,",
          "<1:22>The <1:23,24>voice <1:25>of <1:26,27>prayer <1:28>is <1:29,30>nev<1:31>er <1:32>si<1:33>lent,",
          "<1:34>Nor <1:35,36>die <1:37>the <1:38,39>strains <1:40>of <1:41,42>praise <1:43>a<1:44>way."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "<1:1>So <1:2,3>be <1:4>it, <1:5,6>Lord; <1:7>Thy <1:8,9>throne <1:10>shall <1:11>nev<1:12>er,",
          "<1:13>Like <1:14>earth's <1:15>proud <1:16,17>em<1:18>pires, <1:19>pass <1:20>a<1:21>way;",
          "<1:22>Thy <1:23,24>king<1:25>dom <1:26,27>stands, <1:28>and <1:29,30>grows <1:31>for<1:32>ev<1:33>er,",
          "<1:34>Till <1:35,36>all <1:37>Thy <1:38,39>crea<1:40>tures <1:41,42>own <1:43>Thy <1:44>sway."
        ]
      }
    ]
  },
  {
    "hymnNumber": 57,
    "reference": "SDAH057",
    "title": "Now All the Woods Are Sleeping",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>Now <1:2>all <1:3>the <1:4,5>woods <1:6>are <1:7,8>sleep<1:9>ing,",
          "<1:10,11>And <1:12,13>night <1:14,15>and <1:16,17>still<1:18>ness <1:19,20>creep<1:21>ing",
          "<1:22>O'er <1:23>cit<1:24>y, <1:25,26>man, <1:27>and <1:28>beast;",
          "<1:29>But <1:30>thou, <1:31>my <1:32,33>heart, <1:34>a<1:35,36,37,38>wake <1:39>thee,",
          "<1:40,41>To <1:42>pray'r <1:43,44>a<1:45>while <1:46>be<1:47,48>take <1:49>thee,",
          "<1:50>And <1:51,52>praise <1:53,54>thy <1:55,56>Mak<1:57,58>er <1:59>ere <1:60>thou <1:61>rest."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>My <1:2>Je<1:3>sus, <1:4,5>stay <1:6>Thou <1:7,8>by <1:9>me,",
          "<1:10,11>And <1:12,13>let <1:14,15>no <1:16,17>foe <1:18>come <1:19,20>nigh <1:21>me,",
          "<1:22>Safe <1:23>shel<1:24>tered <1:25,26>by <1:27>Thy <1:28>wing;",
          "<1:29>But <1:30>would <1:31>the <1:32,33>foe <1:34>a<1:35,36,37,38>larm <1:39>me,",
          "<1:40,41>O <1:42>let <1:43,44>him <1:45>nev<1:46>er <1:47,48>harm <1:49>me,",
          "<1:50>But <1:51,52>still <1:53,54>Thine <1:55,56>an<1:57,58>gels <1:59>round <1:60>me <1:61>sing!"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>My <1:2>loved <1:3>ones, <1:4,5>rest <1:6>se<1:7,8>cure<1:9>ly,",
          "<1:10,11>From <1:12,13>ev<1:14,15>ery <1:16,17>per<1:18>il <1:19,20>sure<1:21>ly",
          "<1:22>Our <1:23>God <1:24>will <1:25,26>guard <1:27>your <1:28>heads;",
          "<1:29>And <1:30>hap<1:31>py <1:32,33>slum<1:34>bers <1:35,36,37,38>send <1:39>you,",
          "<1:40,41>And <1:42>bid <1:43,44>His <1:45>hosts <1:46>at<1:47,48>tend <1:49>you,",
          "<1:50>And <1:51,52>gold<1:53,54>en-<1:55,56>armed <1:57,58>watch <1:59>o'er <1:60>your <1:61>beds."
        ]
      }
    ]
  },
  {
    "hymnNumber": 58,
    "reference": "SDAH058",
    "title": "Hark the Vesper Hymn Is Stealing",
    "hasMidi": true,
    "numberOfVerses": 2,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>Hark! <1:2>the <1:3>ves<1:4>per <1:5>hymn <1:6>is <1:7>steal<1:8>ing",
          "<1:9>O'er <1:10>the <1:11>wa<1:12>ters <1:13>soft <1:14>and <1:15>clear;",
          "<1:16>Ju<1:17>bi<1:18>la<1:19>te, <1:20>Ju<1:21>bi<1:22>la<1:23>te, <1:24>Ju<1:25>bi<1:26>la<1:27>te, <1:28,29>A<1:30>men."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>Near<1:2>er <1:3>yet, <1:4>and <1:5>near<1:6>er <1:7>peal<1:8>ing,",
          "<1:9>Soft <1:10>it <1:11>breaks <1:12>up<1:13>on <1:14>the <1:15>ear.",
          "<1:16>Ju<1:17>bi<1:18>la<1:19>te, <1:20>Ju<1:21>bi<1:22>la<1:23>te, <1:24>Ju<1:25>bi<1:26>la<1:27>te, <1:28,29>A<1:30>men."
        ]
      }
    ]
  },
  {
    "hymnNumber": 59,
    "reference": "SDAH059",
    "title": "Great Our Joy As Now We Gather",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>Great <1:2>our <1:3>joy <1:4>as <1:5,6>now <1:7,8>we <1:9,10>gath<1:11>er",
          "<1:12>Where <1:13>the <1:14>Mas<1:15>ter <1:16,17>makes <1:18>us <1:19>one:",
          "<1:20>Where <1:21>we <1:22,23>wor<1:24>ship <1:25>God <1:26>the <1:27>Fa<1:28>ther",
          "<1:29>Thro' <1:30>the <1:31,32>Spir<1:33>it <1:34>of <1:35>His <1:36>Son.",
          "<1:37>All <1:38>who <1:39>search <1:40>for <1:41,42>His <1:43>church",
          "<1:44>Find <1:45>it <1:46,47>where <1:48,49>His <1:50,51>will <1:52,53>is <1:54>done."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>Pre<1:2>cious <1:3>is <1:4>the <1:5,6>tie <1:7,8>that <1:9,10>binds <1:11>us",
          "<1:12>To <1:13>our <1:14>God <1:15>when <1:16,17>faith <1:18>grows <1:19>cold;",
          "<1:20>Pre<1:21>cious <1:22,23>all <1:24>that <1:25>now <1:26>re<1:27>minds <1:28>us",
          "<1:29>He <1:30>is <1:31,32>still <1:33>our <1:34>safe <1:35>strong<1:36>hold.",
          "<1:37>Faith<1:38>ful <1:39>love <1:40>serves <1:41,42>to <1:43>prove",
          "<1:44>Here <1:45>the <1:46,47>Shep<1:48,49>herd <1:50,51>has <1:52,53>His <1:54>fold."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>May <1:2>we <1:3>learn <1:4>from <1:5,6>Christ's <1:7,8>ex<1:9,10>am<1:11>ple",
          "<1:12>How <1:13>to <1:14>use <1:15>this <1:16,17>house <1:18>of <1:19>prayer:",
          "<1:20>He <1:21>who <1:22,23>loved <1:24>and <1:25>cleansed <1:26>His <1:27>tem<1:28>ple",
          "<1:29>Wants <1:30>us <1:31,32>all <1:33>to <1:34>wor<1:35>ship <1:36>there.",
          "<1:37>God <1:38>the <1:39>Son <1:40>shuts <1:41,42>out <1:43>none:",
          "<1:44>In <1:45>His <1:46,47>King<1:48,49>dom <1:50,51>all <1:52,53>may <1:54>share."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "<1:1>Lord, <1:2>in<1:3>spire <1:4>us <1:5,6>with <1:7,8>Your <1:9,10>vi<1:11>sion",
          "<1:12>Of <1:13>a <1:14>world <1:15>which <1:16,17>must <1:18>be <1:19>won!",
          "<1:20>Glo<1:21>rious <1:22,23>is <1:24>the <1:25>church's <1:26>mis<1:27>sion,",
          "<1:28>Long <1:29>en<1:30>deav<1:31,32>ored, <1:33>scarce <1:34>be<1:35>gun!",
          "<1:37>Faith<1:38>ful <1:39>now- <1:40>this <1:41,42>is <1:43>how",
          "<1:44>God's <1:45>e<1:46,47>ter<1:48,49>nal <1:50,51>will <1:52,53>is <1:54>done."
        ]
      }
    ]
  },
  {
    "hymnNumber": 60,
    "reference": "SDAH060",
    "title": "Blessed Jesus, at Thy Word",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>Bless<1:2>ed <1:3>Je<1:4,5>sus, <1:6>at <1:7,8>Thy <1:9>word",
          "<1:10,11>We <1:12>are <1:13,14>gath<1:15>ered <1:16,17>all <1:18>to <1:19,20>hear <1:21>Thee;",
          "<1:22>Let <1:23>our <1:24>hearts <1:25,26>and <1:27>souls <1:28,29>be <1:30>stirred",
          "<1:31>Now <1:32,33>to <1:34,35>seek <1:36>and <1:37,38>love <1:39>and <1:40,41>fear <1:42>Thee;",
          "<1:43>By <1:44>Thy <1:45,46>teach<1:47>ings <1:48>sweet <1:49,50>and <1:51>ho<1:52>ly,",
          "<1:53,54>Drawn <1:55>from <1:56>earth <1:57>to <1:58,59>love <1:60>Thee <1:61,62>sole<1:63>ly."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>All <1:2>our <1:3>knowl<1:4,5>edge, <1:6>sense, <1:7,8>and <1:9>sight",
          "<1:10,11>Lie <1:12>in <1:13,14>deep<1:15>est <1:16,17>dark<1:18>ness <1:19,20>shroud<1:21>ed,",
          "<1:22>Till <1:23>Thy <1:24>Spir<1:25,26>it <1:27>breaks <1:28,29>our <1:30>night",
          "<1:31>With <1:32,33>the <1:34,35>beams <1:36>of <1:37,38>truth <1:39>un<1:40,41>cloud<1:42>ed.",
          "<1:43>Thou <1:44>a<1:45,46>lone <1:47>to <1:48>God <1:49,50>canst <1:51>win <1:52>us;",
          "<1:53,54>Thou <1:55>must <1:56>work <1:57>all <1:58,59>good <1:60>with<1:61,62>in <1:63>us."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>Glo<1:2>rious <1:3>Lord, <1:4,5>Thy<1:6>self <1:7,8>im<1:9>part!",
          "<1:10,11>Light <1:12>of <1:13,14>light, <1:15>from <1:16,17>God <1:18>pro<1:19,20>ceed<1:21>ing,",
          "<1:22>O<1:23>pen <1:24>Thou <1:25,26>our <1:27>ears <1:28,29>and <1:30>heart,",
          "<1:31>Help <1:32,33>us <1:34,35>by <1:36>Thy <1:37,38>Spir<1:39>it's <1:40,41>plead<1:42>ing,",
          "<1:43>Hear <1:44>the <1:45,46>cry <1:47>Thy <1:48>peo<1:49,50>ple <1:51>rais<1:52>es,",
          "<1:53,54>Hear, <1:55>and <1:56>bless <1:57>our <1:58,59>prayers <1:60>and <1:61,62>prais<1:63>es."
        ]
      }
    ]
  },
  {
    "hymnNumber": 61,
    "reference": "SDAH061",
    "title": "God Is Here",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>God <1:2>is <1:3>here! <1:4>As <1:5,6>we <1:7>His <1:8>peo<1:9>ple",
          "<1:10>Meet <1:11>to <1:12,13>of<1:14>fer <1:15,16>praise <1:17>and <1:18>prayer,",
          "<1:19>May <1:20>we <1:21>find <1:22>in <1:23,24>full<1:25>er <1:26>mea<1:27>sure",
          "<1:28>What <1:29>it <1:30,31>is <1:32>in <1:33,34>Christ <1:35>we <1:36>share.",
          "<1:37>Here, <1:38>as <1:39>in <1:40>the <1:41,42>world <1:43>a<1:44>round <1:45>us,",
          "<1:46>All <1:47>our <1:48,49>var<1:50>ied <1:51>skills <1:52>and <1:53>arts",
          "<1:54,55>Wait <1:56>the <1:57>com<1:58>ing <1:59,60>of <1:61>the <1:62>Spir<1:63>it",
          "<1:64,65>In<1:66>to <1:67,68>o<1:69>pen <1:70>minds <1:71>and <1:72>hearts."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>Here <1:2>are <1:3>sym<1:4>bols <1:5,6>to <1:7>re<1:8>mind <1:9>us",
          "<1:10>Of <1:11>our <1:12,13>life<1:14>long <1:15,16>need <1:17>of <1:18>grace;",
          "<1:19>Here <1:20>are <1:21>ta<1:22>ble, <1:23,24>font, <1:25>and <1:26>pul<1:27>pit;",
          "<1:28>Here <1:29>the <1:30,31>Word <1:32>has <1:33,34>cen<1:35>tral <1:36>place.",
          "<1:37>Here <1:38>in <1:39>hon<1:40>es<1:41,42>ty <1:43>of <1:44>preach<1:45>ing,",
          "<1:46>Here <1:47>in <1:48,49>si<1:50>lence, <1:51>as <1:52>in <1:53>speech,",
          "<1:54,55>Here, <1:56>in <1:57>new<1:58>ness <1:59,60>and <1:61>re<1:62>new<1:63>al,",
          "<1:64,65>God <1:66>the <1:67,68>Spir<1:69>it <1:70>comes <1:71>to <1:72>each."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>Here <1:2>our <1:3>chil<1:4>dren <1:5,6>find <1:7>a <1:8>wel<1:9>come",
          "<1:10>In <1:11>the <1:12,13>Shep<1:14>herd's <1:15,16>flock <1:17>and <1:18>fold,",
          "<1:19>Here, <1:20>as <1:21>bread <1:22>and <1:23,24>wine <1:25>are <1:26>tak<1:27>en",
          "<1:28>Christ <1:29>sus<1:30,31>tains <1:32>us <1:33,34>as <1:35>of <1:36>old.",
          "<1:37>Here <1:38>the <1:39>ser<1:40>vants <1:41,42>of <1:43>the <1:44>Ser<1:45>vant",
          "<1:46>Seek <1:47>in <1:48,49>wor<1:50>ship <1:51>to <1:52>ex<1:53>plore",
          "<1:54,55>What <1:56>it <1:57>means <1:58>in <1:59,60>dai<1:61>ly <1:62>liv<1:63>ing",
          "<1:64,65>To <1:66>be<1:67,68>lieve <1:69>and <1:70>to <1:71>a<1:72>dore."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "<1:1>Lord <1:2>of <1:3>all, <1:4>of <1:5,6>church <1:7>and <1:8>king<1:9>dom,",
          "<1:10>In <1:11>age <1:12,13>of <1:14>change <1:15,16>and <1:17>doubt",
          "<1:19>Keep <1:20>us <1:21>faith<1:22>ful <1:23,24>to <1:25>the <1:26>gos<1:27>pel,",
          "<1:28>Help <1:29>us <1:30,31>work <1:32>Your <1:33,34>pur<1:35>pose <1:36>out.",
          "<1:37>Here, <1:38>in <1:39>this <1:40>day's <1:41,42>ded<1:43>i<1:44>ca<1:45>tion,",
          "<1:46>All <1:47>we <1:48,49>have <1:50>to <1:51>give, <1:52>re<1:53>ceive,",
          "<1:54,55>We, <1:56>who <1:57>can<1:58>not <1:59,60>live <1:61>with<1:62>out <1:63>You,",
          "<1:64,65>We <1:66>a<1:67,68>dore <1:69>You! <1:70>we <1:71>be<1:72>lieve!"
        ]
      }
    ]
  },
  {
    "hymnNumber": 62,
    "reference": "SDAH062",
    "title": "How Lovely Is Thy Dwelling Place",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1,2>How <1:3>love<1:4>ly <1:5>is <1:6,7>Thy <1:8>dwell<1:9>ing <1:10>place,",
          "<1:11>O <1:12>Lord <1:13>of <1:14,15>hosts <1:16,17>to <1:18,19,20>me!",
          "<1:21,22>The <1:23>tab<1:24>er<1:25>na<1:26>cles <1:27>of <1:28>Thy <1:29>grace",
          "<1:30,31>How <1:32,33>pleas<1:34>ant, <1:35,36>Lord, <1:37>they <1:38>be!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1,2>My <1:3>thirst<1:4>y <1:5>soul <1:6,7>longs <1:8>ar<1:9>dent<1:10>ly,",
          "<1:11>Yea, <1:12>faints <1:13>Thy <1:14,15>courts <1:16,17>to <1:18,19,20>see;",
          "<1:21,22>My <1:23>ver<1:24>y <1:25>heart <1:26>and <1:27>flesh <1:28>cry <1:29>out,",
          "<1:30,31>O <1:32,33>liv<1:34>ing <1:35,36>God, <1:37>for <1:38>Thee."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1,2>Be<1:3>hold <1:4>the <1:5>spar<1:6,7>row <1:8>find<1:9>eth <1:10>out",
          "<1:11>A <1:12>house <1:13>where<1:14,15>in <1:16,17>to <1:18,19,20>rest;",
          "<1:21,22>The <1:23>swal<1:24>low <1:25>al<1:26>so, <1:27>for <1:28>her<1:29>self",
          "<1:30,31>Pro<1:32,33>vid<1:34>ed <1:35,36>hath <1:37>a <1:38>nest."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "<1:1,2>Ev'n <1:3>Thine <1:4>own <1:5>al<1:6,7>tars, <1:8>where <1:9>she <1:10>safe",
          "<1:11>Her <1:12>young <1:13>ones <1:14,15>forth <1:16,17>may <1:18,19,20>bring,",
          "<1:21,22>O <1:23>Thou, <1:24>al<1:25>might<1:26>y <1:27>Lord <1:28>of <1:29>hosts,",
          "<1:30,31>Who <1:32,33>art <1:34>my <1:35,36>God <1:37>and <1:38>King."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "<1:1,2>Hest <1:3>are <1:4>they <1:5>in <1:6,7>Thy <1:8>house <1:9>that <1:10>dwell,",
          "<1:11>They <1:12>ev<1:13>er <1:14,15>give <1:16,17>Thee <1:18,19,20>praise.",
          "<1:21,22>Blest <1:23>is <1:24>the <1:25>man <1:26>whose <1:27>strength <1:28>Thou <1:29>art,",
          "<1:30,31>In <1:32,33>whose <1:34>heart <1:35,36>are <1:37>Thy <1:38>ways."
        ]
      }
    ]
  },
  {
    "hymnNumber": 63,
    "reference": "SDAH063",
    "title": "O Come, Let Us Sing to the Lord",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>O <1:2>come, <1:3>let <1:4,5>us <1:6>sing <1:7,8>to <1:9>the <1:10>Lord,",
          "<1:11>Come <1:12,13>let <1:14>us <1:15,16>ev<1:17>ery <1:18>one",
          "<1:19>A <1:20,21>joy<1:22>ful <1:23,24>noise <1:25>make <1:26,27,28>to <1:29>the <1:30,31>Rock",
          "<1:32>Of <1:33,34,35>our <1:36>sal<1:37,38,39>va<1:40>tion."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>Let <1:2>us <1:3>be<1:4,5>fore <1:6>His <1:7,8>pre<1:9>sence <1:10>come",
          "<1:11>With <1:12,13>glad <1:14>and <1:15,16>thank<1:17>ful <1:18>voice;",
          "<1:19>Let <1:20,21>us <1:22>sing <1:23,24>psalms <1:25>of <1:26,27,28>praise <1:29>to <1:30,31>Him,",
          "<1:32>And <1:33,34,35>make <1:36>a <1:37,38>joy<1:39>ful <1:40>noise."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>For <1:2>God, <1:3>a <1:4,5>great <1:6>God <1:7,8>and <1:9>great <1:10>King,",
          "<1:11>A<1:12,13>bove <1:14>all <1:15,16>gods, <1:17>He <1:18>is;",
          "<1:19>The <1:20,21>depths <1:22>of <1:23,24>earth <1:25>are <1:26,27,28>in <1:29>His <1:30,31>hand,",
          "<1:32>The <1:33,34,35>strength <1:36>of <1:37,38>hills <1:39>is <1:40>His."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "<1:1>To <1:2>Him <1:3>the <1:4,5>o<1:6>cean <1:7,8>vast <1:9>be<1:10>longs,",
          "<1:11>For <1:12,13>He <1:14>the <1:15,16>sea <1:17>did <1:18>make;",
          "<1:19>The <1:20,21>dry <1:22>land <1:23,24>al<1:25>so <1:26,27,28>from <1:29>His <1:30,31>hands,",
          "<1:32>Its <1:33,34,35>form <1:36>at <1:37,38>first <1:39>did <1:40>take."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "<1:1>O <1:2>come, <1:3>bow <1:4,5>down <1:6>and <1:7,8>wor<1:9>ship <1:10>Him,",
          "<1:11>And <1:12,13>kneel<1:14>ing, <1:15,16>hum<1:17>bly <1:18>pray,",
          "<1:19>Come <1:20,21>to <1:22>our <1:23,24>Mak<1:25>er <1:26,27,28>and <1:29>our <1:30,31>God,",
          "<1:32>And <1:33,34,35>hear <1:36>His <1:37,38>voice <1:39>to<1:40>day."
        ]
      }
    ]
  },
  {
    "hymnNumber": 64,
    "reference": "SDAH064",
    "title": "Lord, Dismiss Us With Thy Blessing",
    "hasMidi": true,
    "numberOfVerses": 2,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>Lord, <1:2>dis<1:3,4>miss <1:5,6>us <1:7>with <1:8>Thy <1:9,10>bless<1:11>ing;",
          "<1:12>Fill <1:13>our <1:14>hearts <1:15,16>with <1:17>joy <1:18>and <1:19>peace;",
          "<1:20>Let <1:21>us <1:22,23>each, <1:24,25>Thy <1:26>love <1:27>pos<1:28,29>sess<1:30>ing,",
          "<1:31>Tri<1:32>umph <1:33>in <1:34,35>re<1:36>deem<1:37>ing <1:38>grace.",
          "<1:39,40>O <1:41,42>re<1:43>fresh <1:44>us, <1:45,46>O <1:47,48>re<1:49>fresh <1:50>us,",
          "<1:51,52>Trav<1:53,54>eling <1:55,56>through <1:57,58>this <1:59>wil<1:60>der<1:61>ness."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>Thanks <1:2>we <1:3,4>give, <1:5,6>and <1:7>ad<1:8>o<1:9,10>ra<1:11>tion,",
          "<1:12>For <1:13>Thy <1:14>gos<1:15,16>pel's <1:17>joy<1:18>ful <1:19>sound.",
          "<1:20>May <1:21>the <1:22,23>fruits <1:24,25>of <1:26>Thy <1:27>sal<1:28,29>va<1:30>tion",
          "<1:31>In <1:32>our <1:33>hearts <1:34,35>and <1:36>lives <1:37>a<1:38>bound.",
          "<1:39,40>Ev<1:41,42>er <1:43>faith<1:44>ful, <1:45,46>ev<1:47,48>er <1:49>faith<1:50>ful",
          "<1:51,52>To <1:53,54>the <1:55,56>truth <1:57,58>may <1:59>we <1:60>be <1:61>found."
        ]
      }
    ]
  },
  {
    "hymnNumber": 65,
    "reference": "SDAH065",
    "title": "God Be With You",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>God <1:2>be <1:3>with <1:4>you <1:5>till <1:6>we <1:7>meet <1:8>a<1:9>gain; ",
          "<1:10>By <1:11>His <1:12>coun<1:13>sels <1:14>guide, <1:15>up<1:16>hold <1:17>you, ",
          "<1:18>With <1:19>His <1:20>sheep <1:21>se<1:22>cure<1:23>ly <1:24>fold <1:25>you; ",
          "<1:26>God <1:27>be <1:28>with <1:29>you <1:30>till <1:31>we <1:32>meet <1:33>a<1:34>gain."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>God <1:2>be <1:3>with <1:4>you <1:5>till <1:6>we <1:7>meet <1:8>a<1:9>gain; ",
          "<1:10>'Neath <1:11>His <1:12>wings <1:13>pro<1:14>tect<1:15>ing <1:16>hide <1:17>you, ",
          "<1:18>Dai<1:19>ly <1:20>man<1:21>na <1:22>still <1:23>pro<1:24>vide <1:25>you; ",
          "<1:26>God <1:27>be <1:28>with <1:29>you <1:30>till <1:31>we <1:32>meet <1:33>a<1:34>gain."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>God <1:2>be <1:3>with <1:4>you <1:5>till <1:6>we <1:7>meet <1:8>a<1:9>gain; ",
          "<1:10>When <1:11>life's <1:12>per<1:13>ils <1:14>thick <1:15>con<1:16>found <1:17>you, ",
          "<1:18>Put <1:19>His <1:20>arms <1:21>un<1:22>fail<1:23>ing <1:24>round <1:25>you; ",
          "<1:26>God <1:27>be <1:28>with <1:29>you <1:30>till <1:31>we <1:32>meet <1:33>a<1:34>gain."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "<1:1>God <1:2>be <1:3>with <1:4>you <1:5>till <1:6>we <1:7>meet <1:8>a<1:9>gain; ",
          "<1:10>Keep <1:11>love's <1:12>ban<1:13>ner <1:14>float<1:15>ing <1:16>o'er <1:17>you, ",
          "<1:18>Smite <1:19>death's <1:20>threat<1:21>ening <1:22>wave <1:23>be<1:24>fore <1:25>you; ",
          "<1:26>God <1:27>be <1:28>with <1:29>you <1:30>till <1:31>we <1:32>meet <1:33>a<1:34>gain."
        ]
      }
    ],
    "chorus": [
      "<1:1>Till <1:2>we <1:3,4,5>meet, <1:6>till <1:7>we <1:8,9>meet, ",
      "<1:10>Till <1:11>we <1:12>meet <1:13>at <1:14,15>Je<1:16,17>sus' <1:18>feet, ",
      "<1:19>Till <1:20>we <1:21,22,23>meet, <1:24>till <1:25>we <1:26,27>meet, ",
      "<1:28>God <1:29>be <1:30>with <1:31>you <1:32>till <1:33>we <1:34>meet <1:35>a<1:36>gain."
    ],
    "timestamps": {
      "chorus": 23.7129
    },
    "chorusMarker": {
      "track": 1,
      "index": 35
    }
  },
  {
    "hymnNumber": 66,
    "reference": "SDAH066",
    "title": "God Be With You",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>God <1:2>be <1:3>with <1:4>you <1:5>till <1:6>we <1:7,8>meet <1:9>a<1:10>gain;",
          "<1:11>By <1:12>His <1:13,14>coun<1:15>sels <1:16>guide, <1:17,18>up<1:19>hold <1:20>you,",
          "<1:21>With <1:22>His <1:23>sheep <1:24>se<1:25>cure<1:26,27>ly <1:28>fold <1:29>you:",
          "<1:30>God <1:31>be <1:32>with <1:33>you <1:34>till <1:35>we <1:36,37>meet <1:38>a<1:39>gain."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>God <1:2>be <1:3>with <1:4>you <1:5>till <1:6>we <1:7,8>meet <1:9>a<1:10>gain;",
          "<1:11>Neath <1:12>His <1:13,14>wings <1:15>se<1:16>cure<1:17,18>ly <1:19>hide <1:20>you,",
          "<1:21>Dai<1:22>ly <1:23>man<1:24>na <1:25>still <1:26,27>pro<1:28>vide <1:29>you:",
          "<1:30>God <1:31>be <1:32>with <1:33>you <1:34>till <1:35>we <1:36,37>meet <1:38>a<1:39>gain."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>God <1:2>be <1:3>with <1:4>you <1:5>till <1:6>we <1:7,8>meet <1:9>a<1:10>gain;",
          "<1:11>When <1:12>life's <1:13,14>per<1:15>ils <1:16>thick <1:17,18>con<1:19>found <1:20>you,",
          "<1:21>Put <1:22>His <1:23>arms <1:24>un<1:25>fail<1:26,27>ing <1:28>round <1:29>you:",
          "<1:30>God <1:31>be <1:32>with <1:33>you <1:34>till <1:35>we <1:36,37>meet <1:38>a<1:39>gain."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "<1:1>God <1:2>be <1:3>with <1:4>you <1:5>till <1:6>we <1:7,8>meet <1:9>a<1:10>gain;",
          "<1:11>Keep <1:12>love's <1:13,14>ban<1:15>ner <1:16>float<1:17,18>ing <1:19>o'er <1:20>you,",
          "<1:21>Smite <1:22>death's <1:23>threat<1:24>ening <1:25>wave <1:26,27>be<1:28>fore <1:29>you:",
          "<1:30>God <1:31>be <1:32>with <1:33>you <1:34>till <1:35>we <1:36,37>meet <1:38>a<1:39>gain."
        ]
      }
    ]
  },
  {
    "hymnNumber": 67,
    "reference": "SDAH067",
    "title": "O Lord Now Let Your Servant",
    "hasMidi": true,
    "numberOfVerses": 2,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>O <1:2>Lord, <1:3>now <1:4>let <1:5,6>Your <1:7>ser<1:8>vant",
          "<1:9>De<1:10>part <1:11>in <1:12>heav'n<1:13>ly <1:14>peace,",
          "<1:15>For <1:16>I <1:17>have <1:18>seen <1:19,20>the <1:21>glo<1:22>ry",
          "<1:23>Of <1:24>Your <1:25,26>re<1:27,28>deem<1:29>ing <1:30>grace:",
          "<1:31>A <1:32>light <1:33>to <1:34>lead <1:35>the <1:36,37>Gen<1:38>tiles",
          "<1:39>Un<1:40>to <1:41>Your <1:42>ho<1:43>ly <1:44>hill,",
          "<1:45>The <1:46>glo<1:47>ry <1:48>of <1:49,50>Your <1:51>peo<1:52>ple,",
          "<1:53>Your <1:54>cho<1:55,56>sen <1:57,58>Is<1:59>ra<1:60>el."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>Then <1:2>grant <1:3>that <1:4>I <1:5,6>may <1:7>fol<1:8>low",
          "<1:9>Your <1:10>gleam, <1:11>O <1:12>glo<1:13>rious <1:14>Light,",
          "<1:15>Till <1:16>earth<1:17>ly <1:18>shad<1:19,20>ows <1:21>scat<1:22>ter,",
          "<1:23>And <1:24>faith <1:25,26>is <1:27,28>changed <1:29>to <1:30>sight;",
          "<1:31>Till <1:32>rap<1:33>tured <1:34>saints <1:35>shall <1:36,37>gath<1:38>er",
          "<1:39>Up<1:40>on <1:41>that <1:42>shin<1:43>ing <1:44>shore,",
          "<1:45>Where <1:46>Christ, <1:47>the <1:48>bless<1:49,50>ed <1:51>Day<1:52>star,",
          "<1:53>Shall <1:54>light <1:55,56>them <1:57,58>ev<1:59>er<1:60>more."
        ]
      }
    ]
  },
  {
    "hymnNumber": 68,
    "reference": "SDAH068",
    "title": "On Our Way Rejoicing",
    "hasMidi": true,
    "numberOfVerses": 2,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>On <1:2>our <1:3>way <1:4>re<1:5>joic<1:6>ing",
          "<1:7>Glad<1:8>ly <1:9>let <1:10>us <1:11>go;",
          "<1:12>Con<1:13>quer'd <1:14>hath <1:15>our <1:16>Lead<1:17>er,",
          "<1:18>Van<1:19>quish'd <1:20>is <1:21>the <1:22>foe.",
          "<1:23>Christ <1:24>with<1:25>out, <1:26>our <1:27>safe<1:28>ty;",
          "<1:29>Christ <1:30>with<1:31>in, <1:32,33>our <1:34>joy;",
          "<1:35>Who, <1:36,37>if <1:38>we <1:39>be <1:40>faith<1:41>ful,",
          "<1:42>Can <1:43>our <1:44>hope <1:45>de<1:46>stroy?"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>Un<1:2>to <1:3>God <1:4>the <1:5>Fa<1:6>ther",
          "<1:7>Joy<1:8>ful <1:9>songs <1:10>we <1:11>sing,",
          "<1:12>Un<1:13>to <1:14>God <1:15>the <1:16>Sav<1:17>ior",
          "<1:18>Thank<1:19>ful <1:20>hearts <1:21>we <1:22>bring,",
          "<1:23>Un<1:24>to <1:25>God <1:26>the <1:27>Spir<1:28>it",
          "<1:29>Bow <1:30>we <1:31>and <1:32,33>a<1:34>dore,",
          "<1:35>On <1:36,37>our <1:38>way <1:39>re<1:40>joic<1:41>ing",
          "<1:42>Now <1:43>and <1:44>ev<1:45>er<1:46>more."
        ]
      }
    ],
    "chorus": [
      "<1:1>On <1:2>our <1:3>way <1:4>re<1:5>joic<1:6>ing",
      "<1:7>As <1:8>we <1:9>for<1:10>ward <1:11>move,",
      "<1:12>Hear<1:13>ken <1:14>to <1:15>our <1:16>prais<1:17>es,",
      "<1:18>O <1:19>blest <1:20>God <1:21>of <1:22>love!"
    ],
    "timestamps": {
      "chorus": 31.2834
    },
    "chorusMarker": {
      "track": 1,
      "index": 47
    }
  },
  {
    "hymnNumber": 69,
    "reference": "SDAH069",
    "title": "Lord Make Us More Holy",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>Lord, <1:2>make <1:3>us <1:4>more <1:5>ho<1:6>ly;",
          "<1:7>Lord, <1:8>make <1:9>us <1:10>more <1:11>ho<1:12>ly;",
          "<1:13>Lord, <1:14>make <1:15>us <1:16>more <1:17>ho<1:18,19>ly",
          "<1:20>Un<1:21>til <1:22>we <1:23,24>meet <1:25>a<1:26>gain."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>Lord, <1:2>make <1:3>us <1:4>more <1:5>faith<1:6>ful;",
          "<1:7>Lord, <1:8>make <1:9>us <1:10>more <1:11>faith<1:12>ful;",
          "<1:13>Lord, <1:14>make <1:15>us <1:16>more <1:17>faith<1:18,19>ful",
          "<1:20>Un<1:21>til <1:22>we <1:23,24>meet <1:25>a<1:26>gain."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>Lord, <1:2>make <1:3>us <1:4>more <1:5>hum<1:6>ble;",
          "<1:7>Lord, <1:8>make <1:9>us <1:10>more <1:11>hum<1:12>ble;",
          "<1:13>Lord, <1:14>make <1:15>us <1:16>more <1:17>hum<1:18,19>ble",
          "<1:20>Un<1:21>til <1:22>we <1:23,24>meet <1:25>a<1:26>gain."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "<1:1>Lord, <1:2>make <1:3>us <1:4>more <1:5>lov<1:6>ing;",
          "<1:7>Lord, <1:8>make <1:9>us <1:10>more <1:11>lov<1:12>ing;",
          "<1:13>Lord, <1:14>make <1:15>us <1:16>more <1:17>lov<1:18,19>ing",
          "<1:20>Un<1:21>til <1:22>we <1:23,24>meet <1:25>a<1:26>gain.",
          "<1:27>Like <1:28>Je<1:29>sus, <1:30>the <1:31>Sav<1:32>ior,",
          "<1:33>Un<1:34>til <1:35>we <1:36>meet <1:37>a<1:38>gain."
        ]
      }
    ]
  },
  {
    "hymnNumber": 70,
    "reference": "SDAH070",
    "title": "Praise Ye the Father",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>Praise <1:2>ye <1:3>the <1:4>Fa<1:5>ther <1:6>for <1:7>His <1:8>lov<1:9>ing-<1:10>kind<1:11>ness,",
          "<1:12>Ten<1:13>der<1:14>ly <1:15,16>cares <1:17>He <1:18>for <1:19>His <1:20>err<1:21>ing <1:22>chil<1:23>dren;",
          "<1:24>Praise <1:25>Him, <1:26>ye <1:27,28>an<1:29>gels, <1:30>praise <1:31>Him <1:32>in <1:33>the <1:34,35>heav<1:36>ens;",
          "<1:37>Praise <1:38>ye <1:39>Je<1:40,41>ho<1:42>vah!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>Praise <1:2>ye <1:3>the <1:4>Sav<1:5>ior, <1:6>great <1:7>is <1:8>His <1:9>com<1:10>pas<1:11>sion,",
          "<1:12>Gra<1:13>cious<1:14>ly <1:15,16>cares <1:17>He <1:18>for <1:19>His <1:20>cho<1:21>sen <1:22>peo<1:23>ple;",
          "<1:24>Young <1:25>men <1:26>and <1:27,28>maid<1:29>ens, <1:30>ye <1:31>old <1:32>men <1:33>and <1:34,35>chil<1:36>dren,",
          "<1:37>Praise <1:38>ye <1:39>the <1:40,41>Sav<1:42>ior!"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>Praise <1:2>ye <1:3>the <1:4>Spir<1:5>it, <1:6>Com<1:7>fort<1:8>er <1:9>of <1:10>Is<1:11>rael,",
          "<1:12>Sent <1:13>of <1:14>the <1:15,16>Fa<1:17>ther <1:18>and <1:19>the <1:20>Son <1:21>to <1:22>bless <1:23>us;",
          "<1:24>Praise <1:25>ye <1:26>the <1:27,28>Fa<1:29>ther, <1:30>Son, <1:31>and <1:32>Ho<1:33>ly <1:34,35>Spir<1:36>it,",
          "<1:37>Praise <1:38>the <1:39>E<1:40>ter<1:41>nal <1:42>Three!"
        ]
      }
    ]
  },
  {
    "hymnNumber": 71,
    "reference": "SDAH071",
    "title": "Come Thou Almighty King",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>Come, <1:2>Thou <1:3>al<1:4,5>might<1:6>y <1:7>King,",
          "<1:8>Help <1:9>us <1:10>Thy <1:11,12,13>name <1:14>to <1:15>sing,",
          "<1:16>Help <1:17>us <1:18>to <1:19>praise!",
          "<1:20>Fa<1:21>ther <1:22>all <1:23>glo<1:24>ri<1:25>ous,",
          "<1:26>O'er <1:27>all <1:28>vic<1:29>to<1:30>ri<1:31>ous,",
          "<1:32>Come, <1:33>and <1:34>reign <1:35>ov<1:36>er <1:37>us,",
          "<1:38>An<1:39>cient <1:40>of <1:41>Days!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>Come, <1:2>Thou <1:3>in<1:4,5>car<1:6>nate <1:7>Word,",
          "<1:8>Gird <1:9>on <1:10>Thy <1:11,12,13>might<1:14>y <1:15>sword,",
          "<1:16>Our <1:17>prayer <1:18>at<1:19>tend;",
          "<1:20>Come, <1:21>and <1:22>Thy <1:23>peo<1:24>ple <1:25>bless,",
          "<1:26>And <1:27>give <1:28>Thy <1:29>Word <1:30>suc<1:31>cess;",
          "<1:32>Spir<1:33>it <1:34>of <1:35>ho<1:36>li<1:37>ness,",
          "<1:38>On <1:39>us <1:40>de<1:41>scend!"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>Come, <1:2>ho<1:3>ly <1:4,5>Com<1:6>fort<1:7>er,",
          "<1:8>Thy <1:9>sa<1:10>cred <1:11,12,13>wit<1:14>ness <1:15>bear,",
          "<1:16>In <1:17>this <1:18>glad <1:19>hour:",
          "<1:20>Thou <1:21>who <1:22>al<1:23>might<1:24>y <1:25>art,",
          "<1:26>Now <1:27>rule <1:28>in <1:29>ev<1:30>ery <1:31>heart,",
          "<1:32>And <1:33>ne'er <1:34>from <1:35>us <1:36>de<1:37>part,",
          "<1:38>Spir<1:39>it <1:40>of <1:41>power!"
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "<1:1>To <1:2>Thee, <1:3>great <1:4,5>One <1:6>in <1:7>Three,",
          "<1:8>E<1:9>ter<1:10>nal <1:11,12,13>prais<1:14>es <1:15>be,",
          "<1:16>Hence, <1:17>ev<1:18>er<1:19>more:",
          "<1:20>Thy <1:21>sov<1:22>ereign <1:23>maj<1:24>es<1:25>ty",
          "<1:26>May <1:27>we <1:28>in <1:29>glo<1:30>ry <1:31>see,",
          "<1:32>And <1:33>to <1:34>e<1:35>ter<1:36>ni<1:37>ty",
          "<1:38>Love <1:39>and <1:40>a<1:41>dore!"
        ]
      }
    ]
  },
  {
    "hymnNumber": 72,
    "reference": "SDAH072",
    "title": "Creator of the Stars of Night",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>Cre<1:2>a<1:3>tor <1:4>of <1:5>the <1:6>stars <1:7>of <1:8>night,",
          "<1:9>Thy <1:10>peo<1:11>ple's <1:12>ev<1:13>er<1:14>last<1:15>ing <1:16>light,",
          "<1:17>O <1:18>Christ, <1:19>Thou <1:20>Sav<1:21>ior <1:22>of <1:23>us <1:24>all,",
          "<1:25>We <1:26>pray <1:27>Thee, <1:28>hear <1:29>us <1:30>when <1:31>we <1:32,33>call.",
          "<1:34>A<1:35>men."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>At <1:2>the <1:3>great <1:4>name <1:5>of <1:6>Je<1:7>sus, <1:8>now",
          "<1:9>All <1:10>knees <1:11>must <1:12>bend, <1:13>all <1:14>hearts <1:15>must <1:16>bow;",
          "<1:17>And <1:18>things <1:19>ce<1:20>les<1:21>tial <1:22>Thee <1:23>shall <1:24>own,",
          "<1:25>And <1:26>things <1:27>ter<1:28>res<1:29>tial, <1:30>Lord <1:31>a<1:32,33>lone.",
          "<1:34>A<1:35>men"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>To <1:2>God <1:3>the <1:4>Fa<1:5>ther, <1:6>God <1:7>the <1:8>Son,",
          "<1:9>And <1:10>God <1:11>the <1:12>Spir<1:13>it, <1:14>Three <1:15>in <1:16>one,",
          "<1:17>Laud, <1:18>hon<1:19>or, <1:20>might, <1:21>and <1:22>glo<1:23>ry <1:24>be",
          "<1:25>From <1:26>age <1:27>to <1:28>age <1:29>e<1:30>ter<1:31>nal<1:32,33>ly.",
          "<1:34>A<1:35>men"
        ]
      }
    ]
  },
  {
    "hymnNumber": 73,
    "reference": "SDAH073",
    "title": "Holy, Holy, Holy",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>Ho<1:2>ly, <1:3>ho<1:4>ly, <1:5>ho<1:6>ly! ",
          "<1:7,8>Lord <1:9>God <1:10>Al<1:11>might<1:12>y! ",
          "<1:13>Ear<1:14>ly <1:15>in <1:16>the <1:17,18>morn<1:19>ing <1:20>our <1:21>song <1:22>shall <1:23>rise <1:24>to <1:25>Thee; ",
          "<1:26>Ho<1:27>ly, <1:28>ho<1:29>ly, <1:30,31>ho<1:32>ly! <1:33>mer<1:34>ci<1:35>ful <1:36>and <1:37>might<1:38>y! ",
          "<1:39>God <1:40>in <1:41>three <1:42>per<1:43>sons, <1:44>bless<1:45>ed <1:46>Trin<1:47>i<1:48>ty!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>Ho<1:2>ly, <1:3>ho<1:4>ly, <1:5>ho<1:6>ly! ",
          "<1:7,8>An<1:9>gels <1:10>a<1:11>dore <1:12>Thee, ",
          "<1:13>Cast<1:14>ing <1:15>down <1:16>their <1:17,18>bright <1:19>crowns <1:20>a<1:21>round <1:22>the <1:23>glass<1:24>y <1:25>sea; ",
          "<1:26>Thou<1:27>sands <1:28>and <1:29>ten <1:30,31>thou<1:32>sands <1:33>wor<1:34>ship <1:35>low <1:36>be<1:37>fore <1:38>Thee, ",
          "<1:39>Which <1:40>wert, <1:41>and <1:42>art, <1:43>and <1:44>ev<1:45>er<1:46>more <1:47>shalt <1:48>be."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>Ho<1:2>ly, <1:3>ho<1:4>ly, <1:5>ho<1:6>ly! ",
          "<1:7,8>Though <1:9>dark<1:10>ness <1:11>hide <1:12>Thee, ",
          "<1:13>Though <1:14>the <1:15>eye <1:16>of <1:17,18>man <1:19>Thy <1:20>great <1:21>glo<1:22>ry <1:23>may <1:24>not <1:25>see; ",
          "<1:26>On<1:27>ly <1:28>Thou <1:29>art <1:30,31>ho<1:32>ly; <1:33>there <1:34>is <1:35>none <1:36>be<1:37>side <1:38>Thee, ",
          "<1:39>Per<1:40>fect <1:41>in <1:42>power, <1:43>in <1:44>love <1:45>and <1:46>pu<1:47>ri<1:48>ty."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "<1:1>Ho<1:2>ly, <1:3>ho<1:4>ly, <1:5>ho<1:6>ly! ",
          "<1:7,8>Lord <1:9>God <1:10>Al<1:11>might<1:12>y! ",
          "<1:13>All <1:14>Thy <1:15>works <1:16>shall <1:17>praise <1:18>Thy <1:19>name <1:20>in <1:21>earth <1:22>and <1:23>sky <1:24>and <1:25>sea; ",
          "<1:26>Ho<1:27>ly, <1:28>ho<1:29>ly, <1:30,31>ho<1:32>ly! <1:33>mer<1:34>ci<1:35>ful <1:36>and <1:37>might<1:38>y! ",
          "<1:39>God <1:40>in <1:41>three <1:42>per<1:43>sons, <1:44>bless<1:45>ed <1:46>Trin<1:47>i<1:48>ty!"
        ]
      }
    ]
  },
  {
    "hymnNumber": 74,
    "reference": "SDAH074",
    "title": "Like a River Glorious",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>Like <1:2>a <1:3>riv<1:4>er <1:5>glo<1:6>rious",
          "<1:7>Is <1:8>God's <1:9>per<1:10>fect <1:11>peace,",
          "<1:12>O<1:13>ver <1:14>all <1:15>vic<1:16>to<1:17>rious",
          "<1:18>In <1:19>its <1:20>bright <1:21>in<1:22>crease;",
          "<1:23>Per<1:24>fect, <1:25>yet <1:26>it <1:27>flow<1:28>eth",
          "<1:29>Full<1:30>er <1:31>ev<1:32>ery <1:33>day,",
          "<1:34>Per<1:35>fect, <1:36>yet <1:37>it <1:38>grow<1:39>eth",
          "<1:40>Deep<1:41>er <1:42>all <1:43>the <1:44>way."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>Hid<1:2>den <1:3>in <1:4>the <1:5>hol<1:6>low",
          "<1:7>Of <1:8>His <1:9>bless<1:10>ed <1:11>hand,",
          "<1:12>Nev<1:13>er <1:14>foe <1:15>can <1:16>fol<1:17>low,",
          "<1:18>Nev<1:19>er <1:20>trai<1:21>tor <1:22>stand;",
          "<1:23>Not <1:24>a <1:25>surge <1:26>of <1:27>wor<1:28>ry,",
          "<1:29>Not <1:30>a <1:31>shade <1:32>of <1:33>care,",
          "<1:34>Not <1:35>a <1:36>blast <1:37>of <1:38>hur<1:39>ry",
          "<1:40>Touch <1:41>the <1:42>spir<1:43>it <1:44>there."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>Ev<1:2>ery <1:3>joy <1:4>or <1:5>test<1:6>ing",
          "<1:7>Comes <1:8>from <1:9>God <1:10>a<1:11>bove,",
          "<1:12>Giv<1:13>en <1:14>to <1:15>His <1:16>chil<1:17>dren",
          "<1:18>As <1:19>an <1:20>act <1:21>of <1:22>love;",
          "<1:23>We <1:24>may <1:25>trust <1:26>Him <1:27>ful<1:28>ly",
          "<1:29>All <1:30>for <1:31>us <1:32>to <1:33>do;",
          "<1:34>They <1:35>who <1:36>trust <1:37>Him <1:38>whol<1:39>ly",
          "<1:40>Find <1:41>Him <1:42>whol<1:43>ly <1:44>true."
        ]
      }
    ],
    "chorus": [
      "<1:1>Trust<1:2>ing <1:3>in <1:4>Je<1:5>ho<1:6>vah,",
      "<1:7>Hearts <1:8>are <1:9>ful<1:10>ly <1:11>blest;",
      "<1:12>Find<1:13>ing, <1:14>as <1:15>He <1:16>prom<1:17>ised,",
      "<1:18>Per<1:19>fect <1:20>peace <1:21>and <1:22>rest."
    ],
    "timestamps": {
      "chorus": 32.5682
    },
    "chorusMarker": {
      "track": 1,
      "index": 45
    }
  },
  {
    "hymnNumber": 75,
    "reference": "SDAH075",
    "title": "The Wonder of It All",
    "hasMidi": true,
    "numberOfVerses": 2,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>There's <1:2>the <1:3>won<1:4>der <1:5>of <1:6>sun<1:7>set <1:8>at <1:9>eve<1:10>ning,",
          "<1:11>The <1:12>won<1:13>der <1:14>as <1:15>sun<1:16>rise <1:17>I <1:18>see;",
          "<1:19>But <1:20>the <1:21>won<1:22>der <1:23>of <1:24>won<1:25>ders <1:26>that <1:27>thrills <1:28,29>my <1:30>soul",
          "<1:31>Is <1:32>the <1:33>won<1:34>der <1:35>that <1:36>God <1:37>loves <1:38>me."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>There's <1:2>the <1:3>won<1:4>der <1:5>of <1:6>spring<1:7>time <1:8>and <1:9>har<1:10>vest,",
          "<1:11>The <1:12,13>sky, <1:14>the <1:15,16>stars, <1:17>the <1:18>sun;",
          "<1:19>But <1:20>the <1:21>won<1:22>der <1:23>of <1:24>won<1:25>ders <1:26>that <1:27>thrills <1:28,29>my <1:30>soul",
          "<1:31>Is <1:32>a <1:33>won<1:34>der <1:35>that's <1:36>only <1:37>be<1:38>gun."
        ]
      }
    ],
    "chorus": [
      "<1:1>O, <1:2>the <1:3>won<1:4>der <1:5>of <1:6>it <1:7>all!",
      "<1:8>The <1:9>won<1:10>der <1:11>of <1:12>it <1:13>all!",
      "<1:14>Just <1:15>to <1:16>think <1:17>that <1:18,19>God <1:20>loves <1:21>me.",
      "<1:22>O, <1:23>the <1:24>won<1:25>der <1:26>of <1:27>it <1:28>all!",
      "<1:29>The <1:30>won<1:31>der <1:32>of <1:33>it <1:34>all!",
      "<1:35>Just <1:36>to <1:37>think <1:38>that <1:39,40>God <1:41>loves <1:42>me."
    ],
    "timestamps": {
      "chorus": 31.4262
    },
    "chorusMarker": {
      "track": 1,
      "index": 39
    }
  },
  {
    "hymnNumber": 76,
    "reference": "SDAH076",
    "title": "O Love That Wilt Not Let Me Go",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>O <1:2>Love <1:3>that <1:4>wilt <1:5>not <1:6>let <1:7>me <1:8,9>go,",
          "<1:10>I <1:11>rest <1:12>my <1:13>wea<1:14>ry <1:15>soul <1:16>in <1:17,18>Thee;",
          "<1:19>I <1:20>give <1:21>Thee <1:22>back <1:23>the <1:24>life <1:25>I <1:26,27>owe,",
          "<1:28>That <1:29>in <1:30>Thine <1:31>o<1:32>cean <1:33>depths <1:34>its <1:35>flow",
          "<1:36>May <1:37>rich<1:38>er, <1:39>full<1:40>er <1:41>be."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>O <1:2>Light <1:3>that <1:4>fol<1:5>lowest <1:6>all <1:7>my <1:8,9>way,",
          "<1:10>I <1:11>yield <1:12>my <1:13>flick<1:14>ering <1:15>torch <1:16>to <1:17,18>Thee;",
          "<1:19>My <1:20>heart <1:21>re<1:22>stores <1:23>its <1:24>bor<1:25>rowed <1:26,27>ray,",
          "<1:28>That <1:29>in <1:30>Thy <1:31>sun<1:32>shine's <1:33>blaze <1:34>its <1:35>day",
          "<1:36>May <1:37>bright<1:38>er, <1:39>fair<1:40>er <1:41>be."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>O <1:2>Joy <1:3>that <1:4>seek<1:5>est <1:6>me <1:7>through <1:8,9>pain,",
          "<1:10>I <1:11>can<1:12>not <1:13>close <1:14>my <1:15>heart <1:16>to <1:17,18>Thee;",
          "<1:19>I <1:20>trace <1:21>the <1:22>rain<1:23>bow <1:24>through <1:25>the <1:26,27>rain,",
          "<1:28>And <1:29>feel <1:30>the <1:31>prom<1:32>ise <1:33>is <1:34>not <1:35>vain",
          "<1:36>That <1:37>morn <1:38>shall <1:39>tear<1:40>less <1:41>be."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "<1:1>O <1:2>Cross <1:3>that <1:4>lift<1:5>est <1:6>up <1:7>my <1:8,9>head,",
          "<1:10>I <1:11>dare <1:12>not <1:13>ask <1:14>to <1:15>fly <1:16>from <1:17,18>Thee;",
          "<1:19>I <1:20>lay <1:21>in <1:22>dust <1:23>life's <1:24>glo<1:25>ry <1:26,27>dead,",
          "<1:28>And <1:29>from <1:30>the <1:31>ground <1:32>there <1:33>blos<1:34>soms <1:35>red",
          "<1:36>Life <1:37>that <1:38>shall <1:39>end<1:40>less <1:41>be."
        ]
      }
    ]
  },
  {
    "hymnNumber": 77,
    "reference": "SDAH077",
    "title": "O Love of God Most Full",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>O <1:2>love <1:3>of <1:4>God <1:5,6>most <1:7,8>full,",
          "<1:9>O <1:10>love <1:11>of <1:12>God <1:13>most <1:14>free,",
          "<1:15>Come <1:16>warm <1:17>my <1:18>heart, <1:19>come <1:20>fill <1:21,22>my <1:23>soul,",
          "<1:24>Come <1:25>lead <1:26>me <1:27>un<1:28>to <1:29>Thee."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>Warm <1:2>as <1:3>the <1:4>glow<1:5,6>ing <1:7,8>sun",
          "<1:9>So <1:10>shines <1:11>Thy <1:12>love <1:13>on <1:14>me,",
          "<1:15>It <1:16>wraps <1:17>me <1:18>'round <1:19>with <1:20>kind<1:21,22>ly <1:23>care,",
          "<1:24>It <1:25>draws <1:26>me <1:27>un<1:28>to <1:29>Thee."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>The <1:2>wild<1:3>est <1:4>sea <1:5,6>is <1:7,8>calm,",
          "<1:9>The <1:10>tem<1:11>pest <1:12>brings <1:13>no <1:14>fear,",
          "<1:15>The <1:16>dark<1:17>est <1:18>night <1:19>is <1:20>full <1:21,22>of <1:23>light,",
          "<1:24>Be<1:25>cause <1:26>Thy <1:27>love <1:28>is <1:29>near."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "<1:1>O <1:2>love <1:3>of <1:4>God <1:5,6>most <1:7,8>full,",
          "<1:9>O <1:10>love <1:11>of <1:12>God <1:13>most <1:14>free,",
          "<1:15>It <1:16>warms <1:17>my <1:18>heart, <1:19>it <1:20>fills <1:21,22>my <1:23>soul,",
          "<1:24>With <1:25>might <1:26>it <1:27>strength<1:28>ens <1:29>me."
        ]
      }
    ]
  },
  {
    "hymnNumber": 78,
    "reference": "SDAH078",
    "title": "For God So Loved Us",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>For <1:2>God <1:3>so <1:4>loved <1:5>us,",
          "<1:6>He <1:7>sent <1:8>the <1:9>Sav<1:10>ior:",
          "<1:11>For <1:12>God <1:13>so <1:14>loved <1:15>us,",
          "<1:16>and <1:17>loves <1:18>me <1:19>too."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>He <1:2>sent <1:3>the <1:4>Sav<1:5>ior,",
          "<1:6>the <1:7>blest <1:8>Re<1:9>deem<1:10>er;",
          "<1:11>He <1:12>sent <1:13>the <1:14>Sav<1:15>ior",
          "<1:16>to <1:17>set <1:18>me <1:19>free."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>He <1:2>bade <1:3>me <1:4>wel<1:5>come,",
          "<1:6>O <1:7>word <1:8>of <1:9>mer<1:10>cy;",
          "<1:11>He <1:12>bade <1:13>me <1:14>wel<1:15>come,",
          "<1:16>O <1:17>voice <1:18>di<1:19>vine."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "<1:1>Glo<1:2>ry <1:3>and <1:4>hon<1:5>or,",
          "<1:6>O <1:7>Love <1:8>e<1:9>ter<1:10>nal,",
          "<1:11>To <1:12>Him <1:13>be <1:14>giv<1:15>en",
          "<1:16>while <1:17>life <1:18>shall <1:19>last."
        ]
      }
    ],
    "chorus": [
      "<1:1>Love <1:2>so <1:3>un<1:4>end<1:5>ing!",
      "<1:6>I'll <1:7>sing <1:8>His <1:9>prais<1:10>es,",
      "<1:11>God <1:12>loves <1:13>His <1:14>chil<1:15>dren,",
      "<1:16>loves <1:17>e<1:18>ven <1:19>me."
    ],
    "timestamps": {
      "chorus": 12.5966
    },
    "chorusMarker": {
      "track": 1,
      "index": 20
    }
  },
  {
    "hymnNumber": 79,
    "reference": "SDAH079",
    "title": "O Love of God, How Strong and True!",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>O <1:2>love <1:3>of <1:4>God, <1:5>how <1:6>strong <1:7>and <1:8>true! ",
          "<1:9>E<1:10>ter<1:11>nal, <1:12>and <1:13>yet <1:14>ev<1:15>er <1:16>new; ",
          "<1:17>Un<1:18>com<1:19>pre<1:20>hend<1:21>ed <1:22,23>and <1:24>un<1:25>bought, ",
          "<1:26>Be<1:27>yond <1:28>all <1:29>know<1:30>ledge <1:31>and <1:32>all <1:33>thought."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>O <1:2>love <1:3>of <1:4>God, <1:5>how <1:6>deep <1:7>and <1:8>great, ",
          "<1:9>Far <1:10>deep<1:11>er <1:12>than <1:13>man's <1:14>deep<1:15>est <1:16>hate; ",
          "<1:17>Self-<1:18>fed, <1:19>self-<1:20>kin<1:21>dled <1:22,23>like <1:24>the <1:25>light, ",
          "<1:26>Change<1:27>less, <1:28>e<1:29>ter<1:30>nal, <1:31>in<1:32>fi<1:33>nite."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>We <1:2>read <1:3>thee <1:4>best <1:5>in <1:6>Him <1:7>who <1:8>came ",
          "<1:9>To <1:10>bear <1:11>for <1:12>us <1:13>the <1:14>cross <1:15>of <1:16>shame; ",
          "<1:17>Sent <1:18>by <1:19>the <1:20>Fa<1:21>ther <1:22,23>from <1:24>on <1:25>high, ",
          "<1:26>Our <1:27>life <1:28>to <1:29>live, <1:30>our <1:31>death <1:32>to <1:33>die."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "<1:1>We <1:2>read <1:3>thy <1:4>power <1:5>to <1:6>bless <1:7>and <1:8>save, ",
          "<1:9>E'en <1:10>in <1:11>the <1:12>dark<1:13>ness <1:14>of <1:15>the <1:16>grave; ",
          "<1:17>Still <1:18>more <1:19>in <1:20>res<1:21>ur<1:22,23>rec<1:24>tion <1:25>light ",
          "<1:26>We <1:27>read <1:28>the <1:29>full<1:30>ness <1:31>of <1:32>thy <1:33>might."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "<1:1>O <1:2>love <1:3>of <1:4>God, <1:5>our <1:6>shield <1:7>and <1:8>stay ",
          "<1:9>Through <1:10>all <1:11>the <1:12>per<1:13>ils <1:14>of <1:15>our <1:16>way! ",
          "<1:17>E<1:18>ter<1:19>nal <1:20>love, <1:21>in <1:22,23>thee <1:24>we <1:25>rest, ",
          "<1:26>For<1:27>ev<1:28>er <1:29>safe, <1:30>for<1:31>ev<1:32>er <1:33>blest."
        ]
      }
    ]
  },
  {
    "hymnNumber": 80,
    "reference": "SDAH080",
    "title": "O World of God",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>O <1:2>world <1:3>of <1:4,5>God, <1:6>so <1:7>vast <1:8,9>and <1:10>strange,",
          "<1:11>Pro<1:12>found <1:13>and <1:14>won<1:15>der<1:16>ful <1:17>and <1:18>fair,",
          "<1:19>Be<1:20>yond <1:21>the <1:22>ut<1:23>most <1:24>reach <1:25,26>of <1:27>thought,",
          "<1:28>But <1:29>not <1:30>be<1:31>yond <1:32>a <1:33>Fa<1:34>ther's <1:35,36>care! ",
          "<1:37>We <1:38>are <1:39>not <1:40>strang<1:41>ers <1:42>on <1:43>this <1:44>earth",
          "<1:45>Whirl<1:46>ing <1:47>a<1:48>mid <1:49>the <1:50>suns <1:51>of <1:52,53>space;",
          "<1:54>We <1:55>are <1:56>God's <1:57>chil<1:58>dren, <1:59>this <1:60>our <1:61,62,63>home,",
          "<1:64>With <1:65>those <1:66>of <1:67>ev<1:68>ery <1:69>clime <1:70>and <1:71>race."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>O <1:2>world <1:3>of <1:4,5>man <1:6>where <1:7>life <1:8,9>is <1:10>lived,",
          "<1:11>So <1:12>strange<1:13>ly <1:14>min<1:15>gling <1:16>joy <1:17>and <1:18>pain,",
          "<1:19>So <1:20>full <1:21>of <1:22>e<1:23>vil <1:24>and <1:25,26>of <1:27>good,",
          "<1:28>So <1:29>need<1:30>ful <1:31>that <1:32>the <1:33>good <1:34>shall <1:35,36>reign! ",
          "<1:37>It <1:38>is <1:39>this <1:40>world <1:41>that <1:42>God <1:43>has <1:44>loved,",
          "<1:45>And <1:46>good<1:47>ness <1:48>was <1:49>its <1:50>Ma<1:51>ker's <1:52,53>plan,",
          "<1:54>The <1:55>prom<1:56>ise <1:57>of <1:58>God's <1:59>tri<1:60>umph <1:61,62,63>is",
          "<1:64>His <1:65>com<1:66>ing <1:67>in <1:68>a <1:69>Son <1:70>of <1:71>Man."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>O <1:2>world <1:3>of <1:4,5>time's <1:6>far-<1:7>stretch<1:8,9>ing <1:10>years!",
          "<1:11>There <1:12>was <1:13>a <1:14>day <1:15>when <1:16>time <1:17>stood <1:18>still,",
          "<1:19>A <1:20>cen<1:21>tral <1:22>mo<1:23>ment <1:24>when <1:25,26>there <1:27>rose",
          "<1:28>A <1:29>cross <1:30>up<1:31>on <1:32>a <1:33>cru<1:34>el <1:35,36>hill; ",
          "<1:37>In <1:38>pain <1:39>and <1:40>death <1:41>love's <1:42>power <1:43>was <1:44>seen,",
          "<1:45>The <1:46>mys<1:47>ter<1:48>y <1:49>of <1:50>time <1:51>re<1:52,53>vealed,",
          "<1:54>The <1:55>wis<1:56>dom <1:57>of <1:58>the <1:59>ways <1:60>of <1:61,62,63>God,",
          "<1:64>The <1:65>grace <1:66>through <1:67>which <1:68>man's <1:69>hurt <1:70>is <1:71>healed."
        ]
      }
    ]
  },
  {
    "hymnNumber": 81,
    "reference": "SDAH081",
    "title": "Thou I Speak With Tongues",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1,2>Though <1:3>I <1:4,5,6>speak <1:7>with <1:8>tongues <1:9>of <1:10>men <1:11>and <1:12,13>an<1:14>gels,",
          "<1:15,16>Though <1:17>I <1:18,19,20>have <1:21>the <1:22,23>proph<1:24,25>et's <1:26>gift,",
          "<1:27,28>Though <1:29>I <1:30,31,32>hold <1:33>the <1:34>keys <1:35>to <1:36>hid<1:37>den <1:38,39>knowl<1:40>edge,",
          "<1:41,42>Though <1:43>my <1:44,45,46>faith <1:47>can <1:48,49>moun<1:50,51>tains <1:52>shift:",
          "<1:53,54>With<1:55>out <1:56,57,58,59,60>love <1:61>I <1:62,63>am <1:64,65>no <1:66,67>bet<1:68>ter,",
          "<1:69,70>With<1:71>out <1:72,73,74>love <1:75>it's <1:76,77>all <1:78,79>for <1:80,81>naught;",
          "<1:82,83>Lord, <1:84>You <1:85,86,87>spent <1:88>Your <1:89>life <1:90>in <1:91>lov<1:92>ing <1:93>oth<1:94>ers:",
          "<1:95>What <1:96,97>this <1:98,99>means <1:100,101>I <1:102,103>would <1:104,105>be <1:106>taught."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1,2>Love <1:3>is <1:4,5,6>pa<1:7>tient, <1:8,9>knows <1:10,11>no <1:12,13>en<1:14>vy,",
          "<1:15,16>Nev<1:17>er <1:18,19,20>gloats <1:21>when <1:22,23>oth<1:24,25>ers <1:26>sin;",
          "<1:27,28>Love <1:29>is <1:30,31,32>nev<1:33>er <1:34>glad <1:35>to <1:36>see <1:37>in<1:38,39>jus<1:40>tice,",
          "<1:41,42>Al<1:43>ways <1:44,45,46>wants <1:47>the <1:48,49>truth <1:50,51>to <1:52>win.",
          "<1:53,54>There's <1:55>no <1:56,57,58,59,60>end <1:61>to <1:62,63>love's <1:64,65>en<1:66,67>dur<1:68>ance,",
          "<1:69,70>There's <1:71>no <1:72,73,74>test <1:75>it <1:76,77>can<1:78,79>not <1:80,81>face;",
          "<1:82,83>Lord, <1:84>You <1:85,86,87>spent <1:88>Your <1:89>life <1:90>in <1:91>lov<1:92>ing <1:93>oth<1:94>ers:",
          "<1:95>I <1:96,97>shall <1:98,99>fail <1:100,101>with<1:102,103>out <1:104,105>Your <1:106>grace."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1,2>Though <1:3>there'll <1:4,5,6>be <1:7>an <1:8>end <1:9>to <1:10>hid<1:11>den <1:12,13>knowl<1:14>edge,",
          "<1:15,16>Vi<1:17>sions, <1:18,19,20>rap<1:21>tures, <1:22,23>proph<1:24,25>e<1:26>cy:",
          "<1:27,28>Faith <1:29>and <1:30,31,32>hope <1:33>and <1:34>love <1:35>shall <1:36>last <1:37>for<1:38,39>ev<1:40>er,",
          "<1:41,42>Love <1:43>the <1:44,45,46>great<1:47>est <1:48,49>of <1:50,51>the <1:52>three.",
          "<1:53,54>With<1:55>out <1:56,57,58,59,60>love <1:61>I <1:62,63>am <1:64,65>no <1:66,67>bet<1:68>ter,",
          "<1:69,70>With<1:71>out <1:72,73,74>love <1:75>it's <1:76,77>all <1:78,79>for <1:80,81>naught;",
          "<1:82,83>Lord, <1:84>You <1:85,86,87>gave <1:88>Your <1:89>life <1:90>in <1:91>sav<1:92>ing <1:93>oth<1:94>ers:",
          "<1:95>What <1:96,97>this <1:98,99>means <1:100,101>I <1:102,103>would <1:104,105>be <1:106>taught."
        ]
      }
    ]
  },
  {
    "hymnNumber": 82,
    "reference": "SDAH082",
    "title": "Before Jehovah's Awful Throne",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>Be<1:2>fore <1:3>Je<1:4>ho<1:5,6>vah's <1:7>aw<1:8,9>ful <1:10>throne,",
          "<1:11>Ye <1:12>na<1:13>tions <1:14>bow <1:15>with <1:16>sa<1:17>cred <1:18>joy;",
          "<1:19>Know <1:20>that <1:21>the <1:22,23>Lord <1:24,25>is <1:26,27>God <1:28,29>a<1:30>lone;",
          "<1:31>He <1:32>can <1:33>cre<1:34>ate, <1:35>and <1:36>He <1:37>de<1:38>stroy."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>His <1:2>sov<1:3>ereign <1:4>power, <1:5,6>with<1:7>out <1:8,9>our <1:10>aid,",
          "<1:11>Made <1:12>us <1:13>of <1:14>clay, <1:15>and <1:16>formed <1:17>us <1:18>men;",
          "<1:19>And <1:20>when <1:21>like <1:22,23>wan<1:24,25>dering <1:26,27>sheep <1:28,29>we <1:30>strayed,",
          "<1:31>He <1:32>brought <1:33>us <1:34>to <1:35>His <1:36>fold <1:37>a<1:38>gain."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>We'll <1:2>crowd <1:3>His <1:4>gates <1:5,6>with <1:7>thank<1:8,9>ful <1:10>songs,",
          "<1:11>High <1:12>as <1:13>the <1:14>heavens <1:15>our <1:16>voic<1:17>es <1:18>raise;",
          "<1:19>And <1:20>earth, <1:21>with <1:22,23>her <1:24,25>ten <1:26,27>thou<1:28,29>sand <1:30>tongues,",
          "<1:31>Shall <1:32>fill <1:33>His <1:34>courts <1:35>with <1:36>sound<1:37>ing <1:38>praise."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "<1:1>Wide <1:2>as <1:3>the <1:4>world <1:5,6>is <1:7>His <1:8,9>com<1:10>mand,",
          "<1:11>Vast <1:12>as <1:13>E<1:14>ter<1:15>ni<1:16>ty <1:17>His <1:18>love;",
          "<1:19>Firm <1:20>as <1:21>a <1:22,23>rock <1:24,25>His <1:26,27>truth <1:28,29>shall <1:30>stand,",
          "<1:31>When <1:32>roll<1:33>ing <1:34>years <1:35>shall <1:36>cease <1:37>to <1:38>move."
        ]
      }
    ]
  },
  {
    "hymnNumber": 83,
    "reference": "SDAH083",
    "title": "O Worship the King",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>O <1:2>wor<1:3>ship <1:4>the <1:5>King, <1:6>all-<1:7>glo<1:8>rious <1:9>a<1:10>bove,",
          "<1:11>O <1:12>grate<1:13>ful<1:14>ly <1:15>sing <1:16>His <1:17>won<1:18>der<1:19>ful <1:20>love;",
          "<1:21>Our <1:22>shield <1:23>and <1:24>de<1:25>fend<1:26>er, <1:27>the <1:28>An<1:29>cient <1:30>of <1:31>days,",
          "<1:32>Pa<1:33>vil<1:34>ioned <1:35>in <1:36>splen<1:37>dor, <1:38>and <1:39>gird<1:40>ed <1:41>with <1:42>praise."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>O <1:2>tell <1:3>of <1:4>His <1:5>might, <1:6>O <1:7>sing <1:8>of <1:9>His <1:10>grace,",
          "<1:11>Whose <1:12>robe <1:13>is <1:14>the <1:15>light, <1:16>whose <1:17>can<1:18>o<1:19>py <1:20>space;",
          "<1:21>His <1:22>char<1:23>iots <1:24>of <1:25>wrath <1:26>the <1:27>deep <1:28>thun<1:29>der<1:30>clouds <1:31>form,",
          "<1:32>And <1:33>dark <1:34>is <1:35>His <1:36>path <1:37>on <1:38>the <1:39>wings <1:40>of <1:41>the <1:42>storm."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>Thy <1:2>boun<1:3>ti<1:4>ful <1:5>care, <1:6>what <1:7>tongue <1:8>can <1:9>re<1:10>cite?",
          "<1:11>It <1:12>breathes <1:13>in <1:14>the <1:15>air, <1:16>it <1:17>shines <1:18>in <1:19>the <1:20>light;",
          "<1:21>It <1:22>streams <1:23>from <1:24>the <1:25>hills, <1:26>it <1:27>de<1:28>scends <1:29>to <1:30>the <1:31>plain,",
          "<1:32>And <1:33>sweet<1:34>ly <1:35>dis<1:36>tills <1:37>in <1:38>the <1:39>dew <1:40>and <1:41>the <1:42>rain."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "<1:1>Frail <1:2>chil<1:3>dren <1:4>of <1:5>dust, <1:6>and <1:7>fee<1:8>ble <1:9>as <1:10>frail,",
          "<1:11>In <1:12>Thee <1:13>do <1:14>we <1:15>trust, <1:16>nor <1:17>find <1:18>Thee <1:19>to <1:20>fail;",
          "<1:21>Thy <1:22>mer<1:23>cies, <1:24>how <1:25>ten<1:26>der! <1:27>how <1:28>firm <1:29>to <1:30>the <1:31>end!",
          "<1:32>Our <1:33>Mak<1:34>er, <1:35>De<1:36>fend<1:37>er, <1:38>Re<1:39>deem<1:40>er, <1:41>and <1:42>Friend!"
        ]
      }
    ]
  },
  {
    "hymnNumber": 84,
    "reference": "SDAH084",
    "title": "God the Omnipotent",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>God <1:2>the <1:3>Om<1:4>nip<1:5>o<1:6>tent! <1:7>King, <1:8>who <1:9>or<1:10>dain<1:11>est",
          "<1:12>Great <1:13>winds <1:14>Thy <1:15>clar<1:16>ions, <1:17>the <1:18>light<1:19>nings <1:20>Thy <1:21>sword;",
          "<1:22>Show <1:23>forth <1:24>Thy <1:25>pit<1:26>y <1:27>on <1:28>high <1:29>where <1:30>Thou <1:31>reign<1:32>est,",
          "<1:33>Give <1:34>to <1:35>us <1:36>peace, <1:37>O <1:38>most <1:39>mer<1:40>ci<1:41>ful <1:42>Lord."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>God <1:2>the <1:3>all-<1:4>mer<1:5>ci<1:6>ful! <1:7>earth <1:8>hath <1:9>for<1:10>sa<1:11>ken",
          "<1:12>Thy <1:13>pre<1:14>cepts <1:15>ho<1:16>ly, <1:17>and <1:18>slight<1:19>ed <1:20>Thy <1:21>word;",
          "<1:22>Bid <1:23>not <1:24>Thy <1:25>wrath <1:26>in <1:27>its <1:28>ter<1:29>rors <1:30>a<1:31>wak<1:32>en;",
          "<1:33>Give <1:34>to <1:35>us <1:36>peace, <1:37>O <1:38>most <1:39>mer<1:40>ci<1:41>ful <1:42>Lord."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>God <1:2>the <1:3>all-<1:4>righ<1:5>teous <1:6>One! <1:7>man <1:8>hath <1:9>de<1:10>fied <1:11>Thee;",
          "<1:12>Yet <1:13>to <1:14>e<1:15>ter<1:16>ni<1:17>ty <1:18>stan<1:19>deth <1:20>Thy <1:21>word;",
          "<1:22>False<1:23>hood <1:24>and <1:25>wrong <1:26>shall <1:27>not <1:28>tar<1:29>ry <1:30>be<1:31>side <1:32>Thee;",
          "<1:33>Pros<1:34>per <1:35>the <1:36>right, <1:37>O <1:38>most <1:39>mer<1:40>ci<1:41>ful <1:42>Lord."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "<1:1>So <1:2>shall <1:3>we <1:4>ren<1:5>der <1:6>Thee <1:7>thank<1:8>ful <1:9>de<1:10>vo<1:11>tion,",
          "<1:12>For <1:13>Thy <1:14>de<1:15>liv<1:16>erance <1:17>from <1:18>per<1:19>il <1:20>and <1:21>sword,",
          "<1:22>Sing<1:23>ing <1:24>in <1:25>cho<1:26>rus <1:27>from <1:28>o<1:29>cean <1:30>to <1:31>o<1:32>cean,",
          "\"<1:33>Thine <1:34>is <1:35>the <1:36>power <1:37>and <1:38>the <1:39>glo<1:40>ry, <1:41>O <1:42>Lord.\""
        ]
      }
    ]
  },
  {
    "hymnNumber": 85,
    "reference": "SDAH085",
    "title": "Eternal Father, Strong to Save",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>E<1:2>ter<1:3>nal <1:4>Fa<1:5>ther, <1:6>strong <1:7>to <1:8>save,",
          "<1:9>Whose <1:10>arm <1:11>hath <1:12>bound <1:13>the <1:14>rest<1:15>less <1:16>wave,",
          "<1:17>Who <1:18>bid'st <1:19>the <1:20>might<1:21>y <1:22>o<1:23>cean <1:24>deep",
          "<1:25>Its <1:26>own <1:27>ap<1:28>point<1:29>ed <1:30>lim<1:31>its <1:32>keep;",
          "<1:33>Oh, <1:34>hear <1:35>us <1:36>when <1:37>we <1:38>cry <1:39>to <1:40>Thee",
          "<1:41>For <1:42>those <1:43>in <1:44>per<1:45>il <1:46>on <1:47>the <1:48>sea."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>O <1:2>Christ, <1:3>whose <1:4>voice <1:5>the <1:6>wa<1:7>ters <1:8>heard,",
          "<1:9>And <1:10>hushed <1:11>their <1:12>rag<1:13>ing <1:14>at <1:15>Thy <1:16>word,",
          "<1:17>Who <1:18>walkedst <1:19>on <1:20>the <1:21>foam<1:22>ing <1:23>deep,",
          "<1:25>And <1:26>calm <1:27>a<1:28>midst <1:29>its <1:30>rage <1:31>didst <1:32>sleep;",
          "<1:33>Oh, <1:34>hear <1:35>us <1:36>when <1:37>we <1:38>cry <1:39>to <1:40>Thee",
          "<1:41>For <1:42>those <1:43>in <1:44>per<1:45>il <1:46>on <1:47>the <1:48>sea."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>O <1:2>Ho<1:3>ly <1:4>Spir<1:5>it, <1:6>who <1:7>didst <1:8>brood",
          "<1:9>Up<1:10>on <1:11>the <1:12>wa<1:13>ters <1:14>dark <1:15>and <1:16>rude,",
          "<1:17>And <1:18>bid <1:19>their <1:20>an<1:21>gry <1:22>tu<1:23>mult <1:24>cease,",
          "<1:25>And <1:26>give, <1:27>for <1:28>wild <1:29>con<1:30>fu<1:31>sion, <1:32>peace:",
          "<1:33>Oh, <1:34>hear <1:35>us <1:36>when <1:37>we <1:38>cry <1:39>to <1:40>Thee",
          "<1:41>For <1:42>those <1:43>in <1:44>per<1:45>il <1:46>on <1:47>the <1:48>sea."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "<1:1>O <1:2>Trin<1:3>i<1:4>ty <1:5>of <1:6>love <1:7>and <1:8>power,",
          "<1:9>All <1:10>trav<1:11>'lers <1:12>shield <1:13>in <1:14>dan<1:15>ger's <1:16>hour;",
          "<1:17>From <1:18>rock <1:19>and <1:20>tem<1:21>pest, <1:22>fire <1:23>and <1:24>foe,",
          "<1:25>Pro<1:26>tect <1:27>them <1:28>where<1:29>so<1:30>e'er <1:31>they <1:32>go;",
          "<1:33>Thus <1:34>ev<1:35>er<1:36>more <1:37>shall <1:38>rise <1:39>to <1:40>Thee",
          "<1:41>Glad <1:42>hymns <1:43>of <1:44>praise <1:45>from <1:46>land <1:47>and <1:48>sea."
        ]
      }
    ]
  },
  {
    "hymnNumber": 86,
    "reference": "SDAH086",
    "title": "How Great Thou Art",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>O <1:2>Lord <1:3>my <1:4>God! <1:5>when <1:6>I <1:7>in <1:8>awe<1:9>some <1:10>won<1:11>der",
          "<1:12>Con<1:13>si<1:14>der <1:15>all <1:16>the <1:17>works <1:18>Thy <1:19>hands <1:20>have <1:21>made,",
          "<1:22>I <1:23>see <1:24>the <1:25>stars, <1:26>I <1:27>hear <1:28>the <1:29>migh<1:30>ty <1:31>thun<1:32>der,",
          "<1:33>Thy <1:34>pow'r <1:35>thro'<1:36>out <1:37>the <1:38>u<1:39>ni<1:40>verse <1:41>dis<1:42>played,"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>When <1:2>thro'<1:3>the <1:4>woods <1:5>and <1:6>fo<1:7>rest <1:8>glades <1:9>I <1:10>wan<1:11>der",
          "<1:12>And <1:13>hear <1:14>the <1:15>birds <1:16>sing <1:17>sweet<1:18>ly <1:19>in <1:20>the <1:21>trees;",
          "<1:22>When <1:23>I <1:24>look <1:25>down <1:26>from <1:27>lof<1:28>ty <1:29>moun<1:30>tain <1:31>gran<1:32>deur",
          "<1:33>And <1:34>hear <1:35>the <1:36>brook <1:37>and <1:38>feel <1:39>the <1:40>gen<1:41>tle <1:42>breeze;"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>And <1:2>when <1:3>I <1:4>think <1:5>that <1:6>God, <1:7>His <1:8>Son <1:9>not <1:10>spa<1:11>ring,",
          "<1:12>Sent <1:13>Him <1:14>to <1:15>die, <1:16>I <1:17>scarce <1:18>can <1:19>take <1:20>it <1:21>in;",
          "<1:22>That <1:23>on <1:24>the <1:25>cross, <1:26>my <1:27>bur<1:28>den <1:29>glad<1:30>ly <1:31>bea<1:32>ring,",
          "<1:33>He <1:34>bled <1:35>and <1:36>died <1:37>to <1:38>take <1:39>a<1:40>way <1:41>my <1:42>sin;"
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "<1:1>When <1:2>Christ <1:3>shall <1:4>come <1:5>with <1:6>shout <1:7>of <1:8>ac<1:9>cla<1:10>ma<1:11>tion",
          "<1:12>And <1:13>take <1:14>me <1:15>home, <1:16>what <1:17>joy <1:18>shall <1:19>fill <1:20>my <1:21>heart!",
          "<1:22>Then <1:23>I <1:24>shall <1:25>bow <1:26>in <1:27>hum<1:28>ble <1:29>a<1:30>do<1:31>ra<1:32>tion",
          "<1:33>And <1:34>there <1:35>pro<1:36>claim, <1:37>my <1:38>God, <1:39>how <1:40>great <1:41>Thou <1:42>art!"
        ]
      }
    ],
    "chorus": [
      "<1:1>Then <1:2>sings <1:3>my <1:4>soul, <1:5>my <1:6>Sa<1:7>vior <1:8>God <1:9>to <1:10>Thee;",
      "<1:11>How <1:12>great <1:13>Thou <1:14>art, <1:15>how <1:16>great <1:17>Thou <1:18>art!",
      "<1:19>Then <1:20>sings <1:21>my <1:22>soul, <1:23>my <1:24>Sa<1:25>vior <1:26>God <1:27>to <1:28>Thee;",
      "<1:29>How <1:30>great <1:31>Thou <1:32>art, <1:33>how <1:34>great <1:35>Thou <1:36>art!"
    ],
    "timestamps": {
      "chorus": 31.5539
    },
    "chorusMarker": {
      "track": 1,
      "index": 43
    }
  },
  {
    "hymnNumber": 87,
    "reference": "SDAH087",
    "title": "God Who Spoke in the Beginning",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>God <1:2>who <1:3>spoke <1:4>in <1:5>the <1:6>be<1:7>gin<1:8>ning,",
          "<1:9>Form<1:10>ing <1:11>rock <1:12>and <1:13>shap<1:14>ing <1:15>spar,",
          "<1:16>Set <1:17>all <1:18>life <1:19>and <1:20>growth <1:21>in <1:22>mo<1:23>tion,",
          "<1:24>Earth<1:25>ly <1:26>world <1:27>and <1:28>dis<1:29>tant <1:30>star;",
          "<1:31>He <1:32>who <1:33>calls <1:34>the <1:35>earth <1:36>to <1:37>or<1:38>der",
          "<1:39>Is <1:40>the <1:41>ground <1:42>of <1:43>what <1:44>we <1:45>are."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>God <1:2>who <1:3>spoke <1:4>thro' <1:5>men <1:6>and <1:7>na<1:8>tions,",
          "<1:9>Thro' <1:10>e<1:11>vents <1:12>long <1:13>past <1:14>and <1:15>gone,",
          "<1:16>Show<1:17>ing <1:18>still <1:19>to<1:20>day <1:21>His <1:22>pur<1:23>pose,",
          "<1:24>Speaks <1:25>su<1:26>preme<1:27>ly <1:28>through <1:29>His <1:30>Son;",
          "<1:31>He <1:32>who <1:33>calls <1:34>the <1:35>earth <1:36>to <1:37>or<1:38>der",
          "<1:39>Gives <1:40>His <1:41>word <1:42>and <1:43>it <1:44>is <1:45>done."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>God <1:2>whose <1:3>speech <1:4>be<1:5>comes <1:6>in<1:7>car<1:8>nate-",
          "<1:9>Christ <1:10>is <1:11>ser<1:12>vant, <1:13>Christ <1:14>is <1:15>Lord-",
          "<1:16>Calls <1:17>us <1:18>to <1:19>a <1:20>life <1:21>of <1:22>ser<1:23>vice,",
          "<1:24>Heart <1:25>and <1:26>will <1:27>to <1:28>ac<1:29>tion <1:30>stirred;",
          "<1:31>He <1:32>who <1:33>us<1:34>es <1:35>man's <1:36>o<1:37>be<1:38>dience",
          "<1:39>Has <1:40>the <1:41>first <1:42>and <1:43>fi<1:44>nal <1:45>word."
        ]
      }
    ]
  },
  {
    "hymnNumber": 88,
    "reference": "SDAH088",
    "title": "I Sing the Mighty Power of God",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>I <1:2>sing <1:3>the <1:4>might<1:5>y <1:6>pow<1:7>er <1:8>of <1:9>God,",
          "<1:10>That <1:11>made <1:12>the <1:13>moun<1:14>tains <1:15>rise,",
          "<1:16>That <1:17>spread <1:18>the <1:19>flow<1:20>ing <1:21>seas <1:22>a<1:23>broad,",
          "<1:24>And <1:25>built <1:26>the <1:27>lof<1:28>ty <1:29>skies;",
          "<1:30>I <1:31>sing <1:32>the <1:33>wis<1:34>dom <1:35>that <1:36>or<1:37>dained",
          "<1:38>The <1:39>sun <1:40>to <1:41>rule <1:42>the <1:43>day;",
          "<1:44>The <1:45>moon <1:46>shines <1:47>full <1:48>at <1:49>His <1:50>com<1:51>mand,",
          "<1:52>And <1:53>all <1:54>the <1:55>stars <1:56>o<1:57>bey."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>I <1:2>sing <1:3>the <1:4>good<1:5>ness <1:6>of <1:7>the <1:8>Lord,",
          "<1:10>That <1:11>filled <1:12>the <1:13>earth <1:14>with <1:15>food;",
          "<1:16>He <1:17>formed <1:18>the <1:19>crea<1:20>tures <1:21>with <1:22>His <1:23>word,",
          "<1:24>And <1:25>then <1:26>pro<1:27>nounced <1:28>them <1:29>good.",
          "<1:30>Lord, <1:31>how <1:32>Thy <1:33>won<1:34>ders <1:35>are <1:36>dis<1:37>played",
          "<1:38>Wher<1:39>e'er <1:40>I <1:41>turn <1:42>my <1:43>eye!",
          "<1:44>If <1:45>I <1:46>sur<1:47>vey <1:48>the <1:49>ground <1:50>I <1:51>tread,",
          "<1:52>Or <1:53>gaze <1:54>up<1:55>on <1:56>the <1:57>sky!"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>There's <1:2>not <1:3>a <1:4>plant <1:5>or <1:6>flow<1:7>er <1:8>be<1:9>low",
          "<1:10>But <1:11>makes <1:12>Thy <1:13>glo<1:14>ries <1:15>known;",
          "<1:16>And <1:17>clouds <1:18>a<1:19>rise, <1:20>and <1:21>tem<1:22>pests <1:23>blow,",
          "<1:24>By <1:25>or<1:26>der <1:27>from <1:28>Thy <1:29>throne.",
          "<1:30>Crea<1:31>tures <1:32>that <1:33>bor<1:34>row <1:35>life <1:36>from <1:37>Thee",
          "<1:38>Are <1:39>sub<1:40>ject <1:41>to <1:42>Thy <1:43>care;",
          "<1:44>There's <1:45>not <1:46>a <1:47>place <1:48>where <1:49>we <1:50>can <1:51>flee",
          "<1:52>But <1:53>God <1:54>is <1:55>pres<1:56>ent <1:57>there."
        ]
      }
    ]
  },
  {
    "hymnNumber": 89,
    "reference": "SDAH089",
    "title": "Let All On Earth Their Voices Raise",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>Let <1:2>all <1:3>on <1:4>earth <1:5>their <1:6>voic<1:7>es <1:8>raise,",
          "<1:9>To <1:10>sing <1:11>the <1:12>great <1:13>Je<1:14>ho<1:15>vah's <1:16>praise,",
          "<1:17>And <1:18>bless <1:19>His <1:20>ho<1:21>ly <1:22>name:",
          "<1:23>His <1:24>glo<1:25>ry <1:26>let <1:27>the <1:28>peo<1:29>ple <1:30>know,",
          "<1:31>His <1:32>won<1:33>ders <1:34>to <1:35>the <1:36>na<1:37>tions <1:38>show,",
          "<1:39>His <1:40>sav<1:41>ing <1:42>grace <1:43>pro<1:44>claim."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>He <1:2>framed <1:3>the <1:4>globe; <1:5>He <1:6>built <1:7>the <1:8>sky;",
          "<1:9>He <1:10>made <1:11>the <1:12>shin<1:13>ing <1:14>worlds <1:15>on <1:16>high,",
          "<1:17>And <1:18>reigns <1:19>in <1:20>glo<1:21>ry <1:22>there:",
          "<1:23>His <1:24>beams <1:25>are <1:26>maj<1:27>es<1:28>ty <1:29>and <1:30>light;",
          "<1:31>His <1:32>beau<1:33>ties, <1:34>how <1:35>di<1:36>vine<1:37>ly <1:38>bright!",
          "<1:39>His <1:40>dwell<1:41>ing <1:42>place, <1:43>how <1:44>fair!"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>Come, <1:2>the <1:3>great <1:4>day, <1:5>the <1:6>glo<1:7>rious <1:8>hour,",
          "<1:9>When <1:10>earth <1:11>shall <1:12>feel <1:13>His <1:14>sav<1:15>ing <1:16>power,",
          "<1:17>All <1:18>na<1:19>tions <1:20>fear <1:21>His <1:22>name;",
          "<1:23>Then <1:24>shall <1:25>the <1:26>race <1:27>of <1:28>men <1:29>con<1:30>fess",
          "<1:31>The <1:32>beau<1:33>ty <1:34>of <1:35>His <1:36>ho<1:37>li<1:38>ness,",
          "<1:39>His <1:40>sav<1:41>ing <1:42>grace <1:43>pro<1:44>claim."
        ]
      }
    ]
  },
  {
    "hymnNumber": 90,
    "reference": "SDAH090",
    "title": "Eternal God Whose Power Upholds",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>E<1:2>ter<1:3>nal <1:4>God, <1:5>whose <1:6>pow<1:7>er <1:8>up<1:9>holds",
          "<1:10>Both <1:11>flow<1:12>er <1:13>and <1:14>flam<1:15>ing <1:16>star,",
          "<1:17>To <1:18>whom <1:19>there <1:20>is <1:21>no <1:22>here <1:23>nor <1:24>there,",
          "<1:25>No <1:26>time, <1:27>no <1:28>near <1:29>nor <1:30>far,",
          "<1:31>No <1:32>a<1:33>lien <1:34>race, <1:35>no <1:36>for<1:37>eign <1:38>shore,",
          "<1:39>No <1:40>child <1:41>un<1:42>sought, <1:43>un<1:44>known:",
          "<1:45>O <1:46>send <1:47>us <1:48>forth, <1:49>Your <1:50>proph<1:51>ets <1:52>true,",
          "<1:53>To <1:54>make <1:55>all <1:56>lands <1:57>Your <1:58>own!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>O <1:2>God <1:3>of <1:4>truth, <1:5>whom <1:6>sci<1:7>ence <1:8>seeks",
          "<1:9>And <1:10>rev<1:11>erent <1:12>souls <1:13>a<1:14>dore,",
          "<1:15>Il<1:16>lu<1:17>mine <1:18>ev<1:19>ery <1:20>ear<1:21>nest <1:22>mind",
          "<1:23>Of <1:24>ev<1:25>ery <1:26>clime <1:27>and <1:28>shore:",
          "<1:29>Dis<1:30>pel <1:31>the <1:32>gloom <1:33>of <1:34>er<1:35>ror's <1:36>night,",
          "<1:37>Of <1:38>ig<1:39>no<1:40>rance <1:41>and <1:42>fear,",
          "<1:43>Un<1:44>til <1:45>true <1:46>wis<1:47>dom <1:48>from <1:49>a<1:50>bove",
          "<1:51>Shall <1:52>make <1:53>life's <1:54>path<1:55>way <1:56>clear!"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>O <1:2>God <1:3>of <1:4>beau<1:5>ty, <1:6>oft <1:7>re<1:8>vealed",
          "<1:9>In <1:10>dreams <1:11>of <1:12>hu<1:13>man <1:14>art,",
          "<1:15>In <1:16>speech <1:17>that <1:18>flows <1:19>to <1:20>mel<1:21>o<1:22>dy,",
          "<1:23>In <1:24>ho<1:25>li<1:26>ness <1:27>of <1:28>heart:",
          "<1:29>Teach <1:30>us <1:31>to <1:32>ban <1:33>all <1:34>ug<1:35>li<1:36>ness,",
          "<1:37>And <1:38>all <1:39>dis<1:40>har<1:41>mo<1:42>ny,",
          "<1:43>Till <1:44>all <1:45>shall <1:46>know <1:47>the <1:48>love<1:49>li<1:50>ness",
          "<1:51>Of <1:52>lives <1:53>made <1:54>fair <1:55>and <1:56>free!"
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "<1:1>O <1:2>God <1:3>of <1:4>righ<1:5>teous<1:6>ness <1:7>and <1:8>grace,",
          "<1:9>Seen <1:10>in <1:11>the <1:12>Christ, <1:13>Your <1:14>Son,",
          "<1:15>Whose <1:16>life <1:17>and <1:18>death <1:19>re<1:20>veal <1:21>Your <1:22>face,",
          "<1:23>By <1:24>whom <1:25>Your <1:26>will <1:27>was <1:28>done;",
          "<1:29>Help <1:30>us <1:31>to <1:32>spread <1:33>Your <1:34>gra<1:35>cious <1:36>reign",
          "<1:37>Till <1:38>greed <1:39>and <1:40>hate <1:41>shall <1:42>cease,",
          "<1:43>And <1:44>kind<1:45>ness <1:46>dwell <1:47>in <1:48>hu<1:49>man <1:50>hearts,",
          "<1:51>And <1:52>all <1:53>the <1:54>earth <1:55>find <1:56>peace!"
        ]
      }
    ]
  },
  {
    "hymnNumber": 91,
    "reference": "SDAH091",
    "title": "Ye Watchers and Ye Holy Ones",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>Ye <1:2>watch<1:3>ers <1:4>and <1:5>ye <1:6>ho<1:7>ly <1:8>ones,",
          "<1:9>Bright <1:10>ser<1:11>aphs, <1:12>cher<1:13>u<1:14>bim <1:15>and <1:16>thrones,",
          "<1:17>Raise <1:18>the <1:19>glad <1:20>strain, <1:21>Al<1:22>le<1:23>lu<1:24>ia!",
          "<1:25>Cry <1:26>out, <1:27>do<1:28>min<1:29>ions, <1:30>prince<1:31>doms, <1:32>pow<1:33>ers,",
          "<1:34>Vir<1:35>tues, <1:36>arch<1:37>an<1:38>gels, <1:39>an<1:40>gels'<1:41>choirs,"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>O <1:2>high<1:3>er <1:4>than <1:5>the <1:6>cher<1:7>u<1:8>bim,",
          "<1:9>More <1:10>glo<1:11>rious <1:12>than <1:13>the <1:14>ser<1:15>a<1:16>phim,",
          "<1:17>Lead <1:18>their <1:19>prais<1:20>es, <1:21>Al<1:22>le<1:23>lu<1:24>ia!",
          "<1:25>Thou <1:26>bear<1:27>er <1:28>of <1:29>the <1:30>e<1:31>ter<1:32>nal <1:33>Word,",
          "<1:34>Most <1:35>gra<1:36>cious, <1:37>mag<1:38>ni<1:39>fy <1:40>the <1:41>Lord."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>O <1:2>friends, <1:3>in <1:4>glad<1:5>ness <1:6>let <1:7>us <1:8>sing,",
          "<1:9>Su<1:10>per<1:11>nal <1:12>an<1:13>thems <1:14>ech<1:15>o<1:16>ing,",
          "<1:17>Al<1:18>le<1:19>lu<1:20>ia, <1:21>Al<1:22>le<1:23>lu<1:24>ia!",
          "<1:25>To <1:26>God <1:27>the <1:28>Fa<1:29>ther, <1:30>God <1:31>the <1:32>Son,",
          "<1:34>And <1:35>God <1:36>the <1:37>Spir<1:38>it, <1:39>Three <1:40>in <1:41>One."
        ]
      }
    ],
    "chorus": [
      "<1:1>Al<1:2>le<1:3>lu<1:4>ia, <1:5>Al<1:6>le<1:7>lu<1:8>ia,",
      "<1:9>Al<1:10>le<1:11>lu<1:12>ia, <1:13>Al<1:14>le<1:15>lu<1:16>ia, <1:17>Al<1:18>le<1:19>lu<1:20>ia!"
    ],
    "timestamps": {
      "chorus": 28.4628
    },
    "chorusMarker": {
      "track": 1,
      "index": 42
    }
  },
  {
    "hymnNumber": 92,
    "reference": "SDAH092",
    "title": "This Is My Father's World",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>This <1:2>is <1:3>my <1:4>Fa<1:5>ther's <1:6>world,",
          "<1:7>And <1:8>to <1:9>my <1:10>lis<1:11>tening <1:12>ears,",
          "<1:13>All <1:14>na<1:15>ture <1:16>sings, <1:17>and <1:18>round <1:19>me <1:20>rings",
          "<1:21>The <1:22>mu<1:23>sic <1:24>of <1:25>the <1:26>spheres.",
          "<1:27>This <1:28>is <1:29>my <1:30>Fa<1:31>ther's <1:32>world;",
          "<1:33>I <1:34>rest <1:35>me <1:36>in <1:37>the <1:38>thought",
          "<1:39>Of <1:40>rocks <1:41>and <1:42>trees, <1:43>of <1:44>skies <1:45>and <1:46>seas;",
          "<1:47>His <1:48>hand <1:49>the <1:50>won<1:51>ders <1:52>wrought."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>This <1:2>is <1:3>my <1:4>Fa<1:5>ther's <1:6>world,",
          "<1:7>The <1:8>birds <1:9>their <1:10>ca<1:11>rols <1:12>raise;",
          "<1:13>The <1:14>morn<1:15>ing <1:16>light, <1:17>the <1:18>li<1:19>ly <1:20>white,",
          "<1:21>De<1:22>clare <1:23>their <1:24>Ma<1:25>ker's <1:26>praise.",
          "<1:27>This <1:28>is <1:29>my <1:30>Fa<1:31>ther's <1:32>world;",
          "<1:33>He <1:34>shines <1:35>in <1:36>all <1:37>that's <1:38>fair;",
          "<1:39>In <1:40>the <1:41>rus<1:42>tling <1:43>grass <1:44>I <1:45>hear <1:46>Him <1:47>pass,",
          "<1:48>He <1:49>speaks <1:50>to <1:51>me <1:52>eve<1:53>ry<1:54>where."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>This <1:2>is <1:3>my <1:4>Fa<1:5>ther's <1:6>world,",
          "<1:7>O <1:8>let <1:9>me <1:10>ne'er <1:11>for<1:12>get",
          "<1:13>That <1:14>though <1:15>the <1:16>wrong <1:17>seems <1:18>oft <1:19>so <1:20>strong,",
          "<1:21>God <1:22>is <1:23>the <1:24>Ru<1:25>ler <1:26>yet.",
          "<1:27>This <1:28>is <1:29>my <1:30>Fa<1:31>ther's <1:32>world;",
          "<1:33>Why <1:34>should <1:35>my <1:36>heart <1:37>be <1:38>sad?",
          "<1:39>The <1:40>Lord <1:41>is <1:42>King; <1:43>let <1:44>the <1:45>hea<1:46>vens <1:47>ring!",
          "<1:48>God <1:49>reigns; <1:50>let <1:51>the <1:52>earth <1:53>be <1:54>glad."
        ]
      }
    ]
  },
  {
    "hymnNumber": 93,
    "reference": "SDAH093",
    "title": "All Things Bright and Beautiful",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": true,
    "startsWithChorus": true,
    "timestamps": {
      "chorus": 18.6832
    },
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>Each <1:2>lit<1:3>tle <1:4>flow<1:5>er <1:6>that <1:7>o<1:8>pens,",
          "<1:9>Each <1:10>lit<1:11>tle <1:12>bird <1:13>that <1:14>sings;",
          "<1:15>He <1:16>made <1:17>their <1:18>glow<1:19>ing <1:20>col<1:21>ors,",
          "<1:22>He <1:23>made <1:24>their <1:25>ti<1:26>ny <1:27>wings."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>The <1:2>pur<1:3>ple-<1:4>head<1:5>ed <1:6>moun<1:7>tain,",
          "<1:8>The <1:9>riv<1:10>er <1:11>run<1:12>ning <1:13>by,",
          "<1:14>The <1:15>sun<1:16>set, <1:17>and <1:18>the <1:19>morn<1:20>ing",
          "<1:21>That <1:22>bright<1:23>ens <1:24>up <1:25>the <1:26>sky,"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>The <1:2>cold <1:3>wind <1:4>in <1:5>the <1:6>win<1:7>ter,",
          "<1:8>The <1:9>pleas<1:10>ant <1:11>sum<1:12>mer <1:13>sun,",
          "<1:14>The <1:15>ripe <1:16>fruits <1:17>in <1:18>the <1:19>gar<1:20>den,",
          "<1:21>He <1:22>made <1:23>them <1:24>ev<1:25>ery <1:26>one."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "<1:1>He <1:2>gave <1:3>us <1:4>eyes <1:5>to <1:6>see <1:7>them,",
          "<1:8>And <1:9>lips <1:10>that <1:11>we <1:12>might <1:13>tell",
          "<1:14>How <1:15>great <1:16>is <1:17>God <1:18>Al<1:19>might<1:20>y,",
          "<1:21>Who <1:22>has <1:23>made <1:24>all <1:25>things <1:26>well."
        ]
      }
    ],
    "chorus": [
      "<1:1>All <1:2>things <1:3>bright <1:4>and <1:5>beau<1:6>ti<1:7>ful,",
      "<1:8>All <1:9>crea<1:10>tures <1:11>great <1:12>and <1:13>small,",
      "<1:14>All <1:15>things <1:16>wise <1:17>and <1:18>won<1:19>der<1:20>ful,",
      "<1:21>The <1:22>Lord <1:23>God <1:24>made <1:25>them <1:26>all."
    ],
    "chorusMarker": {
      "track": 1,
      "index": 1
    }
  },
  {
    "hymnNumber": 94,
    "reference": "SDAH094",
    "title": "Nature With Open Volume Stands",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>Na<1:2>ture <1:3>with <1:4>o<1:5>pen <1:6>vol<1:7>ume <1:8>stands,",
          "<1:9>To <1:10>spread <1:11>its <1:12>Mak<1:13>er's <1:14>praise <1:15>a<1:16>broad;",
          "<1:17>And <1:18>ev<1:19>ery <1:20>la<1:21>bor <1:22>of <1:23>His <1:24>hands",
          "<1:25>Shows <1:26>some<1:27>thing <1:28>wor<1:29>thy <1:30>of <1:31>our <1:32>God."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>But <1:2>in <1:3>the <1:4>grace <1:5>that <1:6>res<1:7>cued <1:8>us",
          "<1:9>His <1:10>bright<1:11>est <1:12>form <1:13>of <1:14>glo<1:15>ry <1:16>shines;",
          "<1:17>'Tis <1:18>fair<1:19>est <1:20>drawn <1:21>up<1:22>on <1:23>the <1:24>cross",
          "<1:25>In <1:26>pre<1:27>cious <1:28>blood <1:29>and <1:30>crim<1:31>son <1:32>lines."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>Here <1:2>His <1:3>whole <1:4>name <1:5>ap<1:6>pears <1:7>com<1:8>plete.",
          "<1:9>Nor <1:10>wit <1:11>can <1:12>guess, <1:13>nor <1:14>rea<1:15>son <1:16>prove,",
          "<1:17>Which <1:18>of <1:19>the <1:20>let<1:21>ters <1:22>best <1:23>is <1:24>writ,",
          "<1:25>The <1:26>pow'r, <1:27>the <1:28>wis<1:29>dom, <1:30>or <1:31>the <1:32>love."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "<1:1>We <1:2>would <1:3>for<1:4>ev<1:5>er <1:6>speak <1:7>His <1:8>name",
          "<1:9>In <1:10>sounds <1:11>to <1:12>mor<1:13>tal <1:14>ears <1:15>un<1:16>known,",
          "<1:17>With <1:18>an<1:19>gels <1:20>join <1:21>to <1:22>praise <1:23>the <1:24>Lamb,",
          "<1:25>And <1:26>wor<1:27>ship <1:28>at <1:29>His <1:30>Fa<1:31>ther's <1:32>throne."
        ]
      }
    ]
  },
  {
    "hymnNumber": 95,
    "reference": "SDAH095",
    "title": "Spring Has Now Unwrapped the Flowers",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>Spring <1:2>has <1:3>now <1:4>un<1:5>wrapped <1:6>the <1:7>flow<1:8>ers,",
          "<1:9>Day <1:10>is <1:11>fast <1:12>re<1:13>viv<1:14>ing,",
          "<1:15>Life <1:16>in <1:17>all <1:18>her <1:19>grow<1:20>ing <1:21>pow<1:22>ers",
          "<1:23>To<1:24>wards <1:25>the <1:26>light <1:27>is <1:28>striv<1:29>ing:",
          "<1:30>Gone <1:31>the <1:32>i<1:33>ron <1:34>touch <1:35>of <1:36>cold,",
          "<1:37>Win<1:38>ter <1:39>time <1:40>and <1:41>frost <1:42>time,",
          "<1:43>Seed<1:44>lings, <1:45>work<1:46>ing <1:47>through <1:48>the <1:49>mould,",
          "<1:50>Now <1:51>make <1:52>up <1:53>for <1:54>lost <1:55>time."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>Herb <1:2>and <1:3>plant <1:4>that <1:5>win<1:6>ter <1:7>long,",
          "<1:8>Slum<1:9>bered <1:10>at <1:11>their <1:12>lei<1:13>surek,",
          "<1:15>Now <1:16>be<1:17>stir<1:18>ring, <1:19>green <1:20>and <1:21>strong,",
          "<1:23>Find <1:24>in <1:25>growth <1:26>their <1:27>plea<1:28>sure:",
          "<1:30>All <1:31>the <1:32>world <1:33>with <1:34>beau<1:35>ty <1:36>fills,",
          "<1:37>Gold <1:38>the <1:39>green <1:40>en<1:41>hanc<1:42>ing;",
          "<1:43>Flow<1:44>ers <1:45>make <1:46>glee <1:47>a<1:48>mong <1:49>the <1:50>hills,",
          "<1:51>Set <1:52>the <1:53>mead<1:54>ows <1:55>danc<1:56>ing."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>Through <1:2>each <1:3>won<1:4>der <1:5>of <1:6>fair <1:7>days",
          "<1:8>God <1:9>Him<1:10>self <1:11>ex<1:12>press<1:13>es;",
          "<1:15>Beau<1:16>ty <1:17>fol<1:18>lows <1:19>all <1:20>His <1:21>ways,",
          "<1:23>As <1:24>the <1:25>world <1:26>He <1:27>bless<1:28>es:",
          "<1:30>So, <1:31>as <1:32>He <1:33>re<1:34>news <1:35>the <1:36>earth,",
          "<1:37>Art<1:38>ist <1:39>with<1:40>out <1:41>ri<1:42>val,",
          "<1:43>In <1:44>His <1:45>grace <1:46>of <1:47>glad <1:48>new <1:49>birth",
          "<1:50>We <1:51>must <1:52>seek <1:53>re<1:54>viv<1:55>al."
        ]
      }
    ]
  },
  {
    "hymnNumber": 96,
    "reference": "SDAH096",
    "title": "The Spacious Firmament",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>The <1:2>spa<1:3>cious <1:4>firm<1:5>a<1:6>ment <1:7>on <1:8>high,",
          "<1:9>With <1:10>all <1:11>the <1:12>blue, <1:13>e<1:14>the<1:15>real <1:16>sky,",
          "<1:17>And <1:18>span<1:19>gled <1:20>heav<1:21>ens, <1:22>a <1:23>shin<1:24>ing <1:25>frame,",
          "<1:26>Their <1:27>great <1:28>O<1:29>rig<1:30>i<1:31>nal <1:32>pro<1:33>claim.",
          "<1:34>Th'un<1:35>wea<1:36>ried <1:37>sun <1:38>from <1:39>day <1:40>to <1:41>day",
          "<1:42>Does <1:43>his <1:44>Cre<1:45>a<1:46>tor's <1:47>pow<1:48>er <1:49>dis<1:50>play,",
          "<1:51>And <1:52>pub<1:53>lish<1:54>es <1:55>to <1:56>ev<1:57>ery <1:58>land",
          "<1:59>The <1:60>work <1:61>of <1:62>an <1:63>al<1:64>might<1:65>y <1:66>hand."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>Soon <1:2>as <1:3>the <1:4>eve<1:5>ning <1:6>shades <1:7>pre<1:8>vail,",
          "<1:9>The <1:10>moon <1:11>takes <1:12>up <1:13>the <1:14>won<1:15>drous <1:16>tale;",
          "<1:17>And <1:18>night<1:19>ly <1:20>to <1:21>the <1:22>lis<1:23>tening <1:24>earth",
          "<1:25>Re<1:26>peats <1:27>the <1:28>sto<1:29>ry <1:30>of <1:31>her <1:32>birth;",
          "<1:33>While <1:34>all <1:35>the <1:36>stars <1:37>that <1:38>round <1:39>her <1:40>burn,",
          "<1:41>And <1:42>all <1:43>the <1:44>plan<1:45>ets <1:46>in <1:47>their <1:48>turn,",
          "<1:49>Con<1:50>firm <1:51>the <1:52>ti<1:53>dings <1:54>as <1:55>they <1:56>roll,",
          "<1:57>And <1:58>spread <1:59>the <1:60>truth <1:61>from <1:62>pole <1:63>to <1:64>pole."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>What <1:2>though <1:3>in <1:4>sol<1:5>emn <1:6>si<1:7>lence <1:8>all",
          "<1:9>Move <1:10>round <1:11>the <1:12>dark <1:13>ter<1:14>res<1:15>trial <1:16>ball?",
          "<1:17>What <1:18>though <1:19>no <1:20>re<1:21>al <1:22>voice <1:23>nor <1:24>sound",
          "<1:25>A<1:26>mid <1:27>their <1:28>ra<1:29>diant <1:30>orbs <1:31>be <1:32>found?",
          "<1:33>In <1:34>rea<1:35>son's <1:36>ear <1:37>they <1:38>all <1:39>re<1:40>joice",
          "<1:41>And <1:42>ut<1:43>ter <1:44>forth <1:45>a <1:46>glo<1:47>rious <1:48>voice,",
          "<1:49>For<1:50>ev<1:51>er <1:52>sing<1:53>ing <1:54>as <1:55>they <1:56>shine,",
          "<1:57>\"The <1:58>hand <1:59>that <1:60>made <1:61>us <1:62>is <1:63>di<1:64>vine?\""
        ]
      }
    ]
  },
  {
    "hymnNumber": 97,
    "reference": "SDAH097",
    "title": "Lord of the Boundless Curves of Space",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>Lord <1:2>of <1:3>the <1:4>bound<1:5>less <1:6>curves <1:7>of <1:8>space",
          "<1:9>And <1:10>time's <1:11>deep <1:12>mys<1:13>te<1:14>ry,",
          "<1:15>To <1:16>Your <1:17>cre<1:18>a<1:19>tive <1:20>might <1:21>we <1:22>trace",
          "<1:23>All <1:24>na<1:25>ture's <1:26>en<1:27>er<1:28>gy."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>Your <1:2>mind <1:3>con<1:4>ceived <1:5>the <1:6>gal<1:7>ax<1:8>y,",
          "<1:9>Each <1:10>at<1:11>om's <1:12>se<1:13>cret <1:14>planned,",
          "<1:15>And <1:16>ev<1:17>ery <1:18>age <1:19>of <1:20>his<1:21>to<1:22>ry",
          "<1:23>Your <1:24>pur<1:25>pose, <1:26>Lord, <1:27>has <1:28>spanned."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>Yours <1:2>is <1:3>the <1:4>im<1:5>age <1:6>stamped <1:7>on <1:8>man,",
          "<1:9>Though <1:10>marred <1:11>by <1:12>man's <1:13>own <1:14>sin;",
          "<1:15>And <1:16>Yours <1:17>the <1:18>lib<1:19>er<1:20>at<1:21>ing <1:22>plan",
          "<1:23>A<1:24>gain <1:25>his <1:26>soul <1:27>to <1:28>win."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "<1:1>Give <1:2>us <1:3>to <1:4>know <1:5>Your <1:6>truth; <1:7>but <1:8>more,",
          "<1:9>The <1:10>strength <1:11>to <1:12>do <1:13>Your <1:14>will;",
          "<1:15>Un<1:16>til <1:17>the <1:18>love <1:19>our <1:20>souls <1:21>a<1:22>dore",
          "<1:23>Shall <1:24>all <1:25>our <1:26>be<1:27>ing <1:28>fill."
        ]
      }
    ]
  },
  {
    "hymnNumber": 98,
    "reference": "SDAH098",
    "title": "Can You Count the Stars?",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>Can <1:2>you <1:3>count <1:4>the <1:5>stars <1:6>that <1:7>bright<1:8>ly",
          "<1:9>Twin<1:10>kle <1:11>in <1:12>the <1:13>mid<1:14>night <1:15>sky?",
          "<1:16>Can <1:17>you <1:18>count <1:19>the <1:20>clouds, <1:21>so <1:22>light<1:23>ly",
          "<1:24>O'er <1:25>the <1:26>mead<1:27>ows <1:28>float<1:29>ing <1:30>by?",
          "<1:31>God, <1:32>the <1:33>Lord, <1:34>doth <1:35>mark <1:36>their <1:37>num<1:38>ber",
          "<1:39>With <1:40>His <1:41>eyes <1:42>that <1:43>nev<1:44>er <1:45>slum<1:46>ber;",
          "<1:47>He <1:48>hath <1:49>made <1:50>them <1:51>ev<1:52>ery <1:53>one,",
          "<1:54>He <1:55>hath <1:56>made <1:57>them <1:58>ev<1:59>ery <1:60>one."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>Can <1:2>you <1:3>count <1:4>the <1:5>wings <1:6>now <1:7>flash<1:8>ing",
          "<1:9>In <1:10>the <1:11>sun<1:12>shine's <1:13>gold<1:14>en <1:15>light?",
          "<1:16>Can <1:17>you <1:18>count <1:19>the <1:20>fish<1:21>es <1:22>splash<1:23>ing",
          "<1:24>In <1:25>the <1:26>cool<1:27>ing <1:28>wa<1:29>ters <1:30>bright?",
          "<1:31>God, <1:32>the <1:33>Lord, <1:34>a <1:35>name <1:36>hath <1:37>giv<1:38>en,",
          "<1:39>To <1:40>all <1:41>crea<1:42>tures <1:43>un<1:44>der <1:45>heav<1:46>en;",
          "<1:47>He <1:48>hath <1:49>named <1:50>them <1:51>ev<1:52>ery <1:53>one,",
          "<1:54>He <1:55>hath <1:56>named <1:57>them <1:58>ev<1:59>ery <1:60>one."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>Do <1:2>you <1:3>know <1:4>how <1:5>man<1:6>y <1:7>chil<1:8>dren",
          "<1:9>Rise <1:10>each <1:11>morn<1:12>ing <1:13>blithe <1:14>and <1:15>gay?",
          "<1:16>Can <1:17>you <1:18>count <1:19>their <1:20>jol<1:21>ly <1:22>voic<1:23>es,",
          "<1:24>Sing<1:25>ing <1:26>sweet<1:27>ly <1:28>day <1:29>by <1:30>day?",
          "<1:31>God <1:32>hears <1:33>all <1:34>the <1:35>hap<1:36>py <1:37>voic<1:38>es,",
          "<1:39>In <1:40>their <1:41>mer<1:42>ry <1:43>songs <1:44>re<1:45>joic<1:46>es;",
          "<1:47>And <1:48>He <1:49>loves <1:50>them, <1:51>ev<1:52>ery <1:53>one,",
          "<1:54>And <1:55>He <1:56>loves <1:57>them, <1:58>ev<1:59>ery <1:60>one."
        ]
      }
    ]
  },
  {
    "hymnNumber": 99,
    "reference": "SDAH099",
    "title": "God Will Take Care of You",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>Be <1:2>not <1:3>dis<1:4>mayed <1:5>what<1:6>e'er <1:7>be<1:8>tide,",
          "<1:9>God <1:10>will <1:11>take <1:12>care <1:13>of <1:14>you;",
          "<1:15>Be<1:16>neath <1:17>His <1:18>wings <1:19>of <1:20>love <1:21>a<1:22>bide,",
          "<1:23>God <1:24>will <1:25>take <1:26>care <1:27>of <1:28>you."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>Through <1:2>days <1:3>of <1:4>toil <1:5>when <1:6>your <1:7>heart <1:8>doth <1:9>fail,",
          "<1:10>God <1:11>will <1:12>take <1:13>care <1:14>of <1:15>you;",
          "<1:16>When <1:17>dan<1:18>gers <1:19>fierce <1:20>your <1:21>path <1:22>as<1:23>sail,",
          "<1:24>God <1:25>will <1:26>take <1:27>care <1:28>of <1:29>you."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>All <1:2>you <1:3>may <1:4>need <1:5>He <1:6>will <1:7>pro<1:8>vide,",
          "<1:9>God <1:10>will <1:11>take <1:12>care <1:13>of <1:14>you;",
          "<1:15>Noth<1:16>ing <1:17>you <1:18>ask <1:19>will <1:20>be <1:21>de<1:22>nied,",
          "<1:23>God <1:24>will <1:25>take <1:26>care <1:27>of <1:28>you."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "<1:1>No <1:2>mat<1:3>ter <1:4>what <1:5>may <1:6>be <1:7>the <1:8>test,",
          "<1:9>God <1:10>will <1:11>take <1:12>care <1:13>of <1:14>you;",
          "<1:15>Lean, <1:16>wea<1:17>ry <1:18>one, <1:19>up<1:20>on <1:21>His <1:22>breast,",
          "<1:23>God <1:24>will <1:25>take <1:26>care <1:27>of <1:28>you."
        ]
      }
    ],
    "chorus": [
      "<1:1>God <1:2>will <1:3>take <1:4>care <1:5>of <1:6>you,",
      "<1:7>Through <1:8>ev<1:9>ery <1:10>day, <1:11>o'er <1:12>all <1:13>the <1:14>way;",
      "<1:15>He <1:16>will <1:17>take <1:18>care <1:19>of <1:20>you,",
      "<1:21>God <1:22>will <1:23>take <1:24>care <1:25>of <1:26>you."
    ],
    "timestamps": {
      "chorus": 24.7449
    },
    "chorusMarker": {
      "track": 1,
      "index": 29
    }
  },
  {
    "hymnNumber": 100,
    "reference": "SDAH100",
    "title": "Great Is Thy Faithfulness",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "<1:1>Great <1:2>is <1:3>Thy <1:4>faith<1:5>ful<1:6>ness, <1:7>O <1:8>God <1:9>my <1:10>Fa<1:11>ther,",
          "<1:12>There <1:13>is <1:14>no <1:15>shad<1:16>ow <1:17>of <1:18>turn<1:19>ing <1:20>with <1:21>Thee;",
          "<1:22>Thou <1:23>chang<1:24>est <1:25>not, <1:26>Thy <1:27>com<1:28>pas<1:29>sions, <1:30>they <1:31>fail <1:32>not;",
          "<1:33>As <1:34>Thou <1:35>hast <1:36>been <1:37>Thou <1:38>for<1:39>ev<1:40>er <1:41>will <1:42>be."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "<1:1>Sum<1:2>mer <1:3>and <1:4>win<1:5>ter, <1:6>and <1:7>spring<1:8>time <1:9>and <1:10>har<1:11>vest,",
          "<1:12>Sun, <1:13>moon, <1:14>and <1:15>stars <1:16>in <1:17>their <1:18>cours<1:19>es <1:20>a<1:21>bove,",
          "<1:22>Join <1:23>with <1:24>all <1:25>na<1:26>ture <1:27>in <1:28>man<1:29>i<1:30>fold <1:31>wit<1:32>ness",
          "<1:33>To <1:34>Thy <1:35>great <1:36>faith<1:37>ful<1:38>ness, <1:39>mer<1:40>cy, <1:41>and <1:42>love."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "<1:1>Par<1:2>don <1:3>for <1:4>sin <1:5>and <1:6>a <1:7>peace <1:8>that <1:9>en<1:10>dur<1:11>eth,",
          "<1:12>Thy <1:13>own <1:14>dear <1:15>pres<1:16>ence <1:17>to <1:18>cheer <1:19>and <1:20>to <1:21>guide;",
          "<1:22>Strength <1:23>for <1:24>to<1:25>day <1:26>and <1:27>bright <1:28>hope <1:29>for <1:30>to<1:31>mor<1:32>row,",
          "<1:33>Bless<1:34>ings <1:35>all <1:36>mine, <1:37>with <1:38>ten <1:39>thou<1:40>sand <1:41>be<1:42>side."
        ]
      }
    ],
    "chorus": [
      "<1:1>Great <1:2>is <1:3>Thy <1:4>faith<1:5>ful<1:6>ness!",
      "<1:7>Great <1:8>is <1:9>Thy <1:10>faith<1:11>ful<1:12>ness!",
      "<1:13>Morn<1:14>ing <1:15>by <1:16>morn<1:17>ing <1:18>new <1:19>mer<1:20>cies <1:21>I <1:22>see;",
      "<1:23>All <1:24>I <1:25>have <1:26>need<1:27>ed <1:28>Thy <1:29>hand <1:30>hath <1:31>pro<1:32>vid<1:33>ed,",
      "<1:34>Great <1:35>is <1:36>Thy <1:37>faith<1:38>ful<1:39>ness! <1:40>Lord <1:41>un<1:42>to <1:43>me!"
    ],
    "timestamps": {
      "chorus": 32.3201
    },
    "chorusMarker": {
      "track": 1,
      "index": 43
    }
  },
  {
    "hymnNumber": 101,
    "reference": "SDAH101",
    "title": "Children of the Heavenly Father",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Children of the heavenly Father",
          "Safely in His bossom gather;",
          "Nestling bird nor star in heaven",
          "Such a refuge e'er was given."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "God His own doth tend and nourish,",
          "In His holy love they flourish;",
          "From all evil things He spares them,",
          "In His mighty arms He bears them."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Neither life nor death shall ever",
          "From the Lord His children sever;",
          "Unto them His grace He showeth,",
          "And their sorrows all He knoweth."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Praise the Lord in joyful numbers,",
          "Your Protector never slumbers;",
          "At the will of your Defender",
          "Every foeman must surrender."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "Though He giveth or He taketh,",
          "God His children ne'er forsaketh;",
          "His the loving purpose solely",
          "To preserve them pure and holy."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 102,
    "reference": "SDAH102",
    "title": "Unto the Hills",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Unto the hills around shall I lift up my longing eyes?",
          "O whence for me shall my salvation come,",
          "From whence arise?",
          "From God the Lord doth come my certain aid,",
          "From God the Lord, who heav'n and earth hath made."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "He will not suffer that thy foot be moved; safe shalt Thou be",
          "No careless slumber shall His eyelids close, who keepeth thee.",
          "Behold our God, the Lord, He slumbereth ne'er,",
          "Who keepeth Israel in His holy care."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Jehovah is Himself thy keeper true, thy changeless shade.",
          "Jehovah thy defense on thy right hand Himself hath made",
          "And thee no sun by day shall ever smite,",
          "No moon shall harm thee in the silent night."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "From every evil shall He keep thy soul, from every sin;",
          "Jehovah shall preserve thy going out, thy coming in.",
          "Above thee watching, He, whom adore,",
          "Shall keep thee henceforth, yea, forevermore."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 103,
    "reference": "SDAH103",
    "title": "O God, Our Help",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "O God, our help in ages past,",
          "Our hope for years to come,",
          "Our shelter from the stormy blast,",
          "And our eternal home!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Under the shadow of Thy throne",
          "Still may we dwell secure;",
          "Sufficient is Thine arm alone,",
          "And our defense is sure."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Before the hills in order stood,",
          "Or earth received her frame,",
          "From everlasting Thou art God,",
          "To endless years the same."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "A thousand ages, in Thy sight,",
          "Are like an evening gone;",
          "Short as the watch that ends the night,",
          "Before the rising sun."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "O God, our help in ages past,",
          "Our hope for years to come;",
          "Be Thou our guide while life shall last,",
          "And our eternal home!"
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 104,
    "reference": "SDAH104",
    "title": "My Shepherd Will Supply My Need",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "My Shepherd will supply my need,",
          "Jehovah is His name.",
          "In pastures fresh He makes me feed",
          "Beside the living stream.",
          "He brings my wand'ring spirit back",
          "When I forsake His ways,",
          "And leads me, for His mercy's sake,",
          "In paths of truth and grace."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "When I walk through the shades of death,",
          "Thy presence is my stay;",
          "A word of Thy supporting breath",
          "Drives all my fears away.",
          "Thy hand in sight of all my foes",
          "Doth still my table spread;",
          "My cup with blessings over flows,",
          "Thine oil anoints my head."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "The sure provisions of my God",
          "Attend me all my days;",
          "O may Thy house be mine abode",
          "And all my work be praise.",
          "There would I find a settled rest",
          "While others go and come;",
          "No more a stranger or a guest,",
          "But like a child at home."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 105,
    "reference": "SDAH105",
    "title": "Sing to the Great Jehovah's Praise",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Sing to the great Jehovah's praise!",
          "All praise to Him belongs;",
          "Who kindly lengthens out our days,",
          "Inspires our choicest songs,",
          "Inspires our choicest songs."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "His providence hath brought us through",
          "Another various year;",
          "We all, with vows and anthems new,",
          "Before our God appear,",
          "Before our God appear."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "O God, Thy mercies past we own,",
          "And Thy continued care;",
          "To Thee presenting through Thy Son",
          "Whate'er we have and are,",
          "Whate'er we have and are."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 106,
    "reference": "SDAH106",
    "title": "Give to Our God Immortal Praise",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Give to our God immortal praise;",
          "Mercy and truth are all His ways:",
          "Wonders of grace to God belong,",
          "Repeat His mercies in your song."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Give to the Lord of lords renown,",
          "The King of kings with glory crown:",
          "His mercies ever shall endure",
          "When lords and kings are known no more."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "He sent His Son with power to save",
          "From guilt and darkness and the grave:",
          "Wonders of grace to God be long,",
          "Repeat His mercies in your song."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Thro' this vain world He guides our feet,",
          "And leads us to His heav'nly seat:",
          "His mercies ever shall endure,",
          "When this vain world shall be no more."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 107,
    "reference": "SDAH107",
    "title": "God  Moves in a Mysterious Way",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "God moves in a mysterious way",
          "His wonders to perform;",
          "He plants His footsteps in the sea,",
          "And rides upon the storm."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Ye fearful saints, fresh courage take;",
          "The clouds ye so much dread",
          "Are big with mercy, and shall break",
          "In blessings on your head."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Judge not the Lord by feeble sense,",
          "But trust Him for His grace;",
          "Behind a frowning providence",
          "He hides a smiling face."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "His purposes will ripen fast,",
          "Unfolding every hour;",
          "The bud may have a bitter taste,",
          "But sweet will be the flower."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "Blind unbelief is sure to err,",
          "And scan His work in vain;",
          "God is His own interpreter,",
          "And He will make it plain."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 108,
    "reference": "SDAH108",
    "title": "Amazing Grace",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Amazing grace! How sweet the sound",
          "That saved a wretch like me!",
          "I once was lost, but now am found;",
          "Was blind, but now I see."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "'Twas grace that taught my heart to fear,",
          "And grace my fears relieved;",
          "How precious did that grace appear",
          "The hour I first believed."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "The Lord has promised good to me,",
          "His word my hope secures;",
          "He will my shield and portion be,",
          "As long as life endures."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Through many dangers, toils, and snares,",
          "I have already come;",
          "'Tis grace hath brought me safe thus far,",
          "And grace will lead me home."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "When we've been there ten thousand years,",
          "Bright shining as the sun,",
          "We've no less days to sing God's praise",
          "Than when we first begun."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 109,
    "reference": "SDAH109",
    "title": "Marvelous Grace",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Marvelous grace of our loving Lord,",
          "Grace that exceeds our sin and our guilt!",
          "Yonder on Calvary's mount outpoured",
          "There where the blood of the Lamb was spilt."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Sin and despair, like the sea-waves cold,",
          "Threaten the soul with infinite loss;",
          "Grace that is greater; yes, grace untold;",
          "Points to the Refuge, the mighty Cross."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Marvelous, infinite, matchless grace,",
          "Freely bestowed on all who believe!",
          "You that are longing to see His face,",
          "Will you this moment His grace receive?"
        ]
      }
    ],
    "chorus": [
      "Grace, grace, God's grace,",
      "Grace that will pardon and cleanse within;",
      "Grace, grace, God's grace,",
      "Grace that is greater than all our sin!"
    ],
    "timestamps": {
      "chorus": 27.5265
    }
  },
  {
    "hymnNumber": 110,
    "reference": "SDAH110",
    "title": "God's Free Mercy Streameth",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "God's free mercy streameth",
          "Over all the world,",
          "And His banner gleameth,",
          "By His church unfurled;",
          "Broad and deep and glorious,",
          "As the heaven above,",
          "Shines in might victorious",
          "His eternal love."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Summer suns are glowing",
          "Over land and sea;",
          "Happy light is flowing,",
          "Bountiful and free;",
          "Everything rejoices",
          "In the mellow rays;",
          "Earth's ten thousand voices",
          "Swell the psalm of praise."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Lord, upon our blindness",
          "Thy pure radiance pour;",
          "For Thy loving-kindness",
          "We would love Thee more;",
          "And when clouds are drifting",
          "Dark across the sky,",
          "Then, the veil uplifting,",
          "Father, be Thou nigh."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "We will never doubt Thee,",
          "Tho' Thou veil Thy light;",
          "Life is dark without Thee,",
          "Death with Thee is bright.",
          "Light of light, shine o'er us",
          "On our pilgrim way,",
          "Go Thou still before us",
          "To the endless day."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 111,
    "reference": "SDAH111",
    "title": "It Took A Miracle",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "My Father is omnipotent,",
          "And that you can't deny;",
          "A God of might and miracles-",
          "'Tis written in the sky."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Though here His glory has been shown,",
          "We still can't fully see",
          "The wonders of His might,",
          "His throne- 'Twill take eternity."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "The Bible tells us of His power",
          "And wisdom all way through,",
          "And every little bird and flower",
          "Are testimonies too."
        ]
      }
    ],
    "chorus": [
      "It took a miracle to put the stars in place,",
      "It took a miracle to hang the world in space;",
      "But when He saved my soul,",
      "Cleansed and made me whole,",
      "It took a miracle of love and grace!"
    ],
    "timestamps": {
      "chorus": 20.9341
    }
  },
  {
    "hymnNumber": 112,
    "reference": "SDAH112",
    "title": "Let Us With a Gladsome Mind",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Let us with a gladsome mind",
          "Praise the Lord, for He is kind:"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "He, with all-commanding might,",
          "Filled the newmade world with light:"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "All things living He does feed;",
          "His full hand supplies their need:"
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Let us then with gladsome mind",
          "Praise the Lord, for He is kind:"
        ]
      }
    ],
    "chorus": [
      "For His mercies shall endure,",
      "Ever faithful, ever sure."
    ],
    "timestamps": {
      "chorus": 10.8501
    }
  },
  {
    "hymnNumber": 113,
    "reference": "SDAH113",
    "title": "As Pants the Hart",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "As pants the hart for cooling streams",
          "When heated in the chase,",
          "So longs my soul, O God, for Thee,",
          "And Thy refreshing grace."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "For Thee, my God, the living God,",
          "My thirsty soul doth pine",
          "O when shall I behold Thy face,",
          "Thou Majesty divine?"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Why restless, why cast down, my soul?",
          "Hope still, and thou shalt sing",
          "The praise of Him who is thy God,",
          "Thy health's eternal spring."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "To Father, Son, and Holy Ghost,",
          "The God whom we adore,",
          "Be glory, as it was, is now,",
          "And shall be evermore."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 114,
    "reference": "SDAH114",
    "title": "There's a Wideness",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "There's a wideness in God's mercy,",
          "Like the wideness of the sea;",
          "There's a kindness in His justice,",
          "Which is more than liberty."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "There is welcome for the sinner,",
          "And more graces for the good;",
          "There is mercy with the Savior;",
          "There is healing in His blood."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "For the love of God is broader",
          "Than the measure of man's mind,",
          "And the heart of the Eternal",
          "Is most wonderfully kind."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "If our love were but more simple,",
          "We should take Him at His word;",
          "And our lives would be all sunshine",
          "In the sweetness of our Lord."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 115,
    "reference": "SDAH115",
    "title": "O Come, O Come, Immanuel",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "O come, O come, Immanuel,",
          "And ransom captive Israel",
          "That mourns in lonely exile here",
          "Until the Son of God appear."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "O come, Thou Wisdom from on high,",
          "And order all things far and nigh;",
          "To us the path of knowledge show,",
          "And cause us in her ways to go."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "O come, Desire of nations, bind",
          "All peoples in one heart and mind;",
          "Bid envy, strife, and quarrels cease;",
          "Fill the whole world with heaven's peace."
        ]
      }
    ],
    "chorus": [
      "Rejoice! Rejoice! Immanuel",
      "Shall come to thee, O Israel!"
    ],
    "timestamps": {
      "chorus": 28.607
    }
  },
  {
    "hymnNumber": 116,
    "reference": "SDAH116",
    "title": "Of the Father's Love Begotten",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Of the Father's love begotten,",
          "Ere the worlds began to be,",
          "He is Alpha and Omega,",
          "He the source, the ending He,",
          "Of the things that are, that have been,",
          "And that future years shall see,",
          "Evermore and evermore!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "O ye heights of heaven adore Him;",
          "Angel hosts, His praises sing;",
          "Powers, dominions, bow before Him,",
          "And extol our God and King;",
          "Let no tongue on earth be silent,",
          "Every voice in concert ring,",
          "Evermore and evermore!"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Christ, to Thee with God the Father",
          "And, O Holy Ghost, to Thee",
          "Hymn and chant and high thanksgiving",
          "And unwearied praises be.",
          "Honor, glory, and dominion,",
          "And eternal victory,",
          "Evermore and evermore! Amen."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 117,
    "reference": "SDAH117",
    "title": "The Advent of Our God",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "The advent of our God",
          "With eager prayers we greet,",
          "And singing haste upon His road",
          "His coming reign to meet."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "The everlasting Son",
          "Was born to make us free;",
          "And He a servant's form put on",
          "To gain our liberty."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "As Judge, on clouds of light,",
          "He soon will come again,",
          "His scattered people to unite",
          "With them in heaven to reign."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Praise to the incarnate Son",
          "Who comes to set us free,",
          "With Father, Spirit, ever one;",
          "To all eternity."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 118,
    "reference": "SDAH118",
    "title": "The First Noel",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "The first noel the angel did say",
          "Was to certain poor shepherds in fields as they lay;",
          "In fields where they lay keeping their sheep,",
          "On a cold winter's night that was so deep."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "They looked up and saw a star",
          "Shining in the east, beyond them far,",
          "And to the earth it gave great light,",
          "And so it continued both day and night."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "And by the light of that same star,",
          "Three wise men came from country far;",
          "To seek for a king was their intent,",
          "And to follow the star wherever it went."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "This star drew nigh to the northwest,",
          "O'er Bethlehem it took its rest,",
          "And there it did both stop and stay,",
          "Right over the place where Jesus lay."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "Then entered in those wise men three,",
          "Full reverently upon the knee,",
          "And offered there, in His presence,",
          "Their gold, and myrrh, and frankincense."
        ]
      }
    ],
    "chorus": [
      "Noel, Noel, Noel, Noel,",
      "Born is the King of Israel."
    ],
    "timestamps": {
      "chorus": 27.44
    }
  },
  {
    "hymnNumber": 119,
    "reference": "SDAH119",
    "title": "Angels, from the Realms of Glory",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Angels from the realms of glory,",
          "Wing your flight o'er all the earth;",
          "Ye who sang creation's story,",
          "Now proclaim Messiah's birth;",
          "Come and worship,",
          "Come and worship,",
          "Worship Christ, the newborn King."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Shepherds, in the field abiding,",
          "Watching o'er your flocks by night,",
          "God with man is now residing;",
          "Yonder shines the Infant Light:",
          "Come and worship,",
          "Come and worship,",
          "Worship Christ, the newborn King."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Sages, leave your contemplations,",
          "Brighter visions beam afar;",
          "Seek the great Desire of nations;",
          "Ye have seen His natal star;",
          "Come and worship,",
          "Come and worship,",
          "Worship Christ, the newborn King."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Saints, before the altar bending,",
          "Watching long in hope and fear,",
          "Suddenly the Lord, descending,",
          "In His temple shall appear;",
          "Come and worship,",
          "Come and worship,",
          "Worship Christ, the newborn King."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 120,
    "reference": "SDAH120",
    "title": "There's a Song in the Air",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "There's a song in the air!",
          "There's a star in the sky!",
          "There's a mother's deep prayer",
          "And a baby's low cry!",
          "And the star rains its fire while the beautiful sing,",
          "For the manger of Bethlehem cradles a King!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "There's a tumult of joy",
          "O'er the wonderful birth,",
          "For the virgin's sweet boy",
          "Is the Lord of the earth.",
          "Aye! the star rains its fire while the beautiful sing,",
          "For the manger of Bethlehem cradles a King!"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "In the light of that star",
          "Lie the ages impearled;",
          "And that song from afar",
          "Has swept over the world.",
          "Every hearth is aflame, and the beautiful sing",
          "In the homes of the nations that Jesus is King!"
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "We rejoice in the light,",
          "And we echo the song",
          "That comes down through the night",
          "From the heavenly throng.",
          "Aye! we shout to the lovely evangel they bring,",
          "And we greet in his cradle our Savior and King!"
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 121,
    "reference": "SDAH121",
    "title": "Go Tell It On the Mountain",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "startsWithChorus": true,
    "timestamps": {
      "chorus": 20.3382
    },
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "While shepherds kept their watching",
          "O'er silent flocks by night,",
          "Behold throughout the heavens",
          "There shone a holy light."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "The shepherds feared and trembled",
          "When lo! Above the earth",
          "Rang out the angel chorus",
          "That hailed our Savior's birth."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Down in a lowly manger",
          "The humble Christ was born,",
          "And brought us God's salvation",
          "That blessed Christmas morn."
        ]
      }
    ],
    "chorus": [
      "Go, tell it on the mountain,",
      "Over the hills and everywhere:",
      "Go, tell it on the mountain",
      "That Jesus Christ is born!"
    ]
  },
  {
    "hymnNumber": 122,
    "reference": "SDAH122",
    "title": "Hark! the Herald Angels Sing",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Hark! the herald angels sing,",
          "\"Glory to the newborn King;",
          "Peace on earth, and mercy mild,",
          "God and sinners reconciled!\"",
          "Joyful, all ye nations, rise,",
          "Join the triumph of the skies;",
          "With th'angelic host proclaim,",
          "\"Christ is born in Bethlehem!\"",
          "Hark! the herald angels sing,",
          "\"Glory to the newborn King.\""
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Christ, by highest heaven adored;",
          "Christ, the everlasting Lord!",
          "In the manger born a king,",
          "While adoring angels sing,",
          "\"Peace on earth, to men good will;\"",
          "Bid the trembling soul be still,",
          "Christ on earth has come to dwell,",
          "Jesus, our Immanuel!",
          "Hark! the herald angels sing,",
          "\"Glory to the newborn King.\""
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Hail, the heaven-born Prince of Peace!",
          "Hail, the Sun of Righteousness!",
          "Life and light to all He brings,",
          "Risen with healing in His wings.",
          "Mild He lays His glory by,",
          "Born that man no more may die,",
          "Born to raise the sons of earth,",
          "Born to give them second birth.",
          "Hark! the herald angels sing,",
          "\"Glory to the newborn King.\""
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 123,
    "reference": "SDAH123",
    "title": "As With Gladness Men of Old",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "As with gladness, men of old",
          "Did the guiding star behold",
          "As with joy they hailed its light",
          "Leading onward, beaming bright",
          "So, most glorious Lord, may we",
          "Evermore be led to Thee."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "As with joyful steps they sped",
          "To that lowly manger bed",
          "There to bend the knee before",
          "Him Whom heav'n and earth adore;",
          "So may we with willing feet",
          "Ever seek Thy mercy seat."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "As they offered gifts most rare",
          "At that manger rude and bare;",
          "So may we with holy joy,",
          "Pure and free from sin's alloy,",
          "All our costliest treasures bring,",
          "Christ, to Thee, our heavenly King."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Holy Jesus, every day",
          "Keep us in the narrow way;",
          "And, when earthly things are past,",
          "Bring our ransomed souls at last",
          "Where they need no star to guide,",
          "Where no clouds Thy glory hide."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 124,
    "reference": "SDAH124",
    "title": "Away in a Manger",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Away in a manger, no crib for a bed,",
          "The little Lord Jesus laid down His sweet head.",
          "The stars in the bright sky looked down where He lay,",
          "The little Lord Jesus asleep on the hay."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "The cattle are lowing, the baby awakes,",
          "But little Lord Jesus no crying He makes.",
          "I love Thee, Lord Jesus! look down from the sky,",
          "And stay by my side till the morning is nigh."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Be near me, Lord Jesus; I ask Thee to stay",
          "Close by me forever, and love me, I pray.",
          "Bless all the dear children in Thy tender care,",
          "And fit us for heaven, to live with Thee there."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 125,
    "reference": "SDAH125",
    "title": "Joy to the World!",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Joy to the world, the Lord is come!",
          "Let earth receive her King;",
          "Let every heart prepare Him room,",
          "And heaven and nature sing,",
          "And heaven and nature sing,",
          "And heaven, and heaven and nature sing."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Joy to the earth, the Savior reigns!",
          "Let men their songs employ;",
          "While fields and floods, rocks, hills and plains,",
          "Repeat the sounding joy,",
          "Repeat the sounding joy,",
          "Repeat, repeat the sounding joy."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "No more let sin and sorrow grow,",
          "Nor thorns infest the ground;",
          "He comes to make His blessings flow",
          "Far as the curse is found,",
          "Far as the curse is found,",
          "Far as, far as the curse is found."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "He rules the world with truth and grace,",
          "And makes the nations prove",
          "The glories of His righteousness,",
          "And wonders of His love,",
          "And wonders of His love,",
          "And wonders, wonders of His love."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 126,
    "reference": "SDAH126",
    "title": "In the Bleak Midwinter",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "In the bleak midwinter",
          "Frosty wind made moan;",
          "Earth stood hard as iron,",
          "Water like a stone;",
          "Snow had fallen, snow on snow,",
          "Snow on snow,",
          "In the bleak minwinter,",
          "Long ago."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Angels and archangels",
          "May have gathered there,",
          "Cherubim and seraphim",
          "Thronged the air.",
          "But His mother only",
          "In her maiden bliss,",
          "Worshiped the beloved",
          "With a kiss."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "What can I give Him,",
          "Poor as I am?",
          "If I were a shepherd",
          "I would bring a lamb;",
          "If I were a wise man",
          "I would do my part;",
          "Yet what can I give Him?",
          "Give my heart."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 127,
    "reference": "SDAH127",
    "title": "Infant Holy, Infant Lowly",
    "hasMidi": true,
    "numberOfVerses": 2,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Infant holy, infant lowly,",
          "For His bed a cattle stall;",
          "Oxen lowing, little knowing",
          "Christ the babe is Lord of all;",
          "Swift are winging angels singing,",
          "Noels ringing, tidings bringing,",
          "Christ the babe is Lord of all,",
          "Christ the babe is Lord of all."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Flocks were sleeping, shepherds keeping",
          "Vigil till the morning new;",
          "Saw the glory, heard the story,",
          "Tidings of the gospel true;",
          "Thus rejoicing, free from sorrow,",
          "Praises voicing greet the morrow,",
          "Christ the babe was born for you,",
          "Christ the babe was born for you."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 128,
    "reference": "SDAH128",
    "title": "Break Forth, O Beauteous Heavenly Light",
    "hasMidi": true,
    "numberOfVerses": 1,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Break forth, O beauteous heavenly light,",
          "And usher in the morning;",
          "Ye shepherds, shrink not with affright,",
          "But hear the angel's warning.",
          "This Child, now weak in infancy,",
          "Our confidence and joy shall be,",
          "The power of Satan breaking,",
          "Our peace eternal making."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 129,
    "reference": "SDAH129",
    "title": "As It Fell Upon A Night",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "As it fell upon a night",
          "In the winter weather,",
          "Angels bright in starry height",
          "Began to sing together."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Shepherds sleeping on the plain",
          "Woke to see the glory,",
          "All amazed they stood and gazed",
          "And heard the angels' story."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Unto you a child is born",
          "In a manger lowly,",
          "Humble, He, yet born to be",
          "The King of Love most holy."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Happy angels from afar,",
          "Cease your singing never!",
          "In excelsis gloria!",
          "Forever and forever."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 130,
    "reference": "SDAH130",
    "title": "It Came Upon the Midnight Clear",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "It came upon the midnight clear,",
          "That glorious song of old,",
          "From angels bending near the earth",
          "To touch their harps of gold:",
          "\"Peace on the earth, good will to men,",
          "From heaven's all-gracious King;\"",
          "The world in solemn stillness lay,",
          "To hear the angels sing."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Still through the cloven skies they come,",
          "With peaceful wings unfurled,",
          "And still their heavenly music floats",
          "O'er all the weary world;",
          "Above its sad and lowly plains",
          "They bend on hovering wing,",
          "And ever o'er its Babel sounds",
          "The blessed angels sing."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "And ye, beneath life's crushing load,",
          "Whose forms are bending low,",
          "Who toil along the climbing way",
          "With painful steps and slow;",
          "Look now! for glad and golden hours",
          "Come swiftly on the wing;",
          "O rest beside the weary road,",
          "And hear the angels sing."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 131,
    "reference": "SDAH131",
    "title": "Lo, How a Rose E'er Blooming",
    "hasMidi": true,
    "numberOfVerses": 2,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Lo, how a rose e'er blooming",
          "From tender stem hath sprung,",
          "Of Jesse's lineage coming",
          "As men of old have sung.",
          "It came, a floweret bright,",
          "Amid the cold of winter,",
          "When half spent was the night."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Isaiah 'twas foretold it,",
          "The Rose I have in mind,",
          "With Mary we behold it,",
          "The virgin mother kind.",
          "To show God's love aright",
          "She bore to them a Savior.",
          "When half spent was the night."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 132,
    "reference": "SDAH132",
    "title": "O Come, All Ye Faithful",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "O come, all ye faithful, joyful and triumphant,",
          "O come ye, O come ye to Bethlehem!",
          "Come and behold Him, born the King of angels!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Sing, choirs of angels, sing in exultation,",
          "O sing, all ye citizens of heaven above!",
          "Glory to God, all glory in the highest!"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Yea, Lord, we greet Thee, born this happy morning,",
          "Jesus, to Thee be all glory given;",
          "Word of the Father, now in flesh appearing!"
        ]
      }
    ],
    "chorus": [
      "O come, let us adore Him,",
      "O come, let us adore Him,",
      "O come, let us adore Him,",
      "Christ the Lord!"
    ],
    "timestamps": {
      "chorus": 26.8994
    }
  },
  {
    "hymnNumber": 133,
    "reference": "SDAH133",
    "title": "Now Is Born the Divine Christ Child",
    "hasMidi": true,
    "numberOfVerses": 2,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "He was born in a stable bare,",
          "On bed of straw how",
          "He sleeps so soundly,",
          "He was born in a stable bare,",
          "Let us worship and to Him bow."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Ages long since are past and gone,",
          "When the wise men foretold",
          "His coming,",
          "Ages long since are past and gone,",
          "When the wise men foretold His birth."
        ]
      }
    ],
    "chorus": [
      "Now is born the divine Christ child,",
      "Play the musette, play the tuneful oboe,",
      "Now is born the divine Christ child,",
      "Sing we all and rejoice this day."
    ],
    "timestamps": {
      "chorus": 19.0836
    }
  },
  {
    "hymnNumber": 134,
    "reference": "SDAH134",
    "title": "O Jesus Sweet",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "O Jesus sweet, O Jesus mild,",
          "Thy Father's will hast Thou fulfilled;",
          "For Thou hast left Thy heavenly throne",
          "Our lowly state to make Thine own.",
          "O Jesus sweet, O Jesus mild."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "O Jesus sweet, O Jesus mild,",
          "With joy hast Thou the whole world filled;",
          "Thou comest down from heaven's hall",
          "To comfort us whom tears enthrall.",
          "O Jesus sweet, O Jesus mild."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "O Jesus sweet, O Jesus mild,",
          "Thou art love's image undefiled.",
          "Inflame our hearts with love's pure fire,",
          "That we may share Thy heart's desire.",
          "O Jesus sweet, O Jesus mild."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "O Jesus sweet, O Jesus mild,",
          "Help us to do as Thou hast willed.",
          "What e'er we have belongs to Thee:",
          "O may we ever faithful be.",
          "O Jesus sweet, O Jesus mild."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 135,
    "reference": "SDAH135",
    "title": "O Little Town of Bethlehem",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "O little town of Bethlehem,",
          "How still we see thee lie!",
          "Above thy deep and dreamless sleep",
          "The silent stars go by;",
          "Yet in thy dark streets shineth",
          "The everlasting light;",
          "The hopes and fears of all the years",
          "Are met in thee tonight."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "For Christ is born of Mary;",
          "And gathered all above,",
          "While mortals sleep, the angels keep",
          "Their watch of wondering love.",
          "O morning stars, together",
          "Proclaim the holy birth!",
          "And praises sing to God the King,",
          "And peace to men on earth."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "How silently, how silently",
          "The wondrous gift is given!",
          "So God imparts to human hearts",
          "The blessings of His heaven.",
          "No ear may hear His coming;",
          "But in this world of sin,",
          "Where meek souls will receive Him still,",
          "The dear Christ enters in."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "O holy Child of Bethlehem,",
          "Descend to us, we pray;",
          "Cast out our sin and enter in;",
          "Be born in us today.",
          "We hear the Christmas angels",
          "The great glad tidings tell;",
          "O come to us, abide with us,",
          "Our Lord Immanuel!"
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 136,
    "reference": "SDAH136",
    "title": "Good Christians, Now Rejoice",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Good Christians, now rejoice,",
          "With heart, and soul, and voice;",
          "Give ye heed to what we say:",
          "Jesus Christ is born today;",
          "Ox and ass before Him bow,",
          "And He is in the manger now.",
          "Christ is born today!",
          "Christ is born today!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Good Christians, now rejoice,",
          "With heart, and soul, and voice;",
          "Now ye hear of endless bliss:",
          "Jesus Christ was born for this!",
          "He hath ope'd the heav'nly door,",
          "And we are blessed evermore.",
          "Christ was born for this!",
          "Christ was born for this!"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Good Christians, now rejoice,",
          "With heart, and soul, and voice;",
          "Now ye need not fear the grave:",
          "Jesus Christ was born to save!",
          "Calls you one and calls you all",
          "To gain His everlasting hall.",
          "Christ was born to save!",
          "Christ was born to save!"
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 137,
    "reference": "SDAH137",
    "title": "We Three Kings of Orient Are",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "We three kings of Orient are;",
          "Bearing gifts we traverse afar",
          "Field and fountain, moor and mountain,",
          "Following yonder star."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Born a king on Bethlehem's plain;",
          "Gold I bring to crown Him again,",
          "King forever, ceasing never",
          "Over us all to reign."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Frankincense to offer have I;",
          "Incense owns a Deity nigh;",
          "Prayer and praising all men raising,",
          "Worship Him, God on high."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Myrrh is mine: its bitter perfume",
          "Breathes a life of gathering gloom:",
          "Sorrowing, sighing, bleeding, dying,",
          "Sealed in the stone-cold tomb."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "Glorious now behold Him arise,",
          "King and God and Sacrifice;",
          "Alleluia, alleluia!",
          "Sounds through the earth and skies."
        ]
      }
    ],
    "chorus": [
      "Oh, star of wonder, star of night,",
      "Star with royal beauty bright,",
      "Westward leading, still proceeding,",
      "Guide us to Thy perfect light."
    ],
    "timestamps": {
      "chorus": 20.3663
    }
  },
  {
    "hymnNumber": 138,
    "reference": "SDAH138",
    "title": "Rise Up Shepherd and Follow",
    "hasMidi": true,
    "numberOfVerses": 2,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "There's a star in the east on Christmas morn.",
          "Rise up, shepherd, and follow.",
          "It will lead to the place where the Savior's born,",
          "Rise up, shepherd, and follow."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "If you take good heed to the angel's words,",
          "Rise up, shepherd, and follow.",
          "You'll forget your flocks, you'll forget your herds",
          "Rise up, shepherd, and follow."
        ]
      }
    ],
    "chorus": [
      "Leave your sheep and leave your lamb,",
      "Rise up, shepherd, and follow.",
      "Leave your ewes and leave your rams,",
      "Rise up, shepherd, and follow.",
      "Follow, Follow,",
      "Rise up, shepherd, and follow.",
      "Follow the star of Bethlehem,",
      "Rise up, shepherd, and follow."
    ],
    "timestamps": {
      "chorus": 19.5223
    }
  },
  {
    "hymnNumber": 139,
    "reference": "SDAH139",
    "title": "While Shepherds Watched Their Flocks",
    "hasMidi": true,
    "numberOfVerses": 6,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "While shepherds watched their flocks by night,",
          "All seated on the ground,",
          "The angel of the Lord came down,",
          "And glory shone around."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "\"Fear not!\" said he for mighty dread",
          "Had seized their troubled mind;",
          "\"Glad tidings of great joy I bring,",
          "To you and all mankind."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "\"To you, in David's town this day,",
          "Is born of David's line,",
          "The Savior who is Christ the Lord;",
          "And this shall be the sign:"
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "\"The heavenly Babe you there shall find",
          "To human view displayed,",
          "All meanly wrapped in swathing bands,",
          "And in a manger laid.\""
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "Thus spake the seraph; and forthwith",
          "Appeared a shining throng",
          "Of angels praising God on high,",
          "Who thus addressed their song:"
        ]
      },
      {
        "verseNumber": 6,
        "content": [
          "\"All glory be to God on high,",
          "And to the earth be peace;",
          "Good will henceforth from heaven to men,",
          "Begin and never cease!\""
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 140,
    "reference": "SDAH140",
    "title": "Thou Didst Leave Thy Throne",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Thou didst leave Thy throne",
          "And Thy kingly crown",
          "When Thou camest to earth for me;",
          "But in Bethlehem's home",
          "Was there found no room",
          "For Thy holy nativity."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Heaven's arches rang",
          "When the angels sang",
          "Proclaiming Thy royal degree;",
          "But of lowly birth",
          "Didst Thou come to earth,",
          "And in greatest humility."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "The foxes found rest,",
          "And the birds their nest",
          "In the shade of the forest tree;",
          "But Thy couch was the sod,",
          "O Thou Son of God,",
          "In the deserts of Galilee."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Thou camest, O Lord,",
          "With the living word",
          "That should set Thy people free;",
          "But with mocking scorn,",
          "And with crown of thorn,",
          "They bore Thee to Calvary."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "When the heavens shall ring,",
          "And the angels sing,",
          "At Thy coming to victory,",
          "Let Thy voice call me home,",
          "Saying, \"Yet there is room,",
          "There is room at My side for thee.\""
        ]
      }
    ],
    "chorus": [
      "O come to my heart, Lord Jesus,",
      "There is room in my heart for Thee."
    ],
    "timestamps": {
      "chorus": 20.6458
    }
  },
  {
    "hymnNumber": 141,
    "reference": "SDAH141",
    "title": "What Child Is This?",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "What child is this, who, laid to rest,",
          "On Mary's lap is sleeping?",
          "Whom angels greet with anthems sweet,",
          "While shepherds watch are keeping?"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Why lies He in such mean estate",
          "Where ox and ass are feeding?",
          "Good Christian, fear: for sinners here",
          "The silent Word is pleading."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "So bring Him incense, gold, and myrrh,",
          "Come, peasant, king, to own Him,",
          "The King of kings salvation brings",
          "Let loving hearts enthrone Him."
        ]
      }
    ],
    "chorus": [
      "This, this is Christ the King,",
      "Whom shepherds guard and angels sing:",
      "Haste, haste to bring Him laud,",
      "The babe, the son of Mary."
    ],
    "timestamps": {
      "chorus": 22.736
    }
  },
  {
    "hymnNumber": 142,
    "reference": "SDAH142",
    "title": "Angels We Have Heard On High",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Angels we have heard on high,",
          "Singing sweetly through the night,",
          "And the mountains in reply",
          "Echoing their brave delight."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Shepherds, why this jubilee?",
          "Why these songs of happy cheer?",
          "What great brightness did you see?",
          "What glad tidings did you hear?"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Come to Bethlehem and see",
          "Him whose birth the angels sing;",
          "Come, adore on bended knee",
          "Christ, the Lord, the newborn King."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "See Him in a manger laid",
          "Whom the angels praise above;",
          "Mary, Joseph, lend your aid,",
          "While we raise our hearts in love."
        ]
      }
    ],
    "chorus": [
      "Gloria in excelsis Deo,",
      "Gloria in excelsis Deo."
    ],
    "timestamps": {
      "chorus": 16.6203
    }
  },
  {
    "hymnNumber": 143,
    "reference": "SDAH143",
    "title": "Silent Night, Holy Night",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Silent night, holy night,",
          "All is calm, all is bright;",
          "Round yon virgin mother and Child!",
          "Holy Infant, so tender and mild,",
          "Sleep in heavenly peace,",
          "Sleep in heavenly peace."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Silent night, holy night,",
          "Darkness flies, all is light;",
          "Shepherds hear the angels sing,",
          "\"Alleluia! hail the King!",
          "Christ the Savior is born,",
          "Christ the Savior is born.\""
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Silent night, holy night,",
          "Son of God, love's pure light;",
          "Radiant beams from Thy holy face,",
          "With the dawn of redeeming grace,",
          "Jesus, Lord, at Thy birth,",
          "Jesus, Lord, at Thy birth."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Silent night, holy night,",
          "Wondrous star, lend thy light;",
          "With the angels let us sing,",
          "Alleluia to our King;",
          "Christ the Savior is born,",
          "Christ the Savior is born."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 144,
    "reference": "SDAH144",
    "title": "O Sing a Song of Bethlehem",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "O sing a song of Bethlehem,",
          "Of shepherds watching there,",
          "And of the news that came to them",
          "From angels in the air:",
          "The light that shone on Bethlehem",
          "Fills all the world today;",
          "Of Jesus' birth and peace on earth",
          "The angels sing alway."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "O sing a song of Nazareth,",
          "Of sunny days of joy,",
          "O sing of fragrant flowers breath,",
          "And of the sinless Boy:",
          "For now the flowers of Nazareth",
          "In every heart may grow;",
          "Now spreads the fame of His dear name",
          "On all the winds that blow."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "O sing a song of Calvary,",
          "Its glory and dismay;",
          "Of Him who hung upon the tree,",
          "And took our sins away:",
          "For He who died on Calvary",
          "Is risen from the grave;",
          "And Christ, our Lord, by heaven adored,",
          "Is mighty now to save."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 145,
    "reference": "SDAH145",
    "title": "Songs of Thankfulness and Praise",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Songs of thankfulness and praise,",
          "Jesus, Lord, to You we raise,",
          "Manifested by the star",
          "To the sages from afar;",
          "Branch of royal David's stem",
          "In Your birth at Bethlehem;"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Manifest at Jordan's stream,",
          "Prophet, Priest, and King supreme;",
          "And at Cana, wedding guest,",
          "In Your Godhead manifest;",
          "Manifest in power divine,",
          "Changing water into wine;"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Manifest in making whole",
          "Palsied limbs and fainting soul;",
          "Manifest in valiant fight,",
          "Quelling all the devil's might;",
          "Manifest in gracious will,",
          "Ever bringing good from ill;"
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Grant us grace to see You, Lord,",
          "Mirrored in Your holy Word;",
          "May we imitate Your way,",
          "And be pure, as pure we may,",
          "That we like to You may be",
          "At Your great epiphany;"
        ]
      }
    ],
    "chorus": [
      "Anthems be to You addressed,",
      "God in man made manifest."
    ],
    "timestamps": {
      "chorus": 26.3743
    }
  },
  {
    "hymnNumber": 146,
    "reference": "SDAH146",
    "title": "I Think When I Read That Sweet Story",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "I think when I read that sweet story of old,",
          "When Jesus was here among men,",
          "How He called little children as lambs to His fold, I should like to have been with Him then."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "I wish that His hands had been placed on my head,",
          "That His arm had been thrown around me,",
          "And that I might have seen His kind look when He said, ''Let the little ones come unto Me.\""
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "I long for the joy of that glorious time,",
          "The sweetest and brightest and best,",
          "When the dear little children of every clime Shall crowd to His arms and be blest."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 147,
    "reference": "SDAH147",
    "title": "Christ Upon the Mountain Peak",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Christ upon the mountain peak",
          "Stands alone in glory blazing;",
          "Let us, if we dare to speak,",
          "With the saints and angels praise Him:",
          "Alleluia, Alleluia, Alleluia."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Trembling at His feet we saw",
          "Moses and Elijah speaking;",
          "All the prophets and the law",
          "Shout thro' them their joyful greeting:",
          "Alleluia, Alleluia, Alleluia."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Swift the cloud of glory came,",
          "God proclaiming in the thunder",
          "Jesus as His Son by name;",
          "Nations cry aloud in wonder!",
          "Alleluia, Alleluia, Alleluia."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "This is God's beloved Son:",
          "Law and prophets fade before Him;",
          "First and last, the only One,",
          "Let creation now adore Him.",
          "Alleluia, Alleluia, Alleluia."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 148,
    "reference": "SDAH148",
    "title": "O Love How Deep How Broad",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "O love, how deep, how broad, how high,",
          "Beyond all thought and fantasy,",
          "That God, the Son of God, should take",
          "Our mortal form for mortal's sake!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "For us baptized, for us He bore",
          "His holy fast and hungered sore;",
          "For us temptation sharp He knew;",
          "For us the tempter over threw."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "For us by wickedness betrayed,",
          "For us, in crown of thorns arrayed,",
          "He bore the shameful cross and death;",
          "For us He gave His dying breath."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "For us He rose from death again,",
          "For us He went on high to reign;",
          "For us He sent His Spirit here",
          "To guide, to strengthen, and to cheer."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "All glory to our Lord and God",
          "For love so deep, so high, so broad;",
          "The Trinity whom we adore",
          "Forever and forevermore."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 149,
    "reference": "SDAH149",
    "title": "Once in Royal David's City",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Once in royal David's city",
          "Stood a lowly cattle shed,",
          "Where a mother laid her Baby",
          "In a manger for His bed;",
          "Mary was that mother mild,",
          "Jesus Christ her little Child."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "He came down to earth from heaven",
          "Who is God and Lord of all,",
          "And His shelter was a stable,",
          "And His cradle was a stall;",
          "With the poor, and mean, and lowly,",
          "Lived on earth our Savior holy."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "And through all His wondrous childhood",
          "He would honor and obey,",
          "Love and watch the lowly mother",
          "In whose gentle arms He lay.",
          "Christian children all must be",
          "Mild, obedient, good as He."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "And our eyes at last shall see Him,",
          "Through His own redeeming love;",
          "For that Child so dear and gentle",
          "Is our Lord in heaven above;",
          "And He leads His children on",
          "To the place where He is gone."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 150,
    "reference": "SDAH150",
    "title": "Who Is He in Yonder Stall?",
    "hasMidi": true,
    "numberOfVerses": 7,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Who is He in yonder stall,",
          "At whose feet the shepherds fall?",
          "'Tis the Lord, O wondrous story,",
          "'Tis the Lord, the King of glory!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Who is He in deep distress,",
          "Fasting in the wilderness?",
          "'Tis the Lord, O wondrous story,",
          "'Tis the Lord, the King of glory!"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Who is He, the gathering throng",
          "Greet with loud triumphant song?",
          "'Tis the Lord, O wondrous story,",
          "'Tis the Lord, the King of glory!"
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Lo, at midnight, who is He",
          "Prays in dark Gethsemane?",
          "'Tis the Lord, O wondrous story,",
          "'Tis the Lord, the King of glory!"
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "Who is He on yonder tree",
          "Dies in shame and agony?",
          "'Tis the Lord, O wondrous story,",
          "'Tis the Lord, the King of glory!"
        ]
      },
      {
        "verseNumber": 6,
        "content": [
          "Who is He that from the grave",
          "Comes to heal and help and save?",
          "'Tis the Lord, O wondrous story,",
          "'Tis the Lord, the King of glory!"
        ]
      },
      {
        "verseNumber": 7,
        "content": [
          "Who is He that from His Throne",
          "Rules through all the world alone?",
          "'Tis the Lord, O wondrous story,",
          "'Tis the Lord, the King of glory!"
        ]
      }
    ],
    "chorus": [
      "At His feet we humbly fall,",
      "Crown Him, crown Him Lord of all.",
      "At His feet we humbly fall; the Lord of all.",
      "Crown Him, crown Him, Jesus, Jesus,",
      "Crown Him Lord of all."
    ],
    "timestamps": {
      "chorus": 17.4167
    }
  },
  {
    "hymnNumber": 151,
    "reference": "SDAH151",
    "title": "Jesus Walked This Lonesome Valley",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Jesus walked this lonesome valley;",
          "He had to walk it by Himself.",
          "O nobody else could walk it for Him.",
          "He had to walk it by Himself."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "I must go and stand my trial.",
          "I have to stand it by myself.",
          "O nobody else could stand it for me.",
          "I have to stand it by myself."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Jesus walked this lonesome valley;",
          "He had to walk it by Himself.",
          "O nobody else could walk it for Him.",
          "He had to walk it by Himself."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 152,
    "reference": "SDAH152",
    "title": "Tell Me the Story of Jesus",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Tell me the story of Jesus,",
          "Write on my heart every word,",
          "Tell me the story most precious",
          "Sweetest that ever was heard;",
          "Tell how the angels, in chorus,",
          "Sang as they welcomed His birth,",
          "Glory to God in the highest,",
          "Peace and good tidings to earth."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Fasting, alone in the desert,",
          "Tell of the days that He passed,",
          "How for our sins He was tempted,",
          "Yet was triumphant at last;",
          "Tell of the years of His labor,",
          "Tell of the sorrow He bore,",
          "He was despised and afflicted,",
          "Homeless, rejected, and poor."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Tell of the cross where they nailed Him,",
          "Writhing in anguish and pain;",
          "Tell of the grave where they laid Him,",
          "Tell how He liveth again;",
          "Love in that story so tender,",
          "Clearer than ever I see;",
          "Stay, let me weep while you whisper,",
          "Love paid the ransom for me."
        ]
      }
    ],
    "chorus": [
      "Tell me the story of Jesus,",
      "Write on my heart every word,",
      "Tell me the story most precious,",
      "Sweetest that ever was heard."
    ],
    "timestamps": {
      "chorus": 40.1931
    }
  },
  {
    "hymnNumber": 153,
    "reference": "SDAH153",
    "title": "Prince of Peace Control My Will",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Prince of Peace, control my will,",
          "Bid this struggling heart be still;",
          "Bid my fears and doubtings cease,",
          "Hush my spirit into peace."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Thou hast bought me with Thy blood,",
          "Opened wide the gate to God;",
          "Peace, I ask, but peace must be,",
          "Lord, in being one with Thee."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "May Thy will, not mine, be done,",
          "May Thy will and mine be one;",
          "Chase these doubtings from my heart,",
          "Now Thy perfect peace impart."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 154,
    "reference": "SDAH154",
    "title": "When I Survey the Wondrous Cross",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "When I survey the wondrous cross",
          "On which the Prince of glory died,",
          "My richest gain I count but loss,",
          "And pour contempt on all my pride."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Forbid it, Lord, that I should boast,",
          "Save in the death of Christ, my God;",
          "All the vain things that charm me most",
          "I sacrifice them to His blood."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "See, from His head, His hands, His feet,",
          "Sorrow and love flow mingled down:",
          "Did e'er such love and sorrow meet,",
          "Or thorns compose so rich a crown?"
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Were the whole realm of nature mine,",
          "That were a present far too small;",
          "Love so amazing, so divine,",
          "Demands my soul, my life, my all."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 155,
    "reference": "SDAH155",
    "title": "When I Survey the Wondrous Cross",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "When I survey the wondrous cross",
          "On which the Prince of glory died,",
          "My richest gain I count but loss,",
          "And pour contempt on all my pride."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "See, from His head, His hands, His feet,",
          "Sorrow and love flow mingled down;",
          "Did e'er such love and sorrow meet?",
          "Or thorns compose so rich a crown?"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Since I, who was undone and lost,",
          "Have pardon through His name and word;",
          "Forbid it, then, that I should boast,",
          "Save in the cross of Christ my Lord."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Were the whole realm of nature mine,",
          "That were a tribute far too small;",
          "Love so amazing, so divine,",
          "Demands my life, my soul, my all."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 156,
    "reference": "SDAH156",
    "title": "O Sacred Head Now Wounded",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "O sacred head, now wounded,",
          "With grief and shame weighed down,",
          "Now scornfully surrounded",
          "With thorns, Thine only crown:",
          "O sacred head, what glory,",
          "What bliss till now was Thine!",
          "Yet, though despised and gory,",
          "I joy to call Thee mine."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "What Thou, my Lord, hast suffered",
          "Was all for sinners' gain;",
          "Mine, mine was the transgression,",
          "But Thine the deadly pain.",
          "Lo, here I fall, my Savior!",
          "'Tis I deserve Thy place;",
          "Look on me with Thy favor,",
          "Vouchsafe to me Thy grace."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "What language shall I borrow",
          "To thank Thee, dearest friend,",
          "For this Thy dying sorrow,",
          "Thy pity without end?",
          "O make me Thine forever;",
          "And should I fainting be,",
          "Lord, let me never, never",
          "Outlive my love to Thee."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 157,
    "reference": "SDAH157",
    "title": "Go to Dark Gethsemane",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Go to dark Gethsemane,",
          "Ye that feel the tempter's power;",
          "Your Redeemer's conflict see;",
          "Watch with Him one bitter hour;",
          "Turn not from His griefs away;",
          "Learn of Jesus Christ to pray."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "See Him at the judgment hall,",
          "Beaten, bound, reviled, arraigned;",
          "See Him meekly bearing all;",
          "Love to man His soul sustained;",
          "Shun not suffering, shame, or loss;",
          "Learn of Christ to bear the cross."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Calvary's mournful mountain climb;",
          "There adoring at His feet,",
          "Mark that miracle of time,",
          "God's own sacrifice complete;",
          "\"It is finished!\" hear Him cry;",
          "Learn of Jesus Christ to die."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 158,
    "reference": "SDAH158",
    "title": "Were You There?",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Were you there when they crucified my Lord?",
          "Were you there when they crucified my Lord?",
          "O! Sometimes it causes me to tremble, tremble, tremble.",
          "Were you there when they crucified my Lord?"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Were you there when they nailed Him to the tree?",
          "Were you there when they nailed Him to the tree?",
          "O! Sometimes it causes me to tremble, tremble, tremble.",
          "Were you there when they nailed Him to the tree?"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Were you there when they pierced Him in the side?",
          "Were you there when they pierced Him in the side?",
          "O! Sometimes it causes me to tremble, tremble, tremble.",
          "Were you there when they pierced Him in the side?"
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Were you there when the sun refused to shine?",
          "Were you there when the sun refused to shine?",
          "O! Sometimes it causes me to tremble, tremble, tremble.",
          "Were you there when the sun refused to shine?"
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "Were you there when they laid Him in the tomb?",
          "Were you there when they laid Him in the tomb?",
          "O! Sometimes it causes me to tremble, tremble, tremble.",
          "Were you there when they laid Him in the tomb?"
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 159,
    "reference": "SDAH159",
    "title": "The Old Rugged Cross",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "On a hill far away stood an old rugged cross,",
          "The emblem of suffering and shame,",
          "And I love that old cross where the dearest and best",
          "For a world of lost sinners was slain."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Oh, that old rugged cross, so despised by the world,",
          "Has a wondrous attraction for me,",
          "For the dear Lamb of God left His glory above,",
          "To bear it to dark Calvary."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "To the old rugged cross I will ever be true,",
          "Its shame and reproach gladly bear;",
          "Then He'll call me some day to my home far away,",
          "Where His glory forever I'll share."
        ]
      }
    ],
    "chorus": [
      "So I'll cherish the old rugged cross,",
      "Till my trophies at last I lay down;",
      "I will cling to the old rugged cross,",
      "And exchange it some day for a crown."
    ],
    "timestamps": {
      "chorus": 28.3173
    }
  },
  {
    "hymnNumber": 160,
    "reference": "SDAH160",
    "title": "Ride On in Majesty",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Ride on! ride on in majesty!",
          "Hark, all the tribes hosanna cry;",
          "O Savior meek, pursue Thy road",
          "With palms and scattered garments strowed."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Ride on! ride on in majesty!",
          "In lowly pomp ride on to die;",
          "O Christ, Thy triumphs now begin",
          "O'er captive death and conquered sin."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Ride on! ride on in majesty!",
          "The winged squadrons of the sky",
          "Look down with sad and wondering eyes",
          "To see the approaching sacrifice."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Ride on! ride on in majesty!",
          "In lowly pomp ride on to die;",
          "Bow Thy meek head to mortal pain,",
          "Then take, O God, Thy power and reign."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 161,
    "reference": "SDAH161",
    "title": "Throned Upon the Awful Tree",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Throned upon the awful tree,",
          "Lamb of God, Your grief we see.",
          "Darkness veils Your anguished face;",
          "None its lines of woe can trace.",
          "None can tell what pangs unknown",
          "Hold You silent and alone."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Silent through those three dread hours,",
          "Wrestling with the evil powers,",
          "Left alone with human sin,",
          "Gloom around You and within,",
          "Till th'appointed time is nigh,",
          "'Till the Lamb of God may die."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Hark, that cry that peals aloud",
          "Upward through the whelming cloud!",
          "You, the Father's only Son,",
          "You, His own anointed one,",
          "You are asking can it be?",
          "\"Why have You forsaken Me?\""
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Lord, should fear and anguish roll",
          "Darkly o'er our sinful soul,",
          "You, who once were thus bereft",
          "That Your own might ne'er be left,",
          "Teach us by that bitter cry",
          "In the gloom to know You nigh."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 162,
    "reference": "SDAH162",
    "title": "Wondrous Love",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "What wondrous love is this, O my soul, O my soul?",
          "What wondrous love is this,",
          "O my soul? What wondrous love is this",
          "That caused the Lord of bliss",
          "To bear the dreadful curse for my soul, for my soul;",
          "To bear the dreadful curse for my soul"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "To God and to the Lamb I will sing,",
          "I will sing; To God and to the Lamb,",
          "I will sing; To God and to the Lamb",
          "Who is the great I am, While millions join the theme,",
          "I will sing, I will sing; While millions join the theme, I will sing."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "And when from death I'm free, I'll sing on, I'll sing on;",
          "And when from death I'm free, I'll sing on;",
          "And when from death I'm free,",
          "I'll sing and joyful be, And through eternity",
          "I'll sing on, I'll sing on! And through eternity, I'll sing on"
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 163,
    "reference": "SDAH163",
    "title": "At the Cross",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Alas, and did my Savior bleed?",
          "And did my Sovereign die?",
          "Would He devote that sacred head",
          "For someone such as I?"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Was it for crimes that I have done,",
          "He suffered on the tree?",
          "Amazing pity! Grace unknown!",
          "And love beyond degree!"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "But drops of grief can ne'er repay",
          "The debt of love I owe:",
          "Here, Lord, I give myself away,",
          "'Tis all that I can do!"
        ]
      }
    ],
    "chorus": [
      "At the cross, at the cross where I first saw the light,",
      "And the burden of my heart rolled away,",
      "It was there by faith I received my sight,",
      "And now I am happy all the day!"
    ],
    "timestamps": {
      "chorus": 21.0721
    }
  },
  {
    "hymnNumber": 164,
    "reference": "SDAH164",
    "title": "There Is a Green Hill Far Away",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "There is a green hill far away,",
          "Without a city wall,",
          "Where the dear Lord was crucified,",
          "Who died to save us all."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "We may not know, we cannot tell,",
          "What pains He had to bear,",
          "But we believe it was for us",
          "He hung and suffered there."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "He died that we might be forgiven,",
          "He died to make us good,",
          "That we might go at last to heaven,",
          "Saved by His precious blood."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "There was no other good enough",
          "To pay the price of sin;",
          "He only could unlock the gate",
          "Of heaven, and let us in."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "O dearly, dearly has He loved!",
          "And we must love Him too,",
          "And trust in His redeeming blood,",
          "And try His works to do."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 165,
    "reference": "SDAH165",
    "title": "Look, You Saints! the Sight Is Glorious",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Look, you saints, the sight is glorious,",
          "See the Man of sorrows now;",
          "From the fight returned victorious,",
          "Every knee to Him shall bow.",
          "Crown Him! Crown Him! Crown Him!",
          "Crown Him! Crown Him! Crown Him!",
          "Crowns become the victor's brow.",
          "Crowns become the victor's brow."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Crown the Savior! angels crown Him!",
          "Rich the trophies Jesus bring;",
          "On the seat of power enthrone Him",
          "While the vault of heaven rings.",
          "Crown Him! Crown Him! Crown Him!",
          "Crown Him! Crown Him! Crown Him!",
          "Crown the Savior, King of kings.",
          "Crown the Savior, King of kings."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Sinners in derision crowned Him,",
          "Mocking thus the Savior's claim;",
          "Saints and angels crowd around Him,",
          "Own His title, praise His name.",
          "Crown Him! Crown Him! Crown Him!",
          "Crown Him! Crown Him! Crown Him!",
          "Spread abroad the victor's fame!",
          "Spread abroad the victor's fame!"
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Hark! those bursts of acclamation!",
          "Hark! those loud triumphant chords!",
          "Jesus takes the highest station;",
          "Oh, what joy the sight affords.",
          "Crown Him! Crown Him! Crown Him!",
          "Crown Him! Crown Him! Crown Him!",
          "King of kings and Lord of lords!",
          "King of kings and Lord of lords!"
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 166,
    "reference": "SDAH166",
    "title": "Christ the Lord Is Risen Today",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Christ the Lord is risen today, Alleluia!",
          "Sons of men and angels say, Alleluia!",
          "Raise your joys and triumphs high, Alleluia!",
          "Sing, ye heavens, and earth reply, Alleluia!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Lives again our glorious King, Alleluia!",
          "Where, O death, is now thy sting? Alleluia!",
          "Once He died, our souls to save, Alleluia!",
          "Where's thy victory, boasting grave? Alleluia!"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Love's redeeming work is done, Alleluia!",
          "Fought the fight, the battle won, Alleluia!",
          "Death in vain forbids Him rise, Alleluia!",
          "Christ hath opened paradise, Alleluia!"
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Soar we now where Christ has led, Alleluia!",
          "Following our exhalted Head, Alleluia!",
          "Made like Him, like Him we rise, Alleluia!",
          "Ours the cross, the grave, the skies, Alleluia!"
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 167,
    "reference": "SDAH167",
    "title": "Alleluia Sing to Jesus",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Alleluia! sing to Jesus!",
          "His the scepter, His the throne;",
          "Alleluia! His the triumph,",
          "His the victory alone;",
          "Hark! the songs of peaceful Sion",
          "Thunder like a mighty flood;",
          "Jesus out of every nation",
          "Hath redeemed us by His blood."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Alleluia! not as orphans",
          "Are we left in sorrow now;",
          "Alleluia! He is near us,",
          "Faith believes, nor questions how:",
          "Though the cloud from sight received Him,",
          "When the forty days were o'er,",
          "Shall our hearts forget His promise,",
          "\"I am with you evermore\"?"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Alleluia! Bread of heaven,",
          "Thou on earth our food, our stay!",
          "Alleluia! here the sinful",
          "Flee to Thee from day to day:",
          "Intercessor, Friend of sinners,",
          "Earth's Redeemer plead for me,",
          "Where the songs of all the sinless",
          "Sweep across the crystal sea."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 168,
    "reference": "SDAH168",
    "title": "And Have the Bright Immensities",
    "hasMidi": true,
    "numberOfVerses": 2,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "And have the bright immensities",
          "Received our risen Lord,",
          "Where light years frame the Pleiades",
          "And point Orion's sword?",
          "Do flaming suns His footsteps trace",
          "Thro' corridors sublime,",
          "The Lord of interstellar space",
          "And conqueror of time?"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "The heav'n that hides Him from our sight",
          "Knows neither near nor far;",
          "A little candle sheds its light",
          "As surely as a star.",
          "And where His loving people meet",
          "To share the gift divine,",
          "There stands He with unhurrying feet;",
          "There heav'nly splendors shine."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 169,
    "reference": "SDAH169",
    "title": "Come, You Faithful",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Come, you faithful, raise the strain",
          "Of triumphant gladness;",
          "God has brought His people forth",
          "Into joy from sadness.",
          "Now rejoice, Jerusalem,",
          "And with true affection",
          "Welcome in unwearied strains",
          "Jesus' resurrection."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "'Tis the spring of souls today;",
          "Christ has burst His prison;",
          "From the frost and gloom of death",
          "Light and life have risen.",
          "All the winter of our sins,",
          "Long and dark, is flying",
          "From His light, to whom we give",
          "Thanks and praise undying."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "\"Alleluia!\" now we cry",
          "To our King immortal,",
          "Who, triumphant, burst the bars",
          "Of the tomb's dark portal;",
          "\"Alleluia!\" with the Son,",
          "God the Father praising;",
          "\"Alleluia!\" yet again",
          "To the Spirit raising."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 170,
    "reference": "SDAH170",
    "title": "Come, You Faithful",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Come, you faithful, raise the strain",
          "Of triumphant gladness;",
          "God has brought His Israel",
          "Into joy from sadness;",
          "Loosed from Pharoah's bitter yoke",
          "Jacob's sons and daughters;",
          "Led them with unmoistened foot",
          "Through the Red Sea waters."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "'Tis the spring of souls today;",
          "Christ has burst His prison,",
          "And from three days' sleep in death",
          "As a sun has risen;",
          "All the winter of our sins,",
          "Long and dark, is flying",
          "From His light, to whom is giv'n",
          "Laud and praise undying."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Now the queen of seasons, bright",
          "With the day of splendor,",
          "With the royal feast of feasts,",
          "Comes its joy to render;",
          "Comes to gladden faithful hearts",
          "Which with true affection",
          "Welcome in unwearied strain",
          "Jesus' resurrection."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "For today among the twelve",
          "Christ appeared, bestowing",
          "His deep peace, which evermore",
          "Passes human knowing.",
          "Neither could the gates of death,",
          "Nor the tomb's dark portal,",
          "Nor the watchers, nor the seal,",
          "Hold Him as a mortal."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "\"Alleluia!\" now we cry",
          "To our King immortal,",
          "Who, triumphant, burst the bars",
          "Of the tomb's dark portal;",
          "\"Alleluia\" with the Son,",
          "God the Father praising;",
          "\"Alleluia!\" yet again",
          "To the Spirit raising."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 171,
    "reference": "SDAH171",
    "title": "Thine Is the Glory",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Thine is the glory,",
          "Risen, conquering Son;",
          "Endless is the vict'ry",
          "Thou o'er death hast won.",
          "Angels in bright raiment",
          "Rolled the stone away,",
          "Kept the folded graveclothes",
          "Where Thy body lay."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Lo! Jesus meets us,",
          "Risen, from the tomb;",
          "Lovingly He greets us,",
          "Scatters fear and gloom;",
          "Let His church with gladness",
          "Hymns of triumph sing,",
          "For her Lord now liveth;",
          "Death hath lost its sting."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "No more we doubt Thee,",
          "Glorious Prince of Life!",
          "Life is naught without Thee;",
          "Aid us in our strife;",
          "Make us more than conqu'rors,",
          "Through Thy deathless love;",
          "Bring us safe through Jordan",
          "With Thy power and love."
        ]
      }
    ],
    "chorus": [
      "Thine is the glory,",
      "Risen, conquering Son;",
      "Endless is the vict'ry",
      "Thou o'er death hast won."
    ],
    "timestamps": {
      "chorus": 34.5509
    }
  },
  {
    "hymnNumber": 172,
    "reference": "SDAH172",
    "title": "The Strife Is O'er",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Alleluia, alleluia, alleluia!",
          "The strife is o'er, the battle done;",
          "Now is the victor's triumph won!",
          "Now be the song of praise begun.",
          "Alleluia!",
          "Alleluia, alleluia, alleluia!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "The pow'rs of death have done their worst,",
          "But Christ their legions has dispersed.",
          "Let shouts of holy joy outburst.",
          "Alleluia!"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "The three sad days have quickly sped,",
          "He rises glorious from the dead.",
          "All glory to our risen head!",
          "Alleluia!"
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Lord, by the stripes which wounded You,",
          "From death's sting free Your servants too,",
          "That we may live and sing to You.",
          "Alleluia!"
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 173,
    "reference": "SDAH173",
    "title": "Good Christian Friends Rejoice",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Good Christian friends, rejoice and sing!",
          "Now is the triumph of our King!",
          "To all the world glad news we bring:"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "The Lord of life is risen for aye;",
          "Bring flowers of song to strew His way;",
          "Let all mankind rejoice and say:"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Praise we in songs of victory",
          "That love, that life which cannot die,",
          "And sing with hearts uplifted high:"
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Thy name we bless, O risen Lord,",
          "And sing today with one accord",
          "The life laid down, the life restored:"
        ]
      }
    ],
    "chorus": [
      "Alleluia! Alleluia! Alleluia!"
    ],
    "timestamps": {
      "chorus": 17.6455
    }
  },
  {
    "hymnNumber": 174,
    "reference": "SDAH174",
    "title": "Star of Our Hope",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Star of our hope! He'll soon appear,",
          "The last loud trumpet speaks Him near;",
          "Hail Him, all saints, from pole to pole;",
          "How welcome to the faithful soul!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "From heaven angelic voices sound:",
          "Behold the Lord of glory crowned,",
          "Arrayed in majesty divine,",
          "And in His highest glories shine."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "The grave yields up its precious trust,",
          "Which long has slumbered in the dust,",
          "Resplendent forms ascending, fair,",
          "Now meet the Savior in the air."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Descending with His azure throne,",
          "He claims the kingdom for His own;",
          "The saints rejoice, they shout, they sing,",
          "And hail Him their triumphant King."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 175,
    "reference": "SDAH175",
    "title": "Now the Green Blade Rises",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Now the green blade rises from the buried grain,",
          "Wheat that in dark earth many days has lain;",
          "Love lives again, that with the dead has been;",
          "Love is come again like wheat arising green."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "In the grave they laid Him, love by hatred slain,",
          "Thinking that He would never wake again,",
          "Laid in the earth like grain that sleeps unseen;",
          "Love is come again like wheat arising green."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Forth He came in triumph, like the risen grain,",
          "He that for three days in the grave had lain;",
          "Raised from the dead, my living Lord is seen;",
          "Love is come again like wheat arising green."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "When our hearts are wintry, grieving, or in pain,",
          "Your touch can call us back to life again,",
          "Fields of our hearts that dead and bare have been;",
          "Love is come again like wheat arising green"
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 176,
    "reference": "SDAH176",
    "title": "Hail the Day That Sees Him Rise",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Hail the day that sees Him rise,",
          "Alleluia!",
          "Glorious to His native skies;",
          "Alleluia!",
          "Christ, awhile to mortals giv'n,",
          "Alleluia!",
          "Enters now the highest heav'n!",
          "Alleluia!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "There the glorious triumph waits;",
          "Alleluia!",
          "Lift your heads, eternal gates!",
          "Alleluia!",
          "Wide unfold the radiant scene;",
          "Alleluia!",
          "Take the King of glory in!",
          "Alleluia!"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "See! He lifts His hands above;",
          "Alleluia!",
          "See! He shows the prints of love:",
          "Alleluia!",
          "Hark! His gracious lips bestow,",
          "Alleluia!",
          "Blessings on His Church below.",
          "Alleluia!"
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Lord beyond our mortal sight,",
          "Alleluia!",
          "Raise our hearts to reach Thy height,",
          "Alleluia!",
          "There Thy face unclouded see,",
          "Alleluia!",
          "Find our heav'n of heav'ns in Thee.",
          "Alleluia!"
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 177,
    "reference": "SDAH177",
    "title": "Jesus, Your Blood and Righteousness",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Jesus, Your blood and righteousness",
          "My beauty are, my glorious dress;",
          "Mid flaming worlds, in these arrayed,",
          "With joy shall I lift up my head."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Bold shall I stand in that great day,",
          "Cleansed and redeemed, no debt to pay;",
          "For by Your cross, absolved I am",
          "From sin and guilt, from fear and shame."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Lord, I believe Your precious blood,",
          "Which at the mercy seat of God",
          "Pleads for the captives' liberty,",
          "Was also shed in love for me."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "When from the dust of death I rise",
          "To claim my mansion in the skies,",
          "This then shall be my only plea:",
          "Christ Jesus lived and died for me."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 178,
    "reference": "SDAH178",
    "title": "The Unveiled Christ",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Once our blessed Christ of beauty",
          "Was veiled off from human view;",
          "But through suffering, death, and sorrow",
          "He has rent the veil in two."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Yes, He is with God, the Father,",
          "Interceding there for you;",
          "For He is the Well-beloved",
          "Since He rent the veil in two."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Holy angels bow before Him,",
          "Men of earth give praises due;",
          "For He is the mighty Conqueror",
          "Since He rent the veil in two."
        ]
      }
    ],
    "chorus": [
      "O behold the Man of Sorrows!",
      "O behold Him in plain view!",
      "Lo! He is the mighty Conqueror",
      "Since He rent the veil in two;",
      "Lo! He is the mighty Conqueror",
      "Since He rent the veil in two."
    ],
    "timestamps": {
      "chorus": 20.8424
    }
  },
  {
    "hymnNumber": 179,
    "reference": "SDAH179",
    "title": "The Wonders of Redeeming Love",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "The wonders of redeeming love",
          "Our highest thoughts exceed;",
          "The Son of God comes from above",
          "For sinful man to bleed."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "He gives Himself, His life, His all,",
          "A sinless sacrifice.",
          "For man He drains the cup of gall,",
          "For man the victim dies."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "And now before His Father's face",
          "His precious blood He pleads;",
          "For those who seek the throne of grace",
          "His lovee still intercedes."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "He knows the frailties of our frame,",
          "For He has borne our grief;",
          "Our great High Priest once felt the same,",
          "And He can send relief."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "His love will not be satisfied,",
          "Till He in glory sees",
          "The faithful ones for whom He died",
          "From sin forever free."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 180,
    "reference": "SDAH180",
    "title": "O Listen to Our Wondrous Story",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "O listen to our wondrous story,",
          "Counted once among the lost;",
          "Yet One came down from heaven's glory,",
          "Saving us at awful cost."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "No angel could His place have taken,",
          "Highest of the high tho' he;",
          "The loved One on the cross forsaken",
          "Was One of the Godhead three!"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Will you surrender to this Savior?",
          "To His scepter humbly bow;",
          "You, too, shall come to know His favor,",
          "He will save you, save you now."
        ]
      }
    ],
    "chorus": [
      "Who saved us from eternal loss?",
      "(Who but God's Son upon the cross?)",
      "What did He do? (He died for you!)",
      "Where is He now? (Believe it thou)",
      "In heaven interceding!"
    ],
    "timestamps": {
      "chorus": 21.4583
    }
  },
  {
    "hymnNumber": 181,
    "reference": "SDAH181",
    "title": "Does Jesus Care?",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Does Jesus care when my heart is pained",
          "Too deeply for mirth and song;",
          "As the burdens press, and the cares distress,",
          "And the way grows weary and long?"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Does Jesus care when my way is dark",
          "With a nameless dread and fear?",
          "As the daylight fades into deep night shades,",
          "Does He care enough to be near?"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Does Jesus care when I've said goodbye",
          "To the dearest on earth to me,",
          "And my sad heart aches till it nearly breaks",
          "Is it aught to Him? does He see?"
        ]
      }
    ],
    "chorus": [
      "O yes, He cares; I know He cares!",
      "His heart is touched with my grief;",
      "When the days are weary, the long nights dreary,",
      "I know my Savior cares."
    ],
    "timestamps": {
      "chorus": 26.8068
    }
  },
  {
    "hymnNumber": 182,
    "reference": "SDAH182",
    "title": "Christ Is Alive",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Christ is alive! Let Christians sing.",
          "His cross stands empty to the sky.",
          "Let streets and homes with praises ring.",
          "His love in death shall never die."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Christ is alive! No longer bound",
          "To distant years in Palestine,",
          "He comes to claim the here and now",
          "And conquer every place and time."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "In every insult, rift, and war",
          "Where color, scorn or wealth divide,",
          "He suffers still, yet loves the more,",
          "And lives, though ever crucified."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Christ is alive! Ascended Lord",
          "He rules the world His Father made,",
          "Till, in the end, His love adored",
          "Shall be to all on earth displayed."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 183,
    "reference": "SDAH183",
    "title": "I Will Sing of Jesus' Love",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "I will sing of Jesus' love,",
          "Sing of Him who first loved me;",
          "For He left bright worlds above,",
          "And died on Calvary."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "O the depths of love divine!",
          "Earth or heaven can never know",
          "How that sins as dark as mine",
          "Can be made as white as snow."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Nothing good for Him I've done;",
          "How could He such love bestow?",
          "Lord, I own my heart is won,",
          "Help me now my love to show."
        ]
      }
    ],
    "chorus": [
      "I will sing of Jesus' love,",
      "Endless praise my heart shall give;",
      "He has died that I might live;",
      "I will sing His love to me."
    ],
    "timestamps": {
      "chorus": 22.4249
    }
  },
  {
    "hymnNumber": 184,
    "reference": "SDAH184",
    "title": "Jesus Paid It All",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "I hear the Savior say,",
          "\"Thy strength indeed is small;",
          "Child of weakness, watch and pray,",
          "Find in Me thine all in all.\""
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Lord, now indeed I find",
          "Thy power, and Thine alone,",
          "Can change the leper's spots,",
          "And melt the heart of stone."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Since nothing good have I",
          "Whereby Thy grace to claim,",
          "I'll wash my garment white",
          "In the blood of Calvary's Lamb."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "And when before the throne",
          "I stand in Him complete,",
          "I'll lay my trophies down,",
          "All down at Jesus' feet."
        ]
      }
    ],
    "chorus": [
      "Jesus paid it all,",
      "All to Him I owe;",
      "Sin had left a crimson stain;",
      "He washed it white as snow."
    ],
    "timestamps": {
      "chorus": 18.2721
    }
  },
  {
    "hymnNumber": 185,
    "reference": "SDAH185",
    "title": "Jesus Is All the World to Me",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Jesus is all the world to me,",
          "My life, my joy, my all;",
          "He is my strength from day to day,",
          "Without Him I would fall.",
          "When I am sad to Him I go,",
          "No other one can cheer me so;",
          "When I am sad He makes me glad,",
          "He's my Friend."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Jesus is all the world to me,",
          "My Friend in trials sore;",
          "I go to Him for blessings, and",
          "He gives them o'er and o'er.",
          "He sends the sunshine and the rain,",
          "He sends the harvest's golden grain;",
          "Sunshine and rain, harvest of grain,",
          "He's my Friend."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Jesus is all the world to me,",
          "And true to Him I'll be;",
          "O how could I this Friend deny,",
          "When He's so true to me?",
          "Following Him I know I'm right,",
          "He watches o'er me day and night;",
          "Following Him by day and night,",
          "He's my Friend."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Jesus is all the world to me,",
          "I want no better friend;",
          "I trust Him now, I'll trust Him when",
          "Life's fleeting days shall end.",
          "Beautiful life with such a Friend;",
          "Beautiful life that has no end;",
          "Eternal life, eternal joy,",
          "He's my Friend."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 186,
    "reference": "SDAH186",
    "title": "I've Found a Friend",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "I've found a Friend; oh, such a Friend!",
          "He loved me ere I knew Him;",
          "He drew me with the cords of love,",
          "And thus He bound me to Him.",
          "And 'round my heart still closely twine",
          "Those ties which nought can sever,",
          "For I am His, and He is mine,",
          "Forever and forever."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "I've found a Friend; oh, such a Friend!",
          "He bled, He died to save me;",
          "And not alone the gift of life,",
          "But His own self He gave me.",
          "Nought that I have my own I call,",
          "I hold it for the Giver;",
          "My heart, my strength, my life, my all,",
          "Are His, and His forever."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "I've found a Friend; oh, such a Friend!",
          "All power to Him is given;",
          "To guard me on my upward course,",
          "And bring me safe to heaven.",
          "The eternal glories gleam afar,",
          "To nerve my faint endeavor;",
          "So now to watch, to work, to war,",
          "And then to rest forever."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "I've found a Friend; oh, such a Friend!",
          "So kind, and true, and tender,",
          "So wise a counselor and guide,",
          "So mighty a defender.",
          "From Him, who loveth me so well,",
          "What power my soul can sever?",
          "Shall life or death, or earth, or hell?",
          "No; I am His forever."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 187,
    "reference": "SDAH187",
    "title": "Jesus What A Friend For Sinners",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Jesus! what a Friend for sinners!",
          "Jesus! Lover of my soul;",
          "Friends may fail me, foes assail me,",
          "He, my Savior, makes me whole."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Jesus! what a Strength for weakness!",
          "Let me hide myself in Him;",
          "Tempted, tried, and sometimes failing,",
          "He, my Strength, my vict'ry wins."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Jesus! what a Help in sorrow!",
          "While the billows o'er me roll,",
          "Even when my heart is breaking,",
          "He, my Comfort, helps my soul."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Jesus! I do now receive Him,",
          "More than all in Him I find,",
          "He hath granted me forgiveness,",
          "I am His, and He is mine."
        ]
      }
    ],
    "chorus": [
      "Hallelujah! what a Savior!",
      "Hallelujah! what a Friend!",
      "Saving, helping, keeping, loving,",
      "He is with me to the end."
    ],
    "timestamps": {
      "chorus": 19.675
    }
  },
  {
    "hymnNumber": 188,
    "reference": "SDAH188",
    "title": "My Song Is Love Unknown",
    "hasMidi": true,
    "numberOfVerses": 6,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "My song is love unknown,",
          "My Savior's love to me,",
          "Love to the loveless shown,",
          "That they might lovely be.",
          "O who am I that for my sake",
          "My Lord should take frail flesh and die?"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "He came from His blest throne,",
          "Salvation to bestow,",
          "But men made strange, and none",
          "The longed-for Christ would know.",
          "But O my Friend, my Friend indeed",
          "Who at my need His life did spend."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Sometimes they strew His way,",
          "And His sweet praises sing,",
          "Resounding all the day,",
          "Hosannas to their King.",
          "Then \"Crucify\" is all their breath,",
          "And for His death they thirst and cry."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Why, what hath my Lord done?",
          "What makes this rage and spite?",
          "He made the lame to run,",
          "He gave the blind their sight.",
          "Sweet injuries! yet they at these",
          "Themselves displease, and 'gainst Him rise."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "They rise, and needs will have",
          "My dear Lord made away;",
          "A murderer they save,",
          "The Prince of life they slay.",
          "Yet cheerful He to suff'ring goes,",
          "That He His foes from thence might free."
        ]
      },
      {
        "verseNumber": 6,
        "content": [
          "Here might I stay and sing,",
          "No story so divine:",
          "Never was love, dear King,",
          "Never was grief like Thine!",
          "This is my Friend, in whose sweet praise",
          "I all my days could gladly spend."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 189,
    "reference": "SDAH189",
    "title": "All That Thrills My Soul",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Who can cheer the heart like Jesus,",
          "By His presence all divine?",
          "True and tender, pure and precious,",
          "Oh, how blest to call Him mine!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Love of Christ so freely given,",
          "Grace of God beyond degree,",
          "Mercy higher than the heaven,",
          "Deeper than the deepest sea."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Every need His hand supplying,",
          "Every good in Him I see;",
          "On His strength divine relying,",
          "He is All in All to me."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "By the crystal flowing river",
          "With the ransomed I will sing,",
          "And forever and forever",
          "Praise and glorify the King"
        ]
      }
    ],
    "chorus": [
      "All that thrills my soul is Jesus;",
      "He is more than life to me; (to me;)",
      "And the fairest of ten thousand,",
      "In my blessed Lord I see."
    ],
    "timestamps": {
      "chorus": 22.5073
    }
  },
  {
    "hymnNumber": 190,
    "reference": "SDAH190",
    "title": "Jesus Loves Me",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Jesus loves me! this I know,",
          "For the Bible tells me so;",
          "Little ones to Him belong,",
          "They are weak, but He is strong."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Jesus loves me! He who died",
          "Heaven's gate to open wide:",
          "He will wash away my sin,",
          "Let His little child come in."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Jesus, take this heart of mine,",
          "Make it pure and wholly Thine;",
          "On the cross You died for me,",
          "I will love and live for Thee."
        ]
      }
    ],
    "chorus": [
      "Yes, Jesus loves me!",
      "Yes, Jesus loves me!",
      "Yes, Jesus loves me!",
      "The Bible tells me so."
    ],
    "timestamps": {
      "chorus": 16.7794
    }
  },
  {
    "hymnNumber": 191,
    "reference": "SDAH191",
    "title": "Love Divine",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Love divine, all loves excelling,",
          "Joy of heaven, to earth come down;",
          "Fix in us Thy humble dwelling,",
          "All Thy faithful mercies crown!",
          "Jesus, Thou art all compassion,",
          "Pure, unbounded love Thou art;",
          "Visit us with Thy salvation,",
          "Enter every trembling heart."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Breathe, O breathe Thy loving Spirit",
          "Into every troubled breast!",
          "Let us all in Thee inherit,",
          "Let us find the promised rest;",
          "Take away our bent to sinning;",
          "Alpha and Omega be;",
          "End of faith, as its beginning,",
          "Set our hearts at liberty."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Come, Almighty to deliver,",
          "Let us all Thy grace receive;",
          "Suddenly return, and never,",
          "Nevermore Thy temples leave.",
          "Thee we would be always blessing,",
          "Serve Thee as Thy hosts above,",
          "Pray, and praise Thee without ceasing,",
          "Glory in Thy perfect love."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Finish, then, Thy new creation;",
          "Pure and spotless let us be;",
          "Let us see Thy great salvation",
          "Perfectly restored in Thee:",
          "Changed from glory into glory,",
          "Till in heaven we take our place,",
          "Till we cast our crowns before Thee,",
          "Lost in wonder, love, and praise."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 192,
    "reference": "SDAH192",
    "title": "O Shepherd Divine",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "O Shepherd divine, I know Thou art mine;",
          "Thy search in the night was for me.",
          "This bleak world is cold, but warm is Thy fold;",
          "My Shepherd, I follow Thee.",
          "Thy beautiful lamp shineth bright o'er my way,",
          "Thy glorious light unto Thy perfect day.",
          "Thro' pastures serene, Thro' valleys of green,",
          "My Shepherd, I follow Thee."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "O Shepherd divine, I know Thou art mine;",
          "Thy great heart was broken for me.",
          "Thy grace and Thy law I picture in awe;",
          "They kissed upon Calvary.",
          "Ah! life that was given to ransom my soul,",
          "Ah! heart that was broken to make sinners whole,",
          "This world is but loss In view of Thy cross,",
          "My Shepherd, I follow Thee."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "O Shepherd divine, I know Thou art mine;",
          "I hear Thee say, \"Follow thou Me.\"",
          "Thy message today illumines my way;",
          "The Spirit of Prophecy.",
          "I thrill at Thy marvelous love to Thy sheep,",
          "The way Thou dost lead to the still waters deep,",
          "One staff and one rod, One fold and one God,",
          "My Shepherd, I follow Thee."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 193,
    "reference": "SDAH193",
    "title": "Savior, Teach Me",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Savior, teach me day by day,",
          "Love's sweet lesson to obey,",
          "Sweeter lesson cannot be,",
          "Loving Him who first loved me."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "With a child's glad heart of love,",
          "At Thy bidding may I move,",
          "Prompt to serve and follow Thee,",
          "Loving Him who first loved me."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Teach me I am not my own,",
          "I am Thine, and Thine alone;",
          "Thine to keep, to rule, to save",
          "From all sin that would enslave."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Love in loving finds employ,",
          "In obedience all her joy;",
          "Ever new that joy will be,",
          "Loving Him who first loved me."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "Teach me thus Thy steps to trace,",
          "Strong to follow in Thy grace.",
          "Learning how to love from Thee,",
          "Loving Him who first loved me."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 194,
    "reference": "SDAH194",
    "title": "Sing We of the Modern City",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Sing we of the modern city,",
          "Scene alike of joy and stress;",
          "Sing we of its namelss people",
          "In their urban wilderness.",
          "Into endless rows of houses",
          "Life is set a millionfold,",
          "Life expressed in human beings",
          "Daily born and growing old."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "In the city full of people,",
          "World of speed and hectic days,",
          "In the everchanging setting",
          "Of the latest trend and craze,",
          "Christ is present, and among us;",
          "In the crowd we see Him stand.",
          "In the bustle of the city",
          "Jesus Christ is every man."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "God is not remote in heaven,",
          "But on earth to share our shame,",
          "Changing graph and mass and number",
          "Into persons with a name.",
          "Christ has shown, beyond statistics,",
          "Human life with glory crowned,",
          "By His timeless presence proving",
          "People matter, people count!"
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 195,
    "reference": "SDAH195",
    "title": "Showers of Blessing",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "\"There shall be showers of blessing;\"",
          "This is the promise of love;",
          "There shall be seasons refreshing,",
          "Sent from the Savior above."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "\"There shall be showers of blessing;\"",
          "Precious reviving again;",
          "Over the hills and the valleys,",
          "Sound of abundance of rain."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "''There shall be showers of blessing;\"",
          "Send them upon us, O Lord;",
          "Grant to us now a refreshing;",
          "Come, and now honor Thy word."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "\"There shall be showers of blessing;\"",
          "O that today they might fall,",
          "Now as to God we're confessing,",
          "Now as on Jesus we call!"
        ]
      }
    ],
    "chorus": [
      "Showers of blessing,",
      "Showers of blessing we need;",
      "Mercy drops round us are falling,",
      "But for the showers we plead."
    ],
    "timestamps": {
      "chorus": 17.25
    }
  },
  {
    "hymnNumber": 196,
    "reference": "SDAH196",
    "title": "Tell Me the Old, Old Story",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Tell me the old, old story",
          "Of unseen things above,",
          "Of Jesus and His glory,",
          "Of Jesus and His love;",
          "Tell me the story simply,",
          "As to a little child,",
          "For I am weak and weary,",
          "And helpless and defiled."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Tell me the story softly,",
          "With earnest tones and grave;",
          "Remember I'm the sinner",
          "Whom Jesus came to save;",
          "Tell me the story always,",
          "If you would really be,",
          "In any time of trouble,",
          "A comforter to me."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Tell me the same old story",
          "When you have cause to fear",
          "That this world's empty glory",
          "Is costing me too dear;",
          "Yes, and when that world's glory",
          "Is dawning on my soul,",
          "Tell me the old, old story:",
          "\"Christ Jesus makes thee whole.\""
        ]
      }
    ],
    "chorus": [
      "Tell me the old, old story,",
      "Tell me the old, old story,",
      "Tell me the old, old story,",
      "Of Jesus and His love."
    ],
    "timestamps": {
      "chorus": 42.1565
    }
  },
  {
    "hymnNumber": 197,
    "reference": "SDAH197",
    "title": "The King of Love My Shepherd Is",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "The King of love my Shepherd is,",
          "Whose goodness faileth never;",
          "I nothing lack if I am His,",
          "And He is mine forever."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Where streams of living water flow",
          "My ransomed soul He leadeth,",
          "And, where the verdant pastures grow,",
          "With food celestial feedeth."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Perverse and foolish, oft I strayed,",
          "But yet in love He sought me,",
          "And on His shoulder gently laid,",
          "And home, rejoicing, brought me."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "And so through all the length of days",
          "Thy goodness faileth never;",
          "Good Shepherd! I would sing Thy praise",
          "Within Thy house forever."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 198,
    "reference": "SDAH198",
    "title": "And Can It Be?",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "And can it be that I should gain",
          "An int'rest in the Savior's blood?",
          "Died He for me, who caused His pain?",
          "For me, who Him to death pursued?",
          "Amazing love! how can it be",
          "That Thou, my God, shouldst die for me?"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "He left His Father's throne above,",
          "So free, so infinite His grace.",
          "Emptied Himself of all but love,",
          "And bled for Adam's helpless race;",
          "'Tis mercy all, immense and free;",
          "For, O my God, it found out me."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Long my imprisoned spirit lay",
          "Fast bound in sin and nature's night;",
          "Thine eye diffused a quick'ning ray,",
          "I woke, the dungeon flamed with light;",
          "My chains fell off, my heart was free;",
          "I rose, went forth and followed Thee."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "No condemnation now I dread;",
          "Jesus, and all in Him, is mine!",
          "Alive in Him, my living Head,",
          "And clothed in righteousness divine,",
          "Bold I approach th'eternal throne,",
          "And claim the crown, through Christ my own."
        ]
      }
    ],
    "chorus": [
      "Amazing love! How can it be",
      "That Thou, my God, shouldst die for me!"
    ],
    "timestamps": {
      "chorus": 36.6813
    }
  },
  {
    "hymnNumber": 199,
    "reference": "SDAH199",
    "title": "The Head That Once Was Crowned",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "The head that once was crowned with thorns",
          "Is crowned with glory now;",
          "A royal diadem adorns",
          "The mighty victor's brow."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "The highest place that heaven affords",
          "Is His, is His by right;",
          "The King of kings, and Lord of lords,",
          "And heaven's eternal light."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "The joy of all who dwell above,",
          "The joy of all below,",
          "To whom He manifests His love,",
          "And grants His name to know."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "To them the cross, with all its shame,",
          "With all its grace is given;",
          "Their name an everlasting name,",
          "Their joy the joy of heaven."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 200,
    "reference": "SDAH200",
    "title": "The Lord Is Coming",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "The Lord is coming, let this be",
          "The herald note of jubilee;",
          "And when we meet and when we part",
          "The salutation from the heart."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "The Lord is coming! sound it forth",
          "From east to west, from south to north;",
          "Speed on! speed on the tidings glad,",
          "That none who love Him may be sad."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "The Lord is coming, swift and sure",
          "And all His judgments shall endure,",
          "And none can hope to escape",
          "His wrath, Who walk not in the narrow path."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "This earth, with her ten thousand wrongs",
          "Will soon be tuned to nobler songs;",
          "Our praise shall then, in realms of light,",
          "With all His universe unite."
        ]
      }
    ],
    "chorus": [
      "The Lord is coming, let this be",
      "The herald note of jubilee,",
      "The herald note of jubilee."
    ],
    "timestamps": {
      "chorus": 17.6974
    }
  },
  {
    "hymnNumber": 201,
    "reference": "SDAH201",
    "title": "Christ Is Coming",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Christ is coming! let creation",
          "Bid her groans and travail cease;",
          "Let the glorious proclamation",
          "Hope restore and faith increase;",
          "Christ is coming!",
          "Christ is coming!",
          "Come, Thou blessed Prince of Peace!",
          "Come, Thou blessed Prince of Peace!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Earth can now but tell the story",
          "Of Thy bitter cross and pain;",
          "She shall yet behold Thy glory",
          "When Thou comest back to reign;",
          "Christ is coming!",
          "Christ is coming!",
          "Let each heart repeat the strain.",
          "Let each heart repeat the strain."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "With that \"blessed hope\" before us,",
          "Let no harp remain unstrung;",
          "Let the mighty advent chorus",
          "Onward roll from tongue to tongue:",
          "Christ is coming!",
          "Christ is coming!",
          "Come, Lord Jesus, quickly come!",
          "Come, Lord Jesus, quickly come!"
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 202,
    "reference": "SDAH202",
    "title": "Hail Him the King of Glory",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Tell it to every kindred and nation,",
          "Tell it far and near;",
          "Earth's darkest night will fade with the dawning,",
          "Jesus will soon appear."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Nations again in strife and commotion,",
          "Warnings by the way;",
          "Signs in the heavens, unerring omens,",
          "Herald the glorious day."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Children of God look up with rejoicing;",
          "Shout and sing His praise;",
          "Blessed are they who, waiting and watching,",
          "Look for the dawning rays."
        ]
      }
    ],
    "chorus": [
      "Hail Him the King of glory,",
      "Once the Lamb for sinners slain;",
      "Tell, tell the wondrous story,",
      "\"Jesus comes to reign.\""
    ],
    "timestamps": {
      "chorus": 19.0159
    }
  },
  {
    "hymnNumber": 203,
    "reference": "SDAH203",
    "title": "This Is the Threefold Truth",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "This is the threefold truth",
          "On which our faith depends;",
          "And with this joyful cry",
          "Worship begins and ends;."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "By this we are upheldWhen doubt and grief assail",
          "Our Christian fortitude",
          "And only grace avails"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "This is the threefold truth",
          "Which, if we hold it fast,",
          "Changes the world and us",
          "And brings us home at last."
        ]
      }
    ],
    "chorus": [
      "Christ had died!Christ has risen!",
      "Christ will come again!"
    ],
    "timestamps": {
      "chorus": 18.4584
    }
  },
  {
    "hymnNumber": 204,
    "reference": "SDAH204",
    "title": "Come, Thou Long Expected Jesus",
    "hasMidi": true,
    "numberOfVerses": 2,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Come, Thou long-expected Jesus!",
          "Born to set Thy people free,",
          "From our fears and sins release us,",
          "Let us find our rest in Thee.",
          "Israel's strength and consolation,",
          "Hope of all the earth Thou art;",
          "Dear Desire of every nation,",
          "Joy of every longing heart."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Born Thy people to deliver,",
          "Born a child, and yet a King,",
          "Born to reign in us forever,",
          "Now Thy gracious kingdom bring,",
          "By Thy own eternal Spirit,",
          "Rule in all our hearts alone;",
          "By Thy all-sufficient merit,",
          "Raise us to Thy glorious throne."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 205,
    "reference": "SDAH205",
    "title": "Gleams of the Golden Morning",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "The golden morning is fast approaching;",
          "Jesus soon will come",
          "To take His faithful and happy children",
          "To their promised home."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "The gospel summons will soon be carried",
          "To the nations round;",
          "The Bridegroom then will cease to tarry",
          "And the trumpet sound."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Attended by all the shining angels,",
          "Down the flaming sky",
          "The Judge will come, and will take His people",
          "Where they will not die."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "There those loved ones who have long been parted,",
          "Will all meet that day;",
          "The tears of those who are broken-hearted",
          "Will be wiped away."
        ]
      }
    ],
    "chorus": [
      "O, we see the gleams of the golden morning",
      "Piercing through this night of gloom!",
      "O, we see the gleams of the golden morning",
      "That will burst the tomb."
    ],
    "timestamps": {
      "chorus": 19.8288
    }
  },
  {
    "hymnNumber": 206,
    "reference": "SDAH206",
    "title": "Face to Face",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Face to face with Christ my Savior,",
          "Face to face, what will it be,",
          "When with rapture I behold Him,",
          "Jesus Christ, who died for me?"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Only faintly now I see Him,",
          "With the darkening veil between",
          "But a blessed day is coming,",
          "When His glory shall be seen."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "What rejoicing in His presence,",
          "When are banished grief and pain;",
          "When the crooked ways are straightened,",
          "And the dark things shall be plain!"
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Face to face! Oh, blissful moment!",
          "Face to face to see and know;",
          "Face to face with my Redeemer,",
          "Jesus Christ, who loves me so."
        ]
      }
    ],
    "chorus": [
      "Face to face shall I behold Him,",
      "Far beyond the starry sky;",
      "Face to face in all His glory",
      "I shall see Him by and by!"
    ],
    "timestamps": {
      "chorus": 22.6322
    }
  },
  {
    "hymnNumber": 207,
    "reference": "SDAH207",
    "title": "It May Be at Morn",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "It may be at morn, when the day is awaking,",
          "When sunlight through darkness and shadow is breaking,",
          "That Jesus will come in the fullness of glory",
          "To receive from the world His own."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "It may be at midday, it may be at twilight,",
          "It may be, perchance, that the blackness of midnight",
          "Will burst into light in the blaze of His glory,",
          "When Jesus receives His own."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "O joy! O delight! should we go without dying,",
          "No sickness, no sadness, no dread, and no crying,",
          "Caught up through the clouds with our Lord into glory,",
          "When Jesus receives His own."
        ]
      }
    ],
    "chorus": [
      "O Lord Jesus, how long, how long",
      "Ere we shout the glad song?",
      "Christ returneth,",
      "Hallelujah! hallelujah! Amen,",
      "Hallelujah! Amen."
    ],
    "timestamps": {
      "chorus": 28.06
    }
  },
  {
    "hymnNumber": 208,
    "reference": "SDAH208",
    "title": "There'll Be No Dark Valley",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "There'll be no dark valley when Jesus comes,",
          "There'll be no dark valley when Jesus comes;",
          "There'll be no dark valley when Jesus comes",
          "To gather His loved ones home."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "There'll be no more sorrow when Jesus comes,",
          "There'll be no more sorrow when Jesus comes;",
          "But a glorious morrow when Jesus comes",
          "To gather His loved ones home."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "There'll be songs of greeting when Jesus comes,",
          "There'll be songs of greeting when Jesus comes;",
          "And a joyful meeting when Jesus comes",
          "To gather His loved ones home."
        ]
      }
    ],
    "chorus": [
      "To gather His loved ones home,",
      "To gather His loved ones home;",
      "There'll be no dark valley when Jesus comes",
      "To gather His loved ones home."
    ],
    "timestamps": {
      "chorus": 20.915
    }
  },
  {
    "hymnNumber": 209,
    "reference": "SDAH209",
    "title": "That Glorious Day Is Coming",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "That glorious day is coming,",
          "The hour is hastening on;",
          "Its radiant light is nearing,",
          "Far brighter than the sun;",
          "In yonder clouds of heaven,",
          "The Savior will appear,",
          "And gather all His chosen,",
          "To meet Him in the air."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "The saints, then all victorious",
          "Will go to meet their Lord;",
          "An earth both bright and glorious,",
          "Will then be their reward;",
          "And God Himself there reigning,",
          "Will wipe all tears away;",
          "Nor clouds nor night remaining,",
          "But one eternal day."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "O Christian, keep from sleeping,",
          "And let your love abound;",
          "Be watchful, prayerful, faithful,",
          "The trumpet soon will sound!",
          "O sinner, hear the warning!",
          "To Jesus quickly!",
          "Then you, in that blest morning,",
          "May meet Him in the sky!"
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 210,
    "reference": "SDAH210",
    "title": "Wake, Awake, for Night Is Flying",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Wake, awake, for night is flying,",
          "The watchmen on the heights are crying,",
          "Awake, Jerusalem, arise!",
          "Midnight's solemn hour is tolling,",
          "His chariot wheels are nearer rolling,",
          "He comes; prepare, ye virgins wise.",
          "Rise up, with willing feet",
          "Go forth, the Bridegroom meet;",
          "Alleluia!",
          "Bear through the night your well-trimmed light,",
          "Speed forth to join the marriage rite."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Zion hears the watchmen singing,",
          "Her heart with deep delight is springing,",
          "She wakes, she rises from her gloom;",
          "Forth her Bridegroom comes, all-glorious,",
          "In grace arrayed, by truth victorious;",
          "Her Star is risen, her Light is come!",
          "All hail, incarnate Lord,",
          "Our crown, and our reward!",
          "Alleluia!",
          "We haste along, in pomp of song,",
          "And gladsome join the marriage throng."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Lamb of God, the heavens adore Thee,",
          "And men and angels sing before Thee,",
          "With harp and cymbal's clearest tone.",
          "By the pearly gates in wonder",
          "We stand, and swell the voice of thunder,",
          "That echoes round Thy dazzling throne.",
          "No vision ever brought,",
          "No ear hath ever caught,",
          "Such bliss and joy;",
          "We raise the song, we swell the throng,",
          "To praise Thee ages all along."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 211,
    "reference": "SDAH211",
    "title": "Lo! He Comes",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Lo! He comes, with clouds descending,",
          "Once for favored sinners slain;",
          "Countless angels, Him attending,",
          "Swell the triumph of His train:",
          "Hallelujah!",
          "Hallelujah!",
          "Jesus comes, and comes to reign."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Every eye shall now behold Him",
          "Robed in dreadful majesty!",
          "Those who set at nought and sold Him,",
          "Pierced, and nailed Him to the tree,",
          "Deeply wailing,",
          "Deeply wailing,",
          "Shall the true Messiah see!"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "When the solemn trump has sounded,",
          "Heaven and earth shall flee away;",
          "All who hate Him, must, confounded,",
          "Hear the summons of that day",
          "\"Come to judgment!",
          "Come to judgment!",
          "Come to judgment! Come away!\""
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Yea, amen! let all adore Thee,",
          "High on Thy eternal throne!",
          "Savior, take the power and glory,",
          "Make Thy righteous sentence known;",
          "O come quickly,",
          "O come quickly,",
          "Claim the kingdom for Thine own!"
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 212,
    "reference": "SDAH212",
    "title": "'Tis Almost Time for the Lord to Come",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "'Tis almost time for the Lord to come,",
          "I hear the people say;",
          "The stars of heaven are growing dim,",
          "It must be the breaking of the day."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "The signs foretold in the sun and moon,",
          "In earth and sea and sky,",
          "Aloud proclaim to all mankind,",
          "The coming of the Master draweth nigh."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "It must be time for the waiting church",
          "To cast her pride away,",
          "With girded loins and burning lamps,",
          "To look for the breaking of the day."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Go quickly out in the streets and lanes",
          "And in the broad highway,",
          "And call the maimed, the halt, and blind,",
          "To be ready for the breaking of the day."
        ]
      }
    ],
    "chorus": [
      "O it must be the breaking of the day!",
      "O it must be the breaking of the day!",
      "The night is almost gone,",
      "The day is coming on;",
      "O it must be the breaking of the day!"
    ],
    "timestamps": {
      "chorus": 20.4364
    }
  },
  {
    "hymnNumber": 213,
    "reference": "SDAH213",
    "title": "Jesus Is Coming Again",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Lift up the trumpet, and loud let it ring:",
          "Jesus is coming again!",
          "Cheer up, ye pilgrims, be joyful and sing;",
          "Jesus is coming again!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Echo it, hilltops; proclaim it, ye plains:",
          "Jesus is coming again!",
          "Coming in glory, the Lamb that was slain;",
          "Jesus is coming again!"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Heavings of earth, tell the vast, wondering throng:",
          "Jesus is coming again!",
          "Tempests and whirlwinds, the anthem prolong;",
          "Jesus is coming again!"
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Nations are angry by this we do know",
          "Jesus is coming again!",
          "Knowledge increases; men run to and fro;",
          "Jesus is coming again!"
        ]
      }
    ],
    "chorus": [
      "Coming again, coming again,",
      "Jesus is coming again!"
    ],
    "timestamps": {
      "chorus": 21.4357
    }
  },
  {
    "hymnNumber": 214,
    "reference": "SDAH214",
    "title": "We Have This Hope",
    "hasMidi": true,
    "numberOfVerses": 2,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "We have this hope that burns within our hearts,",
          "Hope in the coming of the Lord.",
          "We have this faith that Christ alone imparts,",
          "Faith in the promise of His Word.",
          "We believe the time is here,",
          "When the nations far and near",
          "Shall awake, and shout, and sing",
          "Hallelujah! Christ is King!",
          "We have this hope that burns within our hearts,",
          "Hope in the coming of the Lord."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "We are united in Jesus Christ our Lord.",
          "We are united in His love.",
          "Love for the waiting people of the world.",
          "People who need our Savior's love.",
          "Soon the heavn'ns will open wide,",
          "Christ will come to claim His bride.",
          "All the universe will sing",
          "Hallelujah! Christ is King!",
          "We have this hope, this faith, and God's great love,",
          "We are united in Christ."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 215,
    "reference": "SDAH215",
    "title": "The King Shall Come",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "The King shall come when morning dawns",
          "And light triumphant breaks,",
          "When beauty gilds the eastern hills",
          "And life to joy awakes."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Not as of old a little child,",
          "To bear and fight and die,",
          "But crowned with glory like the sun",
          "That lights the morning sky."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "O, brighter than the rising morn",
          "When Christ, victorious, rose",
          "And left the lonesome place of death,",
          "Despite the rage of foes."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "O, brighter than that glorious morn",
          "Shall dawn upon our race",
          "The day when Christ in splendor comes,",
          "And we shall see His face."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "The King shall come when morning dawns",
          "And light and beauty brings.",
          "Hail, Christ the Lord! Your people pray:",
          "Come quickly, King of kings."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 216,
    "reference": "SDAH216",
    "title": "When the Roll Is Called Up Yonder",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "When the trumpet of the Lord shall sound, and time shall be no more,",
          "And the morning breaks, eternal, bright and fair;",
          "When the saved of earth shall gather over on the other shore,",
          "And the roll is called up yonder, I'll be there."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "On that bright and cloudless morning, when the dead in Christ shall rise,",
          "And the glory of His resurrection share;",
          "When His chosen ones shall gather to their home beyond the skies,",
          "And the roll is called up yonder, I'll be there."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Let us labor for the Master from the dawn till setting sun,",
          "Let us talk of all His wondrous love and care,",
          "Then, when all of life is over, and our work on earth is done,",
          "And the roll is called up yonder, I'll be there."
        ]
      }
    ],
    "chorus": [
      "When the roll is called up yonder,",
      "When the roll is called up yonder,",
      "When the roll is called up yonder,",
      "When the roll is called up yonder, I'll be there."
    ],
    "timestamps": {
      "chorus": 20.8695
    }
  },
  {
    "hymnNumber": 217,
    "reference": "SDAH217",
    "title": "The Church Has Waited Long",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "The church has waited long",
          "Her absent Lord to see;",
          "And still in loneliness she waits,",
          "A friendless stranger she."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "How long, O Lord our God,",
          "Holy and true and good,",
          "Wilt Thou not judge Thy suffering church,",
          "Her sighs and tears and blood?"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "We long to hear Thy voice,",
          "To see Thee face to face,",
          "To share Thy crown and glory then,",
          "As now we share Thy grace."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Come, Lord, and wipe away",
          "The curse, the sin, the stain,",
          "And make this blighted world of ours",
          "Thine own fair world again."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 218,
    "reference": "SDAH218",
    "title": "When He Cometh",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "When He cometh, when He cometh",
          "To make up His jewels,",
          "All His jewels, precious jewels,",
          "His loved and His own."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "He will gather, He will gather",
          "The gems for His kingdom",
          "All the pure ones, all the bright ones,",
          "His loved and His own."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Little children, little children",
          "Who love their Redeemer,",
          "Are the jewels, precious jewels,",
          "His loved and His own."
        ]
      }
    ],
    "chorus": [
      "Like the stars of the morning,",
      "His bright crown adorning,",
      "They shall shine in their beauty,",
      "Bright gems for His crown."
    ],
    "timestamps": {
      "chorus": 14.6431
    }
  },
  {
    "hymnNumber": 219,
    "reference": "SDAH219",
    "title": "When Jesus Comes in Glory",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "When Jesus comes in glory,",
          "As Lord and King of kings,",
          "O what a wondrous story",
          "The blessed Bible brings:",
          "His face will shine like sunlight,",
          "His head be white as snow,",
          "His eyes like flaming firelight,",
          "His feet like brass aglow."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "His voice like rushing waters",
          "Will reach with mighty sound",
          "Into the deepest quarters",
          "Of all creation round;",
          "And at this wondrous greeting",
          "The dead in Christ shall rise,",
          "Their Lord and Savior meeting",
          "In glory in the skies."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "And we who are believing",
          "And His appearing love,",
          "Shall know we are receiving",
          "His glory from above;",
          "His resurrection power",
          "Will raise us to the place",
          "Where we that wondrous hour",
          "Shall see Him face to face."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "O hasten Thine appearing,",
          "Thou bright and Morning Star!",
          "Lord, may we soon be hearing",
          "The trumpet sound afar;",
          "Thy people all are yearning",
          "To be Thy raptured bride,",
          "And at Thine own returning",
          "Be caught up to Thy side."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 220,
    "reference": "SDAH220",
    "title": "When He Comes",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "When He comes, (when He comes)",
          "When He comes, (when He comes)",
          "We shall see the Lord in glory",
          "when He comes! (When He comes)",
          "As I read the gospel story,",
          "We shall see the Lord in glory,",
          "We shall see the Lord in glory",
          "when He comes! (when He comes)",
          "With the alleluias ringing to the sky, (to the sky)",
          "With the alleluias ringing to the sky, (to the sky)",
          "As I read the gospel story,",
          "We shall see the Lord in glory,",
          "With the alleluias ringing to the sky! (to the sky)"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "When He comes, (when He comes)",
          "When He comes, (when He comes)",
          "We shall hear the trumpet sounded,",
          "when He comes! (When He comes)",
          "We shall hear the trumpet sounded,",
          "See the Lord by saints surrounded,",
          "We shall hear the trumpet sounded,",
          "when He comes! (when He comes)",
          "With the alleluias ringing to the sky, (to the sky)",
          "With the alleluias ringing to the sky, (to the sky)",
          "We shall hear the trumpet sounded,",
          "See the Lord by saints surrounded,",
          "With the alleluias ringing to the sky! (to the sky)"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "When He comes, (when He comes)",
          "When He comes, (when He comes)",
          "We shall all rise up to meet Him",
          "when He comes! (When He comes)",
          "We shall all rise up to meet Him,",
          "When He calls His own to greet Him",
          "We shall all rise up to meet Him",
          "when He comes! (when He comes)",
          "With the alleluias ringing to the sky, (to the sky)",
          "With the alleluias ringing to the sky, (to the sky)",
          "We shall all rise up to meet Him,",
          "When He calls His own to greet Him,",
          "With the alleluias ringing to the sky! (to the sky)"
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 221,
    "reference": "SDAH221",
    "title": "Rejoice, the Lord Is King",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Rejoice, the Lord is King!",
          "Your Lord and King adore!",
          "Rejoice, give thanks, and sing,",
          "And triumph evermore:",
          "Lift up your heart, lift up your voice!",
          "Rejoice, again I say, rejoice!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Jesus, the Savior, reigns,",
          "The God of truth and love;",
          "When He had purged our stains,",
          "He took His seat above:",
          "Lift up your heart, lift up your voice!",
          "Rejoice, again I say, rejoice!"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "His kingdom cannot fail,",
          "He rules o'er earth and heaven;",
          "The keys of death and grave",
          "Are to our Jesus given:",
          "Lift up your heart, lift up your voice!",
          "Rejoice, again I say, rejoice!"
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Rejoice, in glorious hope!",
          "Our Lord the judge shall come,",
          "And take His servants up",
          "To their eternal home:",
          "Lift up your heart, lift up your voice!",
          "Rejoice, again I say, rejoice!"
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 222,
    "reference": "SDAH222",
    "title": "Hark Ten Thousand Harps and Voices",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Hark! ten thousand harps and voices",
          "Sound the note of praise above;",
          "Jesus reigns, and heaven rejoices,",
          "Jesus reigns, the God of love:",
          "See, He sits on yonder throne;",
          "Jesus rules the world alone.",
          "Alleluia! Alleluia!",
          "Alleluia! Amen."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "King of glory, reign forever,",
          "Thine an everlasting crown;",
          "Nothing from Thy love shall sever",
          "Those whom Thou hast made Thine own;",
          "Happy objects of Thy grace,",
          "Destined to behold Thy face.",
          "Alleluia! Alleluia!",
          "Alleluia! Amen."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Savior, hasten Thine appearing;",
          "Bring, O bring the glorious day,",
          "When, the awful summons hearing,",
          "Heaven and earth shall pass away:",
          "Then, with golden harps we'll sing,",
          "\"Glory, glory to our King!\"",
          "Alleluia! Alleluia!",
          "Alleluia! Amen."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 223,
    "reference": "SDAH223",
    "title": "Crown Him With Many Crowns",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Crown Him with many crowns,",
          "The Lamb upon His throne;",
          "Hark! how the heavenly anthem drowns",
          "All music but its own!",
          "Awake, my soul, and sing",
          "Of Him who died for thee;",
          "And hail Him as thy matchless King",
          "Through all eternity."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Crown Him the Lord of love!",
          "Behold His hands and side,",
          "Those wounds, yet visible above,",
          "In beauty glorified;",
          "No angel in the sky",
          "Can fully bear that sight,",
          "But downward bends his wondering eye",
          "At mysteries so great."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Crown Him the Lord of peace!",
          "Whose hand a scepter sways",
          "From pole to pole, that wars may cease,",
          "And all be prayer and praise;",
          "His reign shall know no end,",
          "And round His pierced feet",
          "Fair flowers of Paradise extend,",
          "Their fragrance ever sweet."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Crown Him the Lord of years,",
          "The Potentate of time,",
          "Creator of the rolling spheres,",
          "Ineffably sublime!",
          "All hail! Redeemer, hail!",
          "For Thou hast died for me;",
          "Thy praise shall never, never fail",
          "Throughout eternity."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 224,
    "reference": "SDAH224",
    "title": "Seek Ye First the Kingdom",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Seek ye first the kingdom, 'Tis your Father's will.",
          "So the voice of Jesus bids us follow still.",
          "Savior, we would hear Thee, Follow, find, and see;",
          "And in life's adventure Thy disciples be."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "As for hidden treasure, Or for matchless pearl,",
          "When at last discovered, some will sell their all:",
          "So, when breaks the vision of that kingdom fair,",
          "Ours shall be its riches and its beauty rare."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "As the silent leaven works its secret way,",
          "Or as grows the seed grain through the night and day;",
          "Lord, so be the increase, peaceable but sure,",
          "Of Thy word within us, And Thy kingdom's power."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "As the tender seedling grows up tall and strong,",
          "And the birds of heaven to its branches throng;",
          "So shall all God's children, from the east and west,",
          "Gather to His kingdom, In its shadow rest."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "Humblest shall be greatest, poor in spirit reign;",
          "Home shall come the childlike, born through Thee again",
          "Eager hearts arrive there on the pilgrim's road,",
          "Hail! the kingdom glorious of the living God!"
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 225,
    "reference": "SDAH225",
    "title": "God Is Working His Purpose Out",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "God is working His purpose out",
          "As year suceeds to year;",
          "God is working His purpose out,",
          "And the time is drawing near;",
          "Nearer and nearer draws the time,",
          "The time that shall surely be",
          "When the earth shall be filled with the glory of God",
          "As the waters cover the sea."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "From utmost east to utmost west,",
          "Where'er man's foot hath trod,",
          "By the mouth of many messengers",
          "Goes forth the voice of God;",
          "Give ear to me, ye confinents,",
          "Ye isles, give ear to me,",
          "That the earth shall be filled with the glory of God",
          "As the waters cover the sea."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "March we forth in the strength of God",
          "With the banner of Christ unfurled,",
          "That the light of the glorious gospel of truth",
          "May shine thru-out the world:",
          "Fight we the fight with sorrow and sin",
          "To set their captives free,",
          "That the earth shall be filled with the glory of God",
          "As the waters cover the sea."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "All we can do is nothing worth",
          "Unless God blesses the deed;",
          "Vainly we hope for the harvest tide",
          "Till God gives life to the seed;",
          "Yet nearer and nearer draws the time,",
          "The time that shall surely be,",
          "When the earth shall be filled with the glory of God",
          "As the waters cover the sea."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 226,
    "reference": "SDAH226",
    "title": "Lift Up Your Heads",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Lift up your heads, ye mighty gates!",
          "Behold the King of glory waits;",
          "The King of kings is drawing near,",
          "The Savior of the world is here."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "The Lord is just, a helper tried;",
          "Mercy is ever at His side;",
          "His kingly crown is holiness,",
          "His scepter, pity in distress."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "O blest the land, the city blest,",
          "Where Christ the Ruler is confessed!",
          "O happy hearts and happy homes",
          "To whom this King in triumph comes!"
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Fling wide the portals of your heart;",
          "Make it a temple, set apart",
          "From earthly use for heaven's employ,",
          "Adorned with prayer, and love, and joy."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "Redeemer, come; I open wide",
          "My heart to Thee; here, Lord, abide.",
          "Let me Thy inner presence feel,",
          "Thy grace and love in me reveal."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 227,
    "reference": "SDAH227",
    "title": "Jesus Shall Reign",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Jesus shall reign where e'r the sun",
          "Does its successive journeys run;",
          "His kingdom stretch from shore to shore,",
          "Till moons shall wax and wane no more."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "People and realms of every tongue",
          "Dwell on His love with sweetest song;",
          "And infant voices shall proclaim",
          "Their earthly blessings on His name."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Blessings abound where e'r He reigns:",
          "The pris'ners leap to lose their chains,",
          "The weary find eternal rest,",
          "And all who suffer want are blest."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Let every creature rise and bring",
          "Honors peculiar to our King;",
          "Angels descend with songs again,",
          "And earth repeat the loud amen."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 228,
    "reference": "SDAH228",
    "title": "A Hymn of Glory Let Us Sing",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "A hymn of glory let us sing;",
          "New hymns thro'out the world shall ring",
          "Alleluia! Alleluia!",
          "Christ, by a road before untrod,",
          "Ascends unto the throne of God.",
          "Alleluia! Alleluia!",
          "Alleluia, alleluia, alleluia!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "O Lord, our homeward pathway bend,",
          "That our unwearied hearts ascend.",
          "Alleluia! Alleluia!",
          "Where, seated on Your Father's throne,",
          "You reign as King of kings alone.",
          "Alleluia! Alleluia!",
          "Alleluia, alleluia, alleluia!"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Give us Your joy on earth, O Lord,",
          "In heav'n to be our great reward.",
          "Alleluia! Alleluia!",
          "When throned with You forever, we",
          "Shall praise Your name eternally.",
          "Alleluia! Alleluia!",
          "Alleluia, alleluia, alleluia!"
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "O risen Christ, ascended Lord,",
          "All praise to You let earth accord:",
          "Alleluia! Alleluia!",
          "You are, while endless ages run,",
          "With Father and with Spirit one.",
          "Alleluia! Alleluia!",
          "Alleluia, alleluia, alleluia!"
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 229,
    "reference": "SDAH229",
    "title": "All Hail the Power of Jesus' Name",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "All hail the power of Jesus' name!",
          "Let angels prostrate fall;",
          "Bring forth the royal diadem,",
          "And crown Him Lord of all!",
          "Bring forth the royal diadem,",
          "And crown Him Lord of all."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Ye seed of Israel's chosen race,",
          "Ye ransomed of the fall,",
          "Hail Him who saves you by His grace,",
          "And crown Him Lord of all!",
          "Hail Him who saves you by His grace,",
          "And crown Him Lord of all."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Let every kindred, every tribe,",
          "On this terrestrial ball,",
          "To Him all majesty ascribe,",
          "And crown Him Lord of all!",
          "To Him all majesty ascribe,",
          "And crown Him Lord of all."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Oh, that with yonder sacred throng",
          "We at His feet may fall,",
          "Join in the everlasting song,",
          "And crown Him Lord of all!",
          "Join in the everlasting song,",
          "And crown Him Lord of all."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 230,
    "reference": "SDAH230",
    "title": "All Glory, Laud, and Honor",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "All glory, laud, and honor",
          "To Thee, Redeemer, King,",
          "To whom the lips of children",
          "Made sweet hosannas ring.",
          "Thou art the King of Israel,",
          "Thou, David's royal Son,",
          "Who in the Lord's name comest,",
          "The King and Blessed One."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "The company of angels",
          "Are praising Thee on high,",
          "And mortal men and all things",
          "Created make reply.",
          "The people of the Hebrews",
          "With palms before Thee went;",
          "Our praise and prayer and anthems",
          "Before Thee we present."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "To Thee, before Thy passion,",
          "They sang their hymns of praise;",
          "To Thee, now high exalted,",
          "Our melody we raise.",
          "Thou didst accept their praises;",
          "Accept the praise we bring,",
          "Who in all good delightest,",
          "Thou good and gracious King."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 231,
    "reference": "SDAH231",
    "title": "Bless Be the King",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Bless be the King whose coming",
          "Is in the name of God!",
          "For Him let doors be opened,",
          "No hearts against Him barred!",
          "Not robed in royal splendor,",
          "In power and pomp comes He;",
          "But clad as are the poorest,",
          "Such His humility."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Bless be the King whose coming",
          "Is in the name of God!",
          "By those who truly listen",
          "His voice is truly heard;",
          "Pity the proud and haughty",
          "Who have not learned to heed",
          "The Christ who is the promise,",
          "Who has atonement made."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Bless be the King whose coming",
          "Is in the name of God!",
          "He only to the humble",
          "Reveals the face of God",
          "All power is His, all glory!",
          "All things are in His hand,",
          "All ages and all peoples,",
          "Till time itself shall end."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Bless be the King whose coming",
          "Is in the name of God!",
          "He offers to the burdened",
          "The rest and grace they need.",
          "Gentle is He and humbled!",
          "And light His yoke shall be,",
          "For He would have us bear it",
          "So He can make us free!"
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 232,
    "reference": "SDAH232",
    "title": "At the Name of Jesus",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "At the name of Jesus",
          "Every knee shall bow,",
          "Every tongue confess Him",
          "King of glory now;",
          "'Tis the Father's pleasure",
          "We should call Him Lord,",
          "Who from the beginning",
          "Was the mighty Word."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "At His voice creation",
          "Sprang at once to sight,",
          "All the angel faces,",
          "All the hosts of light,",
          "Thrones and dominations",
          "Stars upon their way,",
          "All the heavenly orders",
          "In their great array."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Humbled for a season,",
          "To receive a name",
          "From the lips of sinners,",
          "Unto whom He came;",
          "He is God the Savior,",
          "He is Christ the Lord,",
          "Ever to be worshiped,",
          "Trusted and adored."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "In your hearts enthrone Him:",
          "There let Him subdue",
          "All that is not holy,",
          "All that is not true;",
          "Crown Him as your captain",
          "In temptation's hour,",
          "Let His will enfold you",
          "In its light and power."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "Surely, this Lord Jesus",
          "Shall return again,",
          "With His Father’s glory,",
          "With His angel train;",
          "For all wreaths of empire",
          "Meet upon His brow,",
          "And our hearts confess Him",
          "King of glory now."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 233,
    "reference": "SDAH233",
    "title": "Christ, Whose Glory Fills the Skies",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Christ, whose glory fills the skies,",
          "Christ, the true, the only light,",
          "Sun of Righteousness, a rise,",
          "Triumph o'er the shades of night;",
          "Day-spring from on high, be near;",
          "Day-star, in my heart appear."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Dark and cheerless is the morn",
          "Unaccompanied by Thee;",
          "Joyless is the day's return",
          "Till Thy mercy's beams I see;",
          "Till they inward light impart,",
          "Cheer my eyes and warm my heart."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Visit, then, this soul of mine;",
          "Pierce the gloom of sin and grief;",
          "Fill me, Radiancy divine;",
          "Scatter all my unbelief;",
          "More and more Thyself display,",
          "Shining to the perfect day."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 234,
    "reference": "SDAH234",
    "title": "Christ Is the Worlds Light",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Christ is the world's Light,",
          "He and none other;",
          "Born in our darkness, He became our brother.",
          "If we have seen Him, we have seen the Father:",
          "Glory to God on high!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Christ is the world's Peace,",
          "He and none other;",
          "No one can serve Him and despise another.",
          "Who else unites us one in God the Father?",
          "Glory to God on high!"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Christ is the world's Life,",
          "He and none other;",
          "Sold once for silver, murdered here, our brother,",
          "He who redeems us reigns with God the Father.",
          "Glory to God on high!"
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Give God the glory,",
          "God and none other;",
          "Give God the glory, Spirit, Son, and Father;",
          "Give God the glory, God in Man my brother;",
          "Glory to God on high!"
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 235,
    "reference": "SDAH235",
    "title": "Christ Is Made the Sure Foundation",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Christ is made the sure foundation,",
          "Christ, our head and cornerstone,",
          "Chosen of the Lord and precious,",
          "Binding all the Church in one;",
          "Holy Zion's help forever",
          "And our confidence alone."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "To this temple where we call You,",
          "Come, O Lord of hosts, and stay;",
          "Come, with all Your loving kindness,",
          "Hear Your people as they pray;",
          "And Your fullest benediction",
          "Shed within these walls today."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Grant, we pray to all Your faithful",
          "All the gifts they ask to gain;",
          "What they gain from You forever",
          "With the blessed to retain;",
          "And hereafter in Your glory",
          "Evermore with You to reign."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Praise and honor to the Father,",
          "Praise and honor to the Son,",
          "Praise and honor to the Spirit,",
          "Ever three and ever one:",
          "One in might and one in glory",
          "While unending ages run!"
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 236,
    "reference": "SDAH236",
    "title": "I Love Thee",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "I love Thee, I love Thee, I love Thee, my Lord;",
          "I love Thee, my Savior, I love Thee, my God.",
          "I love Thee, I love Thee, and that Thou dost know;",
          "But how much I love Thee my actions will show."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "I'm happy, I'm happy, O, wondrous account!",
          "My joys are immortal, I stand on the mount!",
          "I gaze on my treasure and long to be there,",
          "With Jesus and angels, and kindred so dear."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "O Jesus, my Savior, with Thee I am blest,",
          "My life and salvation, my joy and my rest:",
          "Thy name be my theme, and Thy love be my song;",
          "Thy grace shall inspire both my heart and my tongue."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "O, who's like my Savior? He's Salem's bright King;",
          "He smiles, and He loves me, and helps me to sing.",
          "I'll praise Him, I'll praise Him, with notes loud and clear,",
          "While rivers of pleasure my spirit do cheer."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 237,
    "reference": "SDAH237",
    "title": "In the Cross of Christ I Glory",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "In the cross of Christ I glory,",
          "Towering o'er the wrecks of time;",
          "All the light of sacred story",
          "Gathers round its head sublime."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "When the woes of life o'ertake me,",
          "Hopes deceive, and fears annoy,",
          "Never shall the cross forsake me;",
          "Lo! it glows with peace and joy."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "When the sun of bliss is beaming",
          "Light and love upon my way,",
          "From the cross the radiance streaming",
          "Adds new luster to the day."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Bane and blessing, pain and pleasure,",
          "By the cross are sanctified;",
          "Peace is there that knows no measure,",
          "Joys that through all time abide."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 238,
    "reference": "SDAH238",
    "title": "How Sweet the Name!",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "How sweet the name of Jesus sounds",
          "In a believer's ear!",
          "It soothes his sorrows, heals his wounds,",
          "And drives away his fear."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "It makes the wounded spirit whole,",
          "And calms the troubled breast;",
          "Tis manna to the hungry soul,",
          "And to the weary, rest."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Dear name, the rock on which I build,",
          "My shield and hiding place,",
          "My never-failing treasury, filled",
          "With boundless stores of grace."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Jesus! my Shepherd, Guardian, Friend,",
          "My Prophet, Priest, and King.",
          "My Lord, my life, my way, my end!",
          "Accept the praise I bring."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "Weak is the effort of my heart,",
          "And cold my warmest thought;",
          "But when I see Thee as Thou art,",
          "I'll praise Thee as I ought."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 239,
    "reference": "SDAH239",
    "title": "Jesus, Priceless Treasure",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Jesus, priceless treasure,",
          "Source of purest pleasure,",
          "Truest Friend to me:",
          "Ah! how long I've panted,",
          "And my heart has fainted,",
          "Thirsting, Lord, for Thee.",
          "Thine I am, O spotless Lamb,",
          "I will suffer naught to hide Thee,",
          "Nought I ask beside Thee."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "In Thine arm I rest me;",
          "Foes who would molest me",
          "Cannot reach me here;",
          "Though the earth be shaking,",
          "Every heart be quaking,",
          "Jesus calms my fear;",
          "Sin and hell in conflict fell",
          "With their bitter storms assail me:",
          "Jesus will not fail me."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Hence all fears and sadness!",
          "For the Lord of gladness,",
          "Jesus enters in;",
          "Those who love the Father,",
          "Tho' the storms may gather,",
          "Still have peace within;",
          "Yea, whate'er I here must bear,",
          "Still in Thee lies purest pleasure,",
          "Jesus, priceless treasure!"
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 240,
    "reference": "SDAH240",
    "title": "Fairest Lord Jesus",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Fairest Lord Jesus,",
          "Ruler of all nature,",
          "O Thou of God and man the Son!",
          "Thee will I cherish,",
          "Thee will I honor,",
          "Thou art my glory, joy, and crown."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Fair are the meadows,",
          "Fairer still the woodlands,",
          "Robed in the blooming garb of spring;",
          "Jesus is fairer,",
          "Jesus is purer,",
          "Who makes the woeful heart to sing."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Fair is the sunshine,",
          "Fairer still the moonlight,",
          "And all the twinkling, starry host;",
          "Jesus shines brighter,",
          "Jesus shines purer",
          "Than all the angels heaven can boast."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Beautiful Savior,",
          "Lord of the nations,",
          "Son of God and Son of Man!",
          "Glory and honor,",
          "Praise, adoration,",
          "Now and forevermore be Thine!"
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 241,
    "reference": "SDAH241",
    "title": "Jesus, the Very Thought of Thee",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Jesus, the very thought of Thee,",
          "With sweetness fills my breast;",
          "But sweeter far Thy face to see,",
          "And in Thy presence rest."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "No voice can sing, no heart can frame,",
          "Nor can the memory find",
          "A sweeter sound than Jesus' name,",
          "The Savior of mankind."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "O hope of every contrite heart!",
          "O joy of all the meek,",
          "To those who fall, how kind Thou art!",
          "How good to those who seek!"
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "But what to those who find? Ah! this",
          "Nor tongue nor pen can show:",
          "The love of Jesus; what it is,",
          "None but His loved ones know."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "Jesus, our only joy be Thou,",
          "As Thou our prize wilt be;",
          "In Thee be all our glory now,",
          "And through eternity."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 242,
    "reference": "SDAH242",
    "title": "Jesus, Thou Joy of Loving Hearts",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Jesus, Thou joy of loving hearts!",
          "Thou fount of life! Thou light of men!",
          "From the best bliss that earth imparts,",
          "We turn unfilled to Thee again."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Thy truth unchanged has ever stood;",
          "Thou savest those that on Thee call;",
          "To them that seek Thee Thou art good,",
          "To them that find Thee, all in all."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "We taste Thee, O Thou living Bread,",
          "And long to feast upon Thee still;",
          "We drink of Thee, the Fountainhead,",
          "And thirst our souls from Thee to fill!"
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Our restless spirits yearn for Thee,",
          "Wheree'er our changeful lot is cast;",
          "Glad, when Thy gracious smile we see,",
          "Blest, when our faith can hold Thee fast."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "O Jesus, ever with us stay;",
          "Make all our moments calm and bright;",
          "Chase the dark night of sin a way,",
          "Shed o'er the world Thy holy light!"
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 243,
    "reference": "SDAH243",
    "title": "King of Glory, King of Peace",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "King of glory, King of peace,",
          "I will love Thee;",
          "And that love may never cease,",
          "I will move Thee.",
          "Thou hast granted my request,",
          "Thou hast heard me;",
          "Thou didst note my working breast,",
          "Thou hast spared me."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Wherefore with my utmost art",
          "I will sing Thee,",
          "And the cream of all my heart",
          "I will bring Thee.",
          "Though my sins against me cried,",
          "Thou didst clear me;",
          "And alone, when they replied,",
          "Thou didst hear me."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Seven whole days, not one in seven,",
          "I will praise Thee;",
          "In my heart, though not in heav'n,",
          "I can raise Thee.",
          "Small it is, in this poor sort",
          "To enroll Thee:",
          "Ev'n eternity's too short",
          "To extol Thee."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 244,
    "reference": "SDAH244",
    "title": "My Song Shall Be of Jesus",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "My song shall be of Jesus,",
          "His mercy crowns my days,",
          "He fills my cup with blessings,",
          "And tunes my heart to praise;",
          "My song shall be of Jesus,",
          "The precious Lamb of God,",
          "Who gave Himself my ransom,",
          "And bought me with His blood."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "My song shall be of Jesus,",
          "When sitting at His feet,",
          "I call to mind His goodness",
          "And know my joy's complete;",
          "My song shall be of Jesus,",
          "Whatever ills befall,",
          "I'll sing the grace that saves me,",
          "And triumphs over all."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "My song shall be of Jesus,",
          "While pressing on my way",
          "To where my home shines glorious",
          "In pure and perfect day.",
          "And when my soul shall enter",
          "The many mansions fair,",
          "A song of praise to Jesus",
          "I'll sing forever there."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 245,
    "reference": "SDAH245",
    "title": "More About Jesus",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "More about Jesus I would know,",
          "More of His grace to others show;",
          "More of His saving fullness see,",
          "More of His love who died for me."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "More about Jesus let me learn,",
          "More of His holy will discern;",
          "Spirit of God, my teacher be,",
          "Showing the things of Christ to me."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "More about Jesus; in His word,",
          "Holding communion with my Lord,",
          "Hearing His voice in every line,",
          "Making each faithful saying mine."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "More about Jesus; on His throne,",
          "Riches in glory all His own;",
          "More of His kingdom's sure increase;",
          "More of His coming, Prince of Peace."
        ]
      }
    ],
    "chorus": [
      "More, more about Jesus,",
      "More, more about Jesus;",
      "More of His saving fullness see,",
      "More of His love who died for me."
    ],
    "timestamps": {
      "chorus": 20.7564
    }
  },
  {
    "hymnNumber": 246,
    "reference": "SDAH246",
    "title": "Worthy, Worthy Is the Lamb",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Worthy, worthy is the Lamb,",
          "Worthy, worthy is the Lamb;",
          "Worthy, worthy is the Lamb",
          "That was slain."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Savior, let Thy kingdom come!",
          "Now the power of sin consume;",
          "Bring Thy blest millennium,",
          "Holy Lamb."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Thus may we each moment feel,",
          "Love Him, serve Him, praise Him still,",
          "Till we all on Zion's hill",
          "See the Lamb."
        ]
      }
    ],
    "chorus": [
      "Glory, hallelujah!",
      "Praise Him, hallelujah!",
      "Glory, hallelujah",
      "To the Lamb!"
    ],
    "timestamps": {
      "chorus": 18.06
    }
  },
  {
    "hymnNumber": 247,
    "reference": "SDAH247",
    "title": "Come My Way",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Come, my Way, my Truth, my Life:",
          "Such a Way, as gives us breath;",
          "Such a Truth, as ends all strife;",
          "Such a Life, as killeth death."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Come, my Light, my Feast, my Strength:",
          "Such a Light, as shows a feast;",
          "Such a Feast, as mends in length;",
          "Such a Strength, as makes His guest."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Come, my Joy, my Love, my Heart:",
          "Such a Joy, as none can move;",
          "Such a Love, as none can part;",
          "Such a Heart, as joys in love."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 248,
    "reference": "SDAH248",
    "title": "O, How I Love Jesus",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "There is a name I love to hear,",
          "I love to sing its worth;",
          "It sounds like music in my ear,",
          "The sweetest name on earth."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "It tells me of a Savior's love,",
          "Who died to set me free;",
          "It tells me of His precious blood,",
          "The sinner's perfect plea."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "It tells of One whose loving heart",
          "Can feel my deepest woe,",
          "Who in each sorrow bears a part",
          "That none can bear below."
        ]
      }
    ],
    "chorus": [
      "O, how I love Jesus,",
      "O, how I love Jesus,",
      "O, how I love Jesus",
      "Because He first loved me!"
    ],
    "timestamps": {
      "chorus": 15.9867
    }
  },
  {
    "hymnNumber": 249,
    "reference": "SDAH249",
    "title": "Praise Him! Praise Him!",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Praise Him! praise Him! Jesus, our blessed Redeemer!",
          "Sing, O earth; His wonderful love proclaim!",
          "Hail Him! hail Him! highest archangels in glory;",
          "Strength and honor give to His holy name!",
          "Like a shepherd, Jesus will guard His children,",
          "In His arms He carries them all day long;"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Praise Him! praise Him! Jesus, our blessed Redeemer!",
          "For our sins He suffered, and bled and died;",
          "He our Rock, our hope of eternal salvation,",
          "Hail Him! hail Him! Jesus, the crucified.",
          "Sound His praises! Jesus who bore our sorrows,",
          "Love unbounded, wonderful, deep and strong;"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Praise Him! praise Him! Jesus, our blessed Redeemer!",
          "Heavenly portals, loud with hosannas ring!",
          "Jesus, Savior, reigneth forever and ever;",
          "Crown Him! crown Him! Prophet, and Priest, and King!",
          "Christ is coming over the world victorious,",
          "Power and glory unto the Lord belong;"
        ]
      }
    ],
    "chorus": [
      "Praise Him! praise Him! tell of His excellent greatness;",
      "Praise Him! praise Him ever in joyful song!"
    ],
    "timestamps": {
      "chorus": 35.1852
    }
  },
  {
    "hymnNumber": 250,
    "reference": "SDAH250",
    "title": "O for a Thousand Tongues to Sing",
    "hasMidi": true,
    "numberOfVerses": 6,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "O for a thousand tongues to sing",
          "My great Redeemer's praise,",
          "The glories of my God and King,",
          "The triumphs of His grace!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "My gracious Master and my God,",
          "Assist me to proclaim",
          "To spread thro' all the earth abroad",
          "The honors of Thy name."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Jesus! the name that charms our fears,",
          "That bids our sorrows cease,",
          "'Tis music in the sinners' ears,",
          "Tis life, and health, and peace."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "He breaks the power of canceled sin,",
          "He sets the prisoner free;",
          "His blood can make the foulest clean;",
          "His blood availed for me."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "He speaks, and listening to His voice,",
          "New life the dead receive;",
          "The mournful, broken hearts rejoice;",
          "The humble poor, believe."
        ]
      },
      {
        "verseNumber": 6,
        "content": [
          "Hear Him, ye deaf; His praise, ye dumb,",
          "Your loosened tongues employ;",
          "Ye blind, behold your Savior come;",
          "And leap, ye lame, for joy."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 251,
    "reference": "SDAH251",
    "title": "He Lives",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "I serve a risen Savior, He's in the world today;",
          "I know that He is living, whatever men may say;",
          "I see His hand of mercy, I hear His voice of cheer",
          "And just the time I need Him He's always near."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "In all the world around me I see His loving care,",
          "And tho' my heart grows weary I never will despair;",
          "I know that He is leading thru all the stormy blast,",
          "The day of His appearing will come at last."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Rejoice, rejoice, O Christian, lift up your voice and sing,",
          "Eternal hallelujahs to Jesus Christ the King!",
          "The hope of all who seek Him, the help of all who find,",
          "None other is so loving, so good and kind."
        ]
      }
    ],
    "chorus": [
      "He lives, He lives, Christ Jesus lives today!",
      "He walks with me and talks with me",
      "along life's narrow way.",
      "He lives, He lives, salvation to impart!",
      "You ask me how I know He lives?",
      "He lives within my heart."
    ],
    "timestamps": {
      "chorus": 28.0833
    }
  },
  {
    "hymnNumber": 252,
    "reference": "SDAH252",
    "title": "Come, Let Us Sing",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Come, let us sing the song of songs;",
          "The angels first began the strain;",
          "The homage which to Christ belongs:",
          "\"Worthy the Lamb, for He was slain!\""
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Slain to redeem us by His blood,",
          "To cleanse from every sinful stain,",
          "And make us kings and priests to God:",
          "\"Worthy the Lamb, for He was slain!\""
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "To Him who suffered on the tree,",
          "Our souls, at His soul's price, to gain,",
          "Blessing, and praise, and glory be:",
          "\"Worthy the Lamb, for He was slain!\""
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "To Him, enthroned by filial right",
          "All power in heaven and earth proclaim,",
          "Honor, and majesty, and might:",
          "\"Worthy the Lamb, for He was slain!\""
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "Long as we live, and when we die,",
          "And while in heaven with Him we reign,",
          "This song our song of songs shall be:",
          "\"Worthy the Lamb, for He was slain!\""
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 253,
    "reference": "SDAH253",
    "title": "There's No Other Name Like Jesus",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "There's no other name like Jesus,",
          "'Tis the dearest name we know,",
          "'Tis the angel's joy in Heaven,",
          "'Tis the Christian's joy below."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "There's no other name like Jesus",
          "When the heart with grief is sad,",
          "There's no other name like Jesus",
          "When the heart is free and glad."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "'Tis the hope that I shall see Him",
          "When in glory He appears,",
          "'Tis the hope to hear His welcome",
          "That my fainting spirit cheers."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "If He wills that I should labor",
          "In His vineyard day by day,",
          "Then 'tis well if only Jesus",
          "Blesses all I do or say."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "If He wills that death's cold finger",
          "Touch my feeble, mortal clay,",
          "Then 'tis well if only Jesus",
          "Is my dying trust and stay."
        ]
      }
    ],
    "chorus": [
      "Sweet name, dear name,",
      "There's no other name like Jesus;",
      "Sweet name, dear name,",
      "There's no other name like Jesus."
    ],
    "timestamps": {
      "chorus": 18.4173
    }
  },
  {
    "hymnNumber": 254,
    "reference": "SDAH254",
    "title": "The Great Physician Now Is Near",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "The Great Physician now is near,",
          "The sympathizing Jesus;",
          "He speaks, the drooping heart to cheer,",
          "O hear the voice of Jesus!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "All glory to the dying Lamb!",
          "I now believe in Jesus;",
          "I love the blessed Savior's name,",
          "I love the name of Jesus."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "His name dispels my guilt and fear;",
          "No other name but Jesus;",
          "O how my soul delights to hear",
          "The precious name of Jesus!"
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "And when He comes to bring the crown",
          "The crown of life and glory",
          "Then by His side we will sit down,",
          "And tell redemption's story."
        ]
      }
    ],
    "chorus": [
      "Sweetest note in seraph song,",
      "Sweetest name on mortal tongue,",
      "Sweetest carol ever sung;",
      "Jesus, blessed Jesus!"
    ],
    "timestamps": {
      "chorus": 21.9589
    }
  },
  {
    "hymnNumber": 255,
    "reference": "SDAH255",
    "title": "I Cannot Tell Why",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "I cannot tell why He whom angels worship",
          "Should set His love upon the souls of men,",
          "Or why as Shepherd He should seek the wanderers,",
          "To bring them back, they know not how nor when.",
          "But this I know that He was born of Mary",
          "When Bethlehem's manger was His only home,",
          "And that He lived at Nazareth and labored;",
          "And so the Savior, Savior of the world, has come."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "I cannot tell how silently He suffered",
          "As with His peace He graced this place of tears,",
          "Nor how His heart upon the cross was broken,",
          "The crown of pain to three and thirty years.",
          "But this I know He heals the broken hearted",
          "And stays our sin and calms our lurking fear,",
          "And lifts the burden from the heavy laden;",
          "For still the Savior, Savior of the world, is here."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "I cannot tell how He will win the nations,",
          "How He will claim His earthly heritage,",
          "How satisfy the needs and aspirations",
          "Of east and west, of sinner and of sage.",
          "But this I know all flesh shall see His glory,",
          "And He shall reap the harvest He has sown,",
          "And some glad day His sun will shine in splendor",
          "When He the Savior, Savior of the world, is known."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "I cannot tell how all the lands shall worship,",
          "When at His biding every storm is stilled,",
          "Or who can say how great the jubilation",
          "When all our hearts with love for Him are filled.",
          "But this I know the skies shall sound His praises,",
          "Ten thousand thousand human voices sing,",
          "And earth to heaven, and heaven to earth will answer,",
          "At last the Savior, Savior of the world, is King!"
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 256,
    "reference": "SDAH256",
    "title": "Ye Servants of God",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Ye servants of God, your Master proclaim,",
          "And publish abroad His wonderful name;",
          "The name all victorious of Jesus extol;",
          "His kingdom is glorious, He rules over all."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "God ruleth on high, almighty to save;",
          "And still He is nigh His presence we have;",
          "The great congregation His triumph shall sing,",
          "Ascribing salvation to Jesus our King."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "\"Salvation to God, Who sits on the throne,\"",
          "Let all cry aloud, and honor the Son;",
          "The praises of Jesus the angels proclaim,",
          "Fall down on their faces, and worship the Lamb."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Then let us adore, and give Him His right,",
          "All glory and power, all wisdom and might,",
          "All honor and blessing, with angels above,",
          "And thanks never ceasing, for infinite love."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 257,
    "reference": "SDAH257",
    "title": "Come Down, O Love Divine",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Come down, O Love divine,",
          "Seek Thou this soul of mine,",
          "And visit it with Thine own ardor glowing;",
          "O Comforter, draw near,",
          "Within my heart appear,",
          "And kindle it, Thy holy flame bestowing."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "O let it freely burn,",
          "Till earthly passions turn",
          "To dust and ashes in its heat consuming;",
          "And let Thy glorious light",
          "Shine ever on my sight,",
          "And clothe me round, the while my path illuming."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Let holy charity",
          "Mine outward vesture be,",
          "And lowliness become my inner clothing;",
          "True lowliness of heart",
          "Which takes the humbler part,",
          "And o'er its own shortcomings weeps with loathing."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "And so the yearning strong,",
          "With which the soul will long,",
          "Shall far outpass the power of human telling;",
          "For none can guess its grace,",
          "Till he become the place",
          "Where in the Holy Spirit makes His dwelling."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 258,
    "reference": "SDAH258",
    "title": "Baptize Us Anew",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Baptize us anew",
          "With power from on high,",
          "With love, O refresh us!",
          "Dear Savior, draw nigh.",
          "We humbly beseech Thee, Lord Jesus, we pray,",
          "With love and the Spirit baptize us today."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Unworthy we cry,",
          "Unholy, unclean,",
          "O wash us and cleanse us",
          "From sin's guilty stain.",
          "We humbly beseech Thee, Lord Jesus, we pray,",
          "With love and the Spirit baptize us today."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "O heavenly Dove,",
          "Descend from on high!",
          "We plead Thy rich blessing;",
          "In mercy draw nigh.",
          "We humbly beseech Thee, Lord Jesus, we pray,",
          "With love and the Spirit baptize us today."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "O list the glad voice!",
          "From heaven it came:",
          "Thou art My beloved,",
          "Well pleased I am.",
          "We praise Thee, we bless Thee, dear Lamb that was slain,",
          "We laud and adore Thee, Amen and Amen."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 259,
    "reference": "SDAH259",
    "title": "Draw Us in the Spirits Tether",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Draw us in the Spirit's tether,",
          "For when humbly in Thy name,",
          "Two or three are met together,",
          "Thou art in the midst of them;",
          "Alleluia! Alleluia!",
          "Touch we now Thy garment's hem."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "As the brethren used to gather",
          "In the name of Christ to sup,",
          "Then with thanks to God the Father",
          "Break the bread and bless the cup,",
          "Alleluia! Alleluia!",
          "So knit Thou our friendship up."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "All our meals and all our living",
          "Make us sacraments of Thee,",
          "That by caring, helping, giving,",
          "We may true disciples be.",
          "Alleluia! Alleluia!",
          "We will serve Thee faithfully."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 260,
    "reference": "SDAH260",
    "title": "Hover O'er Me, Holy Spirit",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Hover o'er me, Holy Spirit,",
          "Bathe my trembling heart and brow;",
          "Fill me with Thy hallowed presence,",
          "Come, O come and fill me now."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Thou canst fill me, gracious Spirit,",
          "Though I cannot tell Thee how;",
          "But I need Thee, greatly need Thee;",
          "Come, O come and fill me now."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "I am weakness, full of weakness;",
          "At Thy sacred feet I bow;",
          "Blest, divine, eternal Spirit,",
          "Fill with love, and fill me now."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Cleanse and comfort, bless and save me;",
          "Bathe, O, bathe my heart and brow;",
          "Thou art comforting and saving,",
          "Thou art sweetly filling now."
        ]
      }
    ],
    "chorus": [
      "Fill me now, fill me now,",
      "Jesus, come and fill me now.",
      "Fill me with Thy hallowed presence,",
      "Come, O come and fill me now."
    ],
    "timestamps": {
      "chorus": 20.8856
    }
  },
  {
    "hymnNumber": 261,
    "reference": "SDAH261",
    "title": "The Spirit of the Lord Revealed",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "The Spirit of the Lord revealed",
          "His will to saints of old;",
          "Their heart and mind lips unsealed",
          "His glory to unfold.",
          "Amid the gloom of ancient night",
          "They hailed the dawning Word,",
          "And in the coming of the light",
          "Proclaimed the coming Lord."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "The prophets passed; at length there came",
          "To sojourn and abide,",
          "The Word incarnate, to whose name",
          "The prophets testified;",
          "And He, the twilight overpast,",
          "Himself, the Light of light,",
          "As man with man, revealed at last",
          "The Father to our sight."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Eternal Spirit, who dost speak",
          "To mind and conscience still,",
          "That we in this our day, may seek",
          "To do our Father's will,",
          "To us the word of life impart,",
          "Of Christ, the living way;",
          "Give us the quiet, humble heart",
          "To hear and to obey."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 262,
    "reference": "SDAH262",
    "title": "Sweet Sweet Spirit",
    "hasMidi": true,
    "numberOfVerses": 1,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "There's a sweet, sweet spirit in this place,",
          "And I know that it's the spirit of the Lord;",
          "There are sweet expressions on each face",
          "And I know they feel the presence of the Lord."
        ]
      }
    ],
    "chorus": [
      "Sweet Holy Spirit,",
      "Sweet Heavenly Dove,",
      "Stay right here with us",
      "Filling us with Your love,",
      "And for these blessings we lift our hearts in praise,Without a doubt we'll know that we have been revived",
      "When we shall leave this place."
    ],
    "timestamps": {
      "chorus": 44.6594
    }
  },
  {
    "hymnNumber": 263,
    "reference": "SDAH263",
    "title": "Fire of God Thou Sacred Flame",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Fire of God, Thou sacred flame,",
          "Spirit who in splendor came,",
          "Let Thy heat my soul refine",
          "Till it glows with love divine."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Breath of God, that swept in power",
          "In the pentecostal hour,",
          "Holy Breath, be Thou in me",
          "Source of vital energy."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Strength of God, Thy might within",
          "Conquers sorrow, pain, and sin:",
          "Fortify from evil's art",
          "All the gateways of my heart."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Truth of God, Thy piercing rays",
          "Penetrate my secret ways.",
          "May the light that shames my sin",
          "Guide me holier paths to win."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "Love of God, Thy grace profound",
          "Knoweth neither age nor bound:",
          "Come, my heart's own guest to be,",
          "Dwell forevermore in me."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 264,
    "reference": "SDAH264",
    "title": "O for That Flame of Living Fire",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "O for that flame of living fire",
          "Which shone so bright in saints of old;",
          "Which bade their souls to heaven aspire,",
          "Calm in distress, in danger bold!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Where is that spirit, Lord, which dwelt",
          "In Abram's breast, and sealed him Thine?",
          "Which made Paul's heart with sorrow melt,",
          "And glow with energy divine?"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "That spirit which from age to age",
          "Proclaimed Thy love, and taught Thy ways?",
          "Brightened Isaiah's vivid page,",
          "And breathed in David's hallowed lays?"
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Is not Thy grace as mighty now",
          "As when Elijah felt its power?",
          "When glory beamed from Moses' brow,",
          "Or Job endured the trying hour?"
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "Remember, Lord, the ancient days;",
          "Renew Thy work, Thy grace restore;",
          "And while to Thee our hearts we raise,",
          "On us Thy Holy Spirit pour."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 265,
    "reference": "SDAH265",
    "title": "Breathe on Me, Breath of God",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Breathe on me, Breath of God,",
          "Fill me with life anew,",
          "That I may love what Thou dost love,",
          "And do what Thou wouldst do."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Breathe on me, Breath of God,",
          "Until my heart is pure,",
          "Until with Thee I will one will,",
          "To do and to endure."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Breathe on me, Breath of God,",
          "Till I am wholly Thine,",
          "Until this earthly part of me",
          "Glows with Thy fire divine."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Breathe on me, Breath of God,",
          "So shall I constant be,",
          "And live with Thee the perfect life",
          "Of Thine eternity."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 266,
    "reference": "SDAH266",
    "title": "Spirit of God",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Spirit of God! descend upon my heart;",
          "Wean it from earth; through all its pulses move;",
          "Stoop to my weakness, mighty as Thou art,",
          "And make me love Thee as I ought to love."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "I ask no dream, no prophet ecstasies;",
          "No sudden rending of the veil of clay;",
          "No angel visitant, no op'ning skies;",
          "But take the dimness of my soul away."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Hast Thou not bid us love Thee, God and King?",
          "All, all Thine own, soul, heart, and strength, and mind;",
          "I see Thy cross, there teach my heart to cling:",
          "O let me seek Thee, and O let me find!"
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Teach me to feel that Thou art always nigh;",
          "Teach me the struggles of the soul to bear;",
          "To check the rising doubt, the rebel sigh;",
          "Teach me the patience of unanswered prayer."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "Teach me to love Thee as Thine angels love,",
          "One holy passion filling all my frame;",
          "The baptism of the heav'n-descended dove,",
          "My heart an altar, and Thy love the flame."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 267,
    "reference": "SDAH267",
    "title": "Spirit Divine",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Spirit divine, attend our prayers,",
          "And make this house Thy home;",
          "Descend with all Thy gracious powers,",
          "O come, great Spirit, come!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Come as the light; to us reveal",
          "Our emptiness and woe,",
          "And lead us in those paths of life",
          "Whereon the righteous go."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Come as the fire, and purge our hearts",
          "Like sacrificial flame;",
          "Let our whole soul an off'ring be",
          "To our Redeemer's name."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Come as the dove, and spread Thy wings,",
          "The wings of peaceful love;",
          "And let Thy church on earth become",
          "Blest as the church above."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "Spirit divine, attend our prayers,",
          "Make a lost world Thy home;",
          "Descend with all Thy gracious powers,",
          "O come, great Spirit, come!"
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 268,
    "reference": "SDAH268",
    "title": "Holy Spirit, Light Divine",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Holy Spirit, light divine,",
          "Shine upon this heart of mine,",
          "Chase the shades of night away,",
          "Turn my darkness into day."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Holy Spirit, power divine,",
          "Cleanse this guilty heart of mine;",
          "Long has sin, without control,",
          "Held dominion o'er my soul."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Holy Ghost, with joy divine,",
          "Cheer this saddened heart of mine,",
          "Bid my many woes depart,",
          "Heal my wounded, bleeding heart."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Holy Spirit, all divine,",
          "Dwell within this heart of mine,",
          "Cast down every idol throne,",
          "Reign supreme, and reign alone."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 269,
    "reference": "SDAH269",
    "title": "Come, Holy Spirit",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Come, Holy Spirit, heavenly Dove,",
          "With all Thy quickening powers;",
          "Kindle a flame of sacred love",
          "In these cold hearts of ours."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "O raise our thoughts from things below,",
          "From vanities and toys!",
          "Then shall we with fresh courage go",
          "To reach eternal joys."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Awake our souls to joyful songs;",
          "Let pure devotions rise;",
          "Till praise employs our thankful tongues,",
          "And doubt forever dies."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Father, we would no longer live",
          "At this poor, dying rate;",
          "To Thee our thankful love we give,",
          "For Thine to us is great."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "Come, Holy Spirit, heavenly Dove,",
          "With all Thy quickening powers;",
          "Come, shed abroad a Savior's love,",
          "And that shall kindle ours."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 270,
    "reference": "SDAH270",
    "title": "O Holy Dove of God Descending",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "O holy Dove of God descending,",
          "You are the love that knows no ending.",
          "All of our shattered dreams You're mending:",
          "Spirit, now live in me."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "O holy Wind of God now blowing,",
          "You are the seed that God is sowing.",
          "You are the life that starts us growing:",
          "Spirit, now live in me."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "O holy Rain of God now falling,",
          "You make the Word of God enthralling,",
          "You are that inner voice now calling:",
          "Spirit, now live in me."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "O holy Flame of God now burning,",
          "You are the power of Christ returning.",
          "You are the answer to our yearning:",
          "Spirit, now live in me."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 271,
    "reference": "SDAH271",
    "title": "Break Thou the Bread of Life",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Break Thou the bread of life,",
          "Dear Lord, to me,",
          "As Thou didst break the loaves",
          "Beside the sea;",
          "Beyond the sacred page",
          "I seek Thee, Lord;",
          "My spirit pants for Thee,",
          "O living Word."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Bless Thou the truth, dear Lord,",
          "To me, to me,",
          "As Thou didst bless the bread",
          "By Galilee;",
          "Then shall all bondage cease,",
          "All fetters fall;",
          "And I shall find my peace,",
          "My all in all."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Thou art the bread of life,",
          "O Lord, to me;",
          "Thy holy Word the truth",
          "That saveth me;",
          "Give me to eat and live",
          "With Thee above;",
          "Teach me to love Thy truth,",
          "For Thou art love."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Spirit and life are they,",
          "Words Thou dost speak;",
          "I hasten to obey,",
          "But I am weak;",
          "Thou art my only help,",
          "Thou art my life;",
          "Heeding Thy holy Word",
          "I win the strife."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 272,
    "reference": "SDAH272",
    "title": "Give Me the Bible",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Give me the Bible, star of gladness gleaming,",
          "To cheer the wanderer lone and tempest tossed,",
          "No storm can hide that peaceful radiance beaming,",
          "Since Jesus came to seek and save the lost."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Give me the Bible when my heart is broken,",
          "When sin and grief have filled my soul with fear;",
          "Give me the precious words by Jesus spoken,",
          "Hold up faith's lamp to show my Savior near."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Give me the Bible, all my steps enlighten,",
          "Teach me the danger of these realms below;",
          "That lamp of safety, o'er the gloom shall brighten,",
          "That light alone the path of peace can show."
        ]
      }
    ],
    "chorus": [
      "Give me the Bible; holy message shining,",
      "Thy light shall guide me in the narrow way.",
      "Precept and promise, law and love combining,",
      "'Till night shall vanish in eternal day."
    ],
    "timestamps": {
      "chorus": 23.9498
    }
  },
  {
    "hymnNumber": 273,
    "reference": "SDAH273",
    "title": "Lord, I Have Made Thy Word My Choice",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Lord, I have made Thy word my choice,",
          "My lasting heritage;",
          "There shall my noblest pow'rs rejoice,",
          "My warmest thoughts engage."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "I'll read the histories of Thy love,",
          "And keep Thy laws in sight;",
          "While through Thy promises I rove,",
          "With ever fresh delight."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "In this broad land of wealth unknown,",
          "Where springs of life arise,",
          "Seeds of immortal bliss are sown,",
          "And hidden glory lies."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "The best relief that mourners have,",
          "It makes our sorrows blest;",
          "Our fairest hope beyond the grave,",
          "And our eternal rest."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 274,
    "reference": "SDAH274",
    "title": "O Word of God Incarnate",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "O Word of God Incarnate,",
          "O Wisdom from on high,",
          "O Truth unchanged, unchanging,",
          "O Light of our dark sky,",
          "We praise Thee for the radiance",
          "That from the hallowed page,",
          "A lantern to our footsteps,",
          "Shines on from age to age."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "The church from her dear Master",
          "Received the gift divine,",
          "And still that light she lifteth",
          "O'er all the earth to shine.",
          "It is the golden casket,",
          "Where gems of truth are stored",
          "It is the heaven-drawn picture",
          "Of Christ, the living Word."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "It floateth like a banner",
          "Before God's host unfurled",
          "It shineth like a beacon",
          "Above the darkling world.",
          "It is the chart and compass",
          "That o'er life's surging sea,",
          "'Mid mists and rocks and quicksands,",
          "Still guides, O Christ, to Thee."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "O make Thy church, dear Savior,",
          "A lamp of purest gold,",
          "To bear before the nations",
          "Thy true light, as of old.",
          "O teach Thy wandering pilgrims",
          "By this their path to trace,",
          "Till, clouds and darkness ended,",
          "They see Thee face to face."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 275,
    "reference": "SDAH275",
    "title": "O God of Light",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "O God of light, Your Word, a lamp unfailing,",
          "Shall pierce the darkness of our earthbound way",
          "And show your grace, Your plan for us unveiling,",
          "And guide our footsteps to the perfect day."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "From days of old, through blind and willful ages,",
          "Though we rebelled, You gently sought again,",
          "And spoke through saints, apostles, prophets, sages,",
          "Who wrote with eager or reluctant pen."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Undimmed by time, those words are still revealing",
          "To sinful hearts Your justice and Your grace;",
          "And questing mortals longing for Your healing,",
          "See Your compassion in the Savior's face."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "To all the world Your summons You are sending,",
          "Through all the earth, to every land and race,",
          "That myriad tongues, in one great anthem blending,",
          "May praise and celebrate Your gift of grace."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 276,
    "reference": "SDAH276",
    "title": "Thanks to God",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Thanks to God whose Word was spoken",
          "In the deed that made the earth.",
          "His the voice that called a nation;",
          "His the fires that tried her worth.",
          "God has spoken;",
          "Praise Him for His open Word."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Thanks to God whose Word incarnate",
          "Glorified the flesh of man.",
          "Deeds and words and death and rising",
          "Tell the grace in heaven's plan.",
          "God has spoken;",
          "Praise Him for His open Word."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Thanks to God whose Word is answered",
          "By the Spirit's voice wihin.",
          "Here we drink of joy unmeasured,",
          "Life redeemed from death and sin.",
          "God is speaking;",
          "Praise Him for His open Word."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 277,
    "reference": "SDAH277",
    "title": "For Your Holy Book We Thank You",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "For Your holy book we thank You,",
          "And for all who served You well,",
          "Writing, guarding, and translating,",
          "That its pages might forth tell",
          "Your strong love and tender care",
          "For Your people everywhere."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "For Your holy book we thank You,",
          "And for those who work today,",
          "That the people of all nations,",
          "Reading it and foll'wing, may",
          "Know Your love and tender care",
          "For Your people everywhere."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "For Your holy book we thank You,",
          "May its message be our guide,",
          "May we understand the wisdom",
          "Of the laws it will provide:",
          "And Your love and tender care",
          "For Your people everywhere."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "For Your holy book we thank You,",
          "May its message in our hearts",
          "Lead us now to see in Jesus",
          "All the grace Your word imparts:",
          "All Your love and tender care",
          "For Your people everywhere."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 278,
    "reference": "SDAH278",
    "title": "Lord Jesus Once You Spoke to Men",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Lord Jesus, once You spoke to men",
          "Upon the mountain and the plain,",
          "O help us listen now as then",
          "And wonder at Your words again."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "We all have secret fears to face,",
          "Our minds and motives to amend.",
          "We seek Your truth, we need Your grace,",
          "Our living Lord and present friend."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "The gospel speaks; and we receive",
          "Your light, Your love, Your own command.",
          "O help us live what we believe,",
          "In daily word of heart and hand."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 279,
    "reference": "SDAH279",
    "title": "Only Trust Him",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Come, every soul by sin oppressed,",
          "There's mercy with the Lord,",
          "And He will surely give you rest,",
          "By trusting in His word."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "For Jesus shed His precious blood",
          "Rich blessings to bestow;",
          "Plunge now into the crimson flood",
          "That washes white as snow."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Yes, Jesus is the truth, the way,",
          "That leads you into rest;",
          "Believe in Him without delay,",
          "And you are fully blest."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Come, then, and join this holy band,",
          "And on to glory go,",
          "To dwell in that celestial land,",
          "Where joys immortal flow."
        ]
      }
    ],
    "chorus": [
      "Only trust Him, only trust Him,",
      "Only trust Him now;",
      "He will save you, He will save you,",
      "He will save you now."
    ],
    "timestamps": {
      "chorus": 19.8458
    }
  },
  {
    "hymnNumber": 280,
    "reference": "SDAH280",
    "title": "Come, Ye Sinners",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Come, ye sinners poor and needy,",
          "Weak and wounded, sick and sore;",
          "Jesus ready stands to save you,",
          "Full of pity, love, and power."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Come, ye thirsty, come, and welcome,",
          "God's free bounty glorify;",
          "True belief and true repentance,",
          "Every grace that brings you nigh."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Let not conscience make you linger,",
          "Nor of fitness fondly dream;",
          "All the fitness He requireth",
          "Is to feel your need of Him."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Lo! th' incarnate God, ascended,",
          "Pleads the merit of His blood;",
          "Venture on Him, venture wholly,",
          "Let no other trust intrude."
        ]
      }
    ],
    "chorus": [
      "I will arise and go to Jesus,",
      "He will embrace me in His arms;",
      "In the arms of my dear Savior,",
      "O there are ten thousand charms."
    ],
    "timestamps": {
      "chorus": 20.8869
    }
  },
  {
    "hymnNumber": 281,
    "reference": "SDAH281",
    "title": "I Gave My Life for Thee",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "I gave My life for thee,",
          "My precious blood I shed,",
          "That thou might'st ransomed be,",
          "And quickened from the dead;",
          "I gave, I gave My life for thee,",
          "What hast thou given for Me?",
          "I gave, I gave My life for thee,",
          "What hast thou given for Me?"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "My Father's house of light,",
          "My glory circled throne,",
          "I left for earthly night,",
          "For wanderings sad and lone;",
          "I left, I left it all for thee,",
          "Hast thou left aught for Me?",
          "I left, I left it all for thee,",
          "Hast thou left aught for Me?"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "I suffered much for thee,",
          "More than thy tongue can tell,",
          "Of bitterest agony,",
          "To rescue thee from hell;",
          "I've borne, I've borne it all for thee,",
          "What hast thou borne for Me?",
          "I've borne, I've borne it all for thee,",
          "What hast thou borne for Me?"
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 282,
    "reference": "SDAH282",
    "title": "I Hear Thy Welcome Voice",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "I hear Thy welcome voice,",
          "That calls me, Lord, to Thee;",
          "For cleansing in Thy precious blood,",
          "That flowed on Calvary."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Though coming weak and vile,",
          "Thou dost my strength assure;",
          "Thou dost my vileness fully cleanse,",
          "Till spotless all, and pure."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "'Tis Jesus calls me on",
          "To perfect faith and love,",
          "To perfect hope, and peace, and trust,",
          "For earth and heaven above."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "All hail, atoning blood!",
          "All hail, redeeming grace!",
          "All hail! the gift of Christ, our Lord,",
          "Our Strength and Righteousness."
        ]
      }
    ],
    "chorus": [
      "I am coming, Lord!",
      "Coming now to Thee!",
      "Wash me, cleanse me, in the blood",
      "That flowed on Calvary."
    ],
    "timestamps": {
      "chorus": 17.6677
    }
  },
  {
    "hymnNumber": 283,
    "reference": "SDAH283",
    "title": "O Jesus, Thou Art Standing",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "O Jesus, Thou art standing",
          "Outside the fast-closed door,",
          "In lowly patience waiting",
          "To pass the threshold o'er:",
          "O shame, professing Christian,",
          "His name and sign who bear,",
          "O shame, thrice shame upon us,",
          "To keep Him standing there!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "O Jesus, Thou art knocking;",
          "And, lo, that hand is scarred,",
          "And thorns Thy brow encircle,",
          "And tears Thy face have marred.",
          "O love that passeth knowledge,",
          "So patiently to wait!",
          "O sin that hath no equal,",
          "So fast to bar the gate!"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "O Jesus, Thou art pleading",
          "In accents meek and low,",
          "\"I died for you, My children,",
          "And will ye treat Me so?\"",
          "O Lord, with shame and sorrow",
          "We open now the door;",
          "Dear Savior, enter, enter,",
          "And leave us nevermore."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 284,
    "reference": "SDAH284",
    "title": "For You I Am Praying",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "I have a Savior, He's pleading in glory,",
          "A dear, loving Savior, though earth friends be few;",
          "And now He is watching in tenderness o'er me,",
          "But oh that my Savior were your Savior, too."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "I have a Father; to me He has given",
          "A hope for eternity, blessed and true;",
          "And soon He will call me to meet Him in heaven,",
          "But oh that He'd let me bring you with me, too!"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "I have a robe; 'tis resplendent in whiteness,",
          "Awaiting in glory my wondering view;",
          "Oh, when I receive it, all shining in brightness,",
          "Dear friend, could I see you receiving one, you!"
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "When Jesus has found you, tell others the story,",
          "That my loving Savior is your Savior, too;",
          "Then pray that your Savior will bring them to glory,",
          "And prayer will be answered; 'twas answered for you!"
        ]
      }
    ],
    "chorus": [
      "For you I am praying,",
      "For you I am praying,",
      "For you I am praying,",
      "I'm praying for you."
    ],
    "timestamps": {
      "chorus": 31.8267
    }
  },
  {
    "hymnNumber": 285,
    "reference": "SDAH285",
    "title": "Jesus Calls Us",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Jesus calls us; o'er the tumult",
          "Of our life's wild, restless sea,",
          "Day by day His sweet voice soundeth,",
          "Saying, \"Christian, follow Me.\""
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Jesus calls us from the worship",
          "Of the vain world's golden store,",
          "From each idol that would keep us,",
          "Saying, \"Christian, love Me more.\""
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "In our joys and in our sorrows,",
          "Days of toil and hours of ease,",
          "Still He calls, in cares and pleasures,",
          "\"Christian, love Me more than these.\""
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Jesus calls us! By Thy mercies,",
          "Savior, may we hear Thy call,",
          "Give our hearts to Thy obedience,",
          "Serve and love Thee best of all."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 286,
    "reference": "SDAH286",
    "title": "Wonderful Words of Life",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Sing them over again to me,",
          "Wonderful words of life;",
          "Let me more of their beauty see,",
          "Wonderful words of life.",
          "Words of life and beauty,",
          "Teach me faith and duty;"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Christ, the blessed One, gives to all",
          "Wonderful words of life;",
          "Sinner, list to the loving call,",
          "Wonderful words of life.",
          "All so freely given,",
          "Wooing us to heaven;"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Sweetly echo the gospel call,",
          "Wonderful words of life;",
          "Offer pardon and peace to all,",
          "Wonderful words of life.",
          "Jesus, only Savior,",
          "Sanctify forever;"
        ]
      }
    ],
    "chorus": [
      "Beautiful words, wonderful words,",
      "Wonderful words of life,",
      "Beautiful words, wonderful words,",
      "Wonderful words of life."
    ],
    "timestamps": {
      "chorus": 30.344
    }
  },
  {
    "hymnNumber": 287,
    "reference": "SDAH287",
    "title": "Softly and Tenderly",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Softly and tenderly Jesus is calling,",
          "Calling for you and for me;",
          "At the heart's portal He's waiting and watching,",
          "Watching for you and for me."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Why should we tarry when Jesus is pleading,",
          "Pleading for you and for me?",
          "Why should we linger and heed not His mercies,",
          "Mercies for you and for me?"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Think of the wonderful love He has promised,",
          "Promised for you and for me;",
          "Though we have sinned, He has mercy and pardon,",
          "Pardon for you and for me."
        ]
      }
    ],
    "chorus": [
      "Come home, come home,",
      "Ye who are weary, come home;",
      "Earnestly, tenderly Jesus is calling,",
      "Calling, O sinner, come home!"
    ],
    "timestamps": {
      "chorus": 26.7929
    }
  },
  {
    "hymnNumber": 288,
    "reference": "SDAH288",
    "title": "I Am Going to Calvary",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "I am going to Calvary.",
          "Would you like to come with Me",
          "All the way and back again?",
          "You must follow the Leader then.",
          "You must follow the Leader,",
          "You must follow the Leader,",
          "All the way and back again,",
          "You must follow the Leader."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "If I wear a thorny crown,",
          "If the soldiers knock Me down",
          "Can I really be a king?",
          "Love will answer everything",
          "If you follow the Leader,",
          "If you follow the Leader,",
          "Love will answer everything",
          "If you follow the Leader."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "When I go along the road,",
          "I shall lift a heavy load.",
          "I will carry a cross for you.",
          "You will learn to carry it too",
          "When you follow the Leader,",
          "When you follow the Leader,",
          "You will learn to carry it too",
          "If you follow the Leader."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "I am going to stretch My hands,",
          "Reaching out to all the lands.",
          "Can I really be a king?",
          "Love's the Lord of everything,",
          "When you follow the Leader,",
          "When you follow the Leader,",
          "Love's the Lord of everything",
          "When you follow the Leader."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 289,
    "reference": "SDAH289",
    "title": "The Savior Is Waiting",
    "hasMidi": true,
    "numberOfVerses": 2,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "The Savior is waiting to enter your heart,",
          "Why don't you let Him come in?",
          "There's nothing in this world to keep you apart,",
          "What is your answer to Him?"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "If you'll take one step toward the Savior, my friend,",
          "You'll find His arms open wide;",
          "Receive Him, and all of your darkness will end,",
          "Within your heart He'll abide."
        ]
      }
    ],
    "chorus": [
      "Time after time He has waited before,",
      "And now He is waiting again",
      "To see if you're willing to open the door:",
      "O how He wants to come in."
    ],
    "timestamps": {
      "chorus": 30.5925
    }
  },
  {
    "hymnNumber": 290,
    "reference": "SDAH290",
    "title": "Turn Your Eyes Upon Jesus",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "O soul, are you weary and troubled?",
          "No light in the darkness you see?",
          "There's light for a look at the Savior,",
          "And life more abundant and free!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Through death into life everlasting",
          "He passed, and we follow Him there;",
          "Over us sin no more hath dominion,",
          "For more than conqu'rors we are!"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "His word shall not fail you He promised;",
          "Believe Him and all will be well:",
          "Then go to a world that is dying,",
          "His perfect salvation to tell!"
        ]
      }
    ],
    "chorus": [
      "Turn your eyes upon Jesus,",
      "Look full in His wonderful face;",
      "And the things of earth will grow strangely dim",
      "In the light of His glory and grace."
    ],
    "timestamps": {
      "chorus": 28.6629
    }
  },
  {
    "hymnNumber": 291,
    "reference": "SDAH291",
    "title": "We Have Not Known Thee",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "We have not known Thee as we ought,",
          "Nor learned Thy wisdom, grace, and power;",
          "The things of earth have led our thought,",
          "And trifles of the passing hour.",
          "Lord, give us light Thy truth to see,",
          "And make us wise in knowing Thee."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "We have not feared Thee as we ought,",
          "Nor bowed beneath Thine awful eye,",
          "Nor guarded deed, and word, and thought,",
          "Remembering that God was nigh.",
          "Lord, give us faith to know Thee near,",
          "And grant the grace of holy fear."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "We have not loved Thee as we ought,",
          "Nor cared that we are loved by Thee;",
          "Thy presence we have coldly sought,",
          "And feebly longed Thy face to see.",
          "Lord, give a pure and loving heart",
          "To feel and own the love Thou art."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "We have not served Thee as we ought;",
          "Alas! the duties left undone,",
          "The work with little fervor wrought,",
          "The battles lost, or scarcely won!",
          "Lord, give the zeal, and give the might,",
          "For Thee to toil, for Thee to fight."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "When shall we know Thee as we ought,",
          "And fear, and love, and serve aright!",
          "When shall we, out of trial brought,",
          "Be perfect in the land of light!",
          "Lord, may we day by day prepare",
          "To see Thy face, and serve Thee there."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 292,
    "reference": "SDAH292",
    "title": "Jesus, I Come",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Out of my bondage, sorrow and night,",
          "Jesus, I come, Jesus, I come;",
          "Into Thy freedom, gladness and light,",
          "Jesus, I come to Thee;",
          "Out of my sickness into Thy health,",
          "Out of my want and into Thy wealth,",
          "Out of my sin and into Thyself,",
          "Jesus, I come to Thee."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Out of my shameful failure and loss,",
          "Jesus, I come, Jesus, I come;",
          "Into the glorious gain of Thy cross,",
          "Jesus, I come to Thee;",
          "Out of earth's sorrows into Thy balm,",
          "Out of life's storms and into Thy calm,",
          "Out of distress to jubilant psalm,",
          "Jesus, I come to Thee."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Out of unrest and arrogant pride,",
          "Jesus, I come, Jesus, I come;",
          "Into Thy blessed will to abide,",
          "Jesus, I come to Thee;",
          "Out of myself to dwell in Thy love,",
          "Out of despair into raptures above,",
          "Upward for aye on wings like a dove,",
          "Jesus, I come to Thee."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Out of the fear and dread of the tomb,",
          "Jesus, I come, Jesus, I come;",
          "Into the joy and light of Thy home,",
          "Jesus, I come to Thee;",
          "Out of the depths of ruin untold,",
          "Into the peace of Thy sheltering fold,",
          "Ever Thy glorious face to behold,",
          "Jesus, I come to Thee."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 293,
    "reference": "SDAH293",
    "title": "Heavenly Father, Bless Us Now",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Heavenly Father, bless us now;",
          "At the cross of Christ we bow;",
          "Take our guilt and grief away;",
          "Hear and heal us now, we pray."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Now, O Lord, this very hour,",
          "Send Thy grace and show Thy power;",
          "While we rest upon Thy word,",
          "Come, and bless us now, O Lord!"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Mercy now, O Lord, we plead",
          "In this hour of utter need;",
          "Turn us not away unblest;",
          "Calm our anguish into rest."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "O Thou loving, blessed One,",
          "Rising o'er us like the sun,",
          "Light and life art Thou within:",
          "Savior, Thou, from every sin!"
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 294,
    "reference": "SDAH294",
    "title": "Power in the Blood",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Would you be free from the burden of sin?",
          "There's pow'r in the blood, pow'r in the blood;",
          "Would you o'er evil a victory win?",
          "There's wonderful pow'r in the blood."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Would you be free from your passion and pride?",
          "There's pow'r in the blood, pow'r in the blood;",
          "Come for a cleansing to Calvary's tide?",
          "There's wonderful pow'r in the blood."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Would you do service for Jesus your King?",
          "There's pow'r in the blood, pow'r in the blood;",
          "Would you live daily His praises to sing?",
          "There's wonderful pow'r in the blood."
        ]
      }
    ],
    "chorus": [
      "There is pow'r, pow'r, wonder-working pow'r",
      "In the blood of the Lamb;",
      "There is pow'r, pow'r, wonder-working pow'r",
      "In the precious blood of the Lamb."
    ],
    "timestamps": {
      "chorus": 19.3036
    }
  },
  {
    "hymnNumber": 295,
    "reference": "SDAH295",
    "title": "Chief of Sinners",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Chief of sinners though I be,",
          "Jesus shed His blood for me;",
          "Died that I might live on high,",
          "Died that I might never die;",
          "As the branch is to the vine,",
          "I am His, and He is mine."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "O the height of Jesus' love!",
          "Higher than the heaven above,",
          "Deeper than the deepest sea,",
          "Lasting as eternity;",
          "Love that found me; wondrous thought!",
          "Found me when I sought Him not!"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Chief of sinners though I be,",
          "Christ is all in all to me;",
          "All my wants to Him are known,",
          "All my sorrows are His own;",
          "Safe with Him from earthly strife,",
          "He sustains the hidden life."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 296,
    "reference": "SDAH296",
    "title": "Lord, I'm Coming Home",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "I've wandered far away from God,",
          "Now I'm coming home;",
          "The paths of sin too long I've trod;",
          "Lord, I'm coming home."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "I've wasted many precious years,",
          "Now I'm coming home;",
          "I now repent with bitter tears;",
          "Lord, I'm coming home."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "I'm tired of sin and straying, Lord,",
          "Now I'm coming home;",
          "I'll trust Thy love, believe Thy word;",
          "Lord, I'm coming home."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "My only hope, my only plea,",
          "Now I'm coming home;",
          "That Jesus died, and died for me;",
          "Lord, I'm coming home."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "I need His cleansing blood I know,",
          "Now I'm coming home;",
          "O wash me whiter than the snow;",
          "Lord, I'm coming home."
        ]
      }
    ],
    "chorus": [
      "Coming home, coming home",
      "Nevermore to roam;",
      "Open wide Thine arms of love;",
      "Lord, I'm coming home."
    ],
    "timestamps": {
      "chorus": 24.1317
    }
  },
  {
    "hymnNumber": 297,
    "reference": "SDAH297",
    "title": "God Be Merciful to Me",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "God, be merciful to me,",
          "On Thy grace I rest my plea;",
          "Plenteous in compassion Thou,",
          "Blot out my transgressions now;",
          "Wash me, make me pure within,",
          "Cleanse, O cleanse me from my sin,",
          "Wash me, make me pure within,",
          "Cleanse, O cleanse me from my sin."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "I am evil, born in sin;",
          "Thou desirest truth within.",
          "Thou alone my Savior art,",
          "Teach Thy wisdom to my heart;",
          "Make me pure, Thy grace bestow,",
          "Wash me whiter than the snow,",
          "Make me pure, Thy grace bestow,",
          "Wash me whiter than the snow."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Gracious God, my heart renew,",
          "Make my spirit right and true;",
          "Cast me not away from Thee,",
          "Let Thy Spirit dwell in me;",
          "Thy salvation's joy impart,",
          "Steadfast make my willing heart,",
          "Thy salvation's joy impart,",
          "Steadfast make my willing heart."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Sinners then shall learn from me",
          "And return, O God, to Thee;",
          "Savior, all my guilt remove,",
          "And my tongue shall sing Thy love;",
          "Touch my silent lips, O Lord,",
          "And my mouth shall praise accord,",
          "Touch my silent lips, O Lord,",
          "And my mouth shall praise accord."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 298,
    "reference": "SDAH298",
    "title": "I Lay My Sins On Jesus",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "I lay my sins on Jesus,",
          "The spotless Lamb of God;",
          "He bears them all, and frees us",
          "From the accursed load,",
          "From the accursed load."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "I bring my guilt to Jesus,",
          "To wash my crimson stains",
          "White in His blood most precious,",
          "Till not a stain remains,",
          "Till not a stain remains."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "I lay my wants on Jesus,",
          "All fullness dwells in Him;",
          "He healeth my diseases,",
          "He doth my soul redeem,",
          "He doth my soul redeem."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "I long to be like Jesus,",
          "Meek loving, lowly, mild;",
          "I long to be like Jesus,",
          "The Father's holy child,",
          "The Father's holy child."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "I long to be with Jesus",
          "Amid the heav'nly throng,",
          "To sing with them His praises,",
          "And learn the angels' song,",
          "And learn the angels' song."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 299,
    "reference": "SDAH299",
    "title": "Forgive Our Sins As We Forgive",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "\"Forgive our sins as we forgive,\"",
          "You taught us, Lord, to pray;",
          "But You alone can grant us grace",
          "To live the words we say."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "How can Your pardon reach and bless",
          "The unforgiving heart",
          "That broods on wrongs and will not let",
          "Old bitterness depart?"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "In blazing light Your cross reveals",
          "The truth we dimly knew:",
          "How trifling others' debts to us;",
          "How great our debt to You!"
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Lord, cleanse the depths within our souls",
          "And bid resentment cease;",
          "Then, by Your mercy reconciled,",
          "Our lives will spread Your peace."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 300,
    "reference": "SDAH300",
    "title": "Rock of Ages",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Rock of Ages, cleft for me,",
          "Let me hide myself in Thee;",
          "Let the water and the blood,",
          "From Thy riven side which flowed,",
          "Be of sin the double cure,",
          "Cleanse me from its guilt and power."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Not the labors of my hands",
          "Can fulfill Thy law's demands;",
          "Could my zeal no respite know,",
          "Could my tears forever flow,",
          "All for sin could not atone;",
          "Thou must save, and Thou alone."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "When my pilgrimage I close,",
          "Victor o'er the last of foes,",
          "When I soar to worlds unknown,",
          "And behold Thee on Thy throne,",
          "Rock of Ages, cleft for me,",
          "Let me hide myself in Thee."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 301,
    "reference": "SDAH301",
    "title": "Nearer, Still Nearer",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Nearer, still nearer, close to Thy heart,",
          "Draw me, my Savior, so precious Thou art;",
          "Fold me, O fold me close to Thy breast,",
          "Shelter me safe in that haven of rest,",
          "Shelter me safe in that haven of rest."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Nearer, still nearer, nothing I bring,",
          "Nought as an offering to Jesus my King",
          "Only my sinful now contrite heart;",
          "Grant me the cleansing Thy blood doth impart,",
          "Grant me the cleansing Thy blood doth impart."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Nearer, still nearer, Lord, to be Thine;",
          "Sin, with its follies, I gladly resign,",
          "All of its pleasures, pomp and its pride;",
          "Give me but Jesus, my Lord crucified,",
          "Give me but Jesus, my Lord crucified."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Nearer, still nearer, while life shall last;",
          "Till safe in glory my anchor is cast;",
          "Through endless ages, ever to be,",
          "Nearer, my Savior, still nearer to Thee,",
          "Nearer, my Savior, still nearer to Thee."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 302,
    "reference": "SDAH302",
    "title": "Deeper Yet",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "In the blood from the cross",
          "I have been washed from sin;",
          "But to be free from dross,",
          "Still I would enter in."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Day by day, hour by hour,",
          "Blessings are sent to me;",
          "But for more of His power",
          "Ever my prayer shall be."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Near to Christ I would live,",
          "Following Him each day;",
          "What I ask He will give;",
          "So then with faith I pray."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Now I have peace, sweet peace,",
          "While in this world of sin;",
          "But to pray I'll not cease",
          "Till I am pure within."
        ]
      }
    ],
    "chorus": [
      "Deeper yet, deeper yet,",
      "Into the crimson flood;",
      "Deeper yet, deeper yet,",
      "Under the precious blood."
    ],
    "timestamps": {
      "chorus": 16.6433
    }
  },
  {
    "hymnNumber": 303,
    "reference": "SDAH303",
    "title": "Beneath the Cross of Jesus",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Beneath the cross of Jesus",
          "I fain would take my stand,",
          "The shadow of a mighty rock",
          "Within a weary land;",
          "A home within the wilderness,",
          "A rest upon the way,",
          "From the burning of the noontide heat,",
          "And the burden of the day."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Upon that cross of Jesus",
          "Mine eye at times can see",
          "The very dying form of One",
          "Who suffered there for me;",
          "And from my smitten heart with tears",
          "Two wonders I confess:",
          "The wonders of redeeming love",
          "And my unworthiness."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "I take, O cross, thy shadow",
          "For my abiding place;",
          "I ask no other sunshine than",
          "The sunshine of His face;",
          "Content to let the world go by,",
          "To know no gain nor loss,",
          "My sinful self my only shame,",
          "My glory all the cross."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 304,
    "reference": "SDAH304",
    "title": "Faith of Our Fathers",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Faith of our fathers! living still",
          "In spite of dungeon, fire, and sword,",
          "O how our hearts beat high with joy",
          "Whene'er we hear that glorious word.",
          "Faith of our fathers! holy faith!",
          "We will be true to thee till death."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Our fathers, chained in prisons dark,",
          "Were still in heart and conscience free;",
          "How sweet would be their children's fate,",
          "If they, like them, could die for thee!",
          "Faith of our fathers! holy faith!",
          "We will be true to thee till death."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Faith of our fathers! we will love",
          "Both friend and foe in all our strife,",
          "And preach thee, too, as love knows how,",
          "By kindly words and virtuous life.",
          "Faith of our fathers! holy faith!",
          "We will be true to thee till death."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 305,
    "reference": "SDAH305",
    "title": "Give Me Jesus",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "In the morning when I rise,",
          "In the morning when I rise,",
          "In the morning when I rise,",
          "Give me Jesus."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Dark midnight was my cry,",
          "Dark midnight was my cry,",
          "Dark midnight was my cry,",
          "Give me Jesus."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Just about the break of day,",
          "Just about the break of day,",
          "Just about the break of day,",
          "Give me Jesus."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Oh, when I come to die,",
          "Oh, when I come to die,",
          "Oh, when I come to die,",
          "Give me Jesus."
        ]
      }
    ],
    "chorus": [
      "Give me Jesus, Give me Jesus,",
      "You may have all this world,",
      "Give me Jesus."
    ],
    "timestamps": {
      "chorus": 18.8497
    }
  },
  {
    "hymnNumber": 306,
    "reference": "SDAH306",
    "title": "Draw Me Nearer",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "I am Thine, O Lord, I have heard Thy voice,",
          "And it told Thy love to me;",
          "But I long to rise in the arms of faith,",
          "And be closer drawn to Thee."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Consecrate me now to Thy service, Lord,",
          "By the power of grace divine;",
          "May my soul look up with a steadfast hope",
          "And my will be lost in Thine."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "O the pure delight of a single hour",
          "That before Thy throne I spend,",
          "When I kneel in prayer, and with Thee, my God,",
          "I commune as friend with friend!"
        ]
      }
    ],
    "chorus": [
      "Draw me nearer, nearer, blessed Lord,",
      "To the cross where Thou hast died;",
      "Draw me nearer, nearer, nearer, blessed Lord,",
      "To Thy precious, bleeding side."
    ],
    "timestamps": {
      "chorus": 20.9726
    }
  },
  {
    "hymnNumber": 307,
    "reference": "SDAH307",
    "title": "I Am Coming to the Cross",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "I am coming to the cross;",
          "I am poor, and weak, and blind",
          "I am counting all but dross;",
          "I shall full salvation find."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Long my heart has sighed for Thee;",
          "Long has evil reigned within;",
          "Jesus sweetly speaks to me,",
          "\"I will cleanse you from all sin.\""
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Here I give my all to Thee;",
          "Friends, and time, and earthly store;",
          "Soul and body Thine to be,",
          "Wholly Thine forevermore."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Jesus comes! He fills my soul!",
          "Perfected in Him I am;",
          "I am every whit made whole;",
          "Glory, glory to the Lamb!"
        ]
      }
    ],
    "chorus": [
      "I am trusting, Lord, in Thee,",
      "O Thou Lamb of Calvary;",
      "Humbly at Thy cross I bow;",
      "Save me, Jesus, save me now."
    ],
    "timestamps": {
      "chorus": 17.1979
    }
  },
  {
    "hymnNumber": 308,
    "reference": "SDAH308",
    "title": "Wholly Thine",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "I would be, dear Savior, wholly Thine;",
          "Teach me how, teach me how;",
          "I would do Thy will, O Lord, not mine;",
          "Help me, help me now."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "What is worldly pleasure, wealth, or fame,",
          "Without Thee, without Thee?",
          "I will leave them all for Thy dear name,",
          "This my wealth shall be."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "As I cast earth's transient joys behind,",
          "Come Thou near, come Thou near;",
          "In Thy presence all in all I find,",
          "'Tis my comfort here."
        ]
      }
    ],
    "chorus": [
      "Wholly Thine, wholly Thine,",
      "Wholly Thine, this is my vow;",
      "Wholly Thine, wholly Thine,",
      "Wholly Thine, O Lord, just now."
    ],
    "timestamps": {
      "chorus": 21.719
    }
  },
  {
    "hymnNumber": 309,
    "reference": "SDAH309",
    "title": "I Surrender All",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "All to Jesus I surrender,",
          "All to Him I freely give;",
          "I will ever love and trust Him,",
          "In His presence daily live;"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "All to Jesus I surrender;",
          "Humbly at His feet I bow,",
          "Worldly pleasures all forsaken;",
          "Take me, Jesus, take me now;"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "All to Jesus I surrender;",
          "Make me, Savior, wholly Thine;",
          "Let me feel the Holy Spirit,",
          "Truly know that Thou art mine;"
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "All to Jesus I surrender;",
          "Now I feel the sacred flame.",
          "O the joy of full salvation!",
          "Glory, glory to His name!"
        ]
      }
    ],
    "chorus": [
      "I surrender all,",
      "I surrender all;",
      "All to Thee, my blessed Savior,",
      "I surrender all."
    ],
    "timestamps": {
      "chorus": 21.7618
    }
  },
  {
    "hymnNumber": 310,
    "reference": "SDAH310",
    "title": "I Would Draw Nearer to Jesus",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "I would draw nearer to Jesus,",
          "In His sweet presence abide,",
          "Constantly trying to serve Him,",
          "Safe and secure at His side."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "I would draw nearer to Jesus,",
          "Nothing withholding from Him,",
          "Knowing He loves to be gracious,",
          "I would draw nearer to Him."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "I would draw nearer to Jesus,",
          "Seeking His strength to be true,",
          "Willing to tell of His goodness,",
          "Gladly His blest will to do."
        ]
      }
    ],
    "chorus": [
      "I would draw nearer to Jesus,",
      "I would draw nearer to Him;",
      "Fully surrendered each moment,",
      "I would draw nearer to Him."
    ],
    "timestamps": {
      "chorus": 19.6391
    }
  },
  {
    "hymnNumber": 311,
    "reference": "SDAH311",
    "title": "I Would Be Like Jesus",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Earthly pleasures vainly call me;",
          "I would be like Jesus;",
          "Nothing worldly shall enthrall me;",
          "I would be like Jesus."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "He has broken every fetter,",
          "I would be like Jesus;",
          "That my soul may serve Him better,",
          "I would be like Jesus."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "All the way from earth to glory,",
          "I would be like Jesus;",
          "Telling o'er and o'er the story,",
          "I would be like Jesus."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "That in heaven He may meet me,",
          "I would be like Jesus;",
          "That His words \"Well done\" may greet me,",
          "I would be like Jesus."
        ]
      }
    ],
    "chorus": [
      "Be like Jesus, this my song,",
      "In the home and in the throng,",
      "Be like Jesus, all day long!",
      "I would be like Jesus."
    ],
    "timestamps": {
      "chorus": 17.7887
    }
  },
  {
    "hymnNumber": 312,
    "reference": "SDAH312",
    "title": "Near the Cross",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Jesus, keep me near the cross;",
          "There a precious fountain",
          "Free to all, a healing stream,",
          "Flows from Calvary's mountain."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Near the cross, a trembling soul,",
          "Love and mercy found me;",
          "There the bright and Morning Star",
          "Sheds its beams around me."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Near the cross! O Lamb of God,",
          "Bring its scenes before me;",
          "Help me walk from day to day,",
          "With its shadows o'er me."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Near the cross I'll watch and wait,",
          "Hoping, trusting ever,",
          "Till I reach the golden strand,",
          "Just beyond the river."
        ]
      }
    ],
    "chorus": [
      "In the cross, in the cross,",
      "Be my glory ever,",
      "Till my raptured soul shall find",
      "Rest beyond the river."
    ],
    "timestamps": {
      "chorus": 19.7901
    }
  },
  {
    "hymnNumber": 313,
    "reference": "SDAH313",
    "title": "Just as I Am",
    "hasMidi": true,
    "numberOfVerses": 6,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Just as I am, without one plea,",
          "But that Thy blood was shed for me,",
          "And that Thou bid'st me come to Thee,",
          "O Lamb of God, I come."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Just as I am, and waiting not",
          "To rid my soul of one dark blot,",
          "To Thee whose blood can cleanse each spot,",
          "O Lamb of God, I come."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Just as I am, though tossed about",
          "With many a conflict, many a doubt;",
          "\"Fightings within, and fears without,\"",
          "O Lamb of God, I come."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Just as I am, poor, wretched, blind;",
          "Sight, riches, healing of the mind,",
          "Yea, all I need, in Thee I find,",
          "O Lamb of God, I come."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "Just as I am, Thou wilt receive,",
          "Wilt welcome, pardon, cleanse, relieve;",
          "Because Thy promise I believe,",
          "O Lamb of God, I come."
        ]
      },
      {
        "verseNumber": 6,
        "content": [
          "Just as I am, Thy love I own",
          "Has broken every barrier down;",
          "Now to be Thine, and Thine alone,",
          "O Lamb of God, I come."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 314,
    "reference": "SDAH314",
    "title": "Just as I Am",
    "hasMidi": true,
    "numberOfVerses": 1,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Just as I am, without one plea",
          "But that Thy blood was shed for me",
          "And that Thou bid'st me come to Thee",
          "O Lamb of God, I come, I come."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 315,
    "reference": "SDAH315",
    "title": "O for a Closer Walk!",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "O, for a closer walk with God!",
          "A calm and heavenly frame,",
          "A light to shine upon the road",
          "That leads me to the Lamb."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Return, O holy Dove! return,",
          "Sweet messenger of rest;",
          "I hate the sins that made Thee mourn,",
          "And drove Thee from my breast."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "What peaceful hours I once enjoyed!",
          "How sweet their memory still!",
          "But they have left an aching void",
          "The world can never till."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "The dearest idol I have known,",
          "Whate'er that idol be,",
          "Help me to tear it from Thy throne,",
          "And worship only Thee."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 316,
    "reference": "SDAH316",
    "title": "Live Out Thy Life Within Me",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Live out Thy life within me,",
          "O Jesus, King of kings!",
          "Be Thou Thyself the answer",
          "To all my questionings;",
          "Live out Thy life within me,",
          "In all things have Thy way!",
          "I, the transparent medium",
          "Thy glory to display."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "The temple has been yielded,",
          "And purified of sin;",
          "Let Thy Shekinah glory",
          "Now shine forth from within,",
          "And all the earth keep silence,",
          "The body henceforth be",
          "Thy silent, gentle servant,",
          "Moved only as by Thee."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Its members every moment",
          "Held subject to Thy call,",
          "Ready to have Thee use them,",
          "Or not be used at all;",
          "Held without restless longing,",
          "Or strain, or stress, or fret,",
          "Or chafings at Thy dealings,",
          "Or thoughts of vain regret."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "But restful, calm, and pliant,",
          "From bend and bias free,",
          "Awaiting Thy decision,",
          "When Thou hast need of me.",
          "Live out Thy life within me,",
          "O Jesus, King of kings!",
          "Be Thou the glorious answer",
          "To all my questionings."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 317,
    "reference": "SDAH317",
    "title": "Lead Me to Calvary",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "King of my life, I crown Thee now,",
          "Thine shall the glory be;",
          "Lest I forget Thy thorn-crowned brow,",
          "Lead me to Calvary."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Show me the tomb where Thou wast laid,",
          "Tenderly mourned and wept;",
          "Angels in robes of light arrayed",
          "Guarded Thee whilst Thou slept."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Let me like Mary, thru the gloom,",
          "Come with a gift to Thee;",
          "Show to me now the empty tomb,",
          "Lead me to Calvary."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "May I be willing, Lord, to bear",
          "Daily my cross for Thee;",
          "Even Thy cup of grief to share,",
          "Thou hast borne all for me."
        ]
      }
    ],
    "chorus": [
      "Lest I forget Gethsemane;",
      "Lest I forget Thine agony;",
      "Lest I forget Thy love for me,",
      "Lead me to Calvary."
    ],
    "timestamps": {
      "chorus": 21.2181
    }
  },
  {
    "hymnNumber": 318,
    "reference": "SDAH318",
    "title": "Whiter Than Snow",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Lord Jesus, I long to be perfectly whole;",
          "I want Thee forever to live in my soul;",
          "Break down every idol, cast out every foe;",
          "Now wash me, and I shall be whiter than snow."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Lord Jesus, look down from Thy throne in the skies,",
          "And help me to make a complete sacrifice;",
          "I give up myself, and whatever I know,",
          "Now wash me, and I shall be whiter than snow."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Lord Jesus, for this I most humbly entreat;",
          "I wait, blessed Lord, at Thy crucified feet,",
          "By faith, for my cleansing; I see Thy blood flow,",
          "Now wash me, and I shall be whiter than snow."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Lord Jesus, Thou seest I patiently wait;",
          "Come now, and within me a new heart create;",
          "To those who have sought Thee, Thou never said'st No;",
          "Now wash me, and I shall be whiter than snow."
        ]
      }
    ],
    "chorus": [
      "Whiter than snow, yes whiter than snow;",
      "Now wash me, and I shall be whiter than snow."
    ],
    "timestamps": {
      "chorus": 29.4572
    }
  },
  {
    "hymnNumber": 319,
    "reference": "SDAH319",
    "title": "Lord, I Want to Be a Christian",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Lord, I want to be a Christian",
          "In my heart, in my heart;",
          "Lord, I want to be a Christian",
          "In my heart.",
          "In my heart (In my heart),",
          "In my heart (In my heart),",
          "Lord, I want to be a Christian",
          "In my heart."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Lord, I want to be more loving",
          "In my heart, in my heart;",
          "Lord, I want to be more loving",
          "In my heart.",
          "In my heart,",
          "In my heart,",
          "Lord, I want to be more loving",
          "In my heart."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Lord, I want to be more holy",
          "In my heart, in my heart;",
          "Lord, I want to be more holy",
          "In my heart.",
          "In my heart,",
          "In my heart,",
          "Lord, I want to be more holy",
          "In my heart."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Lord, I want to be like Jesus",
          "In my heart, in my heart;",
          "Lord, I want to be like Jesus",
          "In my heart.",
          "In my heart,",
          "In my heart,",
          "Lord, I want to be like Jesus",
          "In my heart."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 320,
    "reference": "SDAH320",
    "title": "Lord of Creation",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Lord of creation, to You be all praise!",
          "Most mighty Your working, most wondrous Your ways!",
          "Your glory and might are beyond us to tell,",
          "And yet in the heart of the humble You dwell."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Lord of all power, I give You my will,",
          "In joyful obedience Your tasks to fulfill.",
          "Your bondage is freedom; Your service is song;",
          "And held in Your keeping, my weakness is strong."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Lord of all wisdom, I give You my mind,",
          "Rich truth that surpasses man's knowledge to find;",
          "What eye has not seen and what ear has not heard",
          "Is taught by Your Spirit and shines from Your Word."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Lord of all being, I give You my all;",
          "If I ever disown You, I stumble and fall;",
          "But led in Your service Your word to obey,",
          "I'll walk in Your freedom to the end of the way."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 321,
    "reference": "SDAH321",
    "title": "My Jesus, I Love Thee",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "My Jesus, I love Thee, I know Thou art mine;",
          "For Thee all the follies of sin I resign;",
          "My gracious Redeemer, my Savior art Thou;",
          "If ever I loved Thee, my Jesus, 'tis now."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "I love Thee because Thou hast first loved me,",
          "And purchased my pardon on Calvary's tree;",
          "I love Thee for wearing the thorns on Thy brow;",
          "If ever I loved Thee, my Jesus, 'tis now."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "I'll love Thee in life, I will love Thee 'til death,",
          "And praise Thee as long as Thou lendest me breath;",
          "And say when the death dew lies cold on my brow,",
          "If ever I loved Thee, my Jesus, 'tis now."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "In mansions of glory and endless delight,",
          "I'll ever adore Thee in heaven so bright;",
          "I'll sing with the glittering crown on my brow,",
          "If ever I loved Thee, my Jesus, 'tis now."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 322,
    "reference": "SDAH322",
    "title": "Nothing Between",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Nothing between my soul and the Savior,",
          "Naught of this world's delusive dream:",
          "I have renounced all sinful pleasure-",
          "Jesus is mine!",
          "There's nothing between."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Nothing between, like worldly pleasure:",
          "Habits of life, though harmless they seem,",
          "Must not my heart from Him ever sever-",
          "He is my all!",
          "There's nothing between."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Nothing between, e'en many hard trials,",
          "Though the whole world against me convene;",
          "Watching with prayer and much self-denial-",
          "Triumph at last,",
          "With nothing between!"
        ]
      }
    ],
    "chorus": [
      "Nothing between my soul and the Savior,",
      "So that His blessed face may be seen;",
      "Nothing preventing the least of His favor:",
      "Keep the way clear!",
      "Let nothing between."
    ],
    "timestamps": {
      "chorus": 26.706
    }
  },
  {
    "hymnNumber": 323,
    "reference": "SDAH323",
    "title": "O for a Heart to Praise My God!",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "O for a heart to praise my God!",
          "A heart from sin set free,",
          "A heart that always feels Thy blood,",
          "So freely shed for me."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "A heart resigned, submissive, meek,",
          "My dear Redeemer's throne,",
          "Where only Christ is heard to speak,",
          "Where Jesus reigns alone."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "A heart in every thought renewed,",
          "And full of love divine,",
          "Perfect, and right, and pure, and good,",
          "A copy, Lord, of Thine."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Thy nature, gracious Lord, impart;",
          "Come quickly from above;",
          "Write Thy new name upon my heart,",
          "Thy new, best name of Love."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 324,
    "reference": "SDAH324",
    "title": "Just as I Am, Thine Own to Be",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Just as I am, Thine own to be,",
          "Friend of the young, who lovest me,",
          "To consecrate myself to Thee,",
          "O Jesus Christ, I come."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "In the glad morning of my day,",
          "My life to give, my vows to pay,",
          "With no reserve and no delay,",
          "With all my heart I come."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "I would live ever in the light;",
          "I would work ever for the right;",
          "I would serve Thee with all my might;",
          "Therefore, to Thee I come."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Just as I am, young, strong, and free,",
          "To be the best that I can be",
          "For truth, and righteousness, and Thee,",
          "Lord of my life, I come."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 325,
    "reference": "SDAH325",
    "title": "Jesus, I My Cross Have Taken",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Jesus, I my cross have taken,",
          "All to leave and follow Thee;",
          "All things else I have forsaken;",
          "Thou from hence my all shalt be.",
          "Perish every fond ambition,",
          "All I've sought, or hoped, or known;",
          "Yet how rich is my condition,",
          "While I prove the Lord my own."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Let the world despise and leave me;",
          "They have left my Savior, too;",
          "Human hearts and looks deceive me;",
          "Thou art faithful, Thou art true.",
          "O, 'tis not in grief to harm me,",
          "While Thy love is left to me;",
          "O, 'twere not in joy to charm me,",
          "If that love be hid from me."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Soul, then know thy full salvation;",
          "Rise o'er sin, and fear, and care;",
          "Joy to find in every station",
          "Something still to do or bear.",
          "Think what Spirit dwells within thee;",
          "Think what Father's smiles are thine;",
          "Think that Jesus died to win thee;",
          "Child of Heaven, canst thou repine?"
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Haste thee on from grace to glory,",
          "Armed by faith and winged by prayer;",
          "Heaven's eternal day's before thee;",
          "God's own hand shall guide thee there.",
          "Soon shall close thy earthly mission,",
          "Soon shall pass thy pilgrim days;",
          "Hope shall change to glad fruition,",
          "Faith to sight, and prayer to praise."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 326,
    "reference": "SDAH326",
    "title": "Open My Eyes That I May See",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Open my eyes, that I may see",
          "Glimpses of truth Thou hast for me;",
          "Place in my hands the wonderful key",
          "That shall unclasp and set me free."
        ],
        "chorus": [
          "Silently now I wait for Thee,",
          "Ready, my God, Thy will to see;",
          "Open my eyes, illumine me,",
          "Spirit divine!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Open my ears, that I may hear",
          "Voices of truth Thou sendest clear;",
          "And while the wave-notes fall on my ear,",
          "Everything false will disappear."
        ],
        "chorus": [
          "Silently now I wait for Thee,",
          "Ready, my God, Thy will to see;",
          "Open my ears, illumine me,",
          "Spirit divine!"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Open my mouth, and let me bear",
          "Gladly the warm truth ev'rywhere;",
          "Open my heart, and let me prepare",
          "Love with Thy children thus to share."
        ],
        "chorus": [
          "Silently now I wait for Thee,",
          "Ready, my God, Thy will to see;",
          "Open my heart, illumine me,",
          "Spirit divine!"
        ]
      }
    ],
    "chorus": [
      "Silently now I wait for Thee,",
      "Ready, my God, Thy will to see;",
      "Open my eyes, illumine me,",
      "Spirit divine!"
    ],
    "timestamps": {
      "chorus": 22.9709
    }
  },
  {
    "hymnNumber": 327,
    "reference": "SDAH327",
    "title": "I'd Rather Have Jesus",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "I'd rather have Jesus than silver or gold,",
          "I'd rather be His than have riches untold;",
          "I'd rather have Jesus than houses or lands,",
          "I'd rather be led by His nail-pierced hand."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "I'd rather have Jesus than men's applause,",
          "I'd rather be faithful to His dear cause;",
          "I'd rather have Jesus than worldwide fame,",
          "I'd rather be true to His holy name."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "He's fairer than lilies of rarest bloom,",
          "He's sweeter than honey from out the comb;",
          "He's all that my hungering spirit needs,",
          "I'd rather have Jesus and let Him lead."
        ]
      }
    ],
    "chorus": [
      "Than to be the king of a vast domain",
      "Or be held in sin's dread sway;",
      "I'd rather have Jesus than anything",
      "This world affords today."
    ],
    "timestamps": {
      "chorus": 28.6508
    }
  },
  {
    "hymnNumber": 328,
    "reference": "SDAH328",
    "title": "Must Jesus Bear the Cross Alone",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Must Jesus bear the cross alone,",
          "And all the world go free?",
          "No, there's a cross for every one,",
          "And there's a cross for me."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "The consecrated cross I'll bear,",
          "Till He shall set me free;",
          "And then go home my crown to wear,",
          "For there's a crown for me."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Upon the crystal pavement, down",
          "At Jesus' pierced feet,",
          "With joy I'll cast my golden crown,",
          "And His dear name repeat."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 329,
    "reference": "SDAH329",
    "title": "Take the World, but Give Me Jesus",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Take the world, but give me Jesus;",
          "All its joys are but a name,",
          "But His love abideth ever,",
          "Through eternal years the same."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Take the world, but give me Jesus,",
          "Sweetest comfort of my soul;",
          "With my Savior watching o'er me,",
          "I can sing, though billows roll."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Take the world, but give me Jesus;",
          "Let me view His constant smile;",
          "Then throughout my pilgrim journey",
          "Light will cheer me all the while."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Take the world, but give me Jesus;",
          "In His cross my trust shall be,",
          "Till, with clearer, brighter vision,",
          "Face to face my Lord I see."
        ]
      }
    ],
    "chorus": [
      "Oh, the height and depth of mercy!",
      "Oh, the length and breadth of love!",
      "Oh, the fullness of redemption,",
      "Pledge of endless life above."
    ],
    "timestamps": {
      "chorus": 15.4806
    }
  },
  {
    "hymnNumber": 330,
    "reference": "SDAH330",
    "title": "Take My Life and Let It Be",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Take my life, and let it be",
          "Consecrated, Lord, to Thee;",
          "Take my hands, and let them move",
          "At the impulse of Thy love,",
          "At the impulse of Thy love."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Take my feet, and let them be",
          "Swift and beautiful for Thee;",
          "Take my voice, and let me sing",
          "Always, only, for my King,",
          "Always, only, for my King."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Take my lips, and let them be",
          "Filled with messages from Thee;",
          "Take my silver and my gold,",
          "Not a mite would I withhold,",
          "Not a mite would I withhold."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Take my will and make it Thine;",
          "It shall be no longer mine;",
          "Take my heart, it is Thine own!",
          "It shall be Thy royal throne,",
          "It shall be Thy royal throne."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "Take my love; my Lord, I pour",
          "At Thy feet its treasure store;",
          "Take myself, and I will be,",
          "Ever, only, all for Thee,",
          "Ever, only; all for Thee."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 331,
    "reference": "SDAH331",
    "title": "O Jesus I Have Promised",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "O Jesus, I have promised to serve thee to the end;",
          "be thou forever near me, my Master and my friend.",
          "I shall not fear the battle if thou art by my side,",
          "nor wander from the pathway if thou wilt be my guide."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "O let me feel thee near me! The world is ever near;",
          "I see the sights that dazzle, the tempting sounds I hear;",
          "my foes are ever near me, around me and within;",
          "but Jesus, draw thou nearer, and shield my soul from sin."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "O Jesus, thou hast promised to all who follow thee",
          "that where thou art in glory there shall thy servant be.",
          "And Jesus, I have promised to serve thee to the end;",
          "O give me grace to follow, my Master and my Friend."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 332,
    "reference": "SDAH332",
    "title": "The Cleansing Wave",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "O now I see the crimson wave,",
          "The fountain deep and wide;",
          "Jesus, my Lord, mighty to save,",
          "Points to His wounded side."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "I see the new creation rise,",
          "I hear the speaking blood;",
          "It speaks; polluted nature dies,",
          "Sinks 'neath the cleansing flood."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "I rise to walk in heaven's own light,",
          "Above the world and sin;",
          "With heart made pure and garments white,",
          "And Christ enthroned within."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Amazing grace! 'tis heaven below",
          "To feel the blood applied,",
          "And Jesus, only Jesus, know,",
          "My Jesus crucified."
        ]
      }
    ],
    "chorus": [
      "The cleansing stream I see, I see,",
      "I plunge, and O, it cleanseth me!",
      "O praise the Lord! it cleanseth me,",
      "It cleanseth me, yes, cleanseth me."
    ],
    "timestamps": {
      "chorus": 16.601
    }
  },
  {
    "hymnNumber": 333,
    "reference": "SDAH333",
    "title": "On Jordan's Banks the Baptist's Cry",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "On Jordan's banks the Baptist's cry",
          "Announces that the Lord is nigh;",
          "Awake and hearken, for he brings",
          "Glad tidings of the King of kings!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Then cleansed be every life from sin;",
          "Make straight the way for God within,",
          "And let us all our hearts prepare",
          "For Christ to come and enter there."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "We hail You as our Savior, Lord,",
          "Our refuge and our great reward;",
          "Without Your grace we waste away",
          "Like flow'rs that wither and decay."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Stretch forth Your hand, our health restore,",
          "And make us rise to fall no more;",
          "Oh, let Your face upon us shine",
          "And fill the world with love divine."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 334,
    "reference": "SDAH334",
    "title": "Come, Thou Fount of Every Blessing",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Come, Thou Fount of every blessing,",
          "Tune my heart to sing Thy grace;",
          "Streams of mercy, never ceasing,",
          "Call for songs of loudest praise.",
          "Teach me ever to adore Thee,",
          "May I still Thy goodness prove,",
          "While the hope of endless glory",
          "Fills my heart with joy and love."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Here I raise my Ebenezer,",
          "Hither by Thy help I've come,",
          "And I hope by Thy good pleasure",
          "Safely to arrive at home.",
          "Jesus sought me when a stranger,",
          "Wandering from the fold of God;",
          "He to rescue me from danger",
          "Interposed His precious blood."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "O, to grace how great a debtor",
          "Daily I'm constrained to be!",
          "Let Thy goodness, like a fetter,",
          "Bind me closer still to Thee.",
          "Prone to wander, Lord, I feel it,",
          "Prone to leave the God I love;",
          "Here's my heart O, take and seal it;",
          "Seal it for Thy courts above."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 335,
    "reference": "SDAH335",
    "title": "What a Wonderful Savior",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Christ has for sin atonement made,",
          "What a wonderful Savior!",
          "We are redeemed! the price is paid!",
          "What a wonderful Savior!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "I praise Him for the cleansing blood,",
          "What a wonderful Savior!",
          "That reconciled my soul to God;",
          "What a wonderful Savior!"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "He walks beside me all the way,",
          "What a wonderful Savior!",
          "And keeps me faithful day by day;",
          "What a wonderful Savior!"
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "He gives me overcoming power,",
          "What a wonderful Savior!",
          "And triumph in each trying hour;",
          "What a wonderful Savior!"
        ]
      }
    ],
    "chorus": [
      "What a wonderful Savior is Jesus, my Jesus!",
      "What a wonderful Savior is Jesus, my Lord!"
    ],
    "timestamps": {
      "chorus": 19.0157
    }
  },
  {
    "hymnNumber": 336,
    "reference": "SDAH336",
    "title": "There Is a Fountain",
    "hasMidi": true,
    "numberOfVerses": 6,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "There is a fountain filled with blood,",
          "Drawn from Immanuel's veins;",
          "And sinners plunged beneath that flood,",
          "Lose all their guilty stains",
          "Lose all their guilty stains,",
          "Lose all their guilty stains;",
          "And sinners plunged beneath that flood,",
          "Lose all their guilty stains."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "The dying thief rejoiced to see",
          "That fountain in his day;",
          "And there may I, though vile as he,",
          "Wash all my sins away,",
          "Wash all my sins away,",
          "Wash all my sins away;",
          "And there may I, though vile as he,",
          "Wash all my sins away."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Thou dying Lamb! Thy precious blood",
          "Shall never lose its power",
          "Till all the ransomed church of God",
          "Are saved, to sin no more,",
          "Are saved, to sin no more,",
          "Are saved, to sin no more;",
          "Till all the ransomed church of God",
          "Are saved, to sin no more."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "E'er since by faith I saw the stream",
          "Thy flowing wounds supply,",
          "Redeeming love has been my theme,",
          "And shall be till I die,",
          "And shall be till I die,",
          "And shall be till I die;",
          "Redeeming love has been my theme,",
          "And shall be till I die."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "Lord, I believe Thou hast prepared,",
          "Unworthy though I be,",
          "For me a blood-bought, free reward,",
          "A golden harp for me!",
          "A golden harp for me!",
          "A golden harp for me!",
          "For me a blood-bought, free reward,",
          "A golden harp for me!"
        ]
      },
      {
        "verseNumber": 6,
        "content": [
          "There in a nobler, sweeter song,",
          "I'll sing Thy power to save,",
          "When this poor lisping, stammering tongue",
          "Is ransomed from the grave,",
          "Is ransomed from the grave,",
          "Is ransomed from the grave;",
          "When this poor lisping, stammering tongue",
          "Is ransomed from the grave."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 337,
    "reference": "SDAH337",
    "title": "Redeemed!",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Redeemed! how I love to proclaim it!",
          "Redeemed by the blood of the Lamb;",
          "Redeemed through His infinite mercy,",
          "His child, and forever, I am."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Redeemed! and so happy in Jesus!",
          "No language my rapture can tell;",
          "I know that the light of His presence",
          "With me doth continually dwell."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "I know there's a crown that is waiting",
          "In yonder bright mansion for me;",
          "And soon, with the saints made perfect,",
          "At home with the Lord I shall be."
        ]
      }
    ],
    "chorus": [
      "Redeemed, redeemed,",
      "Redeemed by the blood of the Lamb;",
      "Redeemed, redeemed,",
      "His child, and forever, I am."
    ],
    "timestamps": {
      "chorus": 18.2654
    }
  },
  {
    "hymnNumber": 338,
    "reference": "SDAH338",
    "title": "Redeemed",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Redeemed, how I love to proclaim it!",
          "Redeemed by the blood of the Lamb;",
          "Redeemed thro' His infinite mercy,",
          "His child, and forever, I am."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "I think of my blessed Redeemer,",
          "I think of Him all the day long;",
          "I sing, for I cannot be silent;",
          "His love is the theme of my song."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "I know I shall see in His beauty",
          "The King in whose law I delight,",
          "Who lovingly guardeth my footsteps,",
          "And giveth me songs in the night."
        ]
      }
    ],
    "chorus": [
      "Redeemed, redeemed,",
      "Redeemed by the blood of the Lamb;",
      "Redeemed, how I love to proclaim it!",
      "His child and forever I am."
    ],
    "timestamps": {
      "chorus": 19.3619
    }
  },
  {
    "hymnNumber": 339,
    "reference": "SDAH339",
    "title": "God Is My Strong Salvation",
    "hasMidi": true,
    "numberOfVerses": 2,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "God is my strong salvation,",
          "What foe have I to fear?",
          "In darkness and temptation,",
          "My Light, my Help, is near:",
          "Though hosts encamp around me,",
          "Firm in the fight I stand;",
          "What terror can confound me,",
          "With God at my right hand?"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Place on the Lord reliance;",
          "My soul with courage wait;",
          "His truth be thine affiance,",
          "When faint and desolate.",
          "His might thy heart shall strengthen,",
          "His love thy joy increase;",
          "Mercy thy days shall lengthen;",
          "The Lord will give thee peace."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 340,
    "reference": "SDAH340",
    "title": "Jesus Saves",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "We have heard a joyful sound,",
          "Jesus saves, Jesus saves;",
          "Spread the gladness all around,",
          "Jesus saves, Jesus saves;",
          "Bear the news to every land,",
          "Climb the steeps and cross the waves,",
          "Onward, 'tis our Lord's command,",
          "Jesus saves, Jesus saves."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Waft it on the rolling tide,",
          "Jesus saves, Jesus saves;",
          "Tell to sinners, far and wide,",
          "Jesus saves, Jesus saves;",
          "Sing, ye islands of the sea.",
          "Echo back, ye ocean caves,",
          "Earth shall keep her jubilee,",
          "Jesus saves, Jesus saves."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Sing above the battle's strife,",
          "Jesus saves, Jesus saves;",
          "By His death and endless life,",
          "Jesus saves, Jesus saves;",
          "Sing it softly through the gloom,",
          "When the heart for mercy craves,",
          "Sing in triumph o'er the tomb,",
          "Jesus saves, Jesus saves."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Give the winds a mighty voice,",
          "Jesus saves, Jesus saves;",
          "Let the nations now rejoice,",
          "Jesus saves, Jesus saves;",
          "Shout salvation full and free,",
          "Highest hills and deepest caves,",
          "This our song of victory,",
          "Jesus saves, Jesus saves."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 341,
    "reference": "SDAH341",
    "title": "To God Be the Glory",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "To God be the glory, great things He hath done;",
          "So loved He the world that He gave us His Son,",
          "Who yielded His life an atonement for sin,",
          "And opened the life gate that all may go in."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "O perfect redemption, the purchase of blood,",
          "To every believer the promise of God;",
          "The vilest offender who truly believes,",
          "That moment from Jesus a pardon receives."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Great things He hath taught us, great things He hath done,",
          "And great our rejoicing through Jesus the Son;",
          "But purer, and higher, and greater will be",
          "Our wonder, our transport, when Jesus we see."
        ]
      }
    ],
    "chorus": [
      "Praise the Lord, praise the Lord,",
      "Let the earth hear His voice;",
      "Praise the Lord, praise, the Lord,",
      "Let the people rejoice;",
      "O come to the Father, through Jesus the Son,",
      "And give Him the glory, great things He hath done."
    ],
    "timestamps": {
      "chorus": 26.8304
    }
  },
  {
    "hymnNumber": 342,
    "reference": "SDAH342",
    "title": "Is This A Day of New Beginnings",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Is this a day of new beginnings,",
          "Time to remember and move on,",
          "Time to believe what love is bringing,",
          "Laying to rest the pain that's gone?"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "How can the seasons of a planet",
          "Mindlessly spinning round its sun",
          "With just a human name and number",
          "Say that some new thing has begun?"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Yet thro' the life and death of Jesus",
          "Love's mighty Spirit, now as then,",
          "Can make for us a world of difference",
          "As faith and hope are born again."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Then let us, with the Spirit's daring,",
          "Step from the past and leave behind",
          "Its disappointment, guilt, and grieving,",
          "Seeking new paths, and sure to find."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "Christ is alive, and goes before us",
          "To show and share what love can do.",
          "This is a day of new beginnings;",
          "Our God is making all things new."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 343,
    "reference": "SDAH343",
    "title": "I Will Sing of My Redeemer",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "I will sing of my Redeemer,",
          "And His wondrous love to me;",
          "On the cruel cross He suffered",
          "From the curse to set me free."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "I will tell the wondrous story,",
          "How my lost estate to save,",
          "In His boundless love and mercy,",
          "He the ransom freely gave."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "I will sing of my Redeemer,",
          "And His heav'nly love to me;",
          "He from death to life hath brought me,",
          "Son of God, with Him to be."
        ]
      }
    ],
    "chorus": [
      "Sing, Oh, sing of my Redeemer,",
      "With His blood He purchased me;",
      "On the cross He sealed my pardon,",
      "Paid the debt and made me free."
    ],
    "timestamps": {
      "chorus": 24.1797
    }
  },
  {
    "hymnNumber": 344,
    "reference": "SDAH344",
    "title": "I Love Your Kingdom, Lord",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "I love Your kingdom, Lord,",
          "The house of Your abode,",
          "The Church our blest Redeemer saved",
          "With His own precious blood."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "I love Your Church, O God!",
          "Her walls before Thee stand",
          "Dear as the apple of Thine eye,",
          "And graven on Thy hand."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Beyond my highest joy",
          "I prize its heavenly ways,",
          "Its sweet communion, solemn vows,",
          "Its hymns of love and praise."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Sure as Your truth shall last,",
          "To Zion shall be given",
          "The brightest glories earth can yield,",
          "And brighter bliss of heaven."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 345,
    "reference": "SDAH345",
    "title": "Christ Is the World's True Light",
    "hasMidi": true,
    "numberOfVerses": 2,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Christ is the world's true light,",
          "Its captain of salvation",
          "The daystar clear and bright",
          "Of every man and nation;",
          "New life, new hope awakes",
          "Where'er men own His sway:",
          "Freedom her bondage breaks,",
          "And night is turned to day."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "In Christ all races meet,",
          "Their ancient feuds forgetting,",
          "The whole round world complete,",
          "From sunrise to its setting:",
          "When Christ is throned as Lord,",
          "Men shall forsake their fear,",
          "To plowshare beat the sword,",
          "To pruning hook the spear."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "One Lord, in one great name",
          "Unite us all who own Thee,",
          "Cast out our pride and shame",
          "That hinder to enthrone Thee;",
          "The world has waited long,",
          "Has travailed long in pain,",
          "To heal its ancient wrong,",
          "Come, Prince of Peace, and reign."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 346,
    "reference": "SDAH346",
    "title": "Lord Who Dost Give to Thy Church",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Lord, who dost give to Thy church for its healing",
          "Gifts, and the grace to sustain and renew,",
          "Hear as we pray that today and each morrow",
          "We to Thy purpose may show ourselves true."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Clear be the voices of preachers and prophets",
          "Fearlessly speaking the word of the Lord,",
          "Word of redemption thro' God's Son incarnate,",
          "Blessing for cursing, and peace for the sword."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Tender and wise be the hearts of the pastors,",
          "Guiding and guarding the souls in their care,",
          "Firm with the wayward, a strength to the doubting,",
          "Helping the needy their burdens to bear."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "May those who teach grow in knowledge and patience,",
          "Guiding to wisdom the young and the old,",
          "Training for worship and witness and service,",
          "Foes to all falsehood, in truthfulness bold."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "Lord, ever give to us gifts in due measure,",
          "Each needing other, and all having worth;",
          "So to the Father, the Son, and the Spirit,",
          "Glory be shown by the church here on earth."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 347,
    "reference": "SDAH347",
    "title": "Built On the Rock",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Built on the Rock the Church shall stand,",
          "Even when steeples are falling;",
          "Crumbled have spires in every land,",
          "Bells still are chiming and calling-",
          "Calling the young and old to rest,",
          "Calling the souls of those distressed,",
          "Longing for life everlasting."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Not in our temples made with hands",
          "God, the Almighty, is dwelling;",
          "High in the heav'ns His temple stands,",
          "All earthly temples excelling.",
          "Yet He who dwells in heav'n above",
          "Deigns to abide with us in love,",
          "Making our bodies His temple."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "We are God's house of living stones,",
          "Built for His own habitation;",
          "He fills our hearts, His humble thrones,",
          "Granting us life and salvation.",
          "Were two or three to seek His face,",
          "He in their midst would show His grace,",
          "Blessings upon them bestowing."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Yet in this house, an earthly frame,",
          "Jesus His children is blessing;",
          "Hither we come to praise His name,",
          "Faith in our Savior confessing.",
          "Jesus to us His Spirit sent,",
          "Making with us His covenant,",
          "Granting His children the kingdom."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "Thro' all the passing years, O Lord,",
          "Grant that, when church bells are ringing,",
          "Many may come to hear God's Word",
          "Where He this promise is bringing:",
          "I know My own, My own know Me:",
          "You, not the world, My face shall see;",
          "My peace I leave with you. Amen."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 348,
    "reference": "SDAH348",
    "title": "The Church Has One Foundation",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "The church has one foundation,",
          "'Tis Jesus Christ her Lord;",
          "She is His new creation,",
          "By water and the word;",
          "From heaven He came and sought her",
          "To be His holy bride;",
          "With His own blood He bought her,",
          "And for her life He died."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Elect from every nation,",
          "Yet one o'er all the earth,",
          "Her charter of salvation,",
          "One Lord, one faith, one birth;",
          "One holy name she blesses,",
          "Partakes one holy food,",
          "And to one hope she presses,",
          "With every grace endued."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Though with a scornful wonder,",
          "Men see her sore oppressed,",
          "Though foes would rend asunder",
          "The Rock where she doth rest,",
          "Yet saints their faith are keeping;",
          "Their cry goes up, \"How long?\"",
          "And soon the night of weeping",
          "Shall be the morn of song."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "'Mid toil and tribulation,",
          "And tumult of her war,",
          "She waits the consummation",
          "Of peace forevermore;",
          "Till with the vision glorious",
          "Her longing eyes are blest,",
          "And the great church victorious",
          "Shall be the church at rest."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 349,
    "reference": "SDAH349",
    "title": "God Is Love",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Here in Christ we gather, love of Christ our calling.",
          "Christ, our love, is with us, gladness be His greeting.",
          "Let us fear Him, yes, and love Him, God eternal.",
          "Loving Him, let each love Christ in all his brethren."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "When we Christians gather, members of one body,",
          "Let there be in us no discord but one spirit.",
          "Banished now be anger, strife, and every quarrel.",
          "Christ, our God, be always present here among us."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Grant us love's fulfillment, joy with all the blessed,",
          "When we see Your face, O Savior, in its glory.",
          "Shine on us, O purest Light of all creation,",
          "Be our bliss while endless ages sing Your praises."
        ]
      }
    ],
    "chorus": [
      "God is love, and where true love is",
      "God Himself is there."
    ]
  },
  {
    "hymnNumber": 350,
    "reference": "SDAH350",
    "title": "Blest Be the Tie That Binds",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Blest be the tie that binds",
          "Our hearts in Christian love!",
          "The fellowship of kindred minds",
          "Is like to that above."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Before our Father's throne",
          "We pour our ardent prayers;",
          "Our fears, our hopes, our aims are one,",
          "Our comforts, and our cares."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "We share our mutual woes,",
          "Our mutual burdens bear,",
          "And often for each other flows",
          "The sympathizing tear."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "When we asunder part,",
          "It gives us inward pain;",
          "But we shall still be joined in heart,",
          "And hope to meet again."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 351,
    "reference": "SDAH351",
    "title": "Thy Hand, O God Has Guided",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Thy hand, O God, has guided",
          "Thy flock from age to age;",
          "The wondrous tale is written",
          "Full clear on every page;",
          "Our fathers owned Thy goodness,",
          "And we their deeds record;",
          "And both of this bear witness,",
          "One Church, one faith, one Lord."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Thy heralds brought glad tidings",
          "To greatest as to least;",
          "They bade men rise and hasten",
          "To share the great King's feast:",
          "And this was all their teaching,",
          "In every deed and word,",
          "To all alike proclaiming",
          "One Church, one faith, one Lord."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "When shadows thick were falling,",
          "And all seemed sunk in night,",
          "Thou, Lord, did send Thy servants,",
          "Thy chosen sons of light.",
          "On them and on Thy people",
          "Thy plenteous grace was poured,",
          "And this was still their message:",
          "One Church, one faith, one Lord."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Thy mercy will not fail us,",
          "Nor leave Thy work undone;",
          "With Thy right hand to help us,",
          "The vict'ry shall be won;",
          "And then by men and angels",
          "Thy name shall be adored,",
          "And this shall be their anthem:",
          "One Church, one faith, one Lord."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 352,
    "reference": "SDAH352",
    "title": "This Is My Will",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "This is My will, My one command,",
          "That love should dwell among you all.",
          "This is My will that you should love",
          "As I have shown that I love you."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "No greater love a man can have",
          "Than that he die to save his friends.",
          "You are My friends if you obey",
          "What I command that you should do."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "You chose not Me, but I chose you",
          "That you should go and bear much fruit.",
          "I chose you out that you in Me",
          "Should bear much fruit that will abide."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "All that I ask My Father, dear,",
          "For My name's sake you shall receive.",
          "This is My will, My one command,",
          "That love should dwell in each, in all."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 353,
    "reference": "SDAH353",
    "title": "Father Help Your People",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Father, help Your people in this world to build",
          "Something of Your kingdom and to do Your will,",
          "Lead us to discover partnership in love;",
          "Bless our ways of sharing and our pride remove."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Lord of desk and altar, bind our lives in one,",
          "That in work and worship love may set the tone.",
          "Give us grace to listen, clarity of speech;",
          "Make us truly thankful for the gifts of each."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Holy is the setting of each room and yard,",
          "Lecture hall and kitchen, office, shop, and ward.",
          "Holy is the rhythm of our working hours;",
          "Hallow then our purpose, energy, and pow'rs."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Strengthen, Lord, for service hand and heart and brain;",
          "Help us good relations daily to maintain.",
          "Let the living presence of the servant Christ",
          "Heighten our devotion, make our life a feast."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 354,
    "reference": "SDAH354",
    "title": "Thy Love O God",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Thy love, O God, has all mankind created,",
          "And led Thy people to this present hour;",
          "In Christ we see life's glory consummated;",
          "Thy Spirit manifests His living power."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "From out the darkness of our hope's frustration,",
          "From all the broken idols of our pride,",
          "We turn to seek Thy truth's illumination,",
          "And find Thy mercy waiting at our side."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "In pity look upon Thy children's striving",
          "For life and freedom, peace and brotherhood,",
          "Till at the fullness of Thy truth arriving,",
          "We find in Christ the crown of every good."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Inspire Thy church, mid earth's discordant voices,",
          "To preach the gospel of her Lord above,",
          "Until the day this warring world rejoices",
          "To hear the mighty harmonies of love."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 355,
    "reference": "SDAH355",
    "title": "Where Cross the Crowded Ways of Life",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Where cross the crowded ways of life,",
          "Where sound the cries of race and clan,",
          "Above the noise of selfish strife,",
          "We hear Your voice, O Son of Man."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "From tender childhood's helplessness,",
          "From human grief and burdened toil,",
          "From famished souls, from sorrow's stress,",
          "Your heart has never known recoil."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "The cup of water giv'n for You",
          "Still holds the freshness of Your grace;",
          "Yet long these multitudes to view",
          "The strong compassion in Your face."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "O Master, from the mountainside",
          "Make haste to heal these hearts of pain;",
          "Among these restless throngs abide;",
          "O tread the city's streets again;"
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "Till all the world shall learn Your love,",
          "And follow where Your feet have trod;",
          "Till glorious from Your heav'n above,",
          "Shall come the city of our God."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 356,
    "reference": "SDAH356",
    "title": "All Who Love and Serve Youre City",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "All who love and serve your city,",
          "All who bear its daily stress,",
          "All who cry for peace and justice,",
          "All who curse and all who bless."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "In your day of loss and sorrow,",
          "In your day of helpless strife,",
          "Honor, peace, and love retreating,",
          "Seek the Lord, who is your life."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "For all days are days of judgment,",
          "And the Lord is waiting still,",
          "Drawing near His friends who spurn Him,",
          "Off'ring peace from Calv'ry's hill."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Risen Lord, shall yet the city",
          "Be the city of despair?",
          "Come today, our judge, our glory;",
          "Be its name \"The Lord is there!\""
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 357,
    "reference": "SDAH357",
    "title": "Come, Labor On",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Come, labor on.",
          "Who dares stand idle on the harvest plain",
          "While all around him waves the golden grain?",
          "And to each servant does the Master say,",
          "\"Go work today.\""
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Come, labor on.",
          "Claim the high calling angels cannot share;",
          "To young and old the gospel gladness bear;",
          "Redeem the time; its hours too swiftly fly.",
          "The night draws nigh."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Come, labor on.",
          "No time for rest; till glows the western sky,",
          "Till the long shadows o'er our pathway lie,",
          "And a glad sound comes with the setting sun,",
          "\"Well done, well done!\""
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 358,
    "reference": "SDAH358",
    "title": "Far and Near the Fields Are Teeming",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Far and near the fields are teeming",
          "With the sheaves of ripened grain;",
          "Far and near their gold is gleaming",
          "O'er the sunny slope and plain."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Send them forth with morn's first beaming,",
          "Send them in the noontide's glare;",
          "When the sun's last rays are streaming,",
          "Bid them gather everywhere."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "O thou, whom thy Lord is sending,",
          "Gather now the sheaves of gold;",
          "Heavenward then at evening wending",
          "Thou shalt come with joy untold."
        ]
      }
    ],
    "chorus": [
      "Lord of harvest, send forth reapers!",
      "Hear us, Lord, to Thee we cry;",
      "Send them now the sheaves to gather,",
      "Ere the harvest-time pass by."
    ],
    "timestamps": {
      "chorus": 20.6437
    }
  },
  {
    "hymnNumber": 359,
    "reference": "SDAH359",
    "title": "Hark! the Voice of Jesus Calling",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Hark! the voice of Jesus calling,",
          "\"Who will go and work today?",
          "Fields are white, the harvest waiting,",
          "Who will bear the sheaves away?\"",
          "Loud and long the Master calleth,",
          "Rich reward He offers free;",
          "Who will answer, gladly saying,",
          "\"Here am I, O Lord, send me\"?"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "If you cannot cross the ocean",
          "And the heathen lands explore,",
          "You can find the heathen nearer,",
          "You can help them at your door;",
          "If you cannot speak like angels,",
          "If you cannot preach like Paul,",
          "You can tell the love of Jesus,",
          "You can say He died for all."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "If you cannot be the watchman,",
          "Standing high on Zion's wall,",
          "Pointing out the path to heaven,",
          "Offering life and peace to all;",
          "With your prayers and with your bounties",
          "You can do what Heaven demands,",
          "You can be like faithful Aaron,",
          "Holding up the prophet's hands."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "While the souls of men are dying,",
          "And the Master calls for you,",
          "Let none hear you idly saying,",
          "\"There is nothing I can do!\"",
          "Gladly take the task He gives you,",
          "Let His work your pleasure be;",
          "Answer quickly when He calleth,",
          "\"Here am I, O Lord, send me.\""
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 360,
    "reference": "SDAH360",
    "title": "From the Eastern Mountains",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "From the eastern mountains",
          "Pressing on they come,",
          "Wise men in their wisdom,",
          "To His humble home;",
          "Stirred by deep devotion,",
          "Hasting from afar,",
          "Ever journeying onward,",
          "Guided by a star."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "There their Lord and Savior",
          "Meek and lowly lay,",
          "Wondrous light that led them",
          "Onward on their way,",
          "Ever now to lighten",
          "Nations from afar,",
          "As they journey homeward",
          "By that guiding star."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Gather in the outcasts",
          "All who've gone astray,",
          "Throw Thy radiance o'er them,",
          "Guide them on their way;",
          "Those who never knew Thee,",
          "Those who've wandered far,",
          "Guide them by the brightness",
          "Of Thy guiding star."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Until every nation,",
          "Whether bond or free,",
          "'Neath Thy starlit banner,",
          "Jesus follows thee.",
          "O'er the distant mountains",
          "To that heavenly home,",
          "Where no sin nor sorrow",
          "Evermore shall come."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 361,
    "reference": "SDAH361",
    "title": "Hark! 'Tis the Shepherd's Voice I Hear",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Hark! 'tis the Shepherd's voice I hear,",
          "Out in the desert dark and drear,",
          "Calling the sheep who've gone astray,",
          "Far from the Shepherd's fold away."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Who'll go and help the Shepherd kind,",
          "Help Him the wandering ones to find?",
          "Who'll bring them back into the fold,",
          "Where they'll be sheltered from the cold?"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Out in the desert hear their cry,",
          "Out on the mountain wild and high,",
          "Hark! 'tis the Master speaks to thee,",
          "\"Go, find My sheep where'er they be.\""
        ]
      }
    ],
    "chorus": [
      "Bring them in,",
      "Bring them in,",
      "Bring them in from the fields of sin,",
      "Bring them in,",
      "Bring them in,",
      "Bring the wanderers to Jesus."
    ],
    "timestamps": {
      "chorus": 20.5306
    }
  },
  {
    "hymnNumber": 362,
    "reference": "SDAH362",
    "title": "Lift High the Cross",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": true,
    "startsWithChorus": true,
    "timestamps": {
      "chorus": 18.2451
    },
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Come, Christians, follow where our Captain trod,",
          "Our King victorious, Christ, the Son of God."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Led on their way by this triumphant sign,",
          "The hosts of God in conqu'ring ranks combine."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "All newborn soldiers of the Crucified",
          "Bear on their brows the seal of Him who died."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "O Lord, once lifted on the glorious tree,",
          "As Thou hast promised, draw men unto Thee."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "So shall our song of triumph ever be:",
          "Praise to the Crucified for victory!"
        ]
      }
    ],
    "chorus": [
      "Lift high the Cross, the love of Christ proclaim,",
      "Till all the world adore His sacred name."
    ]
  },
  {
    "hymnNumber": 363,
    "reference": "SDAH363",
    "title": "Lord, Whose Love In Humble Service",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Lord, whose love in humble service",
          "Bore the weight of human need,",
          "Who upon the cross, forsaken,",
          "Worked Your mercy's perfect deed:",
          "We, Your servants, bring the worship",
          "Not of voice alone, but heart;",
          "Consecrating to Your purpose",
          "Every gift which You impart."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Still Your children wander homeless;",
          "Still the hungry cry for bread;",
          "Still the captives long for freedom;",
          "Still in grief we mourn our dead.",
          "As You, Lord, in deep compassion",
          "Healed the sick and freed the soul,",
          "By Your Spirit send Your power",
          "To our world to make it whole."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "As we worship, grant us vision,",
          "Till your love's revealing light",
          "In its height and depth and greatness",
          "Dawns upon our quickened sight,",
          "Making known the needs and burdens",
          "Your compassion bids us bear,",
          "Stirring us to ardent service,",
          "Your abundant life to share."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 364,
    "reference": "SDAH364",
    "title": "O Jesus Christ, to You",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "O Jesus Christ, to You may hymns be rising",
          "In every city for Your love and care;",
          "Inspire our worship, grant the glad surprising",
          "That Your blest Spirit brings men everywhere."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Grant us new courage, sacrificial, humble,",
          "Strong in Your strength to venture and to dare,",
          "To lift the fallen, guide the feet that stumble,",
          "Seek out the lonely and God's mercy share."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Show us Your Spirit, brooding o'er each city,",
          "As You did weep above Jerusalem,",
          "Seeking to gather all in love and pity,",
          "And healing those who touch Your garment's hem."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 365,
    "reference": "SDAH365",
    "title": "O Zion, Haste",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "O Zion, haste, thy mission high fulfilling,",
          "To tell to all the world that God is light;",
          "That He who made all nations is not willing",
          "One soul should perish, lost in shades of night."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Proclaim to every people, tongue, and nation",
          "That God, in whom they live and move, is love;",
          "Tell how He stooped to save His lost creation,",
          "And died on earth that man might live above."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Give of thy sons to bear the message glorious;",
          "Give of thy wealth to speed them on their way;",
          "Pour out thy soul for them in prayer victorious;",
          "And all thou spendest Jesus will repay."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "He comes again; O Zion, ere thou meet Him,",
          "Make known to every heart His saving grace;",
          "Let none whom He hath ransomed fail to greet Him,",
          "Through thy neglect, unfit to see His face."
        ]
      }
    ],
    "chorus": [
      "Publish glad tidings,",
      "Tidings of peace,",
      "Tidings of Jesus,",
      "Redemption and release."
    ],
    "timestamps": {
      "chorus": 25.7063
    }
  },
  {
    "hymnNumber": 366,
    "reference": "SDAH366",
    "title": "O Where Are the Reapers?",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "O where are the reapers that garner in",
          "The sheaves of the good from the fields of sin?",
          "With sickles of truth must the work be done,",
          "And no one may rest till the \"harvest home.\""
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "The fields all are ripening, and far and wide",
          "The world now is waiting the harvest tide:",
          "But reapers are few, and the work is great,",
          "And much will be lost should the harvest wait."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "So come with your sickles, ye sons of men,",
          "And gather together the golden grain;",
          "Toil on till the Lord of the harvest come,",
          "Then share ye His joy in the \"harvest home.\""
        ]
      }
    ],
    "chorus": [
      "Where are the reapers? O who will come",
      "And share in the glory of the \"harvest home\"?",
      "O who will help us to garner in",
      "The sheaves of good from the fields of sin?"
    ],
    "timestamps": {
      "chorus": 21.5896
    }
  },
  {
    "hymnNumber": 367,
    "reference": "SDAH367",
    "title": "Rescue the Perishing",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Rescue the perishing,",
          "Care for the dying;",
          "Snatch them in pity from sin and the grave;",
          "Weep o'er the erring one,",
          "Lift up the fallen,",
          "Tell them of Jesus, the mighty to save."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Though they are slighting Him,",
          "Still He is waiting,",
          "Waiting the penitent child to receive.",
          "Plead with them earnestly,",
          "Plead with them gently;",
          "He will forgive if they only believe."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Rescue the perishing,",
          "Duty demands it;",
          "Strength for thy labor the Lord will provide;",
          "Back to the narrow way",
          "Patiently win them;",
          "Tell the poor wanderer a Savior has died."
        ]
      }
    ],
    "chorus": [
      "Rescue the perishing,",
      "Care for the dying;",
      "Jesus is merciful,",
      "Jesus will save."
    ],
    "timestamps": {
      "chorus": 22.5893
    }
  },
  {
    "hymnNumber": 368,
    "reference": "SDAH368",
    "title": "Watchman, Blow the Gospel Trumpet",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Watchman, blow the gospel trumpet,",
          "Every soul a warning give;",
          "Whosoever hears the message",
          "May repent, and turn and live."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Sound it loud o'er every hilltop,",
          "Gloomy shade and sunny plain;",
          "Ocean depths repeat the message,",
          "Full salvation's glad refrain."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Sound it in the hedge and highway,",
          "Earth's dark spots where exiles roam;",
          "Let it tell all things are ready,",
          "Father waits to welcome home."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Sound it for the heavy laden,",
          "Weary, longing to be free;",
          "Sound a Savior's invitation,",
          "Sweetly saying, \"Come to me.\""
        ]
      }
    ],
    "chorus": [
      "Blow the trumpet, trusty watchman,",
      "Blow it loud o'er land and sea;",
      "God commissions, sound the message!",
      "Every captive may be free."
    ],
    "timestamps": {
      "chorus": 20.3436
    }
  },
  {
    "hymnNumber": 369,
    "reference": "SDAH369",
    "title": "Bringing in the Sheaves",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Sowing in the morning, sowing seeds of kindness,",
          "Sowing in the noontide and the dewy eve;",
          "Waiting for the harvest, and the time of reaping,",
          "We shall come rejoicing, bringing in the sheaves."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Sowing in the sunshine, sowing in the shadows,",
          "Fearing neither clouds nor winter's chilling breeze;",
          "By and by the harvest, and the labor ended,",
          "We shall come rejoicing, bringing in the sheaves."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Going forth with weeping, sowing for the Master,",
          "Though the loss sustained our spirit often grieves;",
          "When our weeping's over, He will bid us welcome,",
          "We shall come rejoicing, bringing in the sheaves."
        ]
      }
    ],
    "chorus": [
      "Bringing in the sheaves,",
      "Bringing in the sheaves,",
      "We shall come rejoicing,",
      "Bringing in the sheaves;",
      "Bringing in the sheaves,",
      "Bringing in the sheaves,",
      "We shall come rejoicing,",
      "Bringing in the sheaves."
    ],
    "timestamps": {
      "chorus": 21.4233
    }
  },
  {
    "hymnNumber": 370,
    "reference": "SDAH370",
    "title": "Christ for the World",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Christ for the world we sing;",
          "The world to Christ we bring",
          "With loving zeal;",
          "The poor and them that mourn,",
          "The faint and overborne,",
          "Sin-sick and sorrow-worn,",
          "Whom Christ doth heal."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Christ for the world we sing;",
          "The world to Christ we bring",
          "With fervent prayer;",
          "The wayward and the lost,",
          "By restless passions tossed,",
          "Redeemed at countless cost",
          "From dark despair."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Christ for the world we sing;",
          "The world to Christ we bring",
          "With joyful song;",
          "The newborn souls, whose days,",
          "Reclaimed from error's ways,",
          "Inspired with hope and praise,",
          "To Christ belong."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 371,
    "reference": "SDAH371",
    "title": "Lift Him Up",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Lift Him up, 'tis He that bids you,",
          "Let the dying look and live;",
          "To all weary, thirsting sinners,",
          "Living waters will He give;",
          "And though once so meek and lowly,",
          "Yet the Prince of heaven was He;",
          "And the blind, who grope in darkness,",
          "Through the blood of Christ shall see."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Lift Him up, this precious Savior,",
          "Let the multitude behold",
          "They with willing hearts shall seek Him,",
          "He will draw them to His fold;",
          "They shall gather from the wayside,",
          "Hastening on with joyous feet,",
          "They shall bear the cross of Jesus,",
          "And shall find salvation sweet."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Lift Him up in all His glory,",
          "'Tis the Son of God on high;",
          "Lift Him up, His love shall draw them,",
          "E'en the careless shall draw nigh;",
          "Let them hear again the story",
          "Of the cross, the death of shame;",
          "And from tongue to tongue repeat it;",
          "Mighty throngs shall bless His name."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "O then lift Him up in singing,",
          "Lift the Savior up in prayer;",
          "He, the glorious Redeemer,",
          "All the sins of men did bear,",
          "Yes, the young shall bow before Him,",
          "And the old their voices raise;",
          "All the deaf shall hear hosannah;",
          "And the dumb shall shout His praise."
        ]
      }
    ],
    "chorus": [
      "Lift Him up, the risen Savior,",
      "High amid the waiting throng;",
      "Lift Him up, 'tis He that speaketh,",
      "Now He bids you flee from wrong."
    ],
    "timestamps": {
      "chorus": 33.0575
    }
  },
  {
    "hymnNumber": 372,
    "reference": "SDAH372",
    "title": "How Beauteous Are Their Feet",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "How beauteous are their feet",
          "Who stand on Zion's hill;",
          "Who bring salvation on their tongues,",
          "And words of peace reveal!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "How charming is their voice,",
          "So sweet the tidings are:",
          "\"Zion, behold thy Savior King;",
          "He reigns and triumphs here!\""
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "How happy are our ears,",
          "That hear the joyful sound",
          "Which kings and prophets waited for,",
          "And sought, but never found!"
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "How blessed are our eyes,",
          "That see this heavenly light;",
          "Prophets and kings desired it long,",
          "But died without the sight!"
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "The watchmen join their voice,",
          "And tuneful notes employ;",
          "Jerusalem breaks forth in songs,",
          "And deserts learn the joy."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 373,
    "reference": "SDAH373",
    "title": "Seeking the Lost",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Seeking the lost; yes, kindly entreating",
          "Wanderers on the mountain astray;",
          "\"Come unto Me,\" His message repeating,",
          "Words of the Master speaking today."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Seeking the lost; and pointing to Jesus",
          "Souls that are weak and hearts that are sore,",
          "Leading them forth in ways of salvation,",
          "Showing the path to life evermore."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Thus I would go on missions of mercy,",
          "Following Christ from day unto day,",
          "Cheering the faint and raising the fallen,",
          "Pointing the lost to Jesus, the Way."
        ]
      }
    ],
    "chorus": [
      "Going afar upon the mountain,",
      "Bringing the wand'rer back again, back again,",
      "Into the fold of my Redeemer,",
      "Jesus, the Lamb for sinners slain, for sinners slain."
    ],
    "timestamps": {
      "chorus": 25.1252
    }
  },
  {
    "hymnNumber": 374,
    "reference": "SDAH374",
    "title": "Jesus, With Thy Church Abide",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Jesus, with Thy church abide;",
          "Be her Savior, Lord, and Guide,",
          "While on earth her faith is tried:",
          "We beseech Thee, hear us."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "May her voice be ever clear,",
          "Warning of a judgment near,",
          "Telling of a Savior dear:",
          "We beseech Thee, hear us."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "May she guide the poor and blind,",
          "Seek the lost until she find,",
          "And the broken-hearted bind:",
          "We beseech Thee, hear us."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "May she holy triumphs win,",
          "Overthrow the hosts of sin,",
          "Gather all the nations in:",
          "We beseech Thee, hear us."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 375,
    "reference": "SDAH375",
    "title": "Work, For the Night Is Coming",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Work, for the night is coming;",
          "Work through the morning hours;",
          "Work while the dew is sparkling;",
          "Work 'mid springing flowers;",
          "Work while the day grows brighter,",
          "Under the glowing sun;",
          "Work, for the night is coming,",
          "When man's work is done."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Work, for the night is coming;",
          "Work through the sunny noon;",
          "Fill brightest hours with labor,",
          "Rest comes sure and soon;",
          "Give every flying minute",
          "Something to keep in store;",
          "Work, for the night is coming,",
          "When man works no more."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Work, for the night is coming:",
          "Under the sunset skies,",
          "While their bright tints are glowing,",
          "Work for the daylight flies;",
          "Work till the last beam fadeth,",
          "Fadeth to shine no more;",
          "Work, for the Lord is coming,",
          "When man's work is o'er."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 376,
    "reference": "SDAH376",
    "title": "All Things Are Thine",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "All things are Thine; no gift have we,",
          "Lord of all gifts, to offer Thee;",
          "And hence with grateful hearts today,",
          "Thine own before Thy feet we lay."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Thy will was in the builder's thought;",
          "Thy hand unseen amidst us wrought;",
          "Thro' mortal motive, scheme and plan,",
          "Thy wise, eternal purpose ran."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "No lack Thy perfect fullness knew;",
          "For human needs and longings grew",
          "This house of prayer; this home of rest.",
          "Here may Thy saints be often blessed."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "In weakness and in want we call",
          "On Thee, for whom the heav'ns are small;",
          "Thy glory is Thy children's good,",
          "Thy joy Thy tender Fatherhood."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "O Father! deign these walls to bless;",
          "Make this the abode of righteousness,",
          "And let these doors a gateway be",
          "To lead us from ourselves to Thee!"
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 377,
    "reference": "SDAH377",
    "title": "Go Forth Go Forth With Christ",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Go forth, go forth with Christ,",
          "Who called you to this day,",
          "He who has led, will lead",
          "And keep you in His way:",
          "His word is fast, His promise sure",
          "To all who serve Him and endure."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Go forth, go forth with Christ,",
          "With purpose not your own,",
          "Each vict'ry you shall gain",
          "Through Him your Lord alone:",
          "To guard you in fidelity",
          "His Spirit shall your strength'ner be."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Go forth, go forth with Christ,",
          "His Priesthood you shall share,",
          "Who bought us by His blood",
          "To be His servants here:",
          "Walk in the way your Savior trod,",
          "Go forth with Him, go forth with God."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 378,
    "reference": "SDAH378",
    "title": "Go, Preach My Gospel",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "\"Go, preach My gospel,\" saith the Lord;",
          "\"Bid the whole world My grace receive;",
          "He shall be saved who trusts My word,",
          "And they condemned who disbelieve."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "\"I'll make your great commission known,",
          "And ye shall prove My gospel true",
          "By all the works that I have done,",
          "By all the wonders ye shall do."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "\"Teach all the nations My commands;",
          "I'm with you till the world shall end;",
          "All power is vested in My hands;",
          "I can destroy, and I defend.\""
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "He spake, and light shone round His head;",
          "On a brigh cloud to heaven He rode;",
          "They to the farthest nations spread",
          "The grace of their ascended Lord."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 379,
    "reference": "SDAH379",
    "title": "We Give This Child to You",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "We give this child to You,",
          "Our precious gift of love.",
          "Help us to lead each step aright",
          "With guidance from above."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "O bless each child of Yours,",
          "And grant when they are grown,",
          "They will have learned to love Your way,",
          "And choose it for their own."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "We give ourselves to You,",
          "And may Your Spirit fill",
          "Our hearts and home, that all we do",
          "Be subject to Your will."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 380,
    "reference": "SDAH380",
    "title": "Welcome, Day of Sweet Repose",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Welcome, day of sweet repose!",
          "Blessed be thy sacred hours!",
          "We would trust the One who knows",
          "All our weak and failing powers."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Welcome, day in Eden born!",
          "Holy rest for sinless man!",
          "Like the dawning of fair morn",
          "Come thy hours to us again."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Welcome, day blessed by our Lord!",
          "Toil shall cease and anxious care.",
          "Day commanded by His word,",
          "Day for song and praise and prayer."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Welcome, day our Savior kept!",
          "Keeping, wrought our righteousness,",
          "Day God bids us ne'er forget,",
          "Day of days His name to bless."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 381,
    "reference": "SDAH381",
    "title": "Holy Sabbath Day of Rest",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Holy Sabbath day of rest,",
          "By our Master richly blest,",
          "God-created and divine,",
          "Set aside for holy time."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Seek not pleasures of this earth,",
          "With its folly, noise, and mirth,",
          "There are better things in store,",
          "Over on the other shore."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "As the Sabbath draweth on",
          "Friday eve at set of sun,",
          "Christian household then should meet,",
          "Sing and pray at Jesus' feet,"
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Asking Him for saving grace,",
          "Also vict'ry in the race,",
          "And to help us by His pow'r,",
          "To keep holy every hour."
        ]
      }
    ],
    "chorus": [
      "Yes, the holy Sabbath rest,",
      "By our God divinely blest,",
      "It to us a sign shall be",
      "Throughout all eternity."
    ],
    "timestamps": {
      "chorus": 22.5421
    }
  },
  {
    "hymnNumber": 382,
    "reference": "SDAH382",
    "title": "O Day of Rest and Gladness",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "O day of rest and gladness,",
          "O day of joy and light,",
          "O balm of care and sadness,",
          "Most beautiful, most bright;",
          "On thee, the high and lowly,",
          "Who bend before the throne,",
          "Sing, holy, holy, holy,",
          "To the Eternal One."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Thou art a port protected",
          "From storms that round us rise,",
          "A garden intersected",
          "With streams of paradise;",
          "Thou art a cooling fountain",
          "In life's dry, dreary sand;",
          "From thee, like Pisgah's mountain,",
          "We view our promised land."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "A day of sweet reflection",
          "Thou art, a day of love;",
          "A day to raise affection",
          "From earth to things above.",
          "New graces ever gaining",
          "From this our day of rest",
          "We seek the rest remaining",
          "In mansions of the blest."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 383,
    "reference": "SDAH383",
    "title": "O Day of Rest and Gladness",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "O day of rest and gladness,",
          "O day of joy and light,",
          "O balm of care and sadness,",
          "Most beautiful, most bright;",
          "On thee, the high and lowly,",
          "Who bend before the throne,",
          "Sing, Holy, holy, holy,",
          "To the Eternal One."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Thou art a port protected",
          "From storms that round us rise,",
          "A garden intersected",
          "With streams of Paradise;",
          "Thou art a cooling fountain",
          "In life's dry, dreary sand;",
          "From thee, like Pisgah's mountain,",
          "We view our promised land."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "A day of sweet reflection",
          "Thou art, a day of love;",
          "A day to raise affection",
          "From earth to things above.",
          "New graces ever gaining",
          "From this our day of rest,",
          "We seek the rest remaining",
          "In mansions of the blest."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 384,
    "reference": "SDAH384",
    "title": "Safely Through Another Week",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Safely through another week",
          "God has brought us on our way;",
          "Let us now a blessing seek,",
          "Waiting in His courts today;",
          "Day of all the week the best,",
          "Emblem of eternal rest;",
          "Day of all the week the best,",
          "Emblem of eternal rest."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "While we seek supplies of grace",
          "Through the dear Redeemer's name,",
          "Show Thy reconciling face,",
          "Take away our sin and shame;",
          "From our worldly cares set free",
          "May we rest this day in Thee.",
          "From our worldly cares set free",
          "May we rest this day in Thee."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "When the morn shall bid us rise,",
          "May we feel Thy presence near,",
          "May Thy glory meet our eyes",
          "When we in Thy house appear;",
          "Here afford us, Lord, a taste",
          "Of our everlasting feast.",
          "Here afford us, Lord, a taste",
          "Of our everlasting feast."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "May the gospel's joyful sound",
          "Conquer sinners, comfort saints;",
          "Make the fruits of grace abound,",
          "Bring relief to all complaints;",
          "Thus may all our Sabbaths be",
          "Till we rise to reign with Thee.",
          "Thus may all our Sabbaths be",
          "Till we rise to reign with Thee."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 385,
    "reference": "SDAH385",
    "title": "Crowning Jewel of Creation",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Crowning jewel of creation,",
          "Blest and hallowed, sanctified;",
          "Time and changes all transcending,",
          "Shared forever, glorified."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Sin and sickness, prayer and weeping",
          "Cease at close of earthly days;",
          "But Thy Sabbath is eternal,",
          "Joyful thanks to Thee we raise!"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Teach us Lord, in storm or sunshine",
          "How to truly rest in Thee,",
          "May Thy Sabbath peace enfold us",
          "And our shelter ever be."
        ]
      }
    ],
    "chorus": [
      "Blessed Sabbath made for man,",
      "Gift from the Creator's hand."
    ],
    "timestamps": {
      "chorus": 21.6149
    }
  },
  {
    "hymnNumber": 386,
    "reference": "SDAH386",
    "title": "The Sacred Anthem",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "The sacred anthem slowly rang",
          "Across the fields of praise,",
          "When earth's first Sabbath made complete",
          "All creatures and all days.",
          "Walking with God, there,",
          "Woman and man together share",
          "The blessed Sabbath mood;",
          "And in that green and golden world",
          "Know all God's works are good."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "But now in our diminished lives",
          "We sing a blemished song;",
          "The earth is worn and disarrayed",
          "And all our work goes wrong.",
          "Still in our worship,",
          "Joining in praise and fellowship,",
          "By Sabbath radiance blessed,",
          "We put our doubt and fear away",
          "And rest within God's rest."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "And arching over time and space",
          "The Lord of Sabbaths wills",
          "Renewal for the weary earth",
          "And healing for our ills.",
          "Hearts will rejoice then;",
          "There will be no more weeping, when",
          "We know and shall be known.",
          "With hosts of the redeemed we'll sing",
          "Around God's shining throne."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 387,
    "reference": "SDAH387",
    "title": "Come O Sabbath Day",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Come, O Sabbath day, and bring",
          "Peace and healing on thy wing;",
          "And to every troubled breast",
          "Speak of the divine behest:",
          "Thou shalt rest, Thou shalt rest!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Earthly longings bid retire,",
          "Quench the passions' hurtful fire;",
          "To the wayward, sin oppressed,",
          "Bring thou thy divine behest:",
          "Thou shalt rest, Thou shalt rest!"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Wipe from every cheek the tear,",
          "Banish care and silence fear;",
          "All things working for the best,",
          "Teach us the divine behest:",
          "Thou shalt rest, Thou shalt rest!"
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 388,
    "reference": "SDAH388",
    "title": "Don't Forget the Sabbath",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Don't forget the Sabbath,",
          "The Lord our God hath blest,",
          "Of all the week the brightest,",
          "Of all the week the best;",
          "It brings repose from labor,",
          "It tells of joy divine,",
          "Its beams of light descending,",
          "With heavenly beauty shine."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Keep the Sabbath holy,",
          "And worship Him today,",
          "Who said to His disciples,",
          "\"I am the living way;\"",
          "And if we meekly follow",
          "Our Savior here below,",
          "He'll give us of the fountain",
          "Whose streams eternal flow."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Day of sacred pleasure!",
          "Its golden hours we'll spend",
          "In thankful hymns to Jesus,",
          "The children's dearest Friend;",
          "O gentle loving Savior,",
          "How good and kind Thou art,",
          "How precious is Thy promise",
          "To dwell in every heart!"
        ]
      }
    ],
    "chorus": [
      "Welcome, welcome, ever welcome,",
      "Blessed Sabbath day.",
      "Welcome, welcome, ever welcome,",
      "Blessed Sabbath day."
    ],
    "timestamps": {
      "chorus": 36.3149
    }
  },
  {
    "hymnNumber": 389,
    "reference": "SDAH389",
    "title": "Light of Light, Enlighten Me",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Light of light, enlighten me,",
          "Now anew the day is dawning;",
          "Sun of grace, the shadows flee;",
          "Brighten Thou my Sabbath morning;",
          "With Thy joyous sunshine blest,",
          "Happy is my day of rest."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Let me with my heart today,",
          "Holy, holy, holy, singing,",
          "Rapt awhile from earth away,",
          "All my soul to Thee up springing,",
          "Have a foretaste inward given",
          "How they worship Thee in heaven."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Hence all care, all vanity!",
          "For the day to God is holy;",
          "Come, Thou glorious Majesty,",
          "Deign to fill this temple lowly;",
          "Nought today my soul shall move,",
          "Simply resting in Thy love."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 390,
    "reference": "SDAH390",
    "title": "We Love Thy Sabbath, Lord",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "We love Thy Sabbath, Lord,",
          "And worship at Thy will;",
          "Oh may these hours sweet peace afford",
          "And deeper faith instill."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Thine angels sang for joy",
          "Creation's work to see;",
          "We too, this day, would raise our hearts",
          "In grateful praise to Thee."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Praise for Thy wondrous love,",
          "That sealed this sacred day,",
          "A sign that all may understand",
          "We own Thy sovereign sway."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "O great Creator King,",
          "Through Thy redeeming grace,",
          "Renew and sanctify our hearts",
          "That we may see Thy face."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "And with the white-robed throng,",
          "Upon Mount Sion be,",
          "And joyful sing our Sabbath song",
          "Through all eternity."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 391,
    "reference": "SDAH391",
    "title": "Welcome, Welcome, Day of Rest",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Welcome, welcome, day of rest,",
          "To the world in kindness given;",
          "Welcome to this humble breast,",
          "As the beaming light from heaven."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Day of calm and sweet repose,",
          "Gently now thy moments run;",
          "Balm to soothe our cares and woes,",
          "Till our labor here is done."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Holy day that most we prize,",
          "Day of solemn praise and prayer,",
          "Day to make the simple wise,",
          "O, how great thy blessings are!"
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Welcome, welcome, day of rest,",
          "With thy influence all divine;",
          "May thy hallowed hours be blessed",
          "To this waiting heart of mine."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 392,
    "reference": "SDAH392",
    "title": "Dear Lord We Come At Set of Sun",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Dear Lord, we come at set of sun,",
          "And at Your feet we kneel",
          "To worship You, Creator, King,",
          "This day, Your sign and seal."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Our earthly tasks we lay aside,",
          "According to Your Word,",
          "To enter now Your holy rest,",
          "The Sabbath of the Lord."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Sweet Sabbath rest, your sacred hours",
          "Are as a golden chain",
          "That reaches back to Eden's gate",
          "And points us home again."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "And when this earth shall be renewed,",
          "And sin and death destroyed,",
          "Shall all redeemed each Sabbath day",
          "Still meet to praise their God."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 393,
    "reference": "SDAH393",
    "title": "Lord of the Sabbath",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Lord of the Sabbath and its light,",
          "I hail Thy hallowed day of rest;",
          "It is my weary soul's delight,",
          "The solace of my careworn breast,",
          "The solace of my careworn breast."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "O sacred day of peace and joy,",
          "Thy hours are ever dear to me;",
          "Ne'er may a sinful thought destroy",
          "The holy calm I find in thee,",
          "The holy calm I find in thee."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "How sweetly now they glide along!",
          "How hallowed is the calm they yield!",
          "Transporting is their rapturous song,",
          "And heavenly visions seem revealed,",
          "And heavenly visions seem revealed."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "O Jesus, let me ever hail",
          "Thy presence with the day of rest;",
          "Then will Thy servant never fail",
          "To deem Thy Sabbath doubly blest,",
          "To deem Thy Sabbath doubly blest."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 394,
    "reference": "SDAH394",
    "title": "Far From All Care",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Far from all care we hail the Sabbath morning;",
          "O'er waving field and from the distant sea",
          "Swell notes of praise in harmony resounding",
          "As all creation turns her heart to Thee."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Though man alone, Lord, of Thy great creation",
          "Fails now to laud Thee for Thy love and power,",
          "Yet still a remnant love Thee and remember",
          "Thy holy law and each sweet Sabbath hour."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Lord of the Sabbath, Savior and Creator,",
          "Calm now the throbbings of each troubled breast.",
          "Speak to our hearts the peace of Thy commandments,",
          "Breathe on each soul fair Eden's hallowed rest."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Strong in Thy might and quiet in Thy meekness,",
          "May we Thine image bear from day to day.",
          "Then may we enter pearly gates eternal",
          "And sing redemption's song each Sabbath day."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 395,
    "reference": "SDAH395",
    "title": "As Birds Unto the Genial Homeland",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "As birds unto the genial homeland fly,",
          "The winter's cold and low'ring skies to flee,",
          "So seeks my soul Thy gracious presence here",
          "And finds, O God, its rest and peace in Thee."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Here at Thy shrine we leave all vexing care,",
          "For get the disappointment, grief and tear,",
          "And on the wings of hopeful song and prayer",
          "We rise, and rising feel Thy Spirit here."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Bless all who spend this night in pain and woe,",
          "The burdened heart, the fainting, and distressed,",
          "Thy comfort send to darkened homes bereaved,",
          "Thy saving help to those by want oppressed."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Come, Sabbath joy, each trusting heart now fill,",
          "And blissful peace within our homes abide,",
          "May thankful praise each grateful heart now thrill,",
          "And to God's loving care their lives confide."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 396,
    "reference": "SDAH396",
    "title": "Lord God, Your Love Has Called Us Here",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Lord God, Your love has called us here,",
          "As we, by love, for love were made.",
          "Your living likeness still we bear",
          "Tho' marred, dishonored, disobeyed.",
          "We come, with all our heart and mind",
          "Your call to hear, Your love to find."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "We come with self-inflicted pains",
          "Of broken trust and chosen wrong,",
          "Half-free, half-bound by inner chains,",
          "By social forces swept along,",
          "By powers and systems close confined,",
          "Yet seeking hope for humankind."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Lord God, in Christ You call our name,",
          "And then receive us as Your own,",
          "Not thro' some merit, right, or claim,",
          "But by Your gracious love alone.",
          "We strain to glimpse Your mercy-seat,",
          "And find You kneeling at our feet."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Then take the towel, and break the bread,",
          "And humble us, and call us friends.",
          "Suffer and serve till all are fed",
          "And show how grandly love intends",
          "To work till all creation sings,",
          "To fill all worlds, to crown all things."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "Lord God, in Christ You set us free",
          "Your life to live, Your joy to share.",
          "Give us Your Spirit's liberty",
          "To turn from guilt and dull despair",
          "And offer all that faith can do,",
          "While love is making all things new."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 397,
    "reference": "SDAH397",
    "title": "An Upper Room",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "An upper room did our Lord prepare",
          "For those loved until the end:",
          "And His disciples still gather there,",
          "To celebrate their risen Friend."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "And after supper He washed their feet,",
          "For service, too, is sacrament.",
          "In Him our joy shall be made complete",
          "Sent out to serve, as He was sent."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "A lasting gift Jesus gave His own:",
          "To share His bread, His loving cup.",
          "Whatever burdens may bow us down,",
          "He by His cross shall lift us up."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "No end there is! we depart in peace.",
          "He loves beyond our uttermost:",
          "In every room in our Father's house,",
          "He will be there, as Lord and host."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 398,
    "reference": "SDAH398",
    "title": "Bread of the World",
    "hasMidi": true,
    "numberOfVerses": 2,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Bread of the world in mercy broken,",
          "Wine of the soul in mercy shed,",
          "By whom the words of life are spoken,",
          "And in whose death our sins are dead;"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Look on the heart by sorrow broken,",
          "Look on the tears by sinners shed;",
          "And be Thy feast to us the token",
          "That by Thy grace our souls are fed."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 399,
    "reference": "SDAH399",
    "title": "Beneath the Forms of Outward Rite",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Beneath the forms of outward rite",
          "Thy supper, Lord, is spread",
          "In every quiet upper room",
          "Where fainting souls are fed."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "The bread is always consecrate",
          "Which men divide with men;",
          "And every act of brotherhood",
          "Repeats Thy feast again."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "The blessed cup is only passed",
          "True memory of Thee,",
          "When life anew pours out its wine",
          "With rich sufficiency."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "O Master, through these symbols shared,",
          "Thine own dear self impart,",
          "That in our daily life may flame",
          "The passion of Thy heart."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 400,
    "reference": "SDAH400",
    "title": "I Come With Joy",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "I come with joy to meet my Lord,",
          "Forgiven, loved and free,",
          "In awe and wonder to recall",
          "His life laid down for me,",
          "His life laid down for me."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "I come with Christians far and near",
          "To find, as all are fed,",
          "Our true community of love",
          "In Christ's communion bread,",
          "In Christ's communion bread."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "As Christ breaks bread for us to share",
          "Each proud division ends.",
          "That love that made us makes us one,",
          "And strangers now are friends,",
          "And strangers now are friends."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "And thus with joy we meet our Lord.",
          "His presence always near,",
          "Is in such friendship better known:",
          "We see and praise Him here,",
          "We see and praise Him here."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "Together met, together bound,",
          "We'll go our diff'rent ways,",
          "And as His people in the world,",
          "We'll live and speak His praise,",
          "We'll live and speak His praise."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 401,
    "reference": "SDAH401",
    "title": "In Imitation, Lord of Thee",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "In imitation, Lord, of Thee,",
          "This solemn service we repeat;",
          "For Thine example, full of grace,",
          "Has made this humble duty sweet."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Renew each sacred spark of love,",
          "And vitalize the holy flame;",
          "May union strong our hearts unite",
          "While this we do in Jesus' name."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Our great example Thou shalt be,",
          "In washing Thy disciples feet;",
          "And as we follow Thy command,",
          "Make Thou our fellowship complete."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 402,
    "reference": "SDAH402",
    "title": "By Christ Redeemed",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "By Christ redeemed, in Christ restored,",
          "We keep the memory adored,",
          "And show the death of our dear Lord,",
          "Until He come."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "His broken body in our",
          "stead Is here, in this memorial bread;",
          "And so our feeble love is fed,",
          "Until He come."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "His fearful drops of agony,",
          "His lifeblood shed for us we see;",
          "The wine shall tell the mystery,",
          "Until He come."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "And thus that dark betrayal night,",
          "With the last advent we unite-",
          "The shame, the glory, by this rite,",
          "Until He come."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 403,
    "reference": "SDAH403",
    "title": "Let Us Break Bread Together",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Let us break bread together on our knees;",
          "Let us break bread together on our knees."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Let us drink wine together on our knees;",
          "Let us drink wine together on our knees."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Let us praise God together on our knees;",
          "Let us praise God together on our knees."
        ]
      }
    ],
    "chorus": [
      "When I fall on my knees,",
      "With my face to the rising sun,",
      "O Lord, have mercy on me."
    ],
    "timestamps": {
      "chorus": 15.8084
    }
  },
  {
    "hymnNumber": 404,
    "reference": "SDAH404",
    "title": "Now Let Us From This Table Rise",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Now let us from this table rise",
          "Renewed in body, mind, and soul;",
          "With Christ we die and live again,",
          "His selfless love has made us whole."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "With minds alert, upheld by grace,",
          "To spread the word in speech and deed,",
          "We follow in the steps of Christ,",
          "At one with all in hope and need."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "To fill each human house with love,",
          "It is the sacrament of care;",
          "The work that Christ began to do",
          "We humbly pledge ourselves to share."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Then grant us courage, Father God,",
          "To choose again the pilgrim way",
          "And help us to accept with joy",
          "The challenge of tomorrow's day."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 405,
    "reference": "SDAH405",
    "title": "O God, Unseen, Yet Ever Near",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "O God, unseen, yet ever near,",
          "Reveal Thy presence now",
          "While we in love that hath no fear,",
          "Before Thy glory bow."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Here may Thy faithful people know",
          "The blessings of Thy love,",
          "The streams that thro' the desert flow,",
          "The manna from above."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "We come, obedient to Thy Word",
          "To feast on heav'nly food,",
          "Our meat, the body of our Lord,",
          "Our drink, His precious blood."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Thus may we all Thy words obey,",
          "For we, O God, are Thine,",
          "And go rejoicing on our way,",
          "Renewed by strength divine."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 406,
    "reference": "SDAH406",
    "title": "Love Consecrates the Humblest Act",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Love consecrates the humblest act",
          "And haloes mercy's deeds;",
          "It sheds a benediction sweet",
          "And hallows human needs."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "When in the shadow of the cross",
          "Christ knelt and washed the feet",
          "Of His disciples, He gave us",
          "A sign of love complete."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Love serves and willing, stoops to serve;",
          "What Christ in love so true",
          "Has freely done for one and all,",
          "Let us now gladly do!"
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 407,
    "reference": "SDAH407",
    "title": "Sent Forth By God's Blessing",
    "hasMidi": true,
    "numberOfVerses": 2,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Sent forth by God's blessing,",
          "Our true faith confessing,",
          "The people of God from His dwelling take leave.",
          "The supper is ended.",
          "Oh, now be extended",
          "The fruits of this service in all who believe.",
          "The seed of His teaching,",
          "Receptive souls reaching,",
          "Shall blossom in action for God and for all.",
          "His grace did invite us,",
          "His love shall unite us",
          "To work for God's kingdom and answer His call."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "With praise and thanksgiving",
          "To God ever-living,",
          "The tasks of our everyday life we will face.",
          "Our faith ever sharing,",
          "In love ever caring,",
          "Embracing His children of each tribe and race.",
          "With Your feast You feed us,",
          "With Your light now lead us;",
          "Unite us as one in this life that we share.",
          "Then may all the living",
          "With praise and thanksgiving",
          "Give honor to Christ and His name that we bear."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 408,
    "reference": "SDAH408",
    "title": "Lord, Enthroned in Heavenly Splendor",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Lord, enthroned in heav'nly splendor,",
          "First begotten from the dead,",
          "You alone, our strong defender,",
          "Lifting up Your people's head.",
          "Alleluia,",
          "Jesus, true and living Bread!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Tho' the lowliest form now veil You",
          "As of old in Bethlehem,",
          "Here as there Your angels hail You",
          "Branch and flow'r of Jesse's stem.",
          "Alleluia,",
          "We in worship join with them."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Paschal Lamb, Your off'ring finished",
          "Once for all where You were slain,",
          "In its fullness undiminished",
          "Shall forever more remain.",
          "Alleluia,",
          "Cleansing souls from every stain."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Life-imparting heav'nly manna,",
          "Stricken rock with streaming side,",
          "Heav'n and earth with loud hosanna",
          "Worship You the Lamb who died.",
          "Alleluia,",
          "Ris'n, ascended, glorified!"
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 409,
    "reference": "SDAH409",
    "title": "Jesus Invites His Saints",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Jesus invites His saints",
          "To meet around His board,",
          "And sup in memory of the death",
          "And sufferings of their Lord."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "We take the bread and wine",
          "As emblems of Thy death;",
          "Lord, raise our souls above the sign,",
          "To feast on Thee by faith."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Faith eats the bread of life,",
          "And drinks the living wine;",
          "It looks beyond this scene of strife;",
          "Unites us to the Vine."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Soon shall the night be gone,",
          "Our Lord will come again;",
          "The marriage supper of the Lamb",
          "Will usher in His reign."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 410,
    "reference": "SDAH410",
    "title": "Thy Broken Body Gracious Lord",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Thy broken body, gracious Lord,",
          "Is shadowed by this broken bread;",
          "The wine which in this cup is poured,",
          "Points to the blood which Thou hast shed."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "And while we meet together thus,",
          "We show that we are one in Thee;",
          "Thy precious blood was shed for us,",
          "Thy death, O Lord, hast set us free!"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "We have one hope that Thou wilt come,",
          "Thee in the air we wait to see;",
          "When Thou wilt give Thy saints a home,",
          "And we shall ever reign with Thee."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 411,
    "reference": "SDAH411",
    "title": "The Son of God Proclaim",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "The Son of God proclaim,",
          "The Lord of time and space;",
          "The God who bade the light break forth",
          "Now shines in Jesus' face."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Behold His outstretched hands,",
          "Though all was in His power",
          "He took the towel and basin then,",
          "And serves us in this hour."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "He, God's creative word,",
          "The church's Lord and head,",
          "Here bids us gather as His friends,",
          "And share His wine and bread."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "The Lord of life and death",
          "With wondering praise we sing;",
          "We break the bread at His command,",
          "And name Him God and King."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "We take this cup in hope:",
          "For He, who gladly bore",
          "The shameful cross, is ris'n again,",
          "And reigns forevermore."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 412,
    "reference": "SDAH412",
    "title": "Cover With His Life",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Look upon Jesus, sinless is He;",
          "Father, impute His life unto me.",
          "My life of scarlet, my sin and woe,",
          "Cover with His life, whiter than snow."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Deep are the wounds transgression has made;",
          "Red are the stains; my soul is afraid.",
          "O to be covered, Jesus, with Thee,",
          "Safe from the law that now judgeth me!"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Longing the joy of pardon to know;",
          "Jesus holds out a robe white as snow;",
          "\"Lord, I accept it! leaving my own,",
          "Gladly I wear Thy pure life alone.\""
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Reconciled by His death for my sin,",
          "Justified by His life pure and clean,",
          "Sanctified by obeying His word,",
          "Glorified when returneth my Lord."
        ]
      }
    ],
    "chorus": [
      "Cover with His life, whiter than snow;",
      "Fullness of His life then shall I know;",
      "My life of scarlet, my sin and woe,",
      "Cover with His life, whiter than snow."
    ],
    "timestamps": {
      "chorus": 27.7147
    }
  },
  {
    "hymnNumber": 413,
    "reference": "SDAH413",
    "title": "God Has Spoken By His Prophets",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "God has spoken by His prophets,",
          "Spoken His unchanging Word,",
          "Each from age to age proclaiming",
          "God, the one, the righteous Lord.",
          "Mid the world's despair and turmoil,",
          "One firm anchor holding fast;",
          "God is King, His throne eternal,",
          "God the first, and God the last."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "God has spoken by Christ Jesus,",
          "Christ, the everlasting Son,",
          "Brightness of the Father's glory,",
          "With the Father ever one;",
          "Spoken by the Word incarnate,",
          "God of God, ere time began,",
          "Light of light, to earth descending,",
          "Man, revealing God to man."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "God yet speaks by His own Spirit",
          "Speaking to the hearts of men,",
          "In the age-long Word expounding",
          "God's own message, now as then;",
          "Through the rise and fall of nations",
          "One sure faith yet standing fast,",
          "God is King, His Word unchanging,",
          "God the first, and God the last."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 414,
    "reference": "SDAH414",
    "title": "Fruitful Trees the Spirit's Sowing",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Fruitful trees, the Spirit's sowing,",
          "May we ripen and increase,",
          "Fruit to life eternal growing,",
          "Rich in love and joy and peace."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Laden branches freely bearing",
          "Gifts the Giver loves to bless;",
          "Here is fruit that grows by sharing,",
          "Patience, kindness, gentleness."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Rooted deep in Christ, our Master,",
          "Christ, our pattern and our goal,",
          "Teach us, as the years fly faster,",
          "Goodness, faith, and self control."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Fruitful trees, the Spirit's tending,",
          "May we grow till harvests cease;",
          "Till we taste, in life unending,",
          "Heaven's love and joy and peace."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 415,
    "reference": "SDAH415",
    "title": "Christ the Lord All Power Possessing",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Christ, the Lord, all power possessing,",
          "Parting, mounted heaven's height,",
          "Gracious hands outstretched in blessing,",
          "Clouds received Him from their sight.",
          "Christ ascended, Christ ascended,",
          "Christ ascended on the clouds.",
          "Christ ascended on the clouds."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Daniel views earth's judgment hour,",
          "Angels gathering open books.",
          "God enthroned inflaming power",
          "For His Son's arrival looks.",
          "Christ approaches, Christ approaches,",
          "Christ approaches on the clouds.",
          "Christ approaches on the clouds."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Revelation's word fulfilling,",
          "Trumpet, voices pierce the air.",
          "Saint and sinner fainting, thrilling,",
          "Every eye behold Him there.",
          "Christ is coming, Christ is coming,",
          "Christ is coming on the clouds.",
          "Christ is coming on the clouds."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 416,
    "reference": "SDAH416",
    "title": "The Judgment Has Set",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "The judgment has set, the books have been opened;",
          "How shall we stand in that great day",
          "When every thought, and word, and action,",
          "God, the righteous Judge, shall weigh?"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "The work is begun with those who are sleeping,",
          "Soon will the living here be tried,",
          "Out of the books of God's remembrance,",
          "His decision to abide."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "O, how shall we stand that moment of searching,",
          "When all our sins those books reveal?",
          "When from that court, each case decided,",
          "Shall be granted no appeal?"
        ]
      }
    ],
    "chorus": [
      "How shall we stand in that great day?",
      "How shall we stand in that great day?",
      "Shall we be found before Him wanting?",
      "Or with our sins all washed away?"
    ],
    "timestamps": {
      "chorus": 23.8979
    }
  },
  {
    "hymnNumber": 417,
    "reference": "SDAH417",
    "title": "O Solemn Thought",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "O solemn thought and can it be",
          "The hour of judgment now is come",
          "Which soon must fix our destiny,",
          "And seal the sinner's fearful doom?",
          "Yes, it is so; the judgment hour",
          "Is swiftly hastening to its close;",
          "Then will the Judge, in mighty power,",
          "Descend in vengeance on His foes."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "He who came down to earth to die",
          "An offering for the sins of men,",
          "And then ascended upon on high,",
          "And will e'er long return again,",
          "Is standing now before the ark,",
          "And mercy seat and cherubim,",
          "To plead His blood for saints, and make",
          "The last remembrance of their sin."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "The solemn moment is at hand",
          "When we who have His name confessed,",
          "Each in his lot must singly stand",
          "And pass the final, searching test.",
          "Jesus! we hope in Thee alone;",
          "In mercy now upon us look,",
          "Confess our names before the throne,",
          "And blot our sins from out Thy book."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "O blessed Savior! may we feel",
          "The full importance of this hour.",
          "Inspire our hearts with holy zeal,",
          "And aid us by Thy Spirit's power,",
          "That we may in Thy strength be strong,",
          "And brave the conflict valiantly;",
          "Then, on Mount Zion, join the song,",
          "And swell the notes of victory."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 418,
    "reference": "SDAH418",
    "title": "Day of Judgment, Day of Wonders!",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Day of judgment, day of wonders!",
          "Hark the trumpet's awful sound,",
          "Louder than a thousand thunders,",
          "Shakes the vast creation round!",
          "How the summons,",
          "How the summons",
          "Will the sinner's heart confound!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "See the Lord in glory nearing,",
          "Clothed in majesty divine.",
          "You who long for His appearing,",
          "Then shall say, ''This God is mine!\"",
          "Gracious Savior,",
          "Gracious Savior,",
          "Own me in that day as Thine."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "At His call the dead awaken,",
          "Rise to life from earth and sea!",
          "All the powers of nature shaken",
          "By His looks prepare to flee.",
          "Careless sinner,",
          "Careless sinner,",
          "What will then become of thee?"
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "But to those who have confessed",
          "Loved and served the Lord below,",
          "He will say, \"Come near, ye blessed,",
          "See the kingdom I bestow;",
          "You forever,",
          "You forever",
          "Shall My love and glory know?\""
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 419,
    "reference": "SDAH419",
    "title": "Soon Shall the Trump of God",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Soon shall the trump of God",
          "Give out the welcome sound,",
          "That shakes death's silent chamber walls,",
          "And breaks the turf sealed ground."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "You dwellers in the dust,",
          "Awake, come forth, and sing;",
          "Sharp has your frost of winter been,",
          "But bright shall be your spring."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "'Twas sown in weakness here;",
          "'Twill then be raised in power;",
          "That which was sown in earthly seed",
          "Shall rise a heav'nly flower."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 420,
    "reference": "SDAH420",
    "title": "Jerusalem My Happy Home",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Jerusalem, my happy home,",
          "O how I long for thee!",
          "When will my sorrows have an end,",
          "The joys when shall I see?"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "The walls are all of precious stone,",
          "Most glorious to behold;",
          "Thy gates are richly set with pearl,",
          "Thy streets are paved with gold."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Thy garden and thy pleasant walks",
          "My study long have been;",
          "Such dazzling views by human sight",
          "Have never yet been seen."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Lord, help us by Thy mighty grace,",
          "To keep in view the prize,",
          "Till Thou dost come to take us home",
          "To that blessed paradise."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 421,
    "reference": "SDAH421",
    "title": "For All the Saints",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "For all the saints who from their labors rest,",
          "Who Thee by faith before the world confessed,",
          "Thy name, O Jesus, be forever blest:",
          "Alleluia!",
          "Alleluia!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Thou wast their Rock, their Fortress, and their Might,",
          "Thou, Lord, their captain in the well-fought fight;",
          "Thou, in the darkness drear, their one true light:",
          "Alleluia!",
          "Alleluia!"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "O may Thy soldiers, faithful, true, and bold,",
          "Fight as the saints who nobly fought of old,",
          "And win with them the victor's crown of gold:",
          "Alleluia!",
          "Alleluia!"
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "And when the strife is fierce, the warfare long,",
          "Steals on the ear the distant triumph song,",
          "And hearts are brave again, and arms are strong.",
          "Alleluia!",
          "Alleluia!"
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "From earth's wide bounds, from ocean's farthest coast,",
          "Thro' gates of pearl streams in the countless host,",
          "Singing to Father, Son, and Holy Ghost,",
          "Alleluia!",
          "Alleluia!"
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 422,
    "reference": "SDAH422",
    "title": "Marching to Zion",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Come, we that love the Lord,",
          "And let our joys be known;",
          "Join in a song with sweet accord,",
          "Join in a song with sweet accord,",
          "And thus surround the throne,",
          "And thus surround the throne."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Let those refuse to sing",
          "Who never knew our God;",
          "But children of the heavenly King,",
          "But children of the heavenly King,",
          "May speak their joys abroad,",
          "May speak their joys abroad."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "The hill of Zion yields",
          "A thousand sacred sweets,",
          "Before we reach the heavenly fields,",
          "Before we reach the heavenly fields",
          "Or walk the golden streets,",
          "Or walk the golden streets."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Then let our songs abound,",
          "And every tear be dry;",
          "We're marching through Immanuel's ground,",
          "We're marching through Immanuel's ground,",
          "To fairer worlds on high,",
          "To fairer worlds on high."
        ]
      }
    ],
    "chorus": [
      "We're marching to Zion,",
      "Beautiful, Beautiful Zion;",
      "We're marching upward to Zion,",
      "The beautiful city of God."
    ],
    "timestamps": {
      "chorus": 25.0525
    }
  },
  {
    "hymnNumber": 423,
    "reference": "SDAH423",
    "title": "Glorious Things of Thee Are Spoken",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Glorious things of thee are spoken,",
          "Zion, city of our God;",
          "He whose word cannot be broken",
          "Formed thee for His own abode;",
          "On the Rock of Ages founded,",
          "What can shake thy sure repose?",
          "With salvation's wall surrounded,",
          "Thou mayst smile at all thy foes."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "See the streams of living waters",
          "Springing from eternal love,",
          "Well supply thy sons and daughters,",
          "And all fear and want remove;",
          "Who can faint when such a river",
          "Ever flows their thirst to assuage?",
          "Grace, which, like the Lord, the Giver,",
          "Never fails from age to age."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Round each habitation hovering,",
          "See the cloud and fire appear",
          "For a glory and a covering,",
          "Showing that the Lord is near;",
          "Blest inhabitants of Zion,",
          "Washed in the Redeemer's blood;",
          "Jesus, whom their souls rely on,",
          "Makes them kings and priests to God."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Savior, if of Zion's city",
          "I, through grace, a member am,",
          "Let the world deride or pity,",
          "I will glory in Thy name;",
          "Fading is the worldling's pleasure,",
          "All his boasted pomp and show;",
          "Solid joys and lasting treasure",
          "None but Zion's children know."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 424,
    "reference": "SDAH424",
    "title": "For Thee, O Dear, Dear Country",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "For thee, O dear, dear country,",
          "Mine eyes their vigils keep;",
          "For very love beholding",
          "Thy holy name, they weep.",
          "The mention of thy glory",
          "Is unction to the breast,",
          "And medicine in sickness,",
          "And love, and life, and rest."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "O one, O only mansion!",
          "O Paradise of joy!",
          "Where tears are ever banish'd",
          "And smiles have no alloy;",
          "Thy loveliness oppresses",
          "All human thought and heart,",
          "And none, O Peace, O Sion,",
          "Can sing thavas thou art."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "With jasper glow thy bulwarks,",
          "Thy streets with emeralds blaze;",
          "The sardius and the topaz",
          "Unite in thee their rays;",
          "Thine ageless walls are bonded",
          "With amethyst unpriced;",
          "The saints shall build thy fabric,",
          "And the cornerstone is Christ."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "The cross is all thy splendor,",
          "The Crucified thy praise;",
          "His laud and benediction",
          "Thy ransom'd saints shall raise;",
          "Upon the Rock of Ages",
          "They build thy holy tower;",
          "Thine is the victor's laurel,",
          "And thine the golden dower."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "O sweet and blessed country,",
          "The home of God's elect!",
          "O sweet and blessed country",
          "That eager hearts expect!",
          "Jesus, in mercy bring us",
          "To that dear land of rest,",
          "Who art, with God the Father,",
          "And Spirit, ever blest."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 425,
    "reference": "SDAH425",
    "title": "Holy, Holy, Is What the Angels Sing",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "There is singing up in heaven such as we have never known,",
          "Where the angels sing the praises of the Lamb upon the throne;",
          "Their sweet harps are ever tuneful and their voices always clear,",
          "O that we might be more like them while we serve the Master here!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "But I hear another anthem, blending voices clear and strong,",
          "\"Unto Him who hath redeemed us and hath bought us,\" is the song;",
          "We have come thro' tribulations to this land so fair and bright,",
          "In the fountain freely flowing He hath made our garments white."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Then the angels stand and listen, for they cannot join that song,",
          "Like the sound of many waters, by that happy, bloodwashed throng;",
          "For they sing about great trials, battles fought and vict'ries won,",
          "And they praise their great Redeemer, who hath said to them, \"Well done.\""
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "So, although I'm not an angel, yet I know that over there",
          "I will join a blessed chorus that the angels cannot share;",
          "I will sing about my Savior, who upon dark Calvary",
          "Freely pardoned my transgressions, died to set a sinner free."
        ]
      }
    ],
    "chorus": [
      "Holy, holy, is what the angels sing,",
      "And I expect to help them make the courts of heaven ring;",
      "But when I sing redemption's story, they will fold their wings,",
      "For angels never felt the joys that our salvation brings."
    ],
    "timestamps": {
      "chorus": 32.257
    }
  },
  {
    "hymnNumber": 426,
    "reference": "SDAH426",
    "title": "I Shall See the King",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "I shall see the King",
          "Where the angels sing,",
          "I shall see the King some day,",
          "In the better land,",
          "On the golden strand",
          "And with Him shall ever stay."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "In the land of song,",
          "In the glory throng,",
          "Where there never comes a night,",
          "With my Lord once slain",
          "I shall ever reign",
          "In the glory land of light."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "I shall see the King,",
          "All my tributes bring,",
          "And shall look upon His face;",
          "Then my song shall be",
          "How He ransomed me",
          "And has kept me by His grace."
        ]
      }
    ],
    "chorus": [
      "In His glory, I shall see the King,",
      "And forever endless praises sing;",
      "'Twas on Calvary Jesus died for me;",
      "I shall see the King some day."
    ],
    "timestamps": {
      "chorus": 21.3276
    }
  },
  {
    "hymnNumber": 427,
    "reference": "SDAH427",
    "title": "No Night There",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "In the land of fadeless day",
          "Lies \"the city foursquare;\"",
          "It shall never pass away,",
          "And there is \"no night there?\""
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "All the gates of pearl are made,",
          "In \"the city foursquare;\"",
          "All the streets with gold are laid,",
          "And there is \"no night there!\""
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "And the gates shall never close",
          "To \"the city four square;\"",
          "There life's crystal river flows,",
          "And there is \"no night there!\""
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "There they need no sunshine bright,",
          "In \"that city foursquare,\"",
          "For the Lamb is all the light;",
          "And there is \"no night there?\""
        ]
      }
    ],
    "chorus": [
      "God shall \"wipe away all tears;\"",
      "There's no death, no pain, nor fears;",
      "And they count not time by years,",
      "For there is \"no night there.\""
    ],
    "timestamps": {
      "chorus": 17.932
    }
  },
  {
    "hymnNumber": 428,
    "reference": "SDAH428",
    "title": "Sweet By and By",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "There's a land that is fairer than day,",
          "And by faith we can see it afar;",
          "For the Father waits over the way,",
          "To prepare us a dwelling place there."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "We shall sing on that beautiful shore",
          "The melodious songs of the blest,",
          "And our spirits shall sorrow no more,",
          "Not a sigh for the blessing of rest."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "To our bountiful Father above,",
          "We will offer a tribute of praise,",
          "For the glorious gift of His love,",
          "And the blessings that hallow our days."
        ]
      }
    ],
    "chorus": [
      "In the sweet by and by,",
      "We shall meet on that beautiful shore;",
      "In the sweet by and by,",
      "We shall meet on that beautiful shore."
    ],
    "timestamps": {
      "chorus": 21.7094
    }
  },
  {
    "hymnNumber": 429,
    "reference": "SDAH429",
    "title": "Jerusalem the Golden",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Jerusalem the golden,",
          "With milk and honey blest,",
          "Beneath thy contemplation",
          "Sink heart and voice oppressed.",
          "I know not, O I know not",
          "What holy joys are there;",
          "What radiancy of glory,",
          "What bliss beyond compare."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "They stand, those halls of Zion,",
          "All jubilant with song,",
          "And bright with many an angel,",
          "And all the martyr throng.",
          "The Prince is ever in them,",
          "The daylight is serene;",
          "The pastures of the blessed",
          "Are decked in glorious sheen."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "There is the throne of David,",
          "And there, from care released,",
          "The shout of them that triumph,",
          "The song of them that feast;",
          "And they who, with their Leader,",
          "Have conquered in the fight,",
          "Forever and forever",
          "Are clad in robes of white."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "O sweet and blessed country,",
          "The home of God's elect!",
          "O sweet and blessed country,",
          "That eager hearts expect!",
          "Jesus, in mercy bring us",
          "To that dear land of rest;",
          "Who art, with God the Father,",
          "And Spirit, ever blest."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 430,
    "reference": "SDAH430",
    "title": "Joy By and By",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "O there'll be joy when the work is done,",
          "Joy when the reapers gather home,",
          "Bringing the sheaves at set of sun",
          "To the New Jerusalem."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Sweet are the songs that we hope to sing,",
          "Grateful the thanks our hearts shall bring,",
          "Praising forever Christ our King",
          "In the New Jerusalem."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Pure are the joys that await us there,",
          "Many the golden mansions fair;",
          "Jesus Himself doth them prepare,",
          "In the New Jerusalem."
        ]
      }
    ],
    "chorus": [
      "Joy, joy, there'll be joy by and by,",
      "Joy, joy, where the joys never die;",
      "Joy, joy; for the day draweth nigh",
      "When the workers gather home."
    ],
    "timestamps": {
      "chorus": 20.5526
    }
  },
  {
    "hymnNumber": 431,
    "reference": "SDAH431",
    "title": "Over Yonder",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Come, let us sing of homeland,",
          "Down by the crystal sea;",
          "Wonderful land where Jesus",
          "Buildeth a mansion for me."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Water of life there floweth,",
          "Fruit in abundant store;",
          "Citizens of that country",
          "Hunger and thirst nevermore."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Come go with me to homeland,",
          "Jesus invites you there;",
          "Help spread the invitation,",
          "Tell it to men everywhere."
        ]
      }
    ],
    "chorus": [
      "Over yonder, down by the crystal sea,",
      "Over yonder,",
      "There's where I long to be,",
      "No more sorrow, toil, grief, nor care,",
      "In the homeland bright and fair,",
      "Over, over there."
    ],
    "timestamps": {
      "chorus": 15.495
    }
  },
  {
    "hymnNumber": 432,
    "reference": "SDAH432",
    "title": "Shall We Gather at the River",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Shall we gather at the river",
          "Where bright angel feet have trod,",
          "With its crystal tide forever",
          "Flowing by the throne of God?"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "On the margin of the river,",
          "Washing up its silver spray",
          "We will walk and worship ever,",
          "All the happy golden day."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Ere we reach the shining river,",
          "Lay we every burden down;",
          "Grace our spirits will deliver,",
          "And provide a robe and crown."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Soon we'll reach the shining river,",
          "Soon our pilgrimage will cease,",
          "Soon our happy hearts will quiver",
          "With the melody of peace."
        ]
      }
    ],
    "chorus": [
      "Yes, we'll gather at the river,",
      "The beautiful, the beautiful river;",
      "Gather with the saints at the river",
      "That flows by the throne of God."
    ],
    "timestamps": {
      "chorus": 20.3984
    }
  },
  {
    "hymnNumber": 433,
    "reference": "SDAH433",
    "title": "Ten Thousand Times Ten Thousand",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Ten thousand times ten thousand,",
          "In sparkling raiment bright,",
          "The armies of the ransomed saints",
          "Throng up the steeps of light.",
          "'Tis finished, all is finished,",
          "Their fight with death and sin.",
          "Fling open wide the golden gates,",
          "And let the victors in."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "What rush of hallelujahs",
          "Fills all the earth and sky!",
          "The ringing of a thousand harps",
          "Proclaims the triumph high.",
          "O day for which creation",
          "And all its tribes were made!",
          "O joy, for all its former woes",
          "A thousand-fold repaid!"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "O then what raptured greetings",
          "On Canaan's happy shore!",
          "What knitting severed friendship where",
          "Death partings are no more!",
          "Then eyes with joy shall sparkle,",
          "That brimmed with tears of late;",
          "Orphans no longer fatherless,",
          "Nor widows desolate."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Bring near Thy great salvation,",
          "Thou Lamb for sinners slain,",
          "Fill up the roll of Thine elect,",
          "Then take Thy power and reign!",
          "Appear, Desire of nations,",
          "Thine exiles long for home;",
          "Show in the heavens Thy promised sign;",
          "Thou Prince and Savior, come!"
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 434,
    "reference": "SDAH434",
    "title": "We Speak of the Realms",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "We speak of the realms of the blest,",
          "That country so bright and so fair,",
          "And oft are its glories confessed;",
          "But what must it be to be there!",
          "We speak of its pathway of gold;",
          "Its walls decked with jewels so rare,",
          "Its wonders and pleasures untold;",
          "But what must it be to be there!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "We speak of its freedom from sin,",
          "From sorrow, temptation and care,",
          "From trials without and within;",
          "But what must it be to be there!",
          "We speak of its service of love,",
          "Of the robes which the glorified wear,",
          "Of the church of the Firstborn above;",
          "But what must it be to be there!"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Our mourning is all at an end,",
          "When, raised by the life-giving word,",
          "We see the new city descend,",
          "Adorned as a bride for her Lord;",
          "The city so holy and clean,",
          "No sorrow can breathe in the air;",
          "No gloom of affliction or sin,",
          "No shadow of evil, is there."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Do Thou, midst temptation and woe,",
          "For heaven my spirit prepare;",
          "And shortly I also shall know",
          "And feel what it is to be there.",
          "Then o'er the bright fields we shall roam,",
          "In glory celestial and fair,",
          "With saints and with angels at home,",
          "And Jesus Himself will be there."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 435,
    "reference": "SDAH435",
    "title": "The Glory Song",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "When all my labors and trials are o'er,",
          "And I am safe on that beautiful shore,",
          "Just to be near the dear Lord I adore,",
          "Will through the ages be glory for me."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "When, by the gift of His infinite grace,",
          "I am accorded in heaven a place,",
          "Just to be there and to look on His face,",
          "Will through the ages be glory for me."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Friends will be there I have loved long ago;",
          "Joy like a river around me will flow,",
          "Yet, just a smile from my Savior, I know,",
          "Will through the ages be glory for me."
        ]
      }
    ],
    "chorus": [
      "O that will be glory for me,",
      "Glory for me, glory for me;",
      "When by His grace I shall look on His face,",
      "That will be glory, be glory for me."
    ],
    "timestamps": {
      "chorus": 22.3538
    }
  },
  {
    "hymnNumber": 436,
    "reference": "SDAH436",
    "title": "The Homeland",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "The homeland! O the homeland!",
          "The land of the freeborn!",
          "There's no night in the homeland,",
          "But aye the fadeless morn;",
          "I'm sighing for the homeland,",
          "My heart is aching here;",
          "There is no pain in the homeland",
          "To which I'm drawing near;",
          "There is no pain in the homeland",
          "To which I'm drawing near."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "My Lord is in the homeland,",
          "With angels bright and fair;",
          "There's no sin in the homeland,",
          "And no temptation there;",
          "The music of the homeland",
          "Is ringing in my ears;",
          "And when I think of the homeland",
          "My eyes are filled with tears;",
          "And when I think of the homeland",
          "My eyes are filled with tears."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "The dwellers in the homeland",
          "Are beckoning me to come,",
          "Where neither death nor sorrow",
          "Invades their holy home;",
          "O dear, dear native country!",
          "O rest and peace above!",
          "Christ bring us all to the homeland",
          "Of Thy redeeming love;",
          "Christ bring us all to the homeland",
          "Of Thy redeeming love."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 437,
    "reference": "SDAH437",
    "title": "I'm Going Home",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "My heav'nly home is bright and fair,",
          "Nor pain nor death can enter there;",
          "Its glitt'ring tow'rs the sun outshine,",
          "That heav'nly mansion shall be mine."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "My Father's house is built on high,",
          "Far, far above the starry sky;",
          "When from this earthly prison free,",
          "That heav'nly mansion mine shall be."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Let others seek a home below,",
          "Which flames devour or waves o'erflow;",
          "Be mine a happier lot to own",
          "A heav'nly mansion near the throne."
        ]
      }
    ],
    "chorus": [
      "I'm going home, I'm going home,",
      "I'm going home to die no more;",
      "To die no more; to die no more;",
      "I'm going home to die no more."
    ],
    "timestamps": {
      "chorus": 16.9562
    }
  },
  {
    "hymnNumber": 438,
    "reference": "SDAH438",
    "title": "You Will See Your Lord A-coming",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "You will see your Lord a-coming,",
          "You will see your Lord a-coming,",
          "You will see your Lord a-coming",
          "In a few more days."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Gabriel sounds his mighty trumpet,",
          "Gabriel sounds his mighty trumpet,",
          "Gabriel sounds his mighty trumpet",
          "In a few more days."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "You will see the saints a-rising,",
          "You will see the saints a-rising,",
          "You will see the saints a-rising",
          "In a few more days."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Angels bear them to the Savior,",
          "Angels bear them to the Savior,",
          "Angels bear them to the Savior",
          "In a few more days."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "Then we'll shout, our suff'ring over,",
          "Then we'll shout, our suff'ring over,",
          "Then we'll shout, our suff'ring over",
          "In a few more days."
        ]
      }
    ],
    "chorus": [
      "Hear the band of music,",
      "Hear the band of music,",
      "Hear the band of music which is sounding thro' the air."
    ],
    "timestamps": {
      "chorus": 12.7887
    }
  },
  {
    "hymnNumber": 439,
    "reference": "SDAH439",
    "title": "How Far From Home?",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "How far from home? I asked, as on",
          "I bent my steps; the watchman spake:",
          "\"The long, dark night is almost gone,",
          "The morning soon will break.",
          "Then weep no more, but speed thy flight,",
          "With Hope's bright star thy guiding ray,",
          "Till thou shalt reach the realms of light,",
          "In everlasting day.\""
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "I asked the warrior on the field;",
          "This was his soul-inspiring song:",
          "\"With courage, bold, the sword I'll wield,",
          "The battle is not long.",
          "Then weep no more, but well endure",
          "The conflict, till thy work is done;",
          "For this we know, the prize is sure,",
          "When victory is won.\""
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "I asked again; earth, sea, and sun",
          "Seemed, with one voice, to make reply:",
          "\"Time's wasting sands are nearly run,",
          "Eternity is nigh.",
          "Then weep no more; with warning tones,",
          "Portentous signs are thickening round,",
          "The whole creation, waiting, groans,",
          "To hear the trumpet sound.\""
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Not far from home! O blessed thought!",
          "The traveler's lonely heart to cheer;",
          "Which oft a healing balm has brought,",
          "And dried the mourner's tear.",
          "Then weep no more, since we shall meet",
          "Where weary footsteps never roam;",
          "Our trials past, our joys complete,",
          "Safe in our Father's home."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 440,
    "reference": "SDAH440",
    "title": "How Cheering Is the Christian's Hope",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "How cheering is the Christian's hope,",
          "While toiling here below!",
          "It bouys us up while this passing through",
          "This wilderness of woe,",
          "It bouys us up while passing through",
          "This wilderness of woe."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "It points us to a land of rest",
          "Where saints with Christ will reign;",
          "Where we shall meet the loved of earth,",
          "And never part again."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Fly, lingering moments, fly, O, fly,",
          "Dear Savior, quickly come!",
          "We long to see Thee as Thou art,",
          "And reach that blissful home."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 441,
    "reference": "SDAH441",
    "title": "I Saw One Weary",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "I saw one weary, sad, and torn,",
          "With eager steps press on the way,",
          "Who long the hallowed cross had borne,",
          "Still looking for the promised day;",
          "While many a line of grief and care,",
          "Upon his brow was furrowed there;",
          "I asked what buoyed his spirits up,",
          "\"O this!\" said he \"the blessed hope.\""
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "And one I saw, with sword and shield,",
          "Who boldly braved the world's cold frown,",
          "And fought, unyielding, on the field,",
          "To win an everlasting crown.",
          "Though worn with toil, oppressed by foes,",
          "No murmur from his heart arose;",
          "I asked what buoyed his spirits up,",
          "\"O this!\" said he \"the blessed hope.\""
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "And there was one who left behind",
          "The cherished friends of early years,",
          "And honor, pleasure, wealth resigned,",
          "To tread the path bedewed with tears.",
          "Through trials deep and conflicts sore,",
          "Yet still a smile of joy he wore;",
          "I asked what buoyed his spirits up,",
          "\"O this!\" said he \"the blessed hope.\""
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "While pilgrims here we journey on",
          "In this dark vale of sin and gloom,",
          "Through tribulation, hate, and scorn,",
          "Or through the portals of the tomb,",
          "Till our returning King shall come",
          "To take His exile captives home,",
          "O! what can buoy the spirits up?",
          "'Tis this alone the blessed hope."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 442,
    "reference": "SDAH442",
    "title": "How Sweet Are the Tidings",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "How sweet are the tidings that greet the pilgrim's ear,",
          "As he wanders in exile from home!",
          "Soon, soon will the Savior in glory appear,",
          "And soon will the kingdom come."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "The mossy old graves where the pilgrims sleep",
          "Shall be open as wide as before,",
          "And the millions that sleep in the mighty deep",
          "Shall live on this earth once more."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "There we'll meet ne'er to part in our happy Eden home,",
          "Sweet songs of redemption we'll sing;",
          "From the north, from the south, all the ransomed shall come,",
          "And worship our heavenly King."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Hallelujah, Amen! hallelujah again!",
          "Soon, if faithful, we all shall be there;",
          "O, be watchful, be hopeful, be joyful till then,",
          "And a crown of bright glory we'll wear."
        ]
      }
    ],
    "chorus": [
      "He's coming, coming, coming soon I know,",
      "Coming back to this earth again;",
      "And the weary pilgrims will to glory go,",
      "When the Savior comes to reign."
    ],
    "timestamps": {
      "chorus": 20.2416
    }
  },
  {
    "hymnNumber": 443,
    "reference": "SDAH443",
    "title": "There'll Be No Sorrow There",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "There'll be no night in heaven,",
          "In that blest world above;",
          "No anxious toil, no weary hours;",
          "For labor there is love."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "There'll be no grief in heaven;",
          "For life is one glad day,",
          "And tears are those of former things",
          "Which all have passed away."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "There'll be no sin in heaven;",
          "Behold that blessed throng,",
          "All holy in their spotless robes,",
          "All holy in their song."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "There'll be no sorrow there,",
          "There'll be no sorrow there;",
          "In heaven above, where all is love,",
          "There'll be no sorrow there."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 444,
    "reference": "SDAH444",
    "title": "I'm a Pilgrim",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "I'm a pilgrim, and I'm a stranger;",
          "I can tarry, I can tarry but a night;",
          "Do not detain me, for I am going",
          "To where the fountains are ever flowing."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "There the glory is ever shining!",
          "O, my longing heart, my longing heart is there;",
          "Here in this country so dark and dreary,",
          "I long have wandered forlorn and weary."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "There's the city to which I journey;",
          "My Redeemer, my Redeemer is its light!",
          "There is no sorrow, nor any sighing,",
          "Nor any tears there, or any dying."
        ]
      }
    ],
    "chorus": [
      "I'm a pilgrim, and I'm a stranger;",
      "I can tarry, I can tarry but a night."
    ],
    "timestamps": {
      "chorus": 21.5987
    }
  },
  {
    "hymnNumber": 445,
    "reference": "SDAH445",
    "title": "I'm But a Stranger Here",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "I'm but a stranger here,",
          "Heaven is my home;",
          "Earth is a desert drear,",
          "Heaven is my home;",
          "Danger and sorrow stand",
          "Round me on every hand;",
          "Heaven is my Fatherland,",
          "Heaven is my home."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "What though the tempest rage,",
          "Heaven is my home;",
          "Short is my pilgrimage,",
          "Heaven is my home.",
          "Time's cold and wintry blast",
          "Soon will be over-past;",
          "I shall reach home at last;",
          "Heaven is my home."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "There at my Savior's side,",
          "Heaven is my home;",
          "I shall be glorified,",
          "Heaven is my home.",
          "There'll be the good and blest,",
          "Those I love most and best,",
          "There, too, I soon shall rest;",
          "Heaven is my home."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 446,
    "reference": "SDAH446",
    "title": "Lo, What a Glorious Sight Appears",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Lo, what a glorious sight appears",
          "To our believing eyes!",
          "The earth and seas are passed away,",
          "And the old rolling skies.",
          "And the old rolling skies,",
          "And the old rolling skies;",
          "The earth and seas are passed a way,",
          "And the old rolling skies."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Attending angels shout for joy",
          "And the bright armies sing;",
          "Mortals! behold the sacred seat",
          "Of your descending King.",
          "Of your descending King,",
          "Of your descending King;",
          "Mortals! behold the sacred seat",
          "Of your descending King."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "His own soft hand shall wipe the tears",
          "From every weeping eye;",
          "And pains, and groans, and griefs, and fears,",
          "And death itself shall die!",
          "And death itself shall die,",
          "And death itself shall die;",
          "And pains, and groans, and griefs, and fears,",
          "And death itself shall die."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "How long, dear Savior! oh, how long",
          "Shall this bright hour delay?",
          "Fly swifter round, ye wheels of time!",
          "And bring the welcome day.",
          "And bring the welcome day,",
          "And bring the welcome day;",
          "Fly swifter round, ye wheels of time!",
          "And bring the welcome day."
        ]
      }
    ],
    "chorus": [
      "O that will be joyful, joyful, joyful!",
      "O that will be joyful",
      "When we meet to part no more!",
      "When we meet to part no more on Canaan's happy shore;",
      "Tis there we'll meet at Jesus' feet,",
      "When we meet to part no more!"
    ],
    "timestamps": {
      "chorus": 34.7072
    }
  },
  {
    "hymnNumber": 447,
    "reference": "SDAH447",
    "title": "Long Upon the Mountains",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Long upon the mountains weary,",
          "Have the scattered flock been torn;",
          "Dark the desert paths, and dreary;",
          "Grievous trials have they borne.",
          "Now the gathering call is sounding,",
          "Solemn in its warning voice;",
          "Union, faith, and love, abounding,",
          "Bid the little flock rejoice."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Now the light of truth they're seeking,",
          "In its onward track pursue;",
          "All the ten commandments keeping,",
          "They are holy, just, and true.",
          "On the words of life they're feeding,",
          "Precious to their taste so sweet;",
          "All their Master's precepts heeding,",
          "Bowing humbly at His feet."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "In that light of light and beauty,",
          "In that golden city fair,",
          "Soon its pearly gates they'll enter,",
          "And of all its glories share.",
          "There, divine the soul's expansions;",
          "Free from sin, and death, and pain;",
          "Tears will never dim those mansions",
          "Where the saints immortal reign."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Soon He comes! with clouds descending;",
          "All His saints, entombed arise;",
          "The redeemed, in anthems blending,",
          "Shout their vict'ry thro' the skies.",
          "O, we long for Thine appearing;",
          "Come, O Savior, quickly come!",
          "Blessed hope! our spirits cheering,",
          "Take Thy ransomed children home."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 448,
    "reference": "SDAH448",
    "title": "O When Shall I See Jesus",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "O, when shall I see Jesus and reign with Him above,",
          "And shall hear the trumpet sound in that morning?",
          "And from the flowing fountain drink everlasting love,",
          "And shall hear the trumpet sound in that morning."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Gird on the gospel armor of faith and hope and love,",
          "And you'll hear the trumpet sound in that morning.",
          "And when the combat's ended He'll carry you above,",
          "And you'll hear the trumpet sound in that morning."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Our ears shall hear with transport the host of heaven sing,",
          "And shall hear the trumpet sound in that morning.",
          "Our tongues shall chant the glories of our immortal King.",
          "And shall hear the trumpet sound in that morning,"
        ]
      }
    ],
    "chorus": [
      "O, shout, glory!",
      "For I shall mount above the skies,",
      "When I hear the trumpet sound in that morning."
    ],
    "timestamps": {
      "chorus": 32.3843
    }
  },
  {
    "hymnNumber": 449,
    "reference": "SDAH449",
    "title": "Never Part Again",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "There is a land of pure delight,",
          "Where bliss eternal reigns,",
          "Infinite day excludes the night",
          "And pleasures banish pain."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "There everlasting spring abides,",
          "And never with'ring flowers,",
          "And but a little space divides",
          "This heav'nly land from ours."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Could we but stand where Moses stood,",
          "And view the landscape o'er,",
          "Not all this world's pretended good",
          "Could ever charm us more."
        ]
      }
    ],
    "chorus": [
      "We're trav'ling to Immanuel's land,",
      "We soon shall hear the trumpet sound,",
      "And soon we shall with Jesus reign,",
      "And never, never part again.",
      "What! Never part again?",
      "No, never part again,",
      "What! Never part again?",
      "No, never part again,",
      "And soon we shall with Jesus reign,",
      "And never, never part again."
    ],
    "timestamps": {
      "chorus": 23.3719
    }
  },
  {
    "hymnNumber": 450,
    "reference": "SDAH450",
    "title": "Beautiful Zion",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Beautiful Zion, built above,",
          "Beautiful city that I love,",
          "Beautiful gates of pearly white,",
          "Beautiful temple, God its light."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Beautiful trees forever there,",
          "Beautiful fruit they always bear,",
          "Beautiful rivers gliding by,",
          "Beautiful fountains never dry."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Beautiful crowns on every brow,",
          "Beautiful palms the conquerors show,",
          "Beautiful robes the ransomed wear,",
          "Beautiful all who enter there."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 451,
    "reference": "SDAH451",
    "title": "Together Let Us Sweetly Live",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Together let us sweetly live,",
          "I am bound for the land of Canaan.",
          "Together love to Jesus give;",
          "I am bound for the land of Canaan."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Together let us watch and pray;",
          "I am bound for the land of Canaan.",
          "And wait redemption's joyous day;",
          "I am bound for the land of Canaan."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Our songs of praise shall fill the skies;",
          "I am bound for the land of Canaan.",
          "While higher still our joys shall rise;",
          "I am bound for the land of Canaan."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Then come with me, beloved friend;",
          "I am bound for the land of Canaan.",
          "The joys to come shall never end;",
          "I am bound for the land of Canaan."
        ]
      }
    ],
    "chorus": [
      "O Canaan, bright Canaan,",
      "I am bound for the land of Canaan.",
      "O Canaan, it is my happy home,",
      "I am bound for the land of Canaan."
    ],
    "timestamps": {
      "chorus": 21.2215
    }
  },
  {
    "hymnNumber": 452,
    "reference": "SDAH452",
    "title": "What Heavenly Music",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "What heavenly music steals over the sea!",
          "Entrancing the senses like sweet melody!",
          "'Tis the voice of the angels borne soft on the air;",
          "For me they are singing; their welcome I hear."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "On the banks of old Jordan, here gazing I stand,",
          "And earnestly longing, I stretch forth my hand;",
          "Send a convoy of angels, dear Jesus, I pray!",
          "Let me join that sweet music; come, take me away."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Though dark are the waters and rough is the wave,",
          "If Jesus permit, the wild surges I'll brave;",
          "For that heavenly music hath ravished me so,",
          "I must join in that chorus! I'll go! let me go!"
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 453,
    "reference": "SDAH453",
    "title": "We Have Heard",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "We have heard from the bright, the holy, land;",
          "We have heard, and our hearts are glad;",
          "For we were a lonely pilgrim band,",
          "And weary, and worn, and sad.",
          "They tell us the saints have a dwelling there;",
          "No longer are homeless ones;",
          "And we know that the goodly land is fair,",
          "Where life's pure river runs."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "They say green fields are waving there,",
          "That never a blight shall know;",
          "And the deserts wild are blooming fair,",
          "And the roses of Sharon grow.",
          "There are lovely birds in the bowers green,",
          "Their songs are blithe and sweet;",
          "And their warblings, gushing ever new,",
          "The angels' harpings greet."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "We have heard of the palms, the robes, the crowns,",
          "And the silvery band in white;",
          "Of the city fair, with pearly gates,",
          "All radiant with light.",
          "We have heard of the angels there, and saints,",
          "With their harps of gold, how they sing;",
          "Of the mount with the fruitful tree of life,",
          "Of the leaves that healing bring."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "The King of that country, He is fair,",
          "He's the joy and light of the place;",
          "In His beauty we shall behold Him there,",
          "And bask in His smiling face.",
          "We'll be there, we'll be there in a little while,",
          "We'll join the pure and the blest;",
          "We'll have the palm, the robe, the crown,",
          "And forever be at rest."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 454,
    "reference": "SDAH454",
    "title": "Don't You See My Jesus Coming",
    "hasMidi": true,
    "numberOfVerses": 2,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Don't you see my Jesus coming,",
          "See Him come in yonder cloud?",
          "With ten thousand angels round Him,",
          "How they do my Jesus crowd!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Don't you see the saints ascending,",
          "Hear them shouting thro' the air.",
          "Jesus smiling, trumpets sounding,",
          "Now His glory they shall share."
        ]
      }
    ],
    "chorus": [
      "I am bound for the kingdom,",
      "Will you go to glory with me?",
      "Hallelujah! O praise ye the Lord!"
    ],
    "timestamps": {
      "chorus": 20.0496
    }
  },
  {
    "hymnNumber": 455,
    "reference": "SDAH455",
    "title": "Immortal Love, Forever Full",
    "hasMidi": true,
    "numberOfVerses": 6,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Immortal Love, forever full,",
          "Forever flowing free,",
          "Forever shared, forever whole,",
          "A never ebbing sea!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "We may not climb the heavenly steeps",
          "To bring the Lord Christ down;",
          "In vain we search the lowest deeps,",
          "For Him no depths can drown."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "But warm, sweet, tender, even yet",
          "A present help is He;",
          "And faith has still its Olivet,",
          "And love its Galilee."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "The healing of His seamless dress",
          "Is by our beds of pain;",
          "We touch Him in life's throng and press,",
          "And we are whole again."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "Through Him the first fond prayers are said,",
          "Our lips of childhood frame;",
          "The last low whispers of our dead",
          "Are burdened with His name."
        ]
      },
      {
        "verseNumber": 6,
        "content": [
          "O Lord and Master of us all:",
          "What e'er our name or sign,",
          "We own Thy sway, we hear Thy call,",
          "We test our lives by Thine!"
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 456,
    "reference": "SDAH456",
    "title": "My Lord and I",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "I have a Friend so precious,",
          "So very dear to me,",
          "He loves me with such tender love,",
          "He loves so faithfully;",
          "I could not live apart from Him,",
          "I love to feel Him nigh,",
          "And so we dwell together,",
          "My Lord and I."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Sometimes I'm faint and weary,",
          "He knows that I am weak,",
          "And as He bids me lean on Him,",
          "His help I gladly seek;",
          "He leads me in the paths of light,",
          "Beneath a sunny sky,",
          "And so we walk together,",
          "My Lord and I."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "I tell Him all my sorrows,",
          "I tell Him all my joys,",
          "I tell Him all that pleases me,",
          "I tell Him what annoys;",
          "He tells me what I ought to do,",
          "He tells me how to try,",
          "And so we talk together,",
          "My Lord and I."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "He knows that I am longing",
          "Some weary soul to win,",
          "And so He bids me go and speak",
          "The loving word for Him;",
          "He bids me tell His wondrous love,",
          "And why He came to die,",
          "And so we work together,",
          "My Lord and I."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 457,
    "reference": "SDAH457",
    "title": "I Love to Tell the Story",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "I love to tell the story",
          "Of unseen things above,",
          "Of Jesus and His glory,",
          "Of Jesus and His love;",
          "I love to tell the story,",
          "Because I know 'tis true;",
          "It satisfies my longing",
          "As nothing else can do."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "I love to tell the story;",
          "More wonderful it seems",
          "Than all the golden fancies",
          "Of all our golden dreams;",
          "I love to tell the story,",
          "It did so much for me,",
          "And that is just the reason",
          "I tell it now to thee."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "I love to tell the story;",
          "'Tis pleasant to repeat",
          "What seems each time I tell it,",
          "More wonderfully sweet;",
          "I love to tell the story,",
          "For some have never heard",
          "The message of salvation",
          "From God's own holy word."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "I love to tell the story;",
          "For those who know it best",
          "Seem hungering and thirsting",
          "To hear it like the rest;",
          "And when in scenes of glory",
          "I sing the new, new song,",
          "'Twill be the old, old story",
          "That I have loved so long."
        ]
      }
    ],
    "chorus": [
      "I love to tell the story;",
      "'Twill be my theme in glory",
      "To tell the old, old story",
      "Of Jesus and His love."
    ],
    "timestamps": {
      "chorus": 35.8229
    }
  },
  {
    "hymnNumber": 458,
    "reference": "SDAH458",
    "title": "More Love to Thee",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "More love to Thee, O Christ!",
          "More love to Thee;",
          "Hear Thou the prayer I make",
          "On bended knee.",
          "This is my earnest plea,",
          "More love, O Christ, to Thee,",
          "More love to Thee!",
          "More love to Thee!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Once earthly joy I craved,",
          "Sought peace and rest;",
          "Now Thee alone I seek,",
          "Give what is best.",
          "This all my prayer shall be,",
          "More love, O Christ, to Thee,",
          "More love to Thee!",
          "More love to Thee!"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Let sorrow do its work,",
          "Send grief or pain;",
          "Sweet are Thy messengers,",
          "Sweet their refrain,",
          "When they can sing with me,",
          "More love, O Christ, to Thee,",
          "More love to Thee!",
          "More love to Thee!"
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Then shall my latest breath",
          "Whisper Thy praise;",
          "This be the parting cry",
          "My heart shall raise,",
          "This still its prayer shall be:",
          "More love, O Christ, to Thee,",
          "More love to Thee!",
          "More love to Thee!"
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 459,
    "reference": "SDAH459",
    "title": "As the Bridegroom to His Chosen",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "As the bridegroom to his chosen,",
          "as the king to his realm,",
          "As the keep unto the castle,",
          "as the pilot to the helm,",
          "So, Lord, art Thou to me."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "As the fountain in the garden,",
          "as the candle in the dark,",
          "As the treasure in the coffer,",
          "as the manna in the ark,",
          "So, Lord, art Thou to me."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "As the ruby in the setting,",
          "as the honey in the comb,",
          "As the light within the lantern,",
          "as the father in the home,",
          "So, Lord, art Thou to me."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "As the sunshine in the heavens,",
          "as the image in the glass,",
          "As the fruits up in the fig tree,",
          "as the dew upon the grass,",
          "So, Lord, art Thou to me."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 460,
    "reference": "SDAH460",
    "title": "As Water to the Thirsty",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "As water to the thirsty,",
          "As beauty to the eyes,",
          "As strength that follows weakness,",
          "As truth instead of lies;",
          "As songtime and springtime and summertime to be,",
          "So is my Lord, my living Lord,",
          "So is my Lord to me."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Like calm in place of clamor",
          "Like peace that follows pain,",
          "Like meeting after parting,",
          "Like sunshine after rain;",
          "Like moonlight and starlight and sunlight on the sea,",
          "So is my Lord, my living Lord,",
          "So is my Lord to me."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "As sleep that follows fever,",
          "As gold instead of grey,",
          "As freedom after bondage,",
          "As sunrise to the day;",
          "As home to the trav'ler and all he longs to see,",
          "So is my Lord, my Living Lord,",
          "So is my Lord to me."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 461,
    "reference": "SDAH461",
    "title": "Be Still My Soul",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Be still, my soul: the Lord is on thy side;",
          "Bear patiently the cross of grief or pain;",
          "Leave to thy God to order and provide;",
          "In every change He faithful will remain.",
          "Be still, my soul: thy best, thy heavenly friend",
          "Through thorny ways leads to a joyful end."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Be still, my soul: thy God doth undertake",
          "To guide the future as He has the past.",
          "Thy hope, thy confidence let nothing shake;",
          "All now mysterious shall be bright at last.",
          "Be still, my soul: the waves and winds still know",
          "His voice who ruled them while He dwelth below."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Be still, my soul: the hour is hastening on",
          "When we shall be forever with the Lord,",
          "When disappointment, grief, and fear are gone,",
          "Sorrow forgot, love's purest joys restored.",
          "Be still, my soul: when change and tears are past,",
          "All safe and blessed we shall meet at last."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 462,
    "reference": "SDAH462",
    "title": "Blessed Assurance, Jesus Is Mine!",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Blessed assurance, Jesus is mine!",
          "O, what a foretaste of glory divine!",
          "Heir of salvation, purchase of God,",
          "Born of His Spirit, washed in His blood."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Perfect submission, perfect delight,",
          "Visions of rapture now burst on my sight.",
          "Angels descending bring from above",
          "Echoes of mercy, whispers of love."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Perfect submission, all is at rest,",
          "I in my Savior am happy and blest,",
          "Watching and waiting, looking above,",
          "Filled with His goodness, lost in His love."
        ]
      }
    ],
    "chorus": [
      "This is my story, this is my song,",
      "Praising my Savior all the day long;",
      "This is my story, this is my song,",
      "Praising my Savior all the day long."
    ],
    "timestamps": {
      "chorus": 25.3024
    }
  },
  {
    "hymnNumber": 463,
    "reference": "SDAH463",
    "title": "Peace, Perfect Peace",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Peace, perfect peace, in this dark world of sin?",
          "The blood of Jesus whispers peace within."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Peace, perfect peace, by thronging duties pressed?",
          "To do the will of Jesus: this is rest."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Peace, perfect peace, with loved ones far away?",
          "In Jesus' keeping we are safe, and they."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Peace, perfect peace, our future all unknown?",
          "Jesus we know, and He is on the throne."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 464,
    "reference": "SDAH464",
    "title": "When I Can Read My Title Clear",
    "hasMidi": true,
    "numberOfVerses": 2,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "When I can read my title clear",
          "To mansions in the skies",
          "I'll bid farewell to every fear,",
          "And wipe my weeping eyes;",
          "And wipe my weeping eyes,",
          "And wipe my weeping eyes,",
          "I'll bid farewell to every fear,",
          "And wipe my weeping eyes."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Should earth against my soul engage,",
          "And fiery darts be hurled,",
          "Then I can smile at Satan's rage,",
          "And face a frowning world;",
          "And face a frowning world,",
          "And face a frowning world,",
          "Then I can smile at Satan's rage,",
          "And face a frowning world."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 465,
    "reference": "SDAH465",
    "title": "I Heard the Voice of Jesus",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "I heard the voice of Jesus say,",
          "\"Come unto Me and rest;",
          "Lay down, thou weary one, lay down",
          "Thy head upon My breast.\"",
          "I came to Jesus as I was,",
          "Weary and worn and sad;",
          "I found in Him a resting place,",
          "And He has made me glad."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "I heard the voice of Jesus say,",
          "\"Behold, I freely give",
          "The living water; thirsty one,",
          "Stoop down and drink and live.\"",
          "I came to Jesus, and I drank",
          "Of that life giving stream;",
          "My thirst was quench'd, my soul revived,",
          "And now I live in Him."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "I heard the voice of Jesus say,",
          "\"I am this dark world's light;",
          "Look unto Me, thy morn shall rise,",
          "And all thy day be bright.\"",
          "I looked to Jesus, and I found",
          "In Him my star, my sun;",
          "And in that light of life I'll walk,",
          "Till trav'ling days are done."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 466,
    "reference": "SDAH466",
    "title": "Wonderful Peace",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Far away in the depths of my spirit tonight,",
          "Rolls a melody sweeter than psalm;",
          "In celestial-like strains it unceasingly falls",
          "O'er my soul like an infinite calm."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "What a treasure I have in this wonderful peace,",
          "Buried deep in my innermost soul,",
          "So secure that no power can mine it away,",
          "While the years of eternity roll!"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "I believe when I rise to that city of peace,",
          "Where the Author of peace I shall see,",
          "That one strain of the song which the ransomed will sing,",
          "In that heavenly kingdom will be;"
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Weary soul, without gladness or comfort or rest,",
          "Passing down the rough pathway of time!",
          "Make the Savior your friend ere the shadows grow dark;",
          "O accept of this peace so sublime."
        ]
      }
    ],
    "chorus": [
      "Peace! peace! wonderful peace,",
      "Coming down from the Father above;",
      "Sweep over my spirit forever, I pray,",
      "In fathomless billows of love."
    ],
    "timestamps": {
      "chorus": 23.9393
    }
  },
  {
    "hymnNumber": 467,
    "reference": "SDAH467",
    "title": "Life Is Great! So Sing About It",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Life is great! So sing about it,",
          "As we can and as we should-",
          "Shop and buses, towns and people,",
          "Village, farmland, field and wood,",
          "Life is great and life is given;",
          "Life is lovely, free and good."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Life is great!- what ever happens,",
          "Snow or sunshine, joy or pain,",
          "Hardship, grief or disillusion,",
          "Suffering that I can't explain-",
          "Life is great if someone loves me,",
          "Holds my hand and calls my name."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Love is great!- the love of lovers,",
          "Whispered words and longing eyes;",
          "Love that gazes at the cradle",
          "Where a child of loving lies;",
          "Love that lasts when youth has faded,",
          "Bends with age, but never dies."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Love is giving and receiving-",
          "Boy and girl, or friend with friend;",
          "Love is bearing and forgiving",
          "All the hurts that hate can send;",
          "Love's the greatest way of living,",
          "Hoping, trusting to the end."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "God is great! in Christ He loved us,",
          "As we should, but never can-",
          "Love that suffered, hoped and trusted",
          "When disciples turned and ran,",
          "Love that broke through death forever.",
          "Praise that loving, living Man!"
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 468,
    "reference": "SDAH468",
    "title": "A Child of the King",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "My Father is rich in houses and lands;",
          "He holdeth the wealth of the world in His hands!",
          "Of rubies and diamonds, of silver and gold,",
          "His coffers are full; He has riches untold."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "My Father's own Son, the Savior of men,",
          "Once wandered on earth as the poorest of them;",
          "But now He is pleading for sinners on high,",
          "And will give me a home when He comes by and by."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "I once was an outcast, a stranger on earth,",
          "A sinner by choice, and an alien by birth!",
          "But I've been adopted, my name's written down,",
          "An heir to a mansion, a robe, and a crown."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "A tent or a cottage, O why should I care?",
          "They're building a palace for me over there!",
          "Though exiled from home, yet still I may sing:",
          "\"All glory to God, I'm a child of the King.\""
        ]
      }
    ],
    "chorus": [
      "I'm a child of the King, a child of the King!",
      "With Jesus, my Savior, I'm a child of the King!"
    ],
    "timestamps": {
      "chorus": 27.8055
    }
  },
  {
    "hymnNumber": 469,
    "reference": "SDAH469",
    "title": "Leaning on the Everlasting Arms",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 19.3772
    },
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "What a fellowship, what a joy divine,",
          "Leaning on the everlasting arms;",
          "What a blessedness, what a peace is mine,",
          "Leaning on the everlasting arms."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "O how sweet to walk in this pilgrim way,",
          "Leaning on the everlasting arms;",
          "O how bright the path grows from day to day,",
          "Leaning on the everlasting arms."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "What have I to dread, what have I to fear,",
          "Leaning on the everlasting arms?",
          "I have blessed peace with my Lord so near,",
          "Leaning on the everlasting arms."
        ]
      }
    ],
    "chorus": [
      "Leaning, leaning,",
      "Safe and secure from all alarms;",
      "Leaning, leaning,",
      "Leaning on the everlasting arms."
    ]
  },
  {
    "hymnNumber": 470,
    "reference": "SDAH470",
    "title": "There's Sunshine in My Soul Today",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "There's sunshine in my soul today,",
          "More glorious and bright,",
          "Than glows in any earthly sky,",
          "For Jesus is my light."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "There's music in my soul today,",
          "A carol to my King,",
          "And Jesus, listening, can hear",
          "The songs I cannot sing."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "There's springtime in my soul today,",
          "For when the Lord is near,",
          "The dove of peace sings in my heart,",
          "The flowers of grace appear."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "There's gladness in my soul today,",
          "And hope, and praise, and love,",
          "For blessings which He gives me now,",
          "For joys \"laid up\" above."
        ]
      }
    ],
    "chorus": [
      "O there's sunshine, blessed sunshine,",
      "When the peaceful, happy moments roll;",
      "When Jesus shows His smiling face",
      "There is sunshine in the soul."
    ],
    "timestamps": {
      "chorus": 19.5533
    }
  },
  {
    "hymnNumber": 471,
    "reference": "SDAH471",
    "title": "Grant Us Your Peace",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Dona nobis pacem, pacem;",
          "Dona nobis pacem.",
          "Dona nobis pacem;",
          "Dona nobis pacem.",
          "Dona nobis pacem;",
          "Dona nobis pacem."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Father grant us, grant us Your peace;",
          "Oh, loving Father, grant us Your peace.",
          "Grant us, grant us peace;",
          "Grant us, grant us, grant Your peace;",
          "Grant us, grant us peace;",
          "Loving Father, grant us Your peace."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "A coordenous ta paix, ta paix,",
          "A coordenous ta paix.",
          "A coordenous ta paix;",
          "A coordenous ta paix.",
          "A coordenous ta paix;",
          "A coordenous ta paix."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Padre, danos tu paz, tu paz;",
          "Padre, danos, danos tu paz",
          "Padre, danos, tup az.",
          "Padre, danos, danos tu paz.",
          "Padre, danos tu paz;",
          "Padre, danos, danos tu paz."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 472,
    "reference": "SDAH472",
    "title": "A Song of Heaven and Homeland",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Sometimes I hear strange music,",
          "Like none e'er heard before,",
          "Come floating softly earthward",
          "As thro' heav'n's open door:",
          "It seems like angel voices,",
          "In strains of joy and love,",
          "That swell the mighty chorus",
          "Around the throne above."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Now soft, and low, and restful,",
          "It floods my soul with peace,",
          "As if God's benediction",
          "Bade all earth's troubles cease.",
          "Then grander than the voices,",
          "Of wind, and wave, and sea;",
          "It fills the dome of heaven",
          "With glorious harmony."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "This music haunts me ever,",
          "Like something heard in dreams;",
          "It seems to catch the cadence",
          "Of heav'nly winds and streams.",
          "My heart is filled with rapture,",
          "To think, some day to come,",
          "I'll sing it with the angels;",
          "The song of heav'n and home."
        ]
      }
    ],
    "chorus": [
      "O sweet, celestial music,",
      "Heard from a land afar;",
      "The song of Heav'n and Homeland,",
      "Thro' doors God leaves ajar!"
    ],
    "timestamps": {
      "chorus": 30.9668
    }
  },
  {
    "hymnNumber": 473,
    "reference": "SDAH473",
    "title": "Nearer My God, to Thee",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Nearer, my God, to Thee,",
          "Nearer to Thee!",
          "E'en though it be a cross",
          "That raiseth me!",
          "Still all my song shall be,",
          "Nearer, my God, to Thee,",
          "Nearer, my God, to Thee,",
          "Nearer to Thee."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Though like a wanderer,",
          "Daylight all gone,",
          "Darkness be over me,",
          "My rest a stone;",
          "Yet in my dreams I'd be",
          "Nearer, my God, to Thee,",
          "Nearer, my God, to Thee,",
          "Nearer to Thee."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "There let the way appear,",
          "Steps up to heaven;",
          "All that Thou sendest me,",
          "In mercy given;",
          "Angels to beckon me",
          "Nearer, my God, to Thee,",
          "Nearer, my God, to Thee,",
          "Nearer to Thee."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Then, with my waking thoughts",
          "Bright with Thy praise,",
          "Out of my stony griefs",
          "Bethel I raise;",
          "So by my woes to be",
          "Nearer, my God, to Thee,",
          "Nearer, my God, to Thee,",
          "Nearer to Thee."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "Or if, on joyful wing",
          "Cleaving the sky,",
          "Sun, moon, and stars forgot,",
          "Upward I fly,",
          "Still all my song shall be,",
          "Nearer, my God, to Thee,",
          "Nearer, my God, to Thee,",
          "Nearer to Thee."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 474,
    "reference": "SDAH474",
    "title": "Take the Name of Jesus With You",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Take the name of Jesus with you,",
          "Child of sorrow and of woe;",
          "It will joy and comfort give you,",
          "Take it, then, where'er you go."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Take the name of Jesus ever,",
          "As a shield from every snare;",
          "If temptations round you gather,",
          "Breathe that holy name in prayer."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "O the precious name of Jesus!",
          "How it thrills our souls with joy,",
          "When His loving arms receive us,",
          "And His songs our tongues employ."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "At the name of Jesus bowing,",
          "Falling prostrate at His feet,",
          "King of kings in heaven we'll crown Him,",
          "When our journey is complete."
        ]
      }
    ],
    "chorus": [
      "Precious name, O how sweet!",
      "Hope of earth and joy of heaven;",
      "Precious name, O how sweet!",
      "Hope of earth and joy of heaven."
    ],
    "timestamps": {
      "chorus": 19.1768
    }
  },
  {
    "hymnNumber": 475,
    "reference": "SDAH475",
    "title": "Balm in Gilead",
    "hasMidi": true,
    "numberOfVerses": 2,
    "hasChorus": true,
    "startsWithChorus": true,
    "timestamps": {
      "chorus": 21.7992
    },
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Sometimes I feel discouraged,",
          "And think my work's in vain,",
          "But then the Holy Spirit",
          "Revives my soul again."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "If you cannot preach like Peter,",
          "If you cannot pray like Paul,",
          "You can tell the love of Jesus,",
          "And say He died for all."
        ]
      }
    ],
    "chorus": [
      "There is a balm in Gilead to make the wounded whole;",
      "There is a balm in Gilead to heal the sinsick soul."
    ]
  },
  {
    "hymnNumber": 476,
    "reference": "SDAH476",
    "title": "Burdens Are Lifted At Calvary",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Days are filled with sorrow and care,",
          "Hearts are lonely and drear;",
          "Burdens are lifted at Calvary,",
          "Jesus is very near."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Cast your care on Jesus today,",
          "Leave your worry and fear;",
          "Burdens are lifted at Calvary,",
          "Jesus is very near."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Troubled soul, the Savior can see",
          "Every heartache and tear;",
          "Burdens are lifted at Calvary,",
          "Jesus is very near."
        ]
      }
    ],
    "chorus": [
      "Burdens are lifted at Calvary,",
      "Calvary, Calvary;",
      "Burdens are lifted at Calvary,",
      "Jesus is very near."
    ],
    "timestamps": {
      "chorus": 25.7478
    }
  },
  {
    "hymnNumber": 477,
    "reference": "SDAH477",
    "title": "Come, Ye Disconsolate",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Come, ye disconsolate, where'er ye languish;",
          "Come to the mercy seat, fervently kneel;",
          "Here bring your wounded hearts, here tell your anguish;",
          "Earth has no sorrow that heaven cannot heal."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Joy of the comfortless, light of the straying,",
          "Hope of the penitent, fadeless and pure!",
          "Here speaks the Comforter, tenderly saying,",
          "\"Earth has no sorrow that heaven cannot cure.\""
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Here see the Bread of Life; see waters flowing",
          "Forth from the throne of God, pure from above;",
          "Come to the feast of love; come, ever knowing",
          "Earth has no sorrow but heaven can remove."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 478,
    "reference": "SDAH478",
    "title": "Sweet Hour of Prayer",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Sweet hour of prayer, sweet hour of prayer,",
          "That calls me from a world of care,",
          "And bids me, at my Father's throne,",
          "Make all my wants and wishes known!",
          "In seasons of distress and grief,",
          "My soul has often found relief.",
          "And oft escaped the tempters snare,",
          "By thy return, sweet hour of prayer."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Sweet hour of prayer! sweet hour of prayer!",
          "Thy wings shall my petition bear",
          "To Him whose truth and faithfulness",
          "Engage the waiting soul to bless.",
          "And since He bids me seek His face,",
          "Believe His word, and trust His grace,",
          "I'll cast on Him my every care,",
          "And wait for thee, sweet hour of prayer."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Sweet hour of prayer! sweet hour of prayer!",
          "May I thy consolation share",
          "Till from Mount Pisgah's lofty height",
          "I view my home and take my flight.",
          "In my immortal flesh I'll rise",
          "To seize the everlasting prize.",
          "And shout while passing through the air,",
          "\"Farewell, farewell, sweet hour of prayer!\""
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 479,
    "reference": "SDAH479",
    "title": "Tread Softly",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Be silent, be silent,",
          "A whisper is heard;",
          "Be silent, and listen,",
          "Oh, treasure each word."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Be silent, be silent,",
          "For holy this place,",
          "This altar that echoes",
          "The message of grace."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Be silent, be silent,",
          "Breathe humbly our prayer;",
          "A foretaste of Eden",
          "This moment we share."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Be silent, be silent,",
          "His mercy record;",
          "Be silent, be silent,",
          "And wait on the Lord."
        ]
      }
    ],
    "chorus": [
      "Tread softly, tread softly,",
      "The Master is here;",
      "Tread softly, tread softly,",
      "He bids us draw near."
    ],
    "timestamps": {
      "chorus": 23.3628
    }
  },
  {
    "hymnNumber": 480,
    "reference": "SDAH480",
    "title": "Dear Lord and Father",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Dear Lord and Father of mankind,",
          "Forgive our foolish ways;",
          "Reclothe us in our rightful mind,",
          "In purer lives Thy service find,",
          "In deeper reverence praise,",
          "In deeper reverence, praise."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "In simple trust like theirs who heard,",
          "Beside the Syrian sea,",
          "The gracious calling of the Lord,",
          "Let us, like them, without a word,",
          "Rise up and follow Thee,",
          "Rise up and follow Thee."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "O Sabbath rest by Galilee,",
          "O calm of hills above,",
          "Where Jesus knelt to share with Thee",
          "The silence of eternity,",
          "Interpreted by love,",
          "Interpreted by love."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Drop Thy still dews of quietness,",
          "Till all our strivings cease;",
          "Take from our souls the strain and stress,",
          "And let our ordered lives confess",
          "The beauty of Thy peace,",
          "The beauty of Thy peace."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "Breathe thro' the heats of our desire,",
          "Thy coolness and Thy balm;",
          "Let sense be dumb, let flesh retire;",
          "Speak thro' the earthquake, wind, and fire,",
          "O still small voice of calm,",
          "O still small voice of calm."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 481,
    "reference": "SDAH481",
    "title": "Dear Lord and Father",
    "hasMidi": true,
    "numberOfVerses": 1,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Dear Lord and Father of mankind,",
          "Forgive our feverish ways;",
          "Reclothe us in our rightful mind",
          "In purer lives Thy service find,",
          "In deeper reverence praise."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 482,
    "reference": "SDAH482",
    "title": "Father, Lead Me Day by Day",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Father, lead me day by day,",
          "Ever in Thine own sweet way;",
          "Teach me to be pure and true;",
          "Show me what I ought to do."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "When in danger, make me brave;",
          "Make me know that Thou canst save;",
          "Keep me safe by Thy dear side;",
          "Let me in Thy love abide."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "When I'm tempted to do wrong,",
          "Make me steadfast, wise, and strong;",
          "And when all alone I stand,",
          "Shield me with Thy mighty hand."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "May I do the good I know,",
          "Be Thy loving child below,",
          "Then at last go home to Thee,",
          "Evermore Thy child to be."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 483,
    "reference": "SDAH483",
    "title": "I Need Thee Every Hour",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "I need Thee every hour,",
          "Most gracious Lord;",
          "No tender voice like Thine",
          "Can peace afford."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "I need Thee every hour,",
          "Stay Thou near by;",
          "Temptations lose their power",
          "When Thou art nigh."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "I need Thee every hour,",
          "In joy or pain;",
          "Come quickly, and abide,",
          "Or life is vain."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "I need Thee every hour,",
          "Teach me Thy will,",
          "And Thy rich promises",
          "In me fulfill."
        ]
      }
    ],
    "chorus": [
      "I need Thee, O I need Thee;",
      "Every hour I need Thee!",
      "O bless me now, my Savior;",
      "I come to Thee."
    ],
    "timestamps": {
      "chorus": 16.53
    }
  },
  {
    "hymnNumber": 484,
    "reference": "SDAH484",
    "title": "I Need Thee, Precious Jesus",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "I need Thee, precious Jesus,",
          "For I am very poor;",
          "A stranger and a pilgrim,",
          "I have no earthly store.",
          "I need the love of Jesus",
          "To cheer me on my way,",
          "To guide my doubting footsteps,",
          "To be my strength and stay."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "I need the heart of Jesus",
          "To feel each anxious care,",
          "To tell my every trial,",
          "And all my sorrows share.",
          "I need the Holy Spirit",
          "To teach me what I am,",
          "To show me more of Jesus,",
          "To point me to the Lamb."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "I need Thee, precious Jesus,",
          "I hope to see Thee soon,",
          "Encircled with the rainbow,",
          "And seated on Thy throne.",
          "There, with Thy blood-bought children,",
          "My joy shall ever be",
          "To sing Thy ceaseless praises,",
          "To gaze, my Lord, on Thee!"
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 485,
    "reference": "SDAH485",
    "title": "I Must Tell Jesus",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "I must tell Jesus all of my trials;",
          "I cannot bear the burdens alone,",
          "In my distress He kindly will help me,",
          "He ever loves and cares for His own."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "I must tell Jesus all of my troubles,",
          "He is a kind, compassionate Friend;",
          "If I but ask Him, He will deliver,",
          "Makes of my troubles quickly an end."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "O how the world to evil allures me!",
          "O how my heart is tempted to sin!",
          "I must tell Jesus, and He will help me",
          "Over the world the vict'ry to win."
        ]
      }
    ],
    "chorus": [
      "I must tell Jesus!",
      "I must tell Jesus!",
      "I cannot bear my burdens alone;",
      "I must tell Jesus!",
      "I must tell Jesus!",
      "Jesus can help me, Jesus alone."
    ],
    "timestamps": {
      "chorus": 28.5436
    }
  },
  {
    "hymnNumber": 486,
    "reference": "SDAH486",
    "title": "I Do Believe",
    "hasMidi": true,
    "numberOfVerses": 6,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Father, I stretch my hands to Thee;",
          "No other help I know;",
          "If Thou withdraw Thyself from me,",
          "Ah, whither shall I go?"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "On Thy dear Son I now believe,",
          "O let me feel Thy power;",
          "And all my varied wants relieve,",
          "In this accepted hour."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Author of faith! to Thee I lift",
          "My weary, longing eyes;",
          "O let me now receive that gift;",
          "My soul without it dies."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Surely Thou canst not let me die;",
          "O speak, and I shall live;",
          "And here I will unwearied lie,",
          "Till Thou Thy Spirit give."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "How would my fainting soul rejoice",
          "Could I but see Thy face!",
          "Now let me hear Thy quickening voice,",
          "And taste Thy pardoning grace."
        ]
      },
      {
        "verseNumber": 6,
        "content": [
          "I do believe, I now believe",
          "That Jesus died for me,",
          "And that He shed His precious blood",
          "From sin to set me free."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 487,
    "reference": "SDAH487",
    "title": "In the Garden",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "I come to the garden alone,",
          "While the dew is still on the roses;",
          "And the voice I hear, falling on my ear,",
          "The Son of God discloses."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "He speaks, and the sound of His voice",
          "Is so sweet the birds hush their singing,",
          "And the melody that He gave to me",
          "Within my heart is ringing."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "I'd stay in the garden with Him",
          "Though the night around me be falling,",
          "But He bids me go; through the voice of woe,",
          "His voice to me is calling."
        ]
      }
    ],
    "chorus": [
      "And He walks with me, and He talks with me,",
      "And He tells me I am His own;",
      "And the joy we share as we tarry there,",
      "None other has ever known."
    ],
    "timestamps": {
      "chorus": 24.5897
    }
  },
  {
    "hymnNumber": 488,
    "reference": "SDAH488",
    "title": "At First I Prayed for Light",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "At first I prayed for light:",
          "Could I but see the way,",
          "How gladly, swiftly would I walk",
          "To everlasting day!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "And next I prayed for strength:",
          "That I might tread the road",
          "With firm, unfaltering feet, and win",
          "The heaven's serene abode."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "And then I asked for faith:",
          "Could I but trust my God,",
          "I'd live infolded in His peace,",
          "Though foes were all abroad."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "But now I pray for love:",
          "Deep love to God and man;",
          "A living love that will not fail,",
          "However dark His plan."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "And light and strength and faith",
          "Are opening everywhere!",
          "God waited patiently until",
          "I prayed the larger prayer."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 489,
    "reference": "SDAH489",
    "title": "Jesus, Lover of My Soul",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Jesus, lover of my soul,",
          "Let me to Thy bosom fly,",
          "While the billows near me roll,",
          "While the tempest still is high;",
          "Hide me, O my Savior, hide!",
          "Till the storm of life is past;",
          "Safe into the haven guide,",
          "O receive my soul at last!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Other refuge have I none,",
          "Hangs my helpless soul on Thee;",
          "Leave, O leave me not alone!",
          "Still support and comfort me;",
          "All my trust on Thee is stayed,",
          "All my help from Thee I bring;",
          "Cover my defenseless head",
          "With the shadow of Thy wing."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Thou, O Christ, art all I want,",
          "More than all in Thee I find;",
          "Raise the fallen, cheer the faint,",
          "Heal the sick, and lead the blind.",
          "Just and holy is Thy name,",
          "I am all unrighteousness;",
          "Vile and full of sin I am,",
          "Thou art full of truth and grace."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Plenteous grace with Thee is found;",
          "Grace to pardon all my sin;",
          "Let the healing streams abound,",
          "Make and keep me pure within;",
          "Thou of life the Fountain art,",
          "Freely let me take of Thee;",
          "Spring Thou up within my heart,",
          "Rise to all eternity."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 490,
    "reference": "SDAH490",
    "title": "Jesus, Lover of My Soul",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Jesus, lover of my soul,",
          "Let me to Thy bosom fly,",
          "While the billows near me roll,",
          "While the tempest still is high;",
          "Hide me, O my Savior, hide!",
          "Till the storm of life is past;",
          "Safe into the haven guide,",
          "O receive my soul at last!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Other refuge have I none,",
          "Hangs my helpless soul on Thee;",
          "Leave, O leave me not alone!",
          "Still support and comfort me;",
          "All my trust on Thee is stayed,",
          "All my help from Thee I bring;",
          "Cover my defenseless head",
          "With the shadow of Thy wing."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Thou, O Christ, art all I want,",
          "More than all in Thee I find;",
          "Raise the fallen, cheer the faint,",
          "Heal the sick, and lead the blind.",
          "Just and holy is Thy name,",
          "I am all unrighteousness;",
          "Vile and full of sin I am,",
          "Thou art full of truth and grace."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Plenteous grace with Thee is found;",
          "Grace to pardon all my sin;",
          "Let the healing streams abound,",
          "Make and keep me pure within;",
          "Thou of life the Fountain art,",
          "Freely let me take of Thee;",
          "Spring Thou up within my heart,",
          "Rise to all eternity."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 491,
    "reference": "SDAH491",
    "title": "In the Hour of Trial",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "In the hour of trial,",
          "Jesus, plead for me,",
          "Lest by base denial",
          "I depart from Thee;",
          "When Thou see'st me waver,",
          "With a look recall,",
          "Nor, for fear or favor,",
          "Suffer me to fall."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "With forbidden pleasures,",
          "Would this vain world charm;",
          "Or its sordid treasures",
          "Spread to work me harm;",
          "Bring to my remembrance",
          "Sad Gethsemane,",
          "Or, in darker semblance,",
          "Cross-crowned Calvary."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Should Thy mercy send me",
          "Sorrow, toil, and woe,",
          "Or should pain attend me",
          "On my path below,",
          "Grant that I may never",
          "Fail Thy hand to see;",
          "Grant that I may ever",
          "Cast my care on Thee."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 492,
    "reference": "SDAH492",
    "title": "Like Jesus",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Teach, me, Father, what to say;",
          "Teach me, Father, how to pray;",
          "Teach me all along the way",
          "How to be like Jesus."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Teach me as the days go by,",
          "Teach me not to reason why,",
          "Teach me that to do and die,",
          "Is to be like Jesus."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Teach me that the time is short,",
          "Teach me how to live and work,",
          "Teach me that to never shirk",
          "Is to be like Jesus."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Teach me how we may be one,",
          "Like the Father and the Son;",
          "And when all is overcome,",
          "I will be like Jesus."
        ]
      }
    ],
    "chorus": [
      "I would be like Jesus,",
      "I would be like Jesus!",
      "Help me, Lord, to daily grow",
      "More and more like Jesus!"
    ],
    "timestamps": {
      "chorus": 21.7149
    }
  },
  {
    "hymnNumber": 493,
    "reference": "SDAH493",
    "title": "Fill My Cup Lord",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Like the woman at the well I was seeking",
          "For things that could not satisfy;",
          "And then I heard my Savior speaking:",
          "\"Draw from My well that never shall run dry.\""
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "There are millions in this world who are craving",
          "The pleasure earthly things afford;",
          "But none can match the wondrous treasure",
          "That I find in Jesus Christ my Lord."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "So, my children, if the things this world gave you",
          "Leave hungers that won't pass away,",
          "My blessed Lord will come and save you,",
          "If you kneel to Him and humbly pray:"
        ]
      }
    ],
    "chorus": [
      "Fill my cup, Lord, I lift it up, Lord!",
      "Come and quench this thirsting of my soul;",
      "Bread of heaven, feed me till I want no more-",
      "Fill my cup, fill it up and make me whole!"
    ],
    "timestamps": {
      "chorus": 27.1668
    }
  },
  {
    "hymnNumber": 494,
    "reference": "SDAH494",
    "title": "We Would See Jesus",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "\"We would see Jesus;\" for the shadows lengthen",
          "Across the little landscape of our life;",
          "We would see Jesus, our weak faith to strengthen",
          "For the last conflict, in this mortal strife."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "\"We would see Jesus,\" Rock of our salvation,",
          "Whereon our feet were set with sovereign grace;",
          "Not life, nor death, with all their agitation,",
          "Can thence remove us, gazing on His face."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "\"We would see Jesus;\" other lights are paling,",
          "Which for long years we did rejoice to see;",
          "The blessings of this sinful world are failing;",
          "We would not mourn them, in exchange for Thee."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "\"We would see Jesus;\" this is all we're needing;",
          "Strength, joy, and willingness come with the sight;",
          "We would see Jesus, dying, risen, pleading,",
          "Soon to return and end this mortal night!"
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 495,
    "reference": "SDAH495",
    "title": "Near to the Heart of God",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "There is a place of quiet rest,",
          "Near to the heart of God,",
          "A place where sin cannot molest,",
          "Near to the heart of God."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "There is a place of comfort sweet,",
          "Near to the heart of God,",
          "A place where we our Savior meet,",
          "Near to the heart of God."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "There is a place of full release,",
          "Near to the heart of God,",
          "A place where all is joy and peace,",
          "Near to the heart of God."
        ]
      }
    ],
    "chorus": [
      "O Jesus, blest Redeemer,",
      "Sent from the heart of God,",
      "Hold us, who wait before Thee,",
      "Near to the heart of God."
    ],
    "timestamps": {
      "chorus": 24.4653
    }
  },
  {
    "hymnNumber": 496,
    "reference": "SDAH496",
    "title": "Eternal Love We Have No Good",
    "hasMidi": true,
    "numberOfVerses": 2,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Eternal Love, we have no good to bring Thee,",
          "No single good of all our hands have wrought,",
          "No worthy music have we found to sing Thee,",
          "No jewelled word, no quick upsoaring thought."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "And yet we come; and when our faith would falter",
          "Show us, O Love, the quiet place of prayer,",
          "The golden censer and the golden altar,",
          "And the great angel waiting for us there."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 497,
    "reference": "SDAH497",
    "title": "O Gracious Father of Mankind",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "O gracious Father of mankind,",
          "Our spirits' unseen friend;",
          "High heaven's Lord, our hearts' dear guest,",
          "To Thee our prayers ascend.",
          "Thou dost not wait till human speech",
          "Thy gifts divine implore;",
          "Our dreams, our aims, our work, our lives",
          "Are prayers Thou lovest more."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Thou hearest these, the good and ill,",
          "Deep buried in each breast;",
          "The secret thought, the hidden plan,",
          "Wrought out our unexpressed.",
          "O cleanse our prayers from human dross,",
          "Attune our lives to Thee,",
          "Until we labor for those gifts",
          "We ask on bended knee."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Our best is but Thyself in us,",
          "Our highest thought Thy will;",
          "To hear Thy voice we need but love,",
          "And listen, and be still.",
          "We would not bend Thy will to ours,",
          "But blend our wills to Thine;",
          "Not beat with cries on heaven's doors,",
          "But live Thy life divine."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Thou seekest us in love and truth",
          "More than our minds seek Thee;",
          "Through open gates Thy power flows in",
          "Like flood tides from the sea.",
          "No more we seek Thee from afar,",
          "Nor ask Thee for a sign,",
          "Content to pray in life and love",
          "And toil, till all are Thine."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 498,
    "reference": "SDAH498",
    "title": "Still, Still With Thee",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Still, still with Thee, when purple morning breaketh,",
          "When the bird waketh, and the shadow's flee;",
          "Fairer than morning, lovelier than daylight,",
          "Dawns the sweet consciousness, I am with Thee."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Alone with Thee, amid the mystic shadows,",
          "The solemn hush of nature newly born;",
          "Alone with Thee in breathless adoration,",
          "In the calm dew and freshness of the morn."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Still, still with Thee! As to each newborn morning",
          "A fresh and solemn splendor still is given,",
          "So does this blessed consciousness, awaking,",
          "Breathe each day nearness unto Thee and heaven."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "So shall it be at last, in that bright morning,",
          "When the soul waketh and life's shadows flee;",
          "O in that hour, fairer than daylight dawning,",
          "Shall rise the glorious thought, I am with Thee."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 499,
    "reference": "SDAH499",
    "title": "What a Friend We Have in Jesus",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "What a friend we have in Jesus,",
          "All our sins and griefs to bear;",
          "What a privilege to carry",
          "Everything to God in prayer!",
          "O what peace we often forfeit,",
          "O what needless pain we bear,",
          "All because we do not carry",
          "Everything to God in prayer."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Have we trials and temptations?",
          "Is there trouble anywhere.",
          "We should never be discouraged;",
          "Take it to the Lord in prayer!",
          "Can we find a friend so faithful,",
          "Who will all our sorrows share?",
          "Jesus knows our every weakness;",
          "Take it to the Lord in prayer!"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Are we weak and heavy laden,",
          "Cumbered with a load of care?",
          "Precious Savior, still our refuge,",
          "Take it to the Lord in prayer!",
          "Do thy friends despise, forsake thee?",
          "Take it to the Lord in prayer!",
          "In His arms He'll take and shield thee,",
          "Thou wilt find a solace there."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 500,
    "reference": "SDAH500",
    "title": "Take Time to Be Holy",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Take time to be holy,",
          "Speak oft with thy Lord;",
          "Abide in Him always,",
          "And feed on His word;",
          "Make friends of God's children,",
          "Help those who are weak,",
          "Forgetting in nothing",
          "His blessing to seek."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Take time to be holy,",
          "The world rushes on;",
          "Spend much time in secret",
          "With Jesus alone;",
          "By looking to Jesus,",
          "Like Him thou shalt be;",
          "Thy friends in thy conduct",
          "His likeness shall see."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Take time to be holy,",
          "Let Him be thy Guide,",
          "And run not before Him,",
          "Whatever betide;",
          "In joy or in sorrow,",
          "Still follow thy Lord,",
          "And, looking to Jesus,",
          "Still trust in His word."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Take time to be holy,",
          "Be calm in thy soul,",
          "Each thought and each motive",
          "Beneath His control;",
          "Thus led by His Spirit",
          "To fountains of love,",
          "Thou soon shalt be fitted",
          "For service above."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 501,
    "reference": "SDAH501",
    "title": "'Tis the Blessed Hour of Prayer",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "'Tis the blessed hour of prayer, when our hearts lowly bend,",
          "And we gather to Jesus, our Savior and Friend;",
          "If we come to Him in faith, His protection to share,",
          "What a balm for the weary!",
          "O how sweet to be there!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "'Tis the blessed hour of prayer, when the Savior draws near,",
          "With a tender compassion His children to hear;",
          "When He tells us we may cast at His feet every care,",
          "What a balm for the weary!",
          "O how sweet to be there!"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "'Tis the blessed hour of prayer, when the tempted and tried",
          "To the Savior who loves them their sorrows confide;",
          "With a sympathizing heart He removes every care;",
          "What a balm for the weary!",
          "O how sweet to be there!"
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "At the blessed hour of prayer, trusting Him we believe,",
          "That the blessings we're needing we'll surely receive;",
          "In the fullness of this trust we shall lose every care;",
          "What a balm for the weary!",
          "O how sweet to be there!"
        ]
      }
    ],
    "chorus": [
      "Blessed hour of prayer,",
      "Blessed hour of prayer,",
      "What a balm for the weary!",
      "O how sweet to be there!"
    ],
    "timestamps": {
      "chorus": 30.9381
    }
  },
  {
    "hymnNumber": 502,
    "reference": "SDAH502",
    "title": "Sun of My Soul",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Sun of my soul, O Savior dear!",
          "It is not night if Thou be near;",
          "O may no earth-born cloud arise",
          "To hide Thee from Thy servant's eyes."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "When soft the dews of kindly sleep",
          "My weary eyelids gently steep",
          "Be my last thought; how sweet to rest",
          "Forever on my Savior's breast!"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Abide with me from morn till eve,",
          "For without Thee I cannot live;",
          "Abide with me when night is nigh,",
          "For without Thee I dare not die."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Be near and bless me when I wake,",
          "Ere through the world my way I take;",
          "Till in the ocean of Thy love",
          "I lose myself in heaven above."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 503,
    "reference": "SDAH503",
    "title": "A Quiet Place",
    "hasMidi": true,
    "numberOfVerses": 1,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "There is a quiet place,",
          "Far from the rapid pace where",
          "God can soothe my troubled mind.",
          "Sheltered by tree and flow'r,",
          "There in my quiet hour with Him",
          "My cares are left behind.",
          "Whether a garden small,",
          "Or on a mountain tall,",
          "New strength and courage there I find;",
          "Then from this quiet place",
          "I go prepared to face a new day",
          "With love for all mankind."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 504,
    "reference": "SDAH504",
    "title": "Lord Jesus, Think on Me",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Lord Jesus, think on me,",
          "And purge away my sin;",
          "From earth-born passions set me free,",
          "And make me pure within."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Lord Jesus, think on me,",
          "With care and woe oppressed;",
          "Let me Thy loving servant be,",
          "And taste Thy promised rest."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Lord Jesus, think on me,",
          "Nor let me go astray;",
          "Through darkness and perplexity",
          "Point Thou the heavenly way."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Lord Jesus, think on me,",
          "That I may sing above",
          "To Father, Spirit, and to Thee,",
          "The strains of praise and love."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 505,
    "reference": "SDAH505",
    "title": "I Need the Prayers",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "I need the prayers of those I love,",
          "While trav'ling o'er life's rugged way,",
          "That I may true and faithful be,",
          "And live for Jesus every day."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "I need the prayers of those I love,",
          "To help me in each trying hour,",
          "To bear my tempted soul to Him,",
          "That He may keep me by His pow'r."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "I want my friends to pray for me,",
          "To hold me up on wings of faith,",
          "That I may walk the narrow way,",
          "Kept by our Father's glorious grace."
        ]
      }
    ],
    "chorus": [
      "I want my friends to pray for me,",
      "To bear my tempted soul above,",
      "And intercede with God for me;",
      "I need the prayers of those I love."
    ],
    "timestamps": {
      "chorus": 25.2896
    }
  },
  {
    "hymnNumber": 506,
    "reference": "SDAH506",
    "title": "A Mighty Fortress",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "A mighty fortress is our God,",
          "A bulwark never failing;",
          "Our helper He, amid the flood",
          "Of mortal ills prevailing.",
          "For still our ancient foe",
          "Doth seek to work us woe;",
          "His craft and power are great;",
          "And armed with cruel hate,",
          "On earth is not his equal."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Did we in our own strength confide,",
          "Our striving would be losing,",
          "Were not the right man on our side,",
          "The man of God's own choosing.",
          "Dost ask who that may be?",
          "Christ Jesus, it is He,",
          "Lord Sabaoth His name,",
          "From age to age the same,",
          "And He must win the battle."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "And though this world, with devils filled,",
          "Should threaten to undo us,",
          "We will not fear, for God hath willed",
          "His truth to triumph through us.",
          "The prince of darkness grim,",
          "We tremble not for him;",
          "His rage we can endure,",
          "For lo! his doom is sure,",
          "One little word shall fell him."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "That word above all earthly powers,",
          "No thanks to them, abideth;",
          "The Spirit and the gifts are ours",
          "Through Him who with us sideth;",
          "Let goods and kindred go,",
          "This mortal life also;",
          "The body they may kill;",
          "God's truth abideth still,",
          "His kingdom is forever."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 507,
    "reference": "SDAH507",
    "title": "Moment by Moment",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Dying with Jesus, by death reckoned mine,",
          "Living with Jesus, a new life divine,",
          "Looking to Jesus till glory doth shine,",
          "Moment by moment, O Lord, I am Thine."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Never a trial that He is not there,",
          "Never a burden that He doth not bear,",
          "Never a sorrow that He doth not share,",
          "Moment by moment I'm under His care."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Never a heartache, and never a groan,",
          "Never a teardrop and never a moan;",
          "Never a danger but there on the throne,",
          "Moment by moment He thinks of His own."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Never a weakness that He doth not feel,",
          "Never a sickness that He cannot heal;",
          "Moment by moment, in woe or in weal,",
          "Jesus, my Savior, abides with me still."
        ]
      }
    ],
    "chorus": [
      "Moment by moment I'm kept in His love;",
      "Moment by moment I've life from above;",
      "Looking to Jesus till glory doth shine;",
      "Moment by moment, O Lord, I am Thine."
    ],
    "timestamps": {
      "chorus": 26.7387
    }
  },
  {
    "hymnNumber": 508,
    "reference": "SDAH508",
    "title": "Anywhere With Jesus",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Anywhere with Jesus I can safely go,",
          "Anywhere He leads me in this world below;",
          "Anywhere without Him, dearest joys would fade;",
          "Anywhere with Jesus I am not afraid."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Anywhere with Jesus I am not alone;",
          "Other friends may fail me, He is still my own;",
          "Though His hand may lead me over dreary ways,",
          "Anywhere with Jesus is a house of praise."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Anywhere with Jesus I can go to sleep,",
          "When the gloomy shadows round about me creep,",
          "Knowing I shall waken nevermore to roam;",
          "Anywhere with Jesus will be home sweet home."
        ]
      }
    ],
    "chorus": [
      "Anywhere! anywhere!",
      "Fear I cannot know;",
      "Anywhere with Jesus",
      "I can safely go."
    ],
    "timestamps": {
      "chorus": 23.5182
    }
  },
  {
    "hymnNumber": 509,
    "reference": "SDAH509",
    "title": "How Firm A Foundation",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "How firm a foundation, ye saints of the Lord,",
          "Is laid for your faith in His excellent word!",
          "What more can He say than to you He has said,",
          "To you who for refuge to Jesus hath fled?"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Fear not, I am with thee, O be not dismayed;",
          "For I am thy God, and will still give thee aid;",
          "I'll strengthen thee, help thee, and cause thee to stand,",
          "Upheld by My righteous, omnipotent hand."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "When thro’ the deep waters I call thee to go,",
          "The rivers of sorrow shall not overflow",
          "For I will be with thee, thy troubles to bless,",
          "And sanctify to thee thy deepest distress."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "When thro fiery trials thy pathway shall lie,",
          "My grace, all sufficient, shall be thy supply;",
          "The flame shall not hurt thee; I only design",
          "Thy dross to consume, and thy gold to refine."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "The soul that on Jesus hath leaned for repose,",
          "I will not, I will not desert to his foes;",
          "That soul, Though all hell should endeavor to shake,",
          "I'll never, no never, no never forsake."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 510,
    "reference": "SDAH510",
    "title": "If You Trust in God to Guide You",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "If you but trust in God to guide you",
          "And place your confidence in Him,",
          "You'll find Him always there beside you,",
          "To give you hope and strength within.",
          "For those who trust God's changeless love",
          "Build on the rock that will not move."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "What gain is there in futile weeping,",
          "In helpless anger and distress?",
          "If you are in His care and keeping,",
          "In sorrow will He love you less?",
          "For He who took for you a cross",
          "Will bring you safe through every loss."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "In patient trust await His leisure",
          "In cheerful hope, with heart content",
          "To take whate'er your Father's pleasure",
          "And all-discerning love have sent;",
          "Doubt not your inmost wants are known",
          "To Him who chose you for His own."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Sing, pray, and keep His ways unswerving,",
          "Offer your service faithfully,",
          "And trust His word; though undeserving,",
          "You'll find His promise true to be.",
          "God never will forsake in need",
          "The soul that trusts in Him indeed."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 511,
    "reference": "SDAH511",
    "title": "I Know Whom I Have Believed",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "I know not why God's wondrous grace",
          "To me He hath made known,",
          "Nor why, unworthy, Christ in love",
          "Redeemed me for His own."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "I know not how this saving faith",
          "To me He did impart,",
          "Nor how believing in His word",
          "Wrought peace within my heart."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "I know not how the Spirit moves,",
          "Convincing men of sin,",
          "Revealing Jesus through the word,",
          "Creating faith in Him."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "I know not when my Lord may come,",
          "At night or noon-day fair,",
          "Nor if I walk the vale with Him,",
          "Or meet Him in the air."
        ]
      }
    ],
    "chorus": [
      "But \"I know whom I have believed,",
      "and am persuaded that He is able",
      "To keep that which I've committed",
      "Unto Him against that day.\""
    ],
    "timestamps": {
      "chorus": 19.0475
    }
  },
  {
    "hymnNumber": 512,
    "reference": "SDAH512",
    "title": "Just When I Need Him Most",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Just when I need Him, Jesus is near,",
          "Just when I falter, just when I fear;",
          "Ready to help me, ready to cheer,",
          "Just when I need Him most."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Just when I need Him, Jesus is true,",
          "Never forsaking, all the way through;",
          "Giving for burdens pleasures anew,",
          "Just when I need Him most."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Just when I need Him, Jesus is strong,",
          "Bearing my burdens all the day long;",
          "For all my sorrow giving a song,",
          "Just when I need Him most."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Just when I need Him, He is my all,",
          "Answering when upon Him I call;",
          "Tenderly watching lest I should fall,",
          "Just when I need Him most."
        ]
      }
    ],
    "chorus": [
      "Just when I need Him most,",
      "Just when I need Him most;",
      "Jesus is near to comfort and cheer,",
      "Just when I need Him most."
    ],
    "timestamps": {
      "chorus": 26.8722
    }
  },
  {
    "hymnNumber": 513,
    "reference": "SDAH513",
    "title": "In Heavenly Love Abiding",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "In Heavenly love abiding,",
          "No change my heart shall fear,",
          "And safe is such confiding,",
          "For nothing changes here.",
          "The storm may roar without me,",
          "My heart may low be laid;",
          "But God is round about me,",
          "And can I be dismayed?"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Wherever He may guide me,",
          "No want shall turn me back;",
          "My Shepherd is beside me,",
          "And nothing can I lack.",
          "His wisdom ever waketh,",
          "His sight is never dim;",
          "He knows the way He taketh,",
          "And I will; walk with Him."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Green pastures are before me,",
          "Which yet I have not seen;",
          "Bright skies will soon be o'er me,",
          "Where the darkest clouds have been.",
          "My hope I cannot measure,",
          "The path to life is free;",
          "My Saviour has my treasure,",
          "And He will walk with me."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 514,
    "reference": "SDAH514",
    "title": "Lord of Our Life",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Lord of our life, and God of our salvation,",
          "Star of our night, and hope of every nation,",
          "Hear and receive Thy church's supplication,",
          "Lord God Almighty."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Lord, Thou canst help when earthly armor faileth;",
          "Lord, Thou canst save when deadly sin assaileth;",
          "Lord, o'er Thy rock nor death nor hell prevaileth;",
          "Grant us Thy peace, Lord."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Peace in our hearts our evil thoughts assuaging;",
          "Peace in Thy church, where brothers are engaging;",
          "Peace, when the world its busy war is waging;",
          "Send us, O Savior."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Grant us Thy help till foes are backward driven;",
          "Grant them Thy truth that they may be forgiven;",
          "Grant peace on earth, and, after we have striven,",
          "Peace in Thy heaven."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 515,
    "reference": "SDAH515",
    "title": "The Lord Is My Light",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "The Lord is my light; then why should I fear?",
          "By day and by night His presence is near;",
          "He is my salvation from sorrow and sin;",
          "This blessed persuasion the Spirit brings in."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "The Lord is my light; though clouds may arise,",
          "Faith, stronger than sight, looks up to the skies",
          "Where Jesus forever in glory doth reign:",
          "Then how can I ever in darkness remain?"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "The Lord is my light, the Lord is my strength;",
          "I know in His might I'll conquer at length;",
          "My weakness in mercy He covers with power,",
          "And, walking by faith, He upholds me each hour."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "The Lord is my light, my all and in all;",
          "There is in His sight no darkness at all;",
          "He is my Redeemer, my Savior and King;",
          "With saints and with angels His praises I sing."
        ]
      }
    ],
    "chorus": [
      "The Lord is my light, my joy, and my song;",
      "By day and by night He leads me along;",
      "The Lord is my light, my joy, and my song;",
      "By day and by night He leads me along."
    ],
    "timestamps": {
      "chorus": 21.813
    }
  },
  {
    "hymnNumber": 516,
    "reference": "SDAH516",
    "title": "All the Way",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "All the way my Savior leads me;",
          "What have I to ask beside?",
          "Can I doubt His tender mercy,",
          "Who through life has been my guide?",
          "Heavenly peace, divinest comfort,",
          "Here by faith in Him to dwell;",
          "For I know whate'er befall me,",
          "Jesus doeth all things well;",
          "For I know whate'er befall me,",
          "Jesus doeth all things well."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "All the way my Savior leads me;",
          "Cheers each winding path I tread;",
          "Gives me grace for every trial,",
          "Feeds me with the living bread;",
          "Though my weary steps may falter,",
          "And my soul a-thirst may be,",
          "Gushing from the Rock before me,",
          "Lo, a spring of joy I see;",
          "Gushing from the Rock before me,",
          "Lo, a spring of joy I see."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "All the way my Savior leads me;",
          "O the fullness of His love!",
          "Perfect rest to me is promised",
          "In my Father's house above,",
          "When I wake to life immortal,",
          "Wing my flight to realms of day,",
          "This my song through endless ages,",
          "Jesus led me all the way;",
          "This my song through endless ages,",
          "Jesus led me all the way."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 517,
    "reference": "SDAH517",
    "title": "My Faith Looks Up to Thee",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "My faith looks up to Thee,",
          "Thou Lamb of Calvary,",
          "Savior divine;",
          "Now hear me while I pray,",
          "Take all my guilt away,",
          "O let me from this day",
          "Be wholly Thine."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "May Thy rich grace impart",
          "Strength to my fainting heart,",
          "My zeal inspire;",
          "As Thou hast died for me,",
          "O may my love to Thee",
          "Pure, warm, and changeless be,",
          "A living fire."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "While life's dark maze I tread,",
          "And griefs around me spread,",
          "Be Thou my Guide;",
          "Bid darkness turn to day,",
          "Wipe sorrow's tears away.",
          "Nor let me ever stray",
          "From Thee aside."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 518,
    "reference": "SDAH518",
    "title": "Standing on the Promises",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Standing on the promises of Christ my King,",
          "Thru eternal ages let His praises ring;",
          "Glory in the highest I will shout and sing,",
          "Standing on the promises of God."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Standing on the promises that cannot fail,",
          "When the howling storms of doubt and fear assail,",
          "By the living word of God I shall prevail,",
          "Standing on the promises of God."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Standing on the promises of Christ the Lord,",
          "Bound to Him eternally by love's strong cord,",
          "Overcoming daily with the Spirit's sword,",
          "Standing on the promises of God."
        ]
      }
    ],
    "chorus": [
      "Standing, standing,",
      "Standing on the promises of God my Savior;",
      "Standing, standing,",
      "I'm standing on the promises of God."
    ],
    "timestamps": {
      "chorus": 20.0082
    }
  },
  {
    "hymnNumber": 519,
    "reference": "SDAH519",
    "title": "Give to the Winds Your Fears",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Give to the winds your fears;",
          "In hope be undismayed:",
          "God hears your sighs and counts your tears,",
          "God shall lift up your head."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "To Him commit your griefs;",
          "Your ways put in His hands",
          "To His sure truth and tender care",
          "Who earth and heaven commands."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "O put your trust in God;",
          "In duty's path go on.",
          "Walk in His strength with faith and hope,",
          "So shall your work be done."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Leave to His sovereign sway",
          "To choose and to command;",
          "So you shall, faithful, seek His way",
          "How wise, how strong His hand!"
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 520,
    "reference": "SDAH520",
    "title": "He Hideth My Soul",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "A wonderful Savior is Jesus my Lord,",
          "A wonderful Savior to me,",
          "He hideth my soul in the cleft of the rock,",
          "Where rivers of pleasure I see."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "A wonderful Savior is Jesus my Lord,",
          "He taketh my burden away,",
          "He holdeth me up, and I shall not be moved,",
          "He giveth me strength as my day."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "With numberless blessings each moment He crowns,",
          "And filled with His fullness divine,",
          "I sing in my rapture, Oh, glory to God",
          "For such a Redeemer as mine."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "When clothed in His brightness, transported I rise",
          "To meet Him in clouds of the sky,",
          "His perfect salvation, His wonderful love,",
          "I'll shout with the millions on high."
        ]
      }
    ],
    "chorus": [
      "He hideth my soul in the cleft of the rock",
      "That shadows a dry, thirsty land;",
      "He hideth my life in the depths of His love,",
      "And covers me there with His hand,",
      "And covers me there with His hand."
    ],
    "timestamps": {
      "chorus": 24.1675
    }
  },
  {
    "hymnNumber": 521,
    "reference": "SDAH521",
    "title": "Depth of Mercy",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Depth of mercy!; can there be",
          "Mercy still reserved for me?",
          "Can my God His wrath forbear?",
          "Me, the chief of sinners, spare?"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "I have long withstood His grace,",
          "Long provoked Him to His face,",
          "Would not hearken to His calls,",
          "Grieved Him by a thousand falls."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Now incline me to repent;",
          "Let me now my sins lament;",
          "Now my foul revolt deplore,",
          "Weep, believe, and sin no more."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "There for me the Savior stands,",
          "Shows His wounds and spreads His hands;",
          "God is love! I know, I feel;",
          "Jesus weeps, and loves me still."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 522,
    "reference": "SDAH522",
    "title": "My Hope Is Built on Nothing Less",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "My hope is built on nothing less",
          "Than Jesus' blood and righteousness;",
          "I dare not trust the sweetest frame,",
          "But wholly lean on Jesus' name."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "When darkness seems to veil His face,",
          "I rest on His unchanging grace;",
          "In every high and stormy gale,",
          "My anchor holds within the veil."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "His oath, His covenant, and blood,",
          "Support me in the whelming flood;",
          "When all around my soul gives way,",
          "He then is all my hope and stay."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "When He shall come with trumpet sound,",
          "O may I then in Him be found;",
          "Clad in His righteousness alone,",
          "Faultless to stand before the throne."
        ]
      }
    ],
    "chorus": [
      "On Christ, the solid Rock, I stand;",
      "All other ground is sinking sand,",
      "All other ground is sinking sand."
    ],
    "timestamps": {
      "chorus": 17.523
    }
  },
  {
    "hymnNumber": 523,
    "reference": "SDAH523",
    "title": "My Faith Has Found a Resting Place",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "My faith has found a resting place,",
          "Not in a manmade creed;",
          "I trust the ever living One,",
          "That He for me will plead."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Enough for me that Jesus saves,",
          "This ends my fear and doubt;",
          "A sinful soul I come to Him,",
          "He will not cast me out."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "My soul is resting on the Word,",
          "The living Word of God:",
          "Salvation in my Savior's name,",
          "Salvation through His blood."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "The great Physician heals the sick,",
          "The lost He came to save;",
          "For me His precious blood He shed,",
          "For me His life He gave."
        ]
      }
    ],
    "chorus": [
      "I need no other evidence,",
      "I need no other plea;",
      "It is enough that Jesus died",
      "And rose again for me."
    ],
    "timestamps": {
      "chorus": 17.1182
    }
  },
  {
    "hymnNumber": 524,
    "reference": "SDAH524",
    "title": "'Tis So Sweet to Trust in Jesus",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "'Tis so sweet to trust in Jesus,",
          "Just to take Him at His word;",
          "Just to rest upon His promise,",
          "Just to know, \"Thus saith the Lord.\""
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "O how sweet to trust in Jesus,",
          "Just to trust His cleansing blood;",
          "Just in simple faith to plunge me",
          "'Neath the healing, cleansing flood."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Yes, 'tis sweet to trust in Jesus,",
          "Just from sin and self to cease;",
          "Just from Jesus simply taking",
          "Life, and rest, and joy, and peace."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "I'm so glad I learned to trust Thee,",
          "Precious Jesus, Savior, Friend;",
          "And I know that Thou art with me,",
          "Wilt be with me till the end."
        ]
      }
    ],
    "chorus": [
      "Jesus, Jesus, how I trust Him;",
      "How I've proved Him o'er and o'er!",
      "Jesus, Jesus, precious Jesus!",
      "O for grace to trust Him more!"
    ],
    "timestamps": {
      "chorus": 20.2953
    }
  },
  {
    "hymnNumber": 525,
    "reference": "SDAH525",
    "title": "Hiding in Thee",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "O safe to the Rock that is higher than I,",
          "My soul in its conflicts and sorrows would fly;",
          "So sinful, so weary, Thine, Thine would I be;",
          "Thou blest \"Rock of Ages,\" I'm hiding in Thee."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "In the calm of the noontide, in sorrow's lone hour,",
          "In times when temptation casts o'er me its power;",
          "In the tempests of life, on its wide, heaving sea,",
          "Thou blest \"Rock of Ages,\" I'm hiding in Thee."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "How oft in the conflict, when pressed by the foe,",
          "I have fled to my Refuge and breathed out my woe;",
          "How often, when trials like sea billows roll,",
          "Have I hidden in Thee, O Thou Rock of my soul."
        ]
      }
    ],
    "chorus": [
      "Hiding in Thee,",
      "Hiding in Thee,",
      "Thou blest \"Rock of Ages,\"",
      "I'm hiding in Thee."
    ],
    "timestamps": {
      "chorus": 31.0206
    }
  },
  {
    "hymnNumber": 526,
    "reference": "SDAH526",
    "title": "Because He Lives",
    "hasMidi": true,
    "numberOfVerses": 2,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "God sent His Son, they called Him Jesus,",
          "He came to love, heal, and forgive;",
          "He lived and died to buy my pardon,",
          "An empty grave is there to prove my Savior lives."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "How sweet to hold a newborn baby,",
          "And feel the pride, and joy He gives;",
          "But greater still the calm assurance,",
          "This child can face uncertain days because He lives."
        ]
      }
    ],
    "chorus": [
      "Because He lives I can face tomorrow,",
      "Because He lives all fear is gone;",
      "Because I know He holds the future.",
      "And life is worth the living just because He lives."
    ],
    "timestamps": {
      "chorus": 33.2879
    }
  },
  {
    "hymnNumber": 527,
    "reference": "SDAH527",
    "title": "From Every Stormy Wind",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "From every stormy wind that blows,",
          "From every swelling tide of woes,",
          "There is a calm, a sure retreat;",
          "'Tis found beneath the mercy seat."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "There is a place where Jesus sheds",
          "The oil of gladness on our heads,",
          "A place than all besides more sweet;",
          "It is the blood-bought mercy seat."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "There is a scene where spirits blend,",
          "Where friend holds fellowship with friend;",
          "Though sundered far, by faith they meet",
          "Around one common mercy seat."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "There, there, on angel's wings we soar,",
          "And earthly cares molest no more,",
          "And heaven comes down our souls to greet,",
          "And glory crowns the mercy seat."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "Ah! whither should we flee for aid,",
          "When tempted, desolate, dismayed?",
          "Or how the hosts of sin defeat,",
          "Had suffering saints no mercy seat?"
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 528,
    "reference": "SDAH528",
    "title": "A Shelter in the Time of Storm",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "The Lord's our Rock, in Him we hide,",
          "A shelter in the time of storm;",
          "Secure whatever may betide,",
          "A shelter in the time of storm."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "A shade by day, defense by night,",
          "A shelter in the time of storm;",
          "No fears alarm, no foes affright,",
          "A shelter in the time of storm."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "The raging floods may round us beat,",
          "A shelter in the time of storm;",
          "We find in God a safe retreat,",
          "A shelter in the time of storm."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "O Rock divine, O Refuge dear,",
          "A shelter in the time of storm;",
          "Be Thou our helper, ever near,",
          "A shelter in the time of storm."
        ]
      }
    ],
    "chorus": [
      "Mighty Rock in a weary land,",
      "Cooling shade on the burning sand,",
      "Faithful guide for the pilgrim band;",
      "A shelter in the time of storm."
    ],
    "timestamps": {
      "chorus": 18.8239
    }
  },
  {
    "hymnNumber": 529,
    "reference": "SDAH529",
    "title": "Under His Wings",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Under His wings I am safely abiding;",
          "Though the night deepens and tempests are wild,",
          "Still I can trust Him; I know He will keep me;",
          "He has redeemed me, and I am His child."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Under His wings, what a refuge in sorrow!",
          "How the heart yearningly turns to its rest!",
          "Often when earth has no balm for my healing,",
          "There I find comfort, and there I am blest."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Under His wings, O what precious enjoyment!",
          "There will I hide till life's trials are o'er;",
          "Sheltered, protected, no evil can harm me;",
          "Resting in Jesus I'm safe evermore."
        ]
      }
    ],
    "chorus": [
      "Under His wings, under His wings,",
      "Who from His love can sever?",
      "Under His wings my soul shall abide,",
      "Safely abide forever."
    ],
    "timestamps": {
      "chorus": 24.3494
    }
  },
  {
    "hymnNumber": 530,
    "reference": "SDAH530",
    "title": "It Is Well With My Soul",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "When peace, like a river, attendeth my way,",
          "When sorrows like sea billows roll",
          "Whatever my lot, Thou hast taught me to say,",
          "It is well, it is well with my soul."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "My sin O the joy of this glorious thought",
          "My sin, not in part, but the whole,",
          "Is nailed to the cross, and I bear it no more:",
          "Praise the Lord, praise the Lord, O my soul!"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "And, Lord, haste the day when my faith shall be sight,",
          "The clouds be rolled back as a scroll:",
          "The trump shall resound and the Lord shall descend,",
          "\"Even so\" it is well with my soul."
        ]
      }
    ],
    "chorus": [
      "It is well with my soul,",
      "It is well, it is well with my soul."
    ],
    "timestamps": {
      "chorus": 34.1381
    }
  },
  {
    "hymnNumber": 531,
    "reference": "SDAH531",
    "title": "We'll Build on the Rock",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "We'll build on the Rock, the living Rock,",
          "On Jesus, the Rock of Ages;",
          "So shall we abide the fearful shock,",
          "When loud the tempest rages."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Some build on the sinking sands of life,",
          "On visions of earthly treasure;",
          "Some build on the waves of sin and strife,",
          "Of fame, and worldly pleasure."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "O build on the Rock forever sure,",
          "The firm and the true foundation;",
          "Its hope is the hope which shall endure,",
          "The hope of our salvation."
        ]
      }
    ],
    "chorus": [
      "We'll build on the Rock,",
      "We'll build on the Rock;",
      "We'll build on the Rock, on the solid Rock,",
      "On Christ, the mighty Rock."
    ],
    "timestamps": {
      "chorus": 21.7104
    }
  },
  {
    "hymnNumber": 532,
    "reference": "SDAH532",
    "title": "Day By Day",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Day by day and with each passing moment,",
          "Strength I find to meet my trials here;",
          "Trusting in my Father's wise bestowment,",
          "I've no cause for worry or for fear,",
          "He whose heart is kind beyond all measure",
          "Gives unto each day what He deems best",
          "Lovingly, its part of pain and pleasure,",
          "Mingling toil with peace and rest."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Every day the Lord Himself is near me",
          "With a special mercy for each hour;",
          "All my cares he fain would bear, and cheer me,",
          "He whose name is Counselor and power.",
          "The protection of His child and treasure",
          "Is a charge that on Himself He laid:",
          "As your days, your strength shall be in measure,",
          "This the pledge to me He made."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Help me then in every tribulation",
          "So to trust Thy promises, O Lord,",
          "That I lose not faith's sweet consolation",
          "Offered me within Thy holy Word.",
          "Help me Lord, when toil and trouble meeting,",
          "E'er to take, as from a Father's hand,",
          "One by one, the days, the moments fleeting,",
          "Till I reach the promised land."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 533,
    "reference": "SDAH533",
    "title": "O for a Faith",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "O for a faith that will not shrink,",
          "Though pressed by many a foe;",
          "That will not tremble on the brink of poverty,",
          "Of poverty or woe;",
          "Of poverty or woe."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "That will not murmur or complain",
          "Beneath the chastening rod,",
          "But in the hour of grief or pain, of grief or pain",
          "Can lean upon its God;",
          "Can lean upon its God."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "A faith that shines more bright and clear",
          "When tempests rage without;",
          "That when in danger knows no fear, knows of no fear,",
          "In darkness feels no doubt;",
          "In darkness feels no doubt."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "That bears unmoved the world's dread frown,",
          "Nor heeds its scornful smile;",
          "That sin's wild ocean cannot drown, no, cannot drown,",
          "Nor its soft arts beguile;",
          "Nor its soft arts beguile."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "Lord, give me such a faith as this,",
          "And then, whate'er may come",
          "I'll taste e'en here the hallowed bliss, the hallowed bliss",
          "Of an eternal home;",
          "Of an eternal home."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 534,
    "reference": "SDAH534",
    "title": "Will Your Anchor Hold?",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Will your anchor hold in the storm of life,",
          "When the clouds unfold their wings of strife?",
          "When the strong tides lift, and the cables strain,",
          "Will your anchor drift, or firm remain?"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "If 'tis safely moored, 'twill the storm withstand,",
          "For 'tis well secured by the Savior's hand;",
          "And the cables, passed from His heart to thine,",
          "Can defy the blast, through strength divine."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "It will firmly hold in the straits of Fear,",
          "When the breakers tell that the reef is near;",
          "Though the tempest rave and the wild winds blow,",
          "Not an angry wave shall our bark o'erflow."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "It will surely hold in the floods of death,",
          "When the waters cold chill our latest breath;",
          "On the rising tide it can never fail,",
          "While our hopes abide within the veil."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "When our eyes behold, in the dawning light,",
          "Shining gates of pearl, our harbor bright,",
          "We shall anchor fast to the heavenly shore,",
          "With the storms all past forevermore."
        ]
      }
    ],
    "chorus": [
      "We have an anchor that keeps the soul",
      "Steadfast and sure while the billows roll;",
      "Fastened to the Rock which cannot move,",
      "Grounded firm and deep in the Savior's love."
    ],
    "timestamps": {
      "chorus": 24.5011
    }
  },
  {
    "hymnNumber": 535,
    "reference": "SDAH535",
    "title": "I Am Trusting Thee, Lord Jesus",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "I am trusting Thee, Lord Jesus,",
          "Trusting only Thee;",
          "Trusting Thee for full salvation,",
          "Great and free."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "I am trusting Thee for pardon;",
          "At Thy feet I bow;",
          "For Thy grace and tender mercy,",
          "Trusting now."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "I am trusting Thee to guide me;",
          "Thou alone shalt lead,",
          "Every day and hour supplying",
          "All my need."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "I am trusting Thee, Lord Jesus;",
          "Never let me fall;",
          "I am trusting Thee forever,",
          "And for all."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 536,
    "reference": "SDAH536",
    "title": "God Who Stretched the Spangled Heavens",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "God, who stretched the spangled heavens",
          "Infinite in time and place,",
          "Flung the suns in burning radiance",
          "Through the silent fields of space;",
          "We, Your children in Your likeness,",
          "Share inventive powers with You;",
          "Great Creator, still creating,",
          "Show us what we yet may do."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "We have ventured worlds undreamed of",
          "Since the childhood of our race;",
          "Known the ecstasy of winging",
          "Through untraveled realms of space,",
          "Probed the secrets of the atom,",
          "Yielding unimagined power,",
          "Facing us with life's destruction",
          "Or our most triumphant hour."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "As each far horizon beckons,",
          "May it challenge us anew:",
          "Children of creative purpose,",
          "Serving others, honoring You.",
          "May our dreams prove rich with promise;",
          "Each endeavor well begun;",
          "Great Creator, give us guidance",
          "Till our goals and Yours are one."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 537,
    "reference": "SDAH537",
    "title": "He Leadeth Me",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "He leadeth me! O blessed thought!",
          "O words with heavenly comfort fraught!",
          "Whate'er I do, where'er I be,",
          "Still 'tis God's hand that leadeth me."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Sometimes 'mid scenes of deepest gloom,",
          "Sometimes where Eden's bowers bloom",
          "By waters still, o'er troubled sea;",
          "Still 'tis His hand that leadeth me!"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Lord, I would clasp my hand in Thine,",
          "Nor ever murmur nor repine;",
          "Content, whatever lot I see,",
          "Since 'tis my God that leadeth me."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "And when my task on earth is done,",
          "When, by Thy grace, the victory's won,",
          "E'en death's cold wave I will not flee,",
          "Since God through Jordan leadeth me."
        ]
      }
    ],
    "chorus": [
      "He leadeth me, He leadeth me,",
      "By His own hand He leadeth me;",
      "His faithful follower I would be,",
      "For by His hand He leadeth me."
    ],
    "timestamps": {
      "chorus": 22.6613
    }
  },
  {
    "hymnNumber": 538,
    "reference": "SDAH538",
    "title": "Guide Me, O Thou Great Jehovah",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Guide me, O Thou great Jehovah,",
          "Pilgrim through this barren land;",
          "I am weak, but Thou art mighty;",
          "Hold me with Thy powerful hand;",
          "Bread of heaven, Bread of heaven,",
          "Feed me till I want no more,",
          "Feed me till I want no more."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Open now the crystal fountain,",
          "Whence the healing stream doth flow;",
          "Let the fire and cloudy pillar",
          "Lead me all my journey through;",
          "Strong deliverer, strong deliverer.",
          "Be Thou still my strength and shield,",
          "Be Thou still my strength and shield."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "When I tread the verge of Jordan,",
          "Bid my anxious fears subside;",
          "Death of death and hell's destruction,",
          "Land me safe on Canaan's side;",
          "Songs of praises, songs of praises",
          "I will ever give to Thee,",
          "I will ever give to Thee."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 539,
    "reference": "SDAH539",
    "title": "I Will Early Seek the Savior",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "I will early seek the Savior,",
          "I will learn of Him each day;",
          "I will follow in His footsteps,",
          "I will walk the narrow way."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "I will hasten where He bids me,",
          "I am not too young to go",
          "In the pathway where He leadeth,",
          "Not too young His will to know."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "He is standing at the doorway",
          "Of escape from every sin;",
          "I will knock, for He has promised,",
          "He will hear and let me in."
        ]
      }
    ],
    "chorus": [
      "For He loves me, yes, He loves me,",
      "Jesus loves me, this I know.",
      "Jesus loves me, died to save me,",
      "This is why I love Him so."
    ],
    "timestamps": {
      "chorus": 16.2012
    }
  },
  {
    "hymnNumber": 540,
    "reference": "SDAH540",
    "title": "Gentle Jesus Meek and Mild",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Gentle Jesus, meek and mild,",
          "Look upon a little child;",
          "Pity my simplicity,",
          "Suffer me to come to Thee"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Lamb of God, I look to Thee;",
          "Thou shalt my example be;",
          "Thou art gentle, meek and mild;",
          "Thou wast once a little child"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Fain I would be as Thou art;",
          "Give me Thy obedient heart;",
          "Thou art pitiful and kind,",
          "Let me have Thy loving mind"
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "I shall then show forth Thy praise,",
          "Serve Thee all my happy days;",
          "Then the world shall always see",
          "Christ, the Holy Child in me."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 541,
    "reference": "SDAH541",
    "title": "Lord, Speak to Me",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Lord, speak to me, that I may speak",
          "In living echoes of Thy tone;",
          "As Thou hast sought, so let me seek",
          "Thy erring children lost and lone."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "O lead me, Lord, that I may lead",
          "The wandering and the wavering feet;",
          "O feed me, Lord, that I may feed",
          "Thy hungering ones with manna sweet."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "O strengthen me, that while I stand",
          "Firm on the Rock, and strong in Thee,",
          "I may stretch out a loving hand",
          "To wrestlers with the troubled sea."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 542,
    "reference": "SDAH542",
    "title": "Jesus Friend So Kind",
    "hasMidi": true,
    "numberOfVerses": 2,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Jesus, Friend, so kind and gentle,",
          "Little ones we bring to Thee:",
          "Grant to them Thy dearest blessing,",
          "Let Thine arms around them be;",
          "Now enfold them in Thy goodness,",
          "From all danger keep them free."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Thou who did receive the children",
          "To Thyself so tenderly,",
          "Give to all who teach and guide them",
          "Wisdom and humility.",
          "Vision true to keep them noble,",
          "Love to serve them faithfully."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 543,
    "reference": "SDAH543",
    "title": "Jesus, Friend of Little Children",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Jesus, Friend of little children,",
          "Be a Friend to me;",
          "Take my hand and ever keep me",
          "Close to Thee."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Teach me how to grow in goodness,",
          "Daily as I grow;",
          "Thou hast been a child, and surely",
          "Thou dost know."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Step by step, O, lead me onward,",
          "Upward into youth;",
          "Wiser, stronger, still becoming",
          "In Thy truth."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Never leave me, nor forsake me,",
          "Ever be my Friend;",
          "For I need Thee from life's dawning",
          "To its end."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 544,
    "reference": "SDAH544",
    "title": "Jesus Son of Blessed Mary",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Jesus, Son of blessed Mary,",
          "Once on earth a little child,",
          "Pattern fair of holy living,",
          "Gracious, loving, undefiled:"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Though Thy eager heart was yearning",
          "Heavy laden souls to free,",
          "Yet Thou calledst little children",
          "In their happiness to Thee."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Grant that we, like little children,",
          "Free from pride and guile may be;",
          "Cheerful, trusting, safe, protected",
          "By the blessed Trinity."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 545,
    "reference": "SDAH545",
    "title": "Savior, Like a Shepherd",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Savior, like a Shepherd lead us,",
          "Much we need Thy tenderest care;",
          "In Thy pleasant pastures feed us,",
          "For our use Thy folds prepare.",
          "Blessed Jesus, blessed Jesus,",
          "Thou hast bought us, Thine we are;",
          "Blessed Jesus, blessed Jesus,",
          "Thou hast bought us, Thine we are."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "We are Thine; do Thou befriend us,",
          "Be the Guardian of our way;",
          "Keep Thy flock, from sin defend us,",
          "Seek us when we go astray.",
          "Blessed Jesus, blessed Jesus,",
          "Hear, O hear us, when we pray!",
          "Blessed Jesus, blessed Jesus,",
          "Hear, O hear us, when we pray!"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Thou hast promised to receive us,",
          "Poor and sinful though we be;",
          "Thou hast mercy to relieve us,",
          "Grace to cleanse, and power to free.",
          "Blessed Jesus, blessed Jesus,",
          "We will early turn to Thee;",
          "Blessed Jesus, blessed Jesus,",
          "We will early turn to Thee."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 546,
    "reference": "SDAH546",
    "title": "The Lord's My Shepherd",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "The Lord's my Shepherd; I'll not want.",
          "He makes me down to lie",
          "In pastures green; He leadeth me",
          "The quiet waters by.",
          "He leadeth me, He leadeth me",
          "The quiet waters by."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "My soul He doth restore again,",
          "And me to walk doth make",
          "Within the paths of righteousness,",
          "E'en for His own name's sake;",
          "Within the paths of righteousness",
          "E'en for His own name's sake."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Yea, though I walk in death's dark vale,",
          "Yet will I fear no ill;",
          "For Thou art with me, and Thy rod",
          "And staff me comfort still;",
          "For Thou art with me, and Thy rod",
          "And staff me comfort still."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "My table Thou hast furnished",
          "In presence of my foes;",
          "My head Thou dost with oil anoint,",
          "And my cup overflows.",
          "My head Thou dost with oil anoint,",
          "And my cup overflows."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "Goodness and mercy all my life",
          "Shall surely follow me,",
          "And in God's house forevermore",
          "My dwelling-place shall be.",
          "And in God's house forevermore",
          "My dwelling-place shall be."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 547,
    "reference": "SDAH547",
    "title": "Be Thou My Vision",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Be Thou my vision,",
          "O Lord of my heart;",
          "Naught be all else to me,",
          "Save that Thou art",
          "Thou my best thought, By day or by night,",
          "Waking or sleeping, Thy presence my light."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Be Thou my wisdom,",
          "Be Thou my true word;",
          "I ever with Thee",
          "Thou with me, Lord;",
          "Thou my great Father, I Thy true son;",
          "Thou in me dwelling, and I with Thee one."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Riches I heed not,",
          "Nor man's empty praise,",
          "Thou mine inheritance,",
          "Now and always:",
          "Thou and Thou only, first in my heart,",
          "High King of heaven, my Treasure Thou art."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "High King of heaven,",
          "When vict'ry is won,",
          "May I reach heaven's joys,",
          "O bright heaven's Sun!",
          "Heart of my own heart, whatever befall,",
          "Still be my vision, O ruler of all."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 548,
    "reference": "SDAH548",
    "title": "Now Praise the Hidden God of Love",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Now praise the hidden God of love",
          "In whom we all must live and move,",
          "Who shepherds us, at every stage",
          "Thro' youth, maturity, and age."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Who challenged us, when were young",
          "To storm the citadels of wrong;",
          "In care for others taught us how",
          "God's true community must grow."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Who bids us never lose our zest,",
          "Tho' age is urging us to rest,",
          "But proves to us that we have still",
          "A work to do, a place to fill."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Then talk no more of wasted time,",
          "But Godward look, and upward climb,",
          "Content to sleep, when day is done,",
          "And rise refreshed, and travel on."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 549,
    "reference": "SDAH549",
    "title": "Loving Shepherd of Thy Sheep",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Loving Shepherd of Thy sheep,",
          "Keep Thy lamb, in safety keep;",
          "Nothing can Thy power withstand;",
          "None can pluck me from Thy hand."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Loving Shepherd, ever near,",
          "Teach Thy lamb Thy voice to hear;",
          "Suffer not my steps to stray",
          "From the straight and narrow way."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Where Thou leadest I would go,",
          "Walking in Thy steps below,",
          "Till within the heavenly fold",
          "I my Shepherd shall behold."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 550,
    "reference": "SDAH550",
    "title": "Every Flower That Grows",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Every flow'r that grows,",
          "Every brook that flows,",
          "Tell of beauty God has giv'n for me:",
          "Throughout my life may beauty be",
          "Deep within a heart from sin set free."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Gracious Lord above,",
          "Looking down in love,",
          "Guide my thoughts, my life, in my walk with Thee,",
          "That day by day the world may see",
          "Christ, the Lord and Savior, lives in me."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "All my earthly days,",
          "I shall sing and praise",
          "God the Father, Spirit, and Christ the Son.",
          "Grant faith when life on earth is done,",
          "I shall sing with those whose rest is won."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 551,
    "reference": "SDAH551",
    "title": "Jesus, Savior, Pilot Me",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Jesus, Savior, pilot me",
          "Over life's tempestuous sea;",
          "Unknown waves before me roll,",
          "Hiding rock and treacherous shoal,",
          "Chart and compass come from Thee;",
          "Jesus, Savior, pilot me."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "As a mother stills her child,",
          "Thou canst hush the ocean wild;",
          "Boisterous waves obey Thy will",
          "When Thou sayest to them, \"Be still.\"",
          "Wondrous Sovereign of the sea,",
          "Jesus, Savior, pilot me."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "When at last I near the shore,",
          "And the fearful breakers roar",
          "'Twixt me and the peaceful rest,",
          "Then, while leaning on Thy breast,",
          "May I hear Thee say to me,",
          "\"Fear not, I will pilot thee.\""
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 552,
    "reference": "SDAH552",
    "title": "The Lord's My Shepherd",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "The Lord's my Shepherd, I'll not want;",
          "He makes me down to lie",
          "In pastures green; He leadeth me",
          "The quiet waters by."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "My soul He doth restore again.",
          "And me to walk doth make",
          "Within the paths of righteousness,",
          "E'en for His own name's sake."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Yea, though I walk in death's dark vale,",
          "Yet will I fear no ill,",
          "For Thou art with me, and Thy rod",
          "And staff me comfort still."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "My table Thou hast furnished",
          "In presence of my foes;",
          "My head Thou dost with oil anoint,",
          "And my cup overflows."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "Goodness and mercy all my life",
          "Shall surely follow me;",
          "And in God's house forevermore",
          "My dwelling place shall be."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 553,
    "reference": "SDAH553",
    "title": "Jesus, Guide Our Way",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Jesus, guide our way",
          "To eternal day:",
          "So shall we, no more delaying,",
          "Follow Thee, Thy voice obeying:",
          "Lead us by the hand",
          "To our Father's land."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "When we danger meet",
          "Steadfast make our feet;",
          "Lord, preserve us uncomplaining",
          "Mid the darkness round us reigning:",
          "Through adversity",
          "lies our way to Thee."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Order all our way",
          "Through the mortal day:",
          "In our toil, with aid be near us:",
          "In our need, with succour cheer us:",
          "Till we safely stand",
          "In our Father's land."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 554,
    "reference": "SDAH554",
    "title": "O Let Me Walk With Thee",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "O let me walk with Thee, my God,",
          "As Enoch walked in days of old;",
          "Place Thou my trembling hand in Thine,",
          "And sweet communion with me hold;",
          "E'en though the path I may not see,",
          "Yet, Jesus, let me walk with Thee."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "I cannot, dare not, walk alone;",
          "The tempest rages in the sky,",
          "A thousand snares beset my feet,",
          "A thousand foes are lurking nigh.",
          "Still Thou the raging of the sea,",
          "O Master! let me walk with Thee."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "If I may rest my hand in Thine,",
          "I'Il count the joys of earth but loss,",
          "And firmly, bravely journey on;",
          "I'll bear the banner of the cross",
          "Till Zion's glorious gates I see;",
          "Yet, Savior, let me walk with Thee."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 555,
    "reference": "SDAH555",
    "title": "Shepherd of Tender Youth",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Shepherd of tender youth,",
          "Guiding in love and truth,",
          "Through devious ways;",
          "Christ our triumphant King,",
          "We come Thy name to sing,",
          "Hither our children bring",
          "To shout Thy praise."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Thou art our holy Lord,",
          "The all-subduing Word,",
          "Healer of strife;",
          "Thou didst Thyself abase,",
          "That from sin's deep disgrace",
          "Thou mightest save our race,",
          "And give us life."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Thou art the great High Priest;",
          "Thou hast prepared the feast",
          "Of heavenly love;",
          "While in our mortal pain",
          "None calls on Thee in vain;",
          "Help Thou dost not disdain,",
          "Help from above."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Ever be Thou our Guide,",
          "Our Shepherd and our pride,",
          "Our staff and song;",
          "Jesus, Thou Christ of God,",
          "By Thy perennial word,",
          "Lead us where Thou hast trod,",
          "Make our faith strong."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 556,
    "reference": "SDAH556",
    "title": "As Saints of Old",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "As saints of old their first-fruits brought",
          "Of orchard, flock, and field",
          "To God, the giver of all good,",
          "The source of bounteous yield;",
          "So we today first-fruits would bring,",
          "The wealth of this good land,",
          "Of farm and market, shop and home,",
          "Of mind and heart and hand."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "A world in need now summons us",
          "To labor, love, and give;",
          "To make our life an offering",
          "To God, that all may live,",
          "The church of Christ is calling us",
          "To make the dream come true:",
          "A world redeemed by Christ-like love;",
          "All life in Christ made new."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "In gratitude and humble trust",
          "We bring our best today",
          "To serve Your cause and share Your love",
          "With all along life's way.",
          "O God, who gave Yourself to us",
          "In Jesus Christ Your Son,",
          "Teach us to give ourselves each day",
          "Until life's work is done."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 557,
    "reference": "SDAH557",
    "title": "Come, Ye Thankful People",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Come, ye thankful people, come,",
          "Raise the song of harvest home!",
          "All is safely gathered in,",
          "Ere the winter storms begin;",
          "God, our Maker, doth provide",
          "For our wants to be supplied;",
          "Come to God's own temple, come;",
          "Raise the song of harvest home!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "We ourselves are God's own field,",
          "Fruit unto His praise to yield;",
          "Wheat and tares together sown,",
          "Unto joy or sorrow grown;",
          "First the blade and then the ear,",
          "Then the full corn shall appear;",
          "Grant, O harvest Lord, that we",
          "Wholesome grain and pure may be."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "For the Lord our God shall come,",
          "And shall take His harvest home;",
          "From His field shall purge away",
          "All that doth offend, that day;",
          "Give His angels charge at last",
          "In the fire the tares to cast,",
          "But the fruitful ears to store",
          "In His garner evermore."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Then, thou church triumphant, come,",
          "Raise the song of harvest home;",
          "All are safely gathered in,",
          "Free from sorrow, free from sin;",
          "There forever purified",
          "In God's garner to abide;",
          "Come, ten thousand angels, come,",
          "Raise the glorious harvest home!"
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 558,
    "reference": "SDAH558",
    "title": "For the Fruits of His Creation",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "For the fruits of His creation, thanks be to God;",
          "For the gifts to every nation, thanks be to god;",
          "For the plowing, sowing, reaping,",
          "Silent growth while men are sleeping,",
          "Future needs in earth's safe keeping, thanks be to God!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "In the just reward of labor, God's will is done;",
          "In the help we give our neighbor, God's will is done;",
          "In our world-wide task of caring",
          "For the hungry and despairing,",
          "In the harvests men are sharing, God's will is done."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "For the harvests of His Spirit, thanks be to God;",
          "For the good all men inherit, thanks be to God;",
          "For the wonders that astound us,",
          "For the truths that still confound us,",
          "Most of all, that love has found us, thanks be to God!"
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 559,
    "reference": "SDAH559",
    "title": "Now Thank We All Our God",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Now thank we all our God",
          "With heart and hands and voices,",
          "Who wondrous things hath done,",
          "In whom His world rejoices;",
          "Who, from our mothers' arms",
          "Hath blessed us on our way",
          "With countless gifts of love,",
          "And still is ours today."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "O may this bounteous God",
          "Through all our life be near us,",
          "With ever joyful hearts",
          "And blessed peace to cheer us;",
          "And keep us in His grace,",
          "And guide us when perplexed,",
          "And free us from all ills",
          "In this world and the next."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "All praise and thanks to God,",
          "The Father, now be given,",
          "The Son, and Him who reigns",
          "With them in highest heaven,",
          "The one eternal God,",
          "Whom earth and heaven adore;",
          "For thus it was, is now,",
          "And shall be evermore."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 560,
    "reference": "SDAH560",
    "title": "Let All Things Now Living",
    "hasMidi": true,
    "numberOfVerses": 2,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Let all things now living a song of thanksgiving",
          "To God the Creator triumphantly raise,",
          "Who fashioned and made us, protected and stayed us,",
          "Who guideth us on to the end of our days.",
          "His banners are o'er us, His light goes before us,",
          "A pillar of fire shining forth in the night,",
          "'Til shadows have vanished and darkness is banished,",
          "As forward we travel from light into light."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "His law He enforces: the stars in their courses,",
          "The sun in His orbit, obediently shine;",
          "The hills and the mountains, the rivers and fountains,",
          "The deeps of the ocean proclaim Him divine,",
          "We too should be voicing our love and rejoicing,",
          "With glad adoration a song let us raise,",
          "'Til all things now living unite in thanksgiving",
          "To God in the highest, hosanna and praise."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 561,
    "reference": "SDAH561",
    "title": "We Plow the Fields",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "We plow the fields and scatter",
          "The good seed on the land,",
          "But it is fed and watered",
          "By God's almighty hand.",
          "He sends the snow in winter,",
          "The warmth to swell the grain,",
          "The breezes and the sunshine,",
          "And soft, refreshing rain."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "He only is the Maker",
          "Of all things near and far;",
          "He paints the wayside flower,",
          "He lights the evening star.",
          "The winds and waves obey Him,",
          "By Him the birds are fed;",
          "Much more, to us His children,",
          "He gives our daily bread."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "We thank Thee then, O Father,",
          "For all things bright and good:",
          "The seedtime and the harvest,",
          "Our life, our health, our food.",
          "Accept the gifts we offer",
          "For all Thy love imparts,",
          "And, what Thou most desirest,",
          "Our humble, thankful hearts."
        ]
      }
    ],
    "chorus": [
      "All good gifts around us",
      "Are sent from heaven above;",
      "Then thank the Lord,",
      "O thank the Lord",
      "For all His love."
    ],
    "timestamps": {
      "chorus": 37.1188
    }
  },
  {
    "hymnNumber": 562,
    "reference": "SDAH562",
    "title": "Come Sing A Song of Harvest",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Come, sing a song of harvest,",
          "Of thanks for daily food!",
          "To offer God the first fruits",
          "Is old as gratitude."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Long, long ago, the reapers,",
          "Before they kept the feast,",
          "Put firstfruits in a basket,",
          "And took it to the priest."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Shall we, sometimes forgetful",
          "Of where creation starts,",
          "With science in our pockets",
          "Lose wonder from our hearts?"
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "May God, the great creator,",
          "To whom all life belongs,",
          "Accept this gifts we offer,",
          "Our service and our songs."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "And lest the world go hungry",
          "While ourselves are fed,",
          "Make each of us more ready",
          "To share our daily bread."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 563,
    "reference": "SDAH563",
    "title": "Praise and Thanksgiving",
    "hasMidi": true,
    "numberOfVerses": 1,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Praise and thanksgiving let everyone bring",
          "Unto our Father for every good thing.",
          "All together joyfully sing!"
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 564,
    "reference": "SDAH564",
    "title": "For Sunrise Hope and Sunset Calm",
    "hasMidi": true,
    "numberOfVerses": 2,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "For sunrise hope and sunset calm,",
          "And all that lies between,",
          "For all the sweetness and the balm",
          "That is and that has been,",
          "For comradeship, for peace in strife,",
          "And light on darkened days;",
          "For work to do and strength for life",
          "We sing our hymn of praise."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "But O, we press far, far above",
          "These gifts of pure delight,",
          "And find in Thee, and in Thy love contentment infinite.",
          "O Lord, beloved, in whom are found",
          "All joys of time and place,",
          "What will it be when joy is crowned",
          "By vision of Thy face?"
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 565,
    "reference": "SDAH565",
    "title": "For the Beauty of the Earth",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "For the beauty of the earth,",
          "For the glory of the skies,",
          "For the love which from our birth",
          "Over and around us lies,",
          "Lord of all, to Thee we raise",
          "This our grateful song of praise."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "For the joy of human love,",
          "Brother, sister, parent, child,",
          "Friends on earth and Friend above,",
          "Pleasures pure and undefiled,",
          "Lord of all, to Thee we raise",
          "This our grateful song of praise."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "For the gift of Thy dear Son,",
          "For the hope of heaven at last,",
          "For the Spirit's victory won,",
          "For the crown when life is past,",
          "Lord of all, to Thee we raise",
          "Songs of gratitude and praise."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 566,
    "reference": "SDAH566",
    "title": "Father We Thank Thee",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Father, we thank You",
          "For the light that shines all the day;",
          "For the bright sky You have given",
          "Most like Your heaven;",
          "Father, we thank You."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Father, we thank You",
          "For the lamps that lighten the way;",
          "For human skill's exploration",
          "Of Your creation",
          "Father, we thank You."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Father, we thank You",
          "For the friends who brighten our play;",
          "For Your command to call others",
          "Sisters and brothers;",
          "Father, we thank You."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Father, we thank You",
          "For your love in Jesus today,",
          "Giving us hope for tomorrow",
          "Through joy and sorrow;",
          "Father, we thank You."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 567,
    "reference": "SDAH567",
    "title": "Have Thine Own Way, Lord",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Have Thine own way, Lord!",
          "Have Thine own way!",
          "Thou art the Potter;",
          "I am the clay.",
          "Mold me and make me",
          "After Thy will,",
          "While I am waiting,",
          "Yielded and still."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Have Thine own way, Lord!",
          "Have Thine own way!",
          "Search me and try me,",
          "Master, today!",
          "Whiter than snow, Lord,",
          "Wash me just now,",
          "As in Thy presence",
          "Humbly I bow."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Have Thine own way, Lord!",
          "Have Thine own way!",
          "Wounded and weary",
          "Help me, I pray!",
          "Power; all power;",
          "Surely is Thine!",
          "Touch me and heal me,",
          "Savior divine!"
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Have Thine own way, Lord!",
          "Have Thine own way!",
          "Hold o'er my being",
          "Absolute sway!",
          "Fill with Thy Spirit",
          "Till all shall see",
          "Christ only, always,",
          "Living in me!"
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 568,
    "reference": "SDAH568",
    "title": "Make Me a Captive, Lord",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Make me a captive, Lord,",
          "And then I shall be free;",
          "Force me to render up my sword,",
          "And I shall conqueror be.",
          "I sink in life's alarms",
          "When by myself I stand;",
          "Imprison me within Thine arms,",
          "And strong shall be my hand."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "My heart is weak and poor",
          "Till it a master find;",
          "It has no spring of action sure;",
          "It varies with the wind.",
          "It cannot freely move",
          "Till Thou hast wrought its chain;",
          "Enslave it with Thy matchless love,",
          "And deathless it shall reign."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "My will is not my own",
          "Till Thou hast made it Thine;",
          "If it would reach a monarch's throne",
          "It must its crown resign;",
          "It only stands unbent,",
          "Amid the clashing strife,",
          "When on Thy bosom it has leant",
          "And found in Thee its life."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 569,
    "reference": "SDAH569",
    "title": "Pass Me Not, O Gentle Savior",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Pass me not, O gentle Savior,",
          "Hear my humble cry;",
          "While on others Thou art calling,",
          "Do not pass me by."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Let me at Thy throne of mercy",
          "Find a sweet relief;",
          "Kneeling there in deep contrition,",
          "Help my unbelief."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Trusting only in Thy merit,",
          "Would I seek Thy face;",
          "Heal my wounded, broken spirit,",
          "Save me by Thy grace."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Thou the spring of all my comfort,",
          "More than life for me;",
          "Whom have I on earth beside Thee?",
          "Whom in heaven but Thee?"
        ]
      }
    ],
    "chorus": [
      "Savior, Savior, hear my humble cry,",
      "While on others Thou art calling,",
      "Do not pass me by."
    ],
    "timestamps": {
      "chorus": 22.0727
    }
  },
  {
    "hymnNumber": 570,
    "reference": "SDAH570",
    "title": "Not I, but Christ",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Not I, but Christ, be honored, loved, exalted;",
          "Not I, but Christ, be seen, be known, be heard;",
          "Not I, but Christ, in every look and action,",
          "Not I, but Christ, in every thought and word."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Not I, but Christ, to gently soothe in sorrow,",
          "Not I, but Christ, to wipe the falling tear;",
          "Not I, but Christ, to lift the weary burden,",
          "Not I, but Christ, to hush away all fear."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Christ, only Christ! no idle words e'er falling,",
          "Christ, only Christ; no needless bustling sound;",
          "Christ, only Christ; no self important bearing;",
          "Christ, only Christ; no trace of \"I\" be found."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Not I, but Christ, my every need supplying,",
          "Not I, but Christ, my strength and health to be;",
          "Christ, only Christ, for body, soul, and spirit,",
          "Christ, only Christ, here and eternally."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 571,
    "reference": "SDAH571",
    "title": "What Does the Lord Require",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "What does the Lord require for praise and offering?",
          "What sacrifice, desire or tribute bid you bring?",
          "Do justly; Love mercy; Walk humbly with your God."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Rulers of men, give ear! Should you not justice show?",
          "Will God your pleading hear, while crime and cruelty grow?",
          "Do justly; Love mercy; Walk humbly with your God."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "How shall our life fulfill God's law so hard and high?",
          "Let Christ endue our will with grace to fortify.",
          "Then justly, in mercy we'll humbly walk with God."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 572,
    "reference": "SDAH572",
    "title": "Give of Your Best to the Master",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Give of your best to the Master,",
          "Give of the strength of your youth;",
          "Throw your soul's fresh, glowing ardor",
          "Into the battle for truth.",
          "Jesus has set the example;",
          "Dauntless was He, young and brave;",
          "Give Him your loyal devotion,",
          "Give Him the best that you have."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Give of your best to the Master,",
          "Give Him first place in your heart;",
          "Give Him first place in your service,",
          "Consecrate every part.",
          "Give, and to you shall be given;",
          "God His beloved Son gave;",
          "Gratefully seeking to serve Him,",
          "Give Him the best that you have."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Give of your best to the Master,",
          "Naught else is worthy His love;",
          "He gave Himself for your ransom,",
          "Gave up His glory above;",
          "Laid down His life without murmur,",
          "You from sin's ruin to save;",
          "Give Him your heart's adoration,",
          "Give Him the best that you have."
        ]
      }
    ],
    "chorus": [
      "Give of your best to the Master,",
      "Give of the strength of your youth;",
      "Clad in salvation's full armor,",
      "Join in the battle for truth."
    ],
    "timestamps": {
      "chorus": 42.5984
    }
  },
  {
    "hymnNumber": 573,
    "reference": "SDAH573",
    "title": "I'll Go Where You Want Me to Go",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "It may not be on the mountain's height,",
          "Or over the stormy sea;",
          "It may not be at the battle's front",
          "My Lord will have need of me;",
          "But if by a still, small voice He calls",
          "To paths I do not know,",
          "I'll answer, dear Lord, with my hand in Thine,",
          "I'll go where You want me to go."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Perhaps today there are loving words",
          "Which Jesus would have me speak;",
          "There may be now, in the paths of sin,",
          "Some wand'rer whom I should seek.",
          "O Savior, if Thou wilt be my Guide,",
          "Tho' dark and rugged the way,",
          "My voice shall echo the message sweet,",
          "I'll say what You want me to say."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "There's surely some where a lowly place",
          "In earth's harvest-fields so wide,",
          "Where I may labor thro' life's short day",
          "For Jesus, the Crucified.",
          "So, trusting my all unto Thy care,",
          "I know Thou lovest me!",
          "I'll do Thy will with a heart sincere,",
          "I'll be what You want me to be."
        ]
      }
    ],
    "chorus": [
      "I'll go where You want me to go, dear Lord,",
      "O'er mountain, or plain, or sea;",
      "I'll say what You want me to say, dear Lord,",
      "I'll be what You want me to be."
    ],
    "timestamps": {
      "chorus": 47.6953
    }
  },
  {
    "hymnNumber": 574,
    "reference": "SDAH574",
    "title": "O Master, Let Me Walk With Thee",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "O Master, let me walk with Thee",
          "In lowly paths of service free;",
          "Tell me Thy secret; help me bear",
          "The strain of toil, the fret of care."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Help me the slow of heart to move",
          "By some clear, winning word of love;",
          "Teach me the wayward feet to stay,",
          "And guide them in the homeward way."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Teach me Thy patience; still with Thee",
          "In closer, dearer company,",
          "In work that keeps faith sweet and strong,",
          "In trust that triumphs over wrong;"
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "In hope that sends a shining ray",
          "Far down the future's broadening way;",
          "In peace that only Thou canst give,",
          "With Thee, O Master, let me live."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 575,
    "reference": "SDAH575",
    "title": "Let Your Heart Be Broken",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Let your heart be broken",
          "For a world in need:",
          "Feed the mouths that hunger,",
          "Soothe the wounds that bleed,",
          "Give the cup of water",
          "And the loaf of bread",
          "Be the hands of Jesus,",
          "Serving in His stead."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Here on earth applying",
          "Principles of love,",
          "Visible expression -",
          "God still rules above-",
          "Living illustration",
          "Of the Living Word",
          "To the minds of all who've",
          "Never seen or heard."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Blest to be a blessing,",
          "Privilege to care,",
          "Challenged by the need -",
          "Apparent everywhere.",
          "Where mankind is wanting,",
          "Fill the vacant place.",
          "Be the means through which the",
          "Lord reveals his Grace."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Add to your believing",
          "Deeds that prove it true,",
          "Knowing Christ as Savior,",
          "Make Him Master, too",
          "Follow in His footsteps,",
          "Go where He has trod;",
          "In the world's great trouble",
          "Risk yourself for God."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "Let your heart be tender",
          "And your vision clear;",
          "See mankind  as God sees,",
          "Serve Him far and near.",
          "Let your heart be broken",
          "By a brother's pain;",
          "Share your rich resources,",
          "Give and give again."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 576,
    "reference": "SDAH576",
    "title": "Awake, Awake to Love and Work",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Awake, awake to love and work!",
          "The lark is in the sky;",
          "The fields are wet with diamond dew;",
          "The worlds awake to cry",
          "Their blessings on the Lord of life,",
          "As He goes meekly by."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Come, let thy voice be one with theirs,",
          "Shout with their shout of praise;",
          "See how the giant sun soars up,",
          "Great lord of years and days!",
          "So let the love of Jesus come",
          "And set thy soul ablaze."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "To give and give, and give again,",
          "What God hath given thee;",
          "To spend thyself nor count the cost;",
          "To serve right gloriously",
          "The God who gave all worlds that are,",
          "And all that are to be."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 577,
    "reference": "SDAH577",
    "title": "In the Heart of Jesus",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "In the heart of Jesus",
          "There is love for you,",
          "Love most pure and tender,",
          "Love most deep and true;",
          "Why should you be lonely,",
          "Why for friendship sigh,",
          "When the heart of Jesus",
          "Has a full supply?"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "In the mind of Jesus",
          "There is thought for you,",
          "Warm as summer sunshine,",
          "Sweet as morning dew;",
          "Why should you be fearful,",
          "Why take anxious thought,",
          "Since the mind of Jesus",
          "Cares for those He bought?"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "In the field of Jesus",
          "There is work for you;",
          "Such as even angels",
          "Might rejoice to do;",
          "Why stand idly sighing",
          "For some lifework grand,",
          "While the field of Jesus",
          "Seeks your reaping hand?"
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "In the home of Jesus",
          "There's a place for you;",
          "Glorious, bright, and joyous,",
          "Calm and peaceful, too;",
          "Why then, like a wanderer,",
          "Roam with weary pace,",
          "If the home of Jesus",
          "Holds for you a place?"
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 578,
    "reference": "SDAH578",
    "title": "So Send I You",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "So send I you-by grace made strong to triumph",
          "O'er hosts of hell, o'er darkness, death, and sin,",
          "My name to bear, and in that name to conquer-",
          "So send I you, My victory to win."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "So send I you-to take to souls in bondage",
          "The word or truth that sets the captive free,",
          "To break the bonds of sin, to loose death's fetters-",
          "So send I you, to bring the lost to Me."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "So send I you - My strength to know in weakness,",
          "My joy in grief, My perfect peace in pain,",
          "To prove My power, My grace, My promised presence-",
          "So send I you, eternal fruit to gain."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "So send I you-to bear My cross with patience,",
          "And then one day with joy to lay it down,",
          "To hear My voice, \"Well done, My faithful servant-",
          "Come, share My throne, My kingdom, and My crown!\"",
          "\"As the Father hath sent Me, so send I you.\""
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 579,
    "reference": "SDAH579",
    "title": "'Tis Love That Makes Us Happy",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "'Tis love that makes us happy,",
          "'Tis love that smooths the way;",
          "It helps us mind, it makes us kind",
          "To others every day."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "This world is full of sorrow,",
          "Of sickness, death, and sin;",
          "With loving heart we'll do our part,",
          "And try some soul to win."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "And when this life is over,",
          "And we are called above",
          "Our song shall be, eternally,",
          "Of Jesus and His love."
        ]
      }
    ],
    "chorus": [
      "God is love; we're His little children.",
      "God is love; we would be like Him.",
      "'Tis love that makes us happy,",
      "'Tis love that smooths the way;",
      "It helps us \"mind,\" it makes us kind",
      "To others every day."
    ],
    "timestamps": {
      "chorus": 11.8351
    }
  },
  {
    "hymnNumber": 580,
    "reference": "SDAH580",
    "title": "This Little Light of Mine",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "This little light of mine,",
          "I'm going to let it shine,",
          "This little light of mine,",
          "I'm going to let it shine,",
          "This little light of mine,",
          "I'm going to let it shine,",
          "Let it shine, let it shine, let it shine."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Everywhere I go,",
          "I'm going to let it shine,",
          "Everywhere I go,",
          "I'm going to let it shine,",
          "Everywhere I go,",
          "I'm going to let it shine,",
          "Let it shine, let it shine, let it shine."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "All through the night,",
          "I'm going to let it shine,",
          "All through the night,",
          "I'm going to let it shine,",
          "All through the night,",
          "I'm going to let it shine,",
          "Let it shine, let it shine, let it shine."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 581,
    "reference": "SDAH581",
    "title": "When the Church of Jesus",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "When the church of Jesus",
          "Shuts its outer door,",
          "Lest the roar of traffic",
          "Drown the voice of prayer:",
          "May our prayers, Lord, make us",
          "Ten times more aware",
          "That the world banish",
          "Is our Christian care."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "If our hearts are lifted",
          "Where devotion soars",
          "High above this hungry",
          "Suffering world of ours;",
          "Lest our hymns should drug us",
          "To forget its needs,",
          "Forge our Christian worship",
          "Into Christian deeds."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Lest the gifts we offer,",
          "Money, talents, time,",
          "Serve to salve our conscience",
          "To our secret shame;",
          "Lord, reprove, inspire us",
          "By the way you give;",
          "Teach us, dying Savior,",
          "How true Christians live."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 582,
    "reference": "SDAH582",
    "title": "Working, O Christ, With Thee",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Working, O Christ, with Thee,",
          "Working with Thee,",
          "Unworthy, sinful, weak,",
          "Though we may be;",
          "Our all to Thee we give,",
          "For Thee alone we live,",
          "And by Thy grace achieve,",
          "Working with Thee."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Along the city's waste,",
          "Working with Thee,",
          "Our eager footsteps haste,",
          "Like Thee to be;",
          "The poor we gather in,",
          "The outcasts raise from sin,",
          "And labor souls to win,",
          "Working with Thee."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Savior, we weary not,",
          "Working with Thee,",
          "As hard as Thine our lot",
          "Can never be;",
          "Our joy and comfort this,",
          "\"Thy grace sufficient is;\"",
          "This changes toil to bliss,",
          "Working with Thee."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "So let us labor on,",
          "Working with Thee,",
          "Till earth to Thee is won,",
          "From sin set free;",
          "Till men, from shore to shore,",
          "Receive Thee, and adore,",
          "And join us evermore,",
          "Working with Thee."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 583,
    "reference": "SDAH583",
    "title": "You That Know the Lord",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "You that know the Lord is gracious,",
          "You for whom cornerstone",
          "Stands, of God, elect and precious,",
          "Laid that you may build thereon,",
          "See that on that sure foundation",
          "You a living temple raise.",
          "Towers that may tell forth salvation",
          "Walls that may re-echo praise."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Living stones by God appointed",
          "Each to his alotted place,",
          "Kings and priests, by God anointed,",
          "Shall you not declare His grace?",
          "You a royal generation",
          "Tell the tidings of your birth,",
          "Tidings of a new creation",
          "To an old and weary earth."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Tell the praise of Him who called you",
          "Out of darkness into light,",
          "Broke the fetters that enthralled you,",
          "Gave you freedom, peace, and sight:",
          "Tell the tale of sins forgiven",
          "Strength renewed and hope restored.",
          "Till the earth, in tune with heaven,",
          "Praise and magnify the Lord."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 584,
    "reference": "SDAH584",
    "title": "There's A Spirit in the Air",
    "hasMidi": true,
    "numberOfVerses": 7,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "There's a Spirit in the air,",
          "Telling Christians everywhere",
          "\"Praise the love that Christ revealed,",
          "Living, working in our world.\""
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Lose your shyness, find your tongue;",
          "Tell the world what God has done:",
          "God in Christ has come to stay,",
          "We can see His pow'r today."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "When believers break the bread",
          "When a hungry child is fed:",
          "Praise the love that Christ revealed",
          "Living, working in our world."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Still His Spirit leads the fight,",
          "Seeing wrong and setting right:",
          "God in Christ has come to stay,",
          "We can see His pow'r today."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "When a stranger's not a alone,",
          "Where the homeless find a home,",
          "Praise the love that Christ revealed,",
          "Living, working in our world."
        ]
      },
      {
        "verseNumber": 6,
        "content": [
          "May His Spirit fill our praise,",
          "Guide our thoughts and change our ways.",
          "God in Christ has come to stay,",
          "We can see His pow'r today."
        ]
      },
      {
        "verseNumber": 7,
        "content": [
          "There’s a Spirit in the air,",
          "Calling people everywhere.",
          "Praise the love that Christ revealed:",
          "Living, working in our world."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 585,
    "reference": "SDAH585",
    "title": "When Christ Was Lifted From the Earth",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "When Christ was lifted from the earth",
          "His arms stretched out above",
          "Through every culture, every birth,",
          "To draw an answering love."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Still east and west His love extends",
          "And always, near or far,",
          "He calls and claims us as His friends",
          "And love us as we are."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Where generation, class or race",
          "Divides us to our shame",
          "He sees not labels but a face,",
          "A person and a name."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Thus freely loved, tho' fully known",
          "May I in Christ be free",
          "To welcome and accept His own",
          "As Christ accepted me."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 586,
    "reference": "SDAH586",
    "title": "What Joy It Is to Worship Here",
    "hasMidi": true,
    "numberOfVerses": 2,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "What joy it is to worship here,",
          "And find ourselves at home,",
          "Where God, who uses every gift,",
          "Has room for all who come!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Yet are no two of us alike",
          "Of all the human race,",
          "And we must seek a common ground",
          "If we would share His grace."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 587,
    "reference": "SDAH587",
    "title": "In Christ There Is No East nor West",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "In Christ there is no east nor west,",
          "In Him no south or north;",
          "But one great fellowship of love",
          "Throughout the whole wide earth."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "In Him shall true hearts everywhere",
          "Their high communion find;",
          "His service is the golden cord",
          "Close binding all mankind."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Join hands, then, brothers of the faith,",
          "Whate'er your race may be.",
          "Who serves my Father as a son",
          "Is surely kin to me."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "In Christ now meet both east and west,",
          "In Him meet south and north;",
          "All Christly souls are one in Him",
          "Throughout the whole wide earth."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 588,
    "reference": "SDAH588",
    "title": "Lord of All Nations",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Lord of all nations, grant me grace",
          "To love all people, every race,",
          "And in each person may I see",
          "My kindred loved, redeemer by Thee."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Break down the wall that would divide",
          "Thy children Lord, on every side.",
          "My neighbor's good let me pursue;",
          "Let Christian love bind warm and true."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Forgive me, Lord, where I have erred",
          "By loveless act and thoughtless word.",
          "Make me to see the wrong I do",
          "Will crucify my Lord anew."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Give me Thy courage, Lord, to speak",
          "Whenever strong oppress the weak.",
          "Should I myself the victim be,",
          "Help me forgive, rememb'ring Thee"
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "With Thine own love may I be filled",
          "And by Thy Holy Spirit willed,",
          "That all I touch, where'er I be,",
          "May be divinely touched by Thee."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 589,
    "reference": "SDAH589",
    "title": "Holy Spirit Gracious Guest",
    "hasMidi": true,
    "numberOfVerses": 6,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Holy Spirit, gracious guest,",
          "Hear and grant our heart's request",
          "For that gift supreme and best",
          "Holy heav'nly love."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Faith that mountains could remove,",
          "Tongues of earth or heaven above,",
          "Knowledge, all things, empty prove",
          "If I have no love."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Though I as a martyr bleed,",
          "Give my goods the poor to feed,",
          "All is vain if love I need:",
          "Therefore give me love."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Love is kind and suffers long,",
          "Love is pure and thinks no wrong;",
          "Love than death ifself more strong:",
          "Therefore give us love."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "Prophecy will fade away,",
          "Melting in the light of day;",
          "Love will ever with us stay:",
          "Therefore give us love."
        ]
      },
      {
        "verseNumber": 6,
        "content": [
          "Faith and hope and love we see",
          "Joining hand in had agree-",
          "But the greatest of the three,",
          "And the best is love."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 590,
    "reference": "SDAH590",
    "title": "Trust and Obey",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "When we walk with the Lord",
          "In the light of His word,",
          "What a glory He sheds on our way!",
          "While we do His good will,",
          "He abides with us still,",
          "And with all who will trust and obey."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Not a shadow can rise,",
          "Not a cloud in the skies,",
          "But His smile quickly drives it away;",
          "Not a doubt nor a fear,",
          "Not a sigh nor a tear,",
          "Can abide while we trust and obey."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Not a burden we bear,",
          "Not a sorrow we share,",
          "But our toil He doth richly repay;",
          "Not a grief nor a loss,",
          "Not a frown nor a cross,",
          "But is blest if we trust and obey."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "But we never can prove",
          "The delights of His love,",
          "Until all on the altar we lay,",
          "For the favor He shows,",
          "And the joy He bestows,",
          "Are for them who will trust and obey."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "Then in fellowship sweet",
          "We will sit at His feet,",
          "Or we'll walk by His side in the way;",
          "What He says we will do,",
          "Where He sends we will go,",
          "Never fear, only trust and obey."
        ]
      }
    ],
    "chorus": [
      "Trust and obey, for there's no other way",
      "To be happy in Jesus, but to trust and obey."
    ],
    "timestamps": {
      "chorus": 24.6178
    }
  },
  {
    "hymnNumber": 591,
    "reference": "SDAH591",
    "title": "In Our Work and in Our Play",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "In our work and in our play,",
          "Jesus, ever with us stay;",
          "May we always strive to be",
          "True and faithful unto Thee.",
          "Then we truthfully can sing,",
          "We are children of the King."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "May we in Thy strength subdue",
          "Evil tempers, words untrue,",
          "Thoughts impure, and deeds unkind,",
          "All things hateful to Thy mind.",
          "Then we truthfully can sing,",
          "We are children of the King."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Children of the King are we!",
          "May we loyal to Him be;",
          "Try to please Him every day,",
          "In our work and in our play.",
          "Then we truthfully can sing,",
          "We are children of the King."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 592,
    "reference": "SDAH592",
    "title": "Watchman, Tell Us of the Night",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Watchman, tell us of the night,",
          "What its signs of promise are.",
          "Traveler, o'er yon mountain's height,",
          "See that glory-beaming star.",
          "Watchman, does its beauteous ray",
          "Aught of joy or hope foretell?",
          "Traveler, yes; it brings the day,",
          "Promised day of Israel."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Watchman, tell us of the night,",
          "Higher yet that star ascends.",
          "Traveler, blessedness and light,",
          "Peace and truth its course portends.",
          "Watchman, will its beams alone",
          "Gild the spot that gave them birth?",
          "Traveler, ages are its own;",
          "See, it bursts o'er all the earth."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Watchman, tell us of the night,",
          "For the morning seems to dawn.",
          "Traveler, darkness takes its flight,",
          "Doubt and terror are withdrawn.",
          "Watchman, let your wanderings cease;",
          "Hasten to your quiet home.",
          "Traveler, lo, the Prince of Peace,",
          "Lo, the Son of God is come!"
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 593,
    "reference": "SDAH593",
    "title": "In Times Like These",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "In times like these you need a Savior,",
          "In times like these you need an anchor;",
          "Be very sure, be very sure",
          "Your anchor holds and grips the solid Rock!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "In times like these you need the Bible,",
          "In times like these O be not idle;",
          "Be very sure, be very sure",
          "Your anchor holds and grips the solid Rock!"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "In times like these I have a Savior,",
          "In times like these I have an anchor;",
          "I'm very sure, I'm very sure",
          "My anchor holds and grips the solid Rock!"
        ]
      }
    ],
    "chorus": [
      "This Rock is Jesus, Yes, He's the One,",
      "This Rock is Jesus, The only One!",
      "Be very sure, be very sure",
      "Your anchor holds and grips the solid Rock!"
    ],
    "timestamps": {
      "chorus": 28.5699
    }
  },
  {
    "hymnNumber": 594,
    "reference": "SDAH594",
    "title": "Heir of the Kingdom",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Heir of the kingdom, O why dost thou slumber?",
          "Why art thou sleeping so near thy blest home?",
          "Wake thee, arouse thee, and gird on thine armor,",
          "Speed, for the moments are hurrying on."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Heir of the kingdom, say, why dost thou linger?",
          "How canst thou tarry in sight of the prize?",
          "Up, and adorn thee, the Savior is coming;",
          "Haste to receive Him descending the skies."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Earth's mighty nations, in strife and commotion,",
          "Tremble with terror, and sink in dismay;",
          "Listen, 'tis nought but the chariot's loud rumbling;",
          "Heir of the kingdom, no longer delay."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Stay not, O stay not for earth's vain allurements!",
          "See how its glory is passing away;",
          "Break the strong fetters the foe hath bound o'er thee;",
          "Heir of the kingdom, turn, turn thee away."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "Keep the eye single, the head upward lifted;",
          "Watch for the glory of earth's coming King;",
          "Lo! o'er the mountaintops light is now breaking;",
          "Heirs of the kingdom, rejoice ye and sing."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 595,
    "reference": "SDAH595",
    "title": "Let Every Lamp Be Burning",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Let every lamp be burning bright,",
          "The darkest hour is nearing;",
          "The darkest hour of earth's long night,",
          "Before the Lord's appearing."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Though thousands calmly slumber on,",
          "The last great message spurning,",
          "We'll rest our living faith upon",
          "His promise of returning."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "His word our lamp, His truth our guide,",
          "We cannot be mistaken;",
          "Though dangers rise on every side,",
          "We shall not be forsaken."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Then let good works with faith appear,",
          "To help the world around us;",
          "Obedience brings the blessing near",
          "When faith has firmly bound us."
        ]
      }
    ],
    "chorus": [
      "Then trim your lamps, my brethren dear,",
      "Then trim your lamps with godly fear;",
      "The Master's coming draweth near,",
      "Let every lamp be burning."
    ],
    "timestamps": {
      "chorus": 17.2419
    }
  },
  {
    "hymnNumber": 596,
    "reference": "SDAH596",
    "title": "Look for the Waymarks",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Look for the waymarks as you journey on,",
          "Look for the waymarks passing one by one;",
          "Down through the ages, past the kingdoms four;",
          "Where are we standing?",
          "Look the waymarks o'er."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "First, the Assyrian kingdom ruled the world,",
          "Then MedoPersia's banners were unfurled;",
          "And after Greece held universal sway,",
          "Rome seized the scepter;",
          "Where are we today?"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Down in the feet of iron and of clay,",
          "Weak and divided, soon to pass away;",
          "What will the next great, glorious drama be?",
          "Christ and His coming,",
          "And eternity."
        ]
      }
    ],
    "chorus": [
      "Look for the waymarks, the great prophetic waymarks,",
      "Down through the ages, past the kingdoms four.",
      "Look for the way marks, the great prophetic waymarks;",
      "The journey's almost o'er."
    ],
    "timestamps": {
      "chorus": 22.0087
    }
  },
  {
    "hymnNumber": 597,
    "reference": "SDAH597",
    "title": "Ye Servants of the Lord",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Ye servants of the Lord,",
          "Each in his office wait;",
          "Observant of His heavenly word,",
          "And watchful at his gate."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Let all your lamps be bright,",
          "And trim the golden flame;",
          "Gird up your loins as in His sight;",
          "His coming thus proclaim."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Watch, 'tis your Lord's command,",
          "And while we speak He's near;",
          "Mark the first signal of His hand,",
          "And ready all appear."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "O happy servant, he,",
          "In such a posture found!",
          "He shall his Lord with rapture see,",
          "And be with honor crowned."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 598,
    "reference": "SDAH598",
    "title": "Watch, Ye Saints",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Watch, ye saints, with eyelids waking;",
          "Lo! the powers of heaven are shaking;",
          "Keep your lamps all trimmed and burning,",
          "Ready for your Lord's returning."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Lo! the promise of your Savior,",
          "Pardoned sin and purchased favor,",
          "Blood-washed robes and crowns of glory;",
          "Haste to tell redemption's story."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Kingdoms at their base are crumbling,",
          "Hark! His chariot wheels are rumbling,",
          "Tell, O tell of grace abounding,",
          "While the seventh trump is sounding."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Nations wane, though proud and stately;",
          "Christ His kingdom hasteneth greatly;",
          "Earth her latest pangs is summing;",
          "Shout, ye saints, your Lord is coming."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "Sinners, come, while Christ is pleading;",
          "Now for you He's interceding;",
          "Haste, ere grace and time diminished",
          "Shall proclaim the mystery finished."
        ]
      }
    ],
    "chorus": [
      "Lo! He comes, lo! Jesus comes;",
      "Lo! He comes, He comes all-glorious!",
      "Jesus comes to reign victorious,",
      "Lo! He comes, yes, Jesus comes."
    ],
    "timestamps": {
      "chorus": 18.9199
    }
  },
  {
    "hymnNumber": 599,
    "reference": "SDAH599",
    "title": "Rejoice, Rejoice, Believers",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Rejoice, rejoice, believers,",
          "And let your lights appear:",
          "The evening is advancing,",
          "And darker night is near.",
          "The Bridegroom is arising",
          "And soon He draweth nigh:",
          "Up, pray and watch and wrestle,",
          "At midnight comes the cry."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "The watchers on the mountain",
          "Proclaim the Bridegroom near.",
          "Go, meet Him as He cometh,",
          "With hallelujahs clear.",
          "The marriage feast is waiting,",
          "The gates wide open stand;",
          "Up, up, you heirs of glory,",
          "The Bridegroom is at hand."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "You saints who here in patience",
          "Your cross and suff'rings bore,",
          "Shall live and reign forever,",
          "When sorrow is no more.",
          "Upon the throne of glory",
          "The Lamb you shall behold,",
          "In triumph cast before Him",
          "Your diadems of gold."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Our hope and expectation,",
          "O Jesus, now appear;",
          "Arise, O sun so longed for,",
          "O'er this benighted sphere!",
          "With hearts and hands uplifted,",
          "We plead, O Lord, to see",
          "The day of earth's redemption",
          "That brings us unto Thee."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 600,
    "reference": "SDAH600",
    "title": "Hold Fast Till I Come",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Sweet promise is given to all who believe;",
          "\"Behold I come quickly Mine own to receive;",
          "Hold fast till I come; the danger is great;",
          "Sleep not as do others; be watchful, and wait.\""
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "We'll \"watch unto prayer\" with lamps burning bright;",
          "He comes to all other a \"thief in the night.\"",
          "We know He is near, but know not the day;",
          "As spring shows that summer is not far away."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Yes! this is our hope, 'tis built on His word;",
          "The glorious appearing of Jesus, our Lord;",
          "Of promises all, it stands as the sum:",
          "\"Behold I come quickly, hold fast till I come.\""
        ]
      }
    ],
    "chorus": [
      "\"Hold fast till I come;\" sweet promise of heaven;",
      "\"The kingdom restored, to you shall be given!\"",
      "\"Come, enter My joy, sit down on My throne;",
      "Bright crowns are in waiting; hold fast till I come.\""
    ],
    "timestamps": {
      "chorus": 26.2994
    }
  },
  {
    "hymnNumber": 601,
    "reference": "SDAH601",
    "title": "Watchmen, on the Walls of Zion",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Watchmen, on the walls of Zion,",
          "What, O tell us, of the night?",
          "Is the day-star now arising?",
          "Will the morn soon greet our sight?",
          "O'er your vision",
          "Shine there now some rays of light?",
          "O'er your vision",
          "Shine there now some rays of light?"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Tell, O tell us, are the landmarks",
          "On our voyage all passed by?",
          "Are we nearing now the haven?",
          "Can we e'en the land descry?",
          "Do we truly",
          "See the heavenly kingdom nigh?",
          "Do we truly",
          "See the heavenly kingdom nigh?"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Light is beaming, day is coming!",
          "Let us sound aloud the cry;",
          "We behold the day-star rising",
          "Pure and bright in yonder sky!",
          "Saints, be joyful;",
          "Your redemption draweth nigh;",
          "Saints, be joyful;",
          "Your redemption draweth nigh."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "We have found the chart and compass,",
          "And are sure the land is near;",
          "Onward, onward we are hasting,",
          "Soon the haven will appear;",
          "Let your voices",
          "Sound aloud our holy cheer;",
          "Let your voices",
          "Sound aloud your holy cheer."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 602,
    "reference": "SDAH602",
    "title": "O Brother, Be Faithful",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "O brother, be faithful! soon Jesus will come,",
          "For whom we have waited so long;",
          "O, soon we shall enter our glorious home,",
          "And join in the conqueror's song.",
          "O brother, be faithful! for why should we prove",
          "Unfaithful to Him who hath shown",
          "Such deep, such unbounded and infinite love;",
          "Who died to redeem us His own."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "O brother, be faithful! the city of gold,",
          "Prepared for the good and the blest,",
          "Is waiting its portals of pearl to unfold,",
          "And welcome thee into thy rest.",
          "Then, brother, prove faithful! not long shall we stay",
          "In weariness here, and forlorn,",
          "Time's dark night of sorrow is wearing away,",
          "We haste to the glorious morn."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "O brother, be faithful! He soon will descend,",
          "Creation's omnipotent King,",
          "While legions of angels His chariot attend,",
          "And palm wreaths, of victory bring.",
          "O brother, be faithful! and soon shalt thou hear",
          "Thy Savior pronounce the glad word,",
          "Well done, faithful servant, thy title is clear,",
          "To enter the joy of thy Lord."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "O brother be faithful! eternity's years",
          "Shall tell for thy faithfulness now,",
          "When bright smiles of gladness shall scatter thy tears,",
          "A coronet gleam on thy brow.",
          "O brother, be faithful! the promise is sure,",
          "That waits for the faithful and tried;",
          "To reign with the ransomed, immortal and pure,",
          "And ever with Jesus abide."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 603,
    "reference": "SDAH603",
    "title": "Christian, Seek Not Repose",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Christian, seek not yet repose,",
          "Cast thy dreams of ease away;",
          "Thou art in the midst of foes;",
          "Watch and pray!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Gird thy heavenly armor on,",
          "Wear it ever, night and day;",
          "Ambushed lies the evil one;",
          "Watch and pray!"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Hear the victors who o'ercame;",
          "Still they mark each warrior's way;",
          "All with one sweet voice exclaim:",
          "\"Watch and pray!\""
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Hear, above all, hear thy Lord,",
          "Him thou lovest to obey;",
          "Hide within thy heart His word:",
          "\"Watch and pray!\""
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "Watch, as if on that alone",
          "Hung the issue of the day;",
          "Pray that help may be sent down;",
          "Watch and pray!"
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 604,
    "reference": "SDAH604",
    "title": "We Know Not the Hour",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "We know not the hour of the Master's appearing;",
          "Yet signs all foretell that the moment is nearing",
          "When He shall return; 'tis a promise most cheering;",
          "But we know not the hour."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "There's light for the wise who are seeking salvation;",
          "There's truth in the book of the Lord's revelation;",
          "Each prophecy points to the great consummation;",
          "But we know not the hour."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "We'll watch and we'll pray, with our lamps trimmed and burning;",
          "We'll work and we'll wait till the Master's returning;",
          "We'll sing and rejoice, every omen discerning;",
          "But we know not the hour."
        ]
      }
    ],
    "chorus": [
      "He will come, let us watch and be ready;",
      "He will come, hallelujah! hallelujah!",
      "He will come in the clouds of His Father's bright glory",
      "But we know not the hour."
    ],
    "timestamps": {
      "chorus": 27.3162
    }
  },
  {
    "hymnNumber": 605,
    "reference": "SDAH605",
    "title": "My Soul, Be on Thy Guard",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "My soul, be on thy guard!",
          "Ten thousand foes arise;",
          "The hosts of sin are pressing hard",
          "To draw thee from the skies."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "O watch, and fight, and pray!",
          "The battle ne'er give o'er;",
          "Renew it boldly every day,",
          "And help divine implore."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Ne'er think the victory won,",
          "Nor lay thine armor down;",
          "Thy arduous task will not be done",
          "Till thou obtain the crown."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 606,
    "reference": "SDAH606",
    "title": "Once to Every Man and Nation",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Once to every man and nation",
          "Comes the moment to decide,",
          "In the strife of truth with falsehood,",
          "For the good or evil side;",
          "Some great cause, God's new Messiah,",
          "Offering each the bloom or blight,",
          "And the choice goes by forever",
          "'Twixt that darkness and that light."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Then to side with truth is noble",
          "When we share her wretched crust,",
          "Ere her cause bring fame and profit,",
          "And 'tis prosperous to be just;",
          "Then it is the brave man chooses,",
          "While the coward stands aside,",
          "Till the multitude make virtue",
          "Of the faith they had denied."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "By the light of burning martyrs,",
          "Christ, Thy bleeding feet we track,",
          "Toiling up new Calvaries ever",
          "With the cross that turns not back",
          "New occasions teach new duties,",
          "Time makes ancient good uncouth;",
          "They must upward still and onward,",
          "Who would keep abreast of truth."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Though the cause of evil prosper,",
          "Yet 'tis truth alone is strong;",
          "Though her portion be the scaffold,",
          "And upon the throne be wrong;",
          "Yet that scaffold sways the future,",
          "And, behind the dim unknown,",
          "Standeth God within the shadow,",
          "Keepin watch above His own."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 607,
    "reference": "SDAH607",
    "title": "God of Grace and God of Glory",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "God of grace and God of glory,",
          "On Thy people pour Thy power;",
          "Now fulfill Thy church's story,",
          "Bring her bud to glorious flower.",
          "Grant us wisdom, grant us courage,",
          "For the facing of this hour."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Lo, the hosts of evil round us",
          "Scorn Thy Christ, assail His ways;",
          "From the fears that long have bound us",
          "Free our hearts to faith and praise.",
          "Grant us wisdom, grant us courage,",
          "For the facing of this hour."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Cure Thy children's warring madness,",
          "Bend our pride to Thy control;",
          "Shame our wanton, selfish gladness",
          "Rich in goods and poor in soul.",
          "Grant us wisdom, grant us courage,",
          "Lest we miss Thy kingdom's goal."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Set our feet on lofty places,",
          "Gird our lives that they may be",
          "Armored with all Christ like graces",
          "In the fight to set all free.",
          "Grant us wisdom, grant us courage,",
          "That we fail not man nor Thee."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 608,
    "reference": "SDAH608",
    "title": "Faith Is the Victory",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Encamped along the hills of light,",
          "Ye Christian soldiers, rise,",
          "And press the battle ere the night",
          "Shall veil the glowing skies.",
          "Against the foe in vales below",
          "Let all our strength be hurled;",
          "Faith is the victory, we know,",
          "That overcomes the world."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "On every hand the foe we find",
          "Drawn up in dread array;",
          "Let tents of ease be left behind,",
          "And onward to the fray;",
          "Salvation's helmet on each head,",
          "With truth all girt about,",
          "The earth shall tremble 'neath our tread,",
          "And echo with our shout."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "To him that overcomes the foe,",
          "White raiment shall be giv'n;",
          "Before the angels he shall know",
          "His name confessed in heav'n.",
          "Then onward from the hills of light,",
          "Our hearts with love aflame,",
          "We'll vanquish all the hosts of night",
          "In Jesus' conquering name."
        ]
      }
    ],
    "chorus": [
      "Faith is the victory!",
      "Faith is the victory!",
      "O, glorious victory,",
      "That overcomes the world."
    ],
    "timestamps": {
      "chorus": 33.1561
    }
  },
  {
    "hymnNumber": 609,
    "reference": "SDAH609",
    "title": "Am I a Soldier of the Cross?",
    "hasMidi": true,
    "numberOfVerses": 6,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Am I a soldier of the cross,",
          "A follower of the Lamb?",
          "And shall I fear to own His cause?",
          "Or blush to speak His name?"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Must I be carried to the skies",
          "On flowery beds of ease,",
          "Whilst others fought to win the prize,",
          "And sailed through bloody seas?"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Are there no foes for me to face?",
          "Must I not stem the flood?",
          "Is this vile world a friend of grace,",
          "To help me on to God?"
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Sure I must fight if I would reign;",
          "Increase my courage, Lord;",
          "I'll bear the toil, endure the pain,",
          "Supported by Thy word."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "Thy saints in all this glorious war",
          "Shall conquer, though they die;",
          "They see the triumph from afar,",
          "With faith's discerning eye."
        ]
      },
      {
        "verseNumber": 6,
        "content": [
          "When that illustrious day shall rise,",
          "And all Thy armies shine",
          "In robes of victory through the skies,",
          "The glory shall be Thine."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 610,
    "reference": "SDAH610",
    "title": "Stand Like the Brave",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "O Christian, awake! 'tis the Master's command;",
          "With helmet and shield, and a sword in thy hand,",
          "To meet the bold tempter, go, fearlessly go,",
          "Then stand like the brave, with thy face to the foe."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "The cause of thy Master with vigor defend;",
          "Be watchful, be zealous, and fight to the end;",
          "Wherever He leads thee, go, valiantly go,",
          "Then stand like the brave, with thy face to the foe."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Press on, never doubting, thy Captain is near,",
          "With grace to supply, and with comfort to cheer;",
          "His love, like a stream in the desert will flow;",
          "Then stand like the brave, with thy face to the foe."
        ]
      }
    ],
    "chorus": [
      "Stand like the brave, stand like the brave,",
      "Stand like the brave, with thy face to the foe."
    ],
    "timestamps": {
      "chorus": 27.451
    }
  },
  {
    "hymnNumber": 611,
    "reference": "SDAH611",
    "title": "Awake, My Soul",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Awake, my soul! stretch every nerve,",
          "And press with vigor on;",
          "A heavenly race demands thy zeal,",
          "And an immortal crown."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "'Tis God's all animating voice",
          "That calls thee from on high;",
          "'Tis He whose hand presents the prize",
          "To thine aspiring eye."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "A cloud of witnesses around",
          "Hold thee in full survey;",
          "Forget the steps already trod,",
          "And onward urge thy way."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Blest Savior, introduced by Thee,",
          "Our race have we begun;",
          "And, crowned with victory, at Thy feet",
          "We'll lay our trophies down."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 612,
    "reference": "SDAH612",
    "title": "Onward, Christian Soldiers!",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Onward, Christian soldiers!",
          "Marching as to war,",
          "With the cross of Jesus",
          "Going on before.",
          "Christ the royal Master,",
          "Leads against the foe;",
          "Forward into battle,",
          "See, His banners go!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Like a mighty army",
          "Moves the church of God;",
          "Christians, we are treading",
          "Where the saints have trod;",
          "We are not divided,",
          "All one body we,",
          "One in hope and doctrine,",
          "One in charity."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Crowns and thrones have perished,",
          "Kingdoms rise and wane,",
          "But the church of Jesus",
          "Constant will remain.",
          "Gates of hell can never",
          "'Gainst that church prevail;",
          "We have Christ's own promise,",
          "That can never fail."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Onward, then, ye people!",
          "Join our happy throng,",
          "Blend with ours your voices",
          "In the triumph song;",
          "Glory, praise, and honor",
          "Unto Christ the King,",
          "This through countless ages",
          "Men and angels sing."
        ]
      }
    ],
    "chorus": [
      "Onward, Christian soldiers!",
      "Marching as to war,",
      "With the cross of Jesus",
      "Going on before."
    ],
    "timestamps": {
      "chorus": 33.8282
    }
  },
  {
    "hymnNumber": 613,
    "reference": "SDAH613",
    "title": "Fight the Good Fight",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Fight the good fight with all thy might,",
          "Christ is thy strength and Christ thy right;",
          "Lay hold on life and it shall be",
          "Thy joy and crown eternally."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Run the straight race through God's good grace;",
          "Lift up thine eyes, and seek His face.",
          "Life with its path before us lies;",
          "Christ is the way, and Christ the prize."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Cast care aside, lean on thy guide;",
          "His boundless mercy will provide;",
          "Trust, and the trusting soul shall prove",
          "Christ is its life, and Christ its love."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Faint not, nor fear, His arms are near;",
          "He changeth not and thou art dear.",
          "Only believe, and thou shalt see",
          "That Christ is all in all to thee."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 614,
    "reference": "SDAH614",
    "title": "Sound the Battle Cry",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Sound the battle cry,",
          "See! the foe is nigh;",
          "Raise the standard high",
          "For the Lord;",
          "Gird your armor on,",
          "Stand firm, every one,",
          "Rest your cause upon",
          "His holy word."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Strong to meet the foe,",
          "Marching on we go,",
          "While our cause we know",
          "Must prevail;",
          "Shield and banner bright,",
          "Gleaming in the light,",
          "Battling for the right,",
          "We ne'er can fail."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "O Thou God of all,",
          "Hear us when we call,",
          "Help us, one and all,",
          "By Thy grace;",
          "When the battle's done,",
          "And the victory won,",
          "May we wear the crown",
          "Before Thy face."
        ]
      }
    ],
    "chorus": [
      "Rouse, then, soldiers! rally round the banner!",
      "Ready, steady, pass the word along;",
      "Onward, forward, shout aloud hosanna!",
      "Christ is Captain of the mighty throng."
    ],
    "timestamps": {
      "chorus": 19.9689
    }
  },
  {
    "hymnNumber": 615,
    "reference": "SDAH615",
    "title": "Rise Up O Church of God",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Rise up, O men of God!",
          "His kingdom tarries long.",
          "Bring in the day of brotherhood",
          "And end the night of wrong."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Let women all rise up!",
          "Have done with lesser things.",
          "Give heart and mind and soul and strength",
          "To serve the King of kings."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Rise up, courages youth!",
          "The church for you doth wait,",
          "Her strength unequal to her task;",
          "Rise up, and make her great!"
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Lift high the cross of Christ!",
          "Tread where His feet have trod.",
          "Disciples of the Son of man,",
          "Rise up, O church of God!"
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 616,
    "reference": "SDAH616",
    "title": "Soldiers of Christ Arise",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Soldiers of Christ, arise,",
          "And put your armor on,",
          "Strong in the strength which God supplies",
          "Through His eternal Son;",
          "Strong in the Lord of hosts,",
          "And in His mighty power,",
          "Who in the strength of Jesus trusts",
          "Is more than conqueror."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Stand, then, in His great might,",
          "With all His strength endued;",
          "But take, to arm you for the fight,",
          "The panoply of God;",
          "That, having all things done,",
          "And all your conflicts passed,",
          "You may o'ercome thro' Christ alone,",
          "And stand entire at last."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "From strength to strength go on;",
          "Wrestle, and fight, and pray;",
          "Tread all the powers of darkness down,",
          "And win the well-fought day;",
          "Still let the Spirit cry,",
          "In all His soldiers \"Come!\"",
          "Till Christ the Lord who reigns on high",
          "Shall take the conquerors home."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 617,
    "reference": "SDAH617",
    "title": "We Are Living, We Are Dwelling",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "We are living, we are dwelling,",
          "In a grand and awful time,",
          "In an age on ages telling",
          "To be living is sublime.",
          "Hark! the waking up of nations,",
          "Gog and Magog to the fray;",
          "Hark! what soundeth? Is creation",
          "Groaning for her latter day?"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Christian, rouse and arm for conflict,",
          "Nerve thee for the battlefield;",
          "Bear the helmet of salvation,",
          "And the mighty gospel shield;",
          "Let the breastplate, peace, be on thee,",
          "Take the Spirit's sword in hand;",
          "Boldly, fearlessly, go forth then,",
          "In Jehovah's strength to stand."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "And the prince of evil spirits,",
          "Great deceiver of the world!",
          "He who at the blessed Jesus",
          "Once his deadly weapons hurled;",
          "Cometh with unwonted power,",
          "Knowing that his reign will cease",
          "When the kingdom shall be given",
          "To the mighty Prince of Peace."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Christian, rouse! fight in this warfare,",
          "Cease not till the victory's won;",
          "Till your Captain loud proclaimeth,",
          "\"Servant of the Lord, well done!\"",
          "He, alone, who thus is faithful,",
          "Who abideth to the end,",
          "Hath the promise, in the kingdom",
          "An eternity to spend."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 618,
    "reference": "SDAH618",
    "title": "Stand Up! Stand Up for Jesus!",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Stand up! stand up for Jesus!",
          "Ye soldiers of the cross;",
          "Lift high His royal banner,",
          "It must not suffer loss;",
          "From victory unto victory,",
          "His army shall He lead,",
          "Till every foe is vanquished,",
          "And Christ is Lord indeed."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Stand up! stand up for Jesus!",
          "The trumpet call obey;",
          "Forth to the mighty conflict,",
          "In this His glorious day.",
          "Ye that are His now serve Him",
          "Against unnumbered foes;",
          "Let courage rise with danger,",
          "And strength to strength oppose."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Stand up! stand up for Jesus!",
          "Stand in His strength alone;",
          "The arm of flesh will fail you;",
          "Ye dare not trust your own.",
          "Put on the gospel armor,",
          "And, watching unto prayer,",
          "Where duty calls, or danger,",
          "Be never wanting there."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Stand up! stand up for Jesus!",
          "The strife will not be long;",
          "This day the noise of battle,",
          "The next the victor's song.",
          "To him that overcometh,",
          "A crown of life shall be;",
          "He with the King of glory",
          "Shall reign eternally."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 619,
    "reference": "SDAH619",
    "title": "Lead On, O King Eternal",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Lead on, O King Eternal,",
          "The day of march has come;",
          "Henceforth in fields of conquest",
          "Thy tents shall be our home;",
          "Through days of preparation",
          "Thy grace has made us strong,",
          "And now, O King Eternal,",
          "We lift our battle song."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Lead on, O King Eternal,",
          "Till sin's fierce war shall cease,",
          "And holiness shall whisper",
          "The sweet Amen of peace;",
          "For not with swords, loud clashing,",
          "Nor roll of stirring drums,",
          "With deeds of love and mercy,",
          "The heavenly kingdom comes."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Lead on, O King Eternal,",
          "We follow, not with fears,",
          "For gladness breaks like morning",
          "Where'er Thy face appears;",
          "Thy cross is lifted o'er us;",
          "We journey in its light;",
          "The crown awaits the conquest;",
          "Lead on, O God of might."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 620,
    "reference": "SDAH620",
    "title": "On Jordan's Stormy Banks",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "On Jordan's stormy banks I stand,",
          "And cast a wishful eye",
          "To Canaan's fair and happy land,",
          "Where my possessions lie."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "O'er all those wide extended plains",
          "Shines one eternal day;",
          "There, Christ, the Sun, forever reigns,",
          "And scatters night away."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "When shall I reach that happy place,",
          "And be forever blest?",
          "When shall I see my Father's face,",
          "And in His kingdom rest?"
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Filled with delight, my raptured soul",
          "Would here no longer stay;",
          "Though Jordan's waves around me roll,",
          "Fearless I'd launch away."
        ]
      }
    ],
    "chorus": [
      "I am bound for the promised land,",
      "I am bound for the promised land;",
      "O who will come and go with me?",
      "I am bound for the promised land."
    ],
    "timestamps": {
      "chorus": 20.0336
    }
  },
  {
    "hymnNumber": 621,
    "reference": "SDAH621",
    "title": "Gracious Father, Guard Thy Children",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Gracious Father, guard Thy children",
          "From the foe's destructive power;",
          "Save, O save them, Lord, from falling",
          "In this dark and trying hour.",
          "Thou wilt surely prove Thy people,",
          "All our graces must be tried;",
          "But Thy word illumes our pathway,",
          "And in God we still confide."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "We are in the time of waiting;",
          "Soon we shall behold our Lord,",
          "Wafted far away from sorrow,",
          "To receive our rich reward.",
          "Keep us, Lord, till Thine appearing,",
          "Pure, unspotted from the world;",
          "Let Thy Holy Spirit cheer us",
          "Till Thy banner is unfurled."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "With what joyful exultation",
          "Shall the saints Thy banner see,",
          "When the Lord for whom we've waited",
          "Shall proclaim the jubilee!",
          "Freedom from this world's pollutions;",
          "Freedom from all sin and pain;",
          "Freedom from the wiles of Satan,",
          "And from death's destructive reign."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 622,
    "reference": "SDAH622",
    "title": "Come Come Ye Saints",
    "hasMidi": true,
    "numberOfVerses": 2,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Come, come, ye saints, no toil nor labor fear;",
          "But with joy wend your way.",
          "Though hard to you the journey may appear,",
          "Grace shall be as your day.",
          "We have a living Lord to guide,",
          "And we can trust Him to provide;",
          "Do this, and joy your hearts will swell:",
          "All is well! All is well!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "We'll find the rest which God for us prepared,",
          "When at last He will call;",
          "Where none will come to hurt or make afraid,",
          "He will reign over all.",
          "We will make the air with music ring,",
          "Shout praise to God our Lord and King:",
          "O how we'll make the chorus swell:",
          "All is well! All is well!"
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 623,
    "reference": "SDAH623",
    "title": "I Will Follow Thee",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "I will follow Thee, my Savior,",
          "Wheresoe'er my lot may be.",
          "Where Thou goest I will follow;",
          "Yes, my Lord, I'll follow Thee."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Though the road be rough and thorny,",
          "Trackless as the foaming sea,",
          "Thou hast trod this way before me,",
          "And I'll gladly follow Thee."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Though I meet with tribulations,",
          "Sorely tempted though I be;",
          "I remember Thou wast tempted,",
          "And rejoice to follow Thee."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Though Thou leadest me through affliction,",
          "Poor, forsaken though I be;",
          "Thou wast destitute, afflicted,",
          "And I only follow Thee."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "Though to Jordan's rolling billows,",
          "Cold and deep, Thou leadest me,",
          "Thou hast crossed the waves before me,",
          "And I still will follow Thee."
        ]
      }
    ],
    "chorus": [
      "I will follow Thee, my Savior,",
      "Thou didst shed Thy blood for me;",
      "And though all men should forsake Thee,",
      "By Thy grace I'll follow Thee."
    ],
    "timestamps": {
      "chorus": 19.4036
    }
  },
  {
    "hymnNumber": 624,
    "reference": "SDAH624",
    "title": "I Want Jesus to Walk With Me",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "I want Jesus to walk with me.",
          "I want Jesus to walk with me.",
          "All along my pilgrim journey,",
          "I want Jesus to walk with me."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "In my trials Lord, walk with me.",
          "In my trials Lord, walk with me.",
          "When the shades of life are falling,",
          "I want Jesus to walk with me."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "In my sorrows, Lord, walk with me.",
          "In my sorrows, Lord, walk with me.",
          "When my heart within is aching,",
          "I want Jesus to walk with me."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 625,
    "reference": "SDAH625",
    "title": "Higher Ground",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "I'm pressing on the upward way,",
          "New heights I'm gaining every day;",
          "Still praying as I onward bound,",
          "\"Lord, plant my feet on higher ground.\""
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "My heart has no desire to stay",
          "Where doubts arise and fears dismay;",
          "Though some may dwell where these abound,",
          "My prayer, my aim is higher ground."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "I want to live above the world,",
          "Though Satan's darts at me are hurled;",
          "For faith has caught the joyful sound,",
          "The song of saints on higher ground."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "I want to scale the utmost height,",
          "And catch a gleam of glory bright;",
          "But still I'll pray till heaven I've found,",
          "\"Lord, lead me on to higher ground.\""
        ]
      }
    ],
    "chorus": [
      "Lord, lift me up, and I shall stand",
      "By faith, on heaven's tableland;",
      "A higher plane than I have found;",
      "Lord, plant my feet on higher ground."
    ],
    "timestamps": {
      "chorus": 19.5909
    }
  },
  {
    "hymnNumber": 626,
    "reference": "SDAH626",
    "title": "In a Little While We're Going Home",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Let us sing a song that will cheer us by the way,",
          "In a little while we're going home;",
          "For the night will end in the everlasting day,",
          "In a little while we're going home."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "We will do the work that our hands may find to do,",
          "In a little while we're going home;",
          "And the grace of God will our daily strength renew,",
          "In a little while we're going home."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "We will smooth the path for some weary, wayworn feet,",
          "In a little while we're going home;",
          "And may loving hearts spread around an influence sweet!",
          "In a little while we're going home."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "There's a rest beyond, there's relief from every care,",
          "In a little while we're going home;",
          "And no tears shall fall in that city bright and fair,",
          "In a little while we're going home."
        ]
      }
    ],
    "chorus": [
      "In a little while,",
      "In a little while,",
      "We shall cross the billow's foam;",
      "We shall meet at last,",
      "When the stormy winds are past,",
      "In a little while we're going home."
    ],
    "timestamps": {
      "chorus": 21.7357
    }
  },
  {
    "hymnNumber": 627,
    "reference": "SDAH627",
    "title": "Jacob's Ladder",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "We are climbing Jacob's ladder.",
          "We are climbing Jacob's ladder.",
          "We are climbing Jacob's ladder,",
          "Soldiers of the cross."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Every round goes higher, higher.",
          "Every round goes higher, higher.",
          "Every round goes higher, higher,",
          "Soldiers of the cross."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Sinner, do you love my Jesus?",
          "Sinner, do you love my Jesus?",
          "Sinner, do you love my Jesus?",
          "Soldiers of the cross."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "If you love Him, why not serve Him?",
          "If you love Him, why not serve Him?",
          "If you love Him, why not serve Him?",
          "Soldiers of the cross."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 628,
    "reference": "SDAH628",
    "title": "As Jacob With Travel Was Weary",
    "hasMidi": true,
    "numberOfVerses": 2,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "A Jacob with travel was weary one day,",
          "At night on a stone for a pillow he lay;",
          "He saw in a vision a ladder so high",
          "That its foot was on earth and its top in the sky."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "For the angels of Jacob are guarding it still:",
          "And remember each step that by faith we pass o'er,",
          "Some prophet or martyr has trod it before."
        ]
      }
    ],
    "chorus": [
      "Alleluia to Jesus who died on the tree,",
      "And has raised up a ladder of mercy for me,",
      "And has raised up a ladder of mercy for me."
    ],
    "timestamps": {
      "chorus": 27.3166
    }
  },
  {
    "hymnNumber": 629,
    "reference": "SDAH629",
    "title": "O Happy Band of Pilgrims",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "O happy band of pilgrims,",
          "If onward ye will tread",
          "With Jesus as your fellow,",
          "To Jesus as your Head!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "O happy if ye labor",
          "As Jesus did for men;",
          "O happy if ye hunger",
          "As Jesus hungered then!"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "The trials that beset you,",
          "The sorrows ye endure,",
          "The manifold temptations",
          "That death alone can cure,"
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "What are they but His jewels",
          "Of right celestial worth?",
          "What are they but the ladder",
          "Set up to heaven on earth?"
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "O happy band of pilgrims,",
          "Look upward to the skies,",
          "Where such a light affliction",
          "Shall win you such a prize!"
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 630,
    "reference": "SDAH630",
    "title": "Rise, My Soul, and Stretch Thy Wings",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Rise, my soul, and stretch thy wings,",
          "Thy better portion trace;",
          "Rise from transitory things",
          "Toward heaven, thy native place:",
          "Sun, and moon, and stars decay;",
          "Time shall soon this earth remove;",
          "Rise, my soul, and haste away",
          "To seats prepared above."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Rivers to the ocean run,",
          "Nor stay in all their course;",
          "Fire ascending seeks the sun;",
          "Both speed them to their source;",
          "So a soul that's born of God,",
          "Longs to view His glorious face,",
          "Forward tends to His abode",
          "To rest in His embrace."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Cease, ye pilgrims, cease to mourn;",
          "Press onward to the prize;",
          "Soon our Savior will return,",
          "Triumphant in the skies;",
          "Yet a season, and you know",
          "Happy entrance will be given,",
          "All our sorrows left below,",
          "And earth exchanged for heaven."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 631,
    "reference": "SDAH631",
    "title": "When On Life A Darkness Falls",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "When on life a darkness falls,",
          "When the mist flows chilling,",
          "Paths and signposts lost in doubt,",
          "Loveless, unfulfilling,",
          "Reach us, Jesus, from Your cross,",
          "Though we feel forsaken;",
          "Keep us through the aching night",
          "Till new dawns awaken."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "When the dreams and vows of youth",
          "Painfully accuse us,",
          "Stab our conscience, steal our worth,",
          "Christ will not refuse us:",
          "Peace the world cannot provide,",
          "Daily resurrection,",
          "Strong companion at our side",
          "For each new direction."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Come and meet Him, Friend and Lord,",
          "Thro' the gospel story:",
          "Open door to life and peace,",
          "Window into glory.",
          "All who seek Him, soon are found,",
          "Made His close relation:",
          "Christ our pathway, Christ our home,",
          "Christ our sure foundation."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 632,
    "reference": "SDAH632",
    "title": "Until Then",
    "hasMidi": true,
    "numberOfVerses": 2,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "My heart can sing when I pause to remember",
          "A heartache here is but a stepping stone",
          "Along a trail that's winding always upward,",
          "This troubled world is not my final home."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "The things of earth will dim and lose their value",
          "If we recall they're borrowed for a while;",
          "And things of earth that cause the heart to tremble,",
          "Remembered there will only bring a smile."
        ]
      }
    ],
    "chorus": [
      "But until then my heart will go on singing,",
      "Until then with joy I'll carry on",
      "Until the day my eyes behold the city,",
      "Until the day God calls me home."
    ],
    "timestamps": {
      "chorus": 30.0386
    }
  },
  {
    "hymnNumber": 633,
    "reference": "SDAH633",
    "title": "When We All Get to Heaven",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Sing the wondrous love of Jesus,",
          "Sing His mercy and His grace;",
          "In the mansions bright and blessed",
          "He'll prepare for us a place."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "While we walk the pilgrim pathway",
          "Clouds will overspread the sky;",
          "But when traveling days are over",
          "Not a shadow, not a sigh."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Let us then be true and faithful,",
          "Trusting, serving every day;",
          "Just one glimpse of Him in glory",
          "Will the toils of life repay."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Onward to the prize before us!",
          "Soon His beauty we'll behold;",
          "Soon the pearly gates will open",
          "We shall tread the streets of gold."
        ]
      }
    ],
    "chorus": [
      "When we all get to heaven,",
      "What a day of rejoicing that will be!",
      "When we all see Jesus,",
      "We'll sing and shout the victory!"
    ],
    "timestamps": {
      "chorus": 19.5972
    }
  },
  {
    "hymnNumber": 634,
    "reference": "SDAH634",
    "title": "Come All Christians Be Committed",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Come, all Christians, be committed",
          "To the service of the lord;",
          "Make your lives for him more fitted,",
          "Tune your hearts with one accord.",
          "Come into His courts with gladness,",
          "Each his sacred vows renew,",
          "Turn away from sin and sadness,",
          "Be transformed with life anew."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Of your time and talents give ye,",
          "They are gifts from God above;",
          "To be used by Christians freely",
          "To proclaim His wondrous love.",
          "Come again to serve the Savior,",
          "Tithes and off'rings with you bring.",
          "In your work, with Him find favor,",
          "And with joy His praises sing."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "God's command to love each other",
          "Is required of every one;",
          "Showing mercy to one another",
          "Mirrors His redemptive plan.",
          "In compassion He has given",
          "Of His love that is divine;",
          "On the cross sins were forgiven;",
          "Joy and peace are fully thine."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Come in praise and adoration,",
          "All who in Christ's name believe;",
          "Worship Him with consecration,",
          "Grace and love you will receive.",
          "For His grace give Him the glory,",
          "For the Spirit and the Word,",
          "And repeat the gospel story",
          "Till mankind His name has heard."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 635,
    "reference": "SDAH635",
    "title": "Lord of All Good",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Lord of all good, our gifts we bring You now;",
          "Use them Your holy purpose to fulfill.",
          "Tokens of love and pledges they shall be",
          "That our whole life is offered to Your will."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "We give our minds to understand Your ways;",
          "Hands, voices, eyes to serve Your great design;",
          "Hearts with the flame of Your own love ablaze:",
          "Thus for Your glory all our pow'rs combine."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Father, whose bounty all creation shows;",
          "Christ, by whose willing sacrifice we live;",
          "Spirit, from whom all life in fullness flows:",
          "To You with grateful hearts ourselves we give."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 636,
    "reference": "SDAH636",
    "title": "God Whose Giving Knows No Ending",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "God, whose giving knows no ending,",
          "From Your rich and endless store:",
          "Nature's wonder, Jesus' wisdom,",
          "Costly cross, grave's shattered door.",
          "Gifted by You, we turn to You,",
          "Off'ring up ourselves in praise:",
          "Thankful song shall rise forever,",
          "Gracious donor of our days."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Skills and time are ours for pressing",
          "Toward the goals of Christ, Your Son:",
          "All at peace in health and freedom,",
          "Races joined, the church made one.",
          "Now direct our daily labor,",
          "Lest we strive for self alone:",
          "Born with talents, make us servants",
          "Fit to answer at Your throne."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Treasure, too, You have entrusted,",
          "Gain through pow'rs Your grace conferred:",
          "Ours to use for home and kindred,",
          "And to spread the Gospel Word.",
          "Open wide our hands in sharing,",
          "As we heed Christ's ageless call.",
          "Healing, teaching, and reclaiming,",
          "Serving You by loving all."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 637,
    "reference": "SDAH637",
    "title": "Son of God, Eternal Savior",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Son of God, eternal Savior,",
          "Source of life and truth and grace,",
          "Word made flesh, whose birth among us",
          "Hallows all our human race,",
          "You our head, who throned in glory,",
          "For Your own will ever plead:",
          "Fill us with Your love and pity,",
          "Heal our wrongs, and help our need."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Bind us all as one together",
          "In Your church's sacred fold,",
          "Weak and healthy, poor and wealthy,",
          "Sad and joyful, young and old.",
          "Is there want or pain or sorrow?",
          "Make us all the burden share.",
          "Are there spirits crushed and broken?",
          "Teach us, Lord, to soothe their care."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "As You, Lord, have lived for others,",
          "So may we for others live.",
          "Freely have Your gifts been granted;",
          "Freely may Your servants give.",
          "Yours the gold and Yours the silver,",
          "Yours the wealth of land and sea;",
          "We but stewards of Your bounty",
          "Held in solemn trust will be."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Come, O Christ, and reign among us,",
          "King of love and Prince of Peace,",
          "Hush the storm of strife and passion,",
          "Bid its cruel discords cease,",
          "By Your patient years of toiling,",
          "By Your silent hours of pain,",
          "Quench our fevered thirst of pleasure,",
          "Stem our selfish greed of gain."
        ]
      },
      {
        "verseNumber": 5,
        "content": [
          "Son of God, eternal Savior,",
          "Source of life and truth and grace,",
          "Word made flesh, whose birth among us",
          "Hallows all our human race:",
          "By Your praying, by Your willing",
          "That Your people should be one,",
          "Grant, oh, grant our hope's fruition:",
          "Here on earth Your will be done."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 638,
    "reference": "SDAH638",
    "title": "The Wise May Bring Their Learning",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "The wise may bring their learning,",
          "The rich may bring their wealth,",
          "And some may bring their greatness,",
          "And some their strength and health:",
          "We too would bring our treasures",
          "To offer to the King,",
          "We have no wealth or learning-",
          "What shall we children bring?"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "We'll bring Him hearts that love Him,",
          "We'll bring Him thankful praise,",
          "And young souls meekly striving",
          "To follow in His ways:",
          "And these be the treasures",
          "We offer to the King,",
          "And these are gifts that ever",
          "The poorest child may bring."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "We'll bring the little duties",
          "We have to do each day;",
          "We'll try our best to please Him",
          "At home, at school, at play:",
          "And better are these treasures",
          "To offer to the King",
          "Than richest gift without them:",
          "Yet these a child may bring."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 639,
    "reference": "SDAH639",
    "title": "A Diligent and Grateful Heart",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "A diligent and grateful heart",
          "Prompts me to sing Thy praise.",
          "Thy love and mercies from the start",
          "Have blessed me all my days."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "I thank Thee for the means to serve",
          "With talents and with tithes,",
          "For sharing brings the utmost joy",
          "When lifting other lives."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "My thanks I give you for stewardship",
          "To minister through deeds,",
          "To serve and share with patient care",
          "Thy people in their needs."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "O Lord, I dedicate my all",
          "In this response to Thee.",
          "Help me to magnify this call",
          "In deep humility."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 640,
    "reference": "SDAH640",
    "title": "For Beauty of Meadows",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "For beauty of meadows, for grandeur of trees,",
          "For flowers of woodlands, for creatures of seas,",
          "For all You created and gave us to share,",
          "We praise You, Creator, extolling Your care."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "As stewards of beauty received at Your hand,",
          "As creatures who hear Your most urgent command,",
          "We turn from our wasteful destruction of life,",
          "Confessing our failures, confessing our strife."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Teach us once again to be gardeners in peace;",
          "All nature around us is ours but on lease;",
          "Your name we would hallow in all that we do,",
          "Fulfilling our calling, creating with You."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 641,
    "reference": "SDAH641",
    "title": "God in His Love For Us",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "God in His love for us lent us this planet,",
          "Gave it a purpose in time and in space:",
          "Small as a spark from the fire of creation,",
          "Cradle of life and the home of our race."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Thanks be to God for its bounty and beauty,",
          "Life that sustains us in body and mind:",
          "Plenty for all, if we learn how to share it,",
          "Riches undreamed of to fathom and find."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Long have our human wars ruined its harvest;",
          "Long has earth bowed to the terror of forced;",
          "Long have we wasted what others have need of,",
          "Poisoned the fountain of life at its source."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Earth is the Lord's: it is ours to enjoy it,",
          "Ours, as His stewards, to farm and defend.",
          "From its pollution, misuse, and destruction,",
          "Good Lord, deliver us, world without end!"
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 642,
    "reference": "SDAH642",
    "title": "We Praise Thee With Our Minds",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "We praise Thee with our minds, O Lord,",
          "Kept sharp to think Thy thought;",
          "Come, Holy Ghost with grace outpoured,",
          "To teach what Christ hath taught.",
          "In all our learning may we seek",
          "That wisdom from above",
          "Which comes to all: the brave, the meek,",
          "Who ask in faith and love."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "We praise Thee thro' our bodies, Lord,",
          "Kept strong to do Thy will;",
          "Thy Spirit's temples, which afford",
          "A means to praise Thee still.",
          "We give ourselves, a sacrifice,",
          "To live as unto Thee;",
          "For Thou alone hast paid the price",
          "To bring salvation free."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "We praise Thee in our hearts, O King,",
          "Kept pure to know Thy ways;",
          "And raise to Thee a hymn to sing",
          "Eternally Thy praise.",
          "Altho adoring hearts will bow",
          "As age on ages roll;",
          "We praise Thee in our beings now,",
          "Mind, body, heart, and soul."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 643,
    "reference": "SDAH643",
    "title": "Father Who On Us Do Shower",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Father, who on us do shower",
          "Gifts of plenty form Your dower,",
          "To Your people give the power",
          "All Your gifts to use aright."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Give pure happiness in leisure",
          "Temperance in every pleasure,",
          "Wholesome use of earthly treasure",
          "Bodies clean and spirits bright."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Lift from this and every nation",
          "All that brings us degradation;",
          "Quell the forces of temptation;",
          "Put Your enemies to flight."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Father, You who sought and found us,",
          "Son of God, whose love has bound us,",
          "Holy Spirit, in us, round us,",
          "Hear us, Godhead infinite."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 644,
    "reference": "SDAH644",
    "title": "O God, Whose Will Is Life and Good",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "O God, whose will is life and good",
          "For all of mortal breath:",
          "Unite in bonds of servanthood",
          "All those who strive with death."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Make strong their hands and hearts and wills",
          "To drive disease afar,",
          "To strive against the body's ills",
          "And wage Your healing war."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "By healing of the sick and blind,",
          "Christ's mercy they proclaim,",
          "Make known the great physician's mind,",
          "Affirm the Savior's name."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Before them set Your gracious will,",
          "That they, with heart and soul,",
          "To You may consecrate their skill",
          "And make the sufferer whole."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 645,
    "reference": "SDAH645",
    "title": "God of Our Fathers",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "God of our fathers, whose almighty hand",
          "Leads forth in beauty all the starry band",
          "Of shining worlds in splendor through the skies,",
          "Our grateful songs before Thy throne arise."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Thy love divine hath led us in the past,",
          "In this free land by Thee our lot is cast;",
          "Be Thou our ruler, guardian, guide, and stay,",
          "Thy word our law, Thy paths our chosen way."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "From war's alarms, from deadly pestilence,",
          "Be Thy strong arm our ever sure defense;",
          "Thy true religion in our hearts increase,",
          "Thy bounteous goodness nourish us in peace."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Refresh Thy people on their toilsome way,",
          "Lead us from night to never-ending day;",
          "Fill all our lives with love and grace divine,",
          "And glory, laud, and praise be ever Thine."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 646,
    "reference": "SDAH646",
    "title": "To the Name That Brings Salvation",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "To the name that brings salvation",
          "Let the nations bow the head;",
          "Let them kneel in adoration",
          "When this name of names is said;",
          "Let them pray for restoration",
          "Of all things in Christ the head."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "He through every generation",
          "Rules in endless majesty;",
          "May the kings of every nation",
          "Now foreswear their enmity,",
          "And with humble veneration",
          "In the love of God agree."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Lord, we pray for upright rulers:",
          "Guard them surely in their need",
          "From the vanity of power",
          "And the emptiness of greed;",
          "Let them see the truth of lowness,",
          "And on justice let them feed."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 647,
    "reference": "SDAH647",
    "title": "Mine Eyes Have Seen the Glory",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Mine eyes have seen the glory of the coming of the Lord;",
          "He is trampling out the vintage where the grapes of wrath are stored;",
          "He has loosed the fateful lightning of His terrible swift sword;",
          "His truth is marching on."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "He has sounded forth the trumpet that shall never call retreat;",
          "He is sifting out the hearts of men before His judgment seat;",
          "O be swift, my soul, to answer Him; be jubilant, my feet!",
          "Our God is marching on."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "In the beauty of the lilies Christ was born across the sea,",
          "With a glory in His bosom that transfigures you and me;",
          "As He died to make men holy, let us live to make men free!",
          "While God is marching on."
        ]
      }
    ],
    "chorus": [
      "Glory! glory! Hallelujah!",
      "Glory! glory! Hallelujah!",
      "Glory! glory! Hallelujah!",
      "His truth is marching on."
    ],
    "timestamps": {
      "chorus": 22.959
    }
  },
  {
    "hymnNumber": 648,
    "reference": "SDAH648",
    "title": "I Vow to Thee, My Country",
    "hasMidi": true,
    "numberOfVerses": 2,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "I vow to thee, my country, all earthly things above,",
          "Entire and whole and perfect, the service of my love:",
          "The love that asks the reason the love that stands the test,",
          "That lays upon the altar the dearest and the best;",
          "The love that never falters, the love that pays the price,",
          "The love that makes undaunted the final sacrifice."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "And there's another country, I've heard of long ago,",
          "Most dear to them that love her, most great to them that know;",
          "We may not count her armies, we may not see her King;",
          "Her fortress is a faithful heart, her pride is suffering;",
          "And one by one and fervently we pray for her increase,",
          "And her ways are ways of gentleness and all her paths are peace."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 649,
    "reference": "SDAH649",
    "title": "Lord, While for All Mankind",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Lord, while for all mankind we pray,",
          "Of every clime and coast,",
          "O hear us for our native land,",
          "The land we love the most."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "O guard our shores from every foe;",
          "With peace our borders bless;",
          "With prosperous times our cities crown,",
          "Our fields with plenteousness."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Unite us in the sacred love",
          "Of knowledge, truth, and Thee,",
          "And let our hills and valleys shout",
          "The songs of liberty."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Lord of the nations, thus to Thee",
          "Our country we commend;",
          "Be Thou her refuge and her trust,",
          "Her everlasting friend."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 650,
    "reference": "SDAH650",
    "title": "Our Father By Whose Name",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Our Father, by whose name,",
          "All fatherhood is known,",
          "Who dost in love proclaim",
          "Each family Thine own,",
          "Bless Thou all parents, guarding well,",
          "With constant love as sentinel,",
          "The homes in which Thy people dwell."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "O Christ, Thyself a child",
          "Within an earthly home,",
          "With heart still undefiled,",
          "Thou didst to manhood come;",
          "Our children bless, in every place,",
          "That they may all behold Thy face,",
          "And knowing Thee may grow in grace."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "O Spirit, who dost bind",
          "Our hearts in unity,",
          "Who teaches us to find",
          "The love from self set free,",
          "In all our hearts such love increase,",
          "That every home, by this release,",
          "May be dwelling place of peace."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 651,
    "reference": "SDAH651",
    "title": "Happy the Home That Welcomes You",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Happy the home that welcomes You, Lord Jesus,",
          "Truest of friends, most honored guest of all,",
          "Where hearts and eyes are bright with joy to greet You,",
          "Your lightest wishes eager to fulfill."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Happy the home where man and wife together",
          "Are of one mind believing in Your love:",
          "Through love and pain, prosperity and hardship,",
          "Through good and evil days Your care they prove."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Happy the home, O loving Friend of children,",
          "Where they are giv'n to You with hands of prayer,",
          "Where at Your feet they early learn to listen",
          "To Your own words, and thank You for Your care"
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 652,
    "reference": "SDAH652",
    "title": "Love at Home",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "There is beauty all around,",
          "When there's love at home;",
          "There is joy in every sound,",
          "When there's love at home.",
          "Peace and plenty here abide,",
          "Smiling fair on every side;",
          "Time doth softly, sweetly glide,",
          "When there's love at home."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Kindly heaven smiles above,",
          "When there's love at home;",
          "All the earth is fill'd with love,",
          "When there's love at home.",
          "Sweeter sings the brooklet by,",
          "Brighter beams the azure sky;",
          "O, there's One who smiles on high",
          "When there's love at home."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Jesus, make me wholly Thine,",
          "Then there's love at home;",
          "May Thy sacrifice be mine,",
          "Then there's love at home.",
          "Safely from all harm I'll rest,",
          "With no sinful care distress'd,",
          "Thro' Thy tender mercy blessed,",
          "When there's love at home."
        ]
      }
    ],
    "chorus": [
      "Love at home, love at home;",
      "Time doth softly, sweetly glide,",
      "When there's love at home."
    ],
    "timestamps": {
      "chorus": 36.6533
    }
  },
  {
    "hymnNumber": 653,
    "reference": "SDAH653",
    "title": "Lead Them, My God, to Thee",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Lead them, my God, to Thee,",
          "Lead them to Thee,",
          "These children dear of mine,",
          "Thou gavest me;",
          "O, by Thy love divine,"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "When earth looks bright and fair,",
          "Festive and gay,",
          "Let no delusive snare",
          "Lure them astray;",
          "But from temptation's power,"
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "E'en for such little ones,",
          "Christ came a child,",
          "And in this world of sin",
          "Lived undefiled.",
          "O, for His sake, I pray,"
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Yea, though my faith be dim,",
          "I would believe",
          "That Thou this precious gift",
          "Wilt now receive;",
          "O, take their young hearts now,"
        ]
      }
    ],
    "chorus": [
      "Lead them, my God, to Thee;",
      "Lead them, my God, to Thee,",
      "Lead them to Thee."
    ],
    "timestamps": {
      "chorus": 25.5049
    }
  },
  {
    "hymnNumber": 654,
    "reference": "SDAH654",
    "title": "Lord Bless Our Homes",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Lord, bless our homes with peace and love and laughter,",
          "With understanding and with loyalty.",
          "May we together follow Christ the Master",
          "And know the blessing of His sov'reignty."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "May every heart receive His loving spirit",
          "And know the truth that makes life truly free;",
          "Then, in that spirit may we live united,",
          "And find in God our deep security."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Forgive the hurts our selfishness inflicted",
          "On those we love and those who love us best.",
          "Christ, heal the scars, and draw us all together",
          "In Him whose will is peace and joy and rest."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Father, in gratitude for homes and loved ones,",
          "We open now our hearts to all mankind.",
          "Grant us Your spirit-love for one another-",
          "So in Your peace may we our concord find."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 655,
    "reference": "SDAH655",
    "title": "Happy the Home",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Happy the home when God is there,",
          "And love fills every breast;",
          "When one their wish, and one their prayer,",
          "And one their heavenly rest."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Happy the home where Jesus' name",
          "Is sweet to every ear;",
          "Where children early lisp His fame,",
          "And parents hold Him dear."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Happy the home where prayer is heard,",
          "And praise is wont to rise;",
          "Where parents love the Sacred Word",
          "And all its wisdom prize."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "Lord, let us in our homes agree",
          "This blessed peace to gain;",
          "Unite our hearts in love to Thee,",
          "And love to all will reign."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 656,
    "reference": "SDAH656",
    "title": "O Perfect Love",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "O perfect Love, all human thought transcending,",
          "Lowly we kneel in prayer before Thy throne,",
          "That theirs may be the love that has no ending,",
          "Whom Thou forevermore dost join in one."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "O perfect Life, be Thou their full assurance,",
          "Of tender charity and steadfast faith,",
          "Of patient hope, and quiet, brave endurance,",
          "With child-like trust that fears nor pain nor death."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Grant them the joy which brightens earthly sorrow;",
          "Grant them the peace which calms all earthly strife,",
          "Add to life's day the glorious unknown morrow",
          "That dawns upon eternal love and life."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 657,
    "reference": "SDAH657",
    "title": "O God From Whom Mankind",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "O God from whom mankind derives its name;",
          "Whose covenant of grace remains the same,",
          "Be with there two who now before You wait;",
          "Enlarge the love they come to consecrate."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "May through their union other lives be blessed;",
          "Their door be wide to stranger and to guest,",
          "Give them the understanding that is kind,",
          "Grant them the blessing of an open mind."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Preserve their days from inwardness of heart;",
          "To each the gift of truthful speech impart.",
          "Their bond be strong against all strain and strife",
          "Amid the changes of this earthly life."
        ]
      },
      {
        "verseNumber": 4,
        "content": [
          "From stage to stage on life's unfolding way",
          "Bring to their mind the vows they make this day,",
          "Your Spirit be their Guide in every move,",
          "Their faith in Christ the basis of their love."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 658,
    "reference": "SDAH658",
    "title": "Heavenly Father Hear Our Prayer",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Heav'nly Father, hear our prayer",
          "As we bow before You:",
          "Bless them in the life they share,",
          "Humbly we implore You.",
          "Be their guide in all endeavors,",
          "Be their hope that nothing severs;",
          "Constant source of love divine,",
          "Let Your love within them shine!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "As they pledge their love this day",
          "Here before Your altar,",
          "May their hearts, upon You stayed,",
          "Never fail or falter.",
          "Be their comfort in all sorrow;",
          "Be their reason for tomorrow.",
          "Grant them strength to live each hour",
          "Trusting solely in Your pow'r."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Blest Creator, Lord of life,",
          "Hear our glad thanksgiving.",
          "Husband you have joined to wife",
          "For their earthly living.",
          "Justified by Jesus' merit.",
          "Life eternal they inherit.",
          "When their days on earth have passed,",
          "Take them to Your home at last!"
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 659,
    "reference": "SDAH659",
    "title": "May the Grace of Christ Our Savior",
    "hasMidi": true,
    "numberOfVerses": 2,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "May the grace of Christ our Savior",
          "And the Father's boundless love,",
          "With the Holy Spirit's favor,",
          "Rest upon them from above."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Thus may they abide in union",
          "With each other and the Lord,",
          "And possess, in sweet communion,",
          "Joys which earth cannot afford."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 660,
    "reference": "SDAH660",
    "title": "Glory Be to the Father",
    "hasMidi": true,
    "numberOfVerses": 1,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Glory be to the Father, and to the Son, and to the Holy Ghost;",
          "As it was in the beginning, is now, and ever shall be, world without end.",
          "Amen,",
          "Amen."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 661,
    "reference": "SDAH661",
    "title": "Holy, Holy, Holy",
    "hasMidi": true,
    "numberOfVerses": 2,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Holy, holy, holy,",
          "Holy is the Lord!",
          "Holy, holy, holy,",
          "Holy is our God!",
          "He who always liveth,",
          "Evermore the same",
          "Heav'n and earth He ruleth,",
          "Come and praise His name!"
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Holy, holy, holy,",
          "Holy is the Lord!",
          "Holy, holy, holy,",
          "Holy is our God!",
          "Glorious and beloved",
          "Is the One adored!",
          "Holy, holy, holy,",
          "Holy is the Lord."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 662,
    "reference": "SDAH662",
    "title": "Let All Mortal Flesh Keep Silence",
    "hasMidi": true,
    "numberOfVerses": 1,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Let all mortal flesh keep silence,",
          "And with fear and trembling stand;",
          "Ponder nothing earthly-minded,",
          "For with blessing in His hand,",
          "Christ our God to earth descendeth,",
          "Our full homage to demand.",
          "Amen."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 663,
    "reference": "SDAH663",
    "title": "Dresden Amen",
    "hasMidi": true,
    "numberOfVerses": 1,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Amen,",
          "Amen."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 664,
    "reference": "SDAH664",
    "title": "Sevenfold Amen",
    "hasMidi": true,
    "numberOfVerses": 1,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Amen, Amen, Amen, Amen, Amen, Amen, Amen."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 665,
    "reference": "SDAH665",
    "title": "All Things Come of Thee",
    "hasMidi": true,
    "numberOfVerses": 1,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "All things come of Thee, O Lord;",
          "And of Thine own have we given Thee.",
          "Amen."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 666,
    "reference": "SDAH666",
    "title": "Cast Thy Burden Upon the Lord",
    "hasMidi": true,
    "numberOfVerses": 1,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Cast thy burden upon the Lord,",
          "And He shall sustain thee;",
          "He never will suffer the righteous to fall;",
          "He is at thy right hand.",
          "Thy mercy, Lord, is great, and far above the heavens;",
          "Let none be made ashamed, that wait upon Thee."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 667,
    "reference": "SDAH667",
    "title": "Lord, Bless Thy Word to Every Heart",
    "hasMidi": true,
    "numberOfVerses": 1,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Lord, bless Thy word to every heart",
          "In this Thy house today,",
          "And help us each as now we part,",
          "Its precepts to obey.",
          "Amen",
          "Amen."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 668,
    "reference": "SDAH668",
    "title": "O Thou Who Hearest",
    "hasMidi": true,
    "numberOfVerses": 1,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "O Thou who hearest every heartfelt prayer,",
          "With Thy rich grace, Lord, all our hearts prepare;",
          "Thou art our life,",
          "Thou art our love and light,",
          "O let this Sabbath hour with Thee be bright.",
          "Amen."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 669,
    "reference": "SDAH669",
    "title": "The Lord Bless You and Keep You",
    "hasMidi": true,
    "numberOfVerses": 1,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "The Lord bless you and keep you;",
          "The Lord lift His countenance upon you,",
          "And give you peace, and give you peace;",
          "The Lord make His face to shine upon you,",
          "And be gracious unto you, be gracious,",
          "The Lord be gracious, gracious unto you.",
          "Amen."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 670,
    "reference": "SDAH670",
    "title": "We Give Thee But Thine Own",
    "hasMidi": true,
    "numberOfVerses": 1,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "We give Thee but Thine own,",
          "Whate'er the gift may be;",
          "All that we have is Thine alone,",
          "A trust, O Lord, from Thee."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 671,
    "reference": "SDAH671",
    "title": "As We Come to You in Prayer",
    "hasMidi": true,
    "numberOfVerses": 1,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Now, Dear Lord, as we pray,",
          "Take our hearts and minds far away",
          "From the press of the world all around",
          "To Your throne where grace does abound.",
          "May our lives be transform'd by Your love,",
          "May our souls be refreshed from above.",
          "At this moment, let people everywhere",
          "Join us now as we come to You in prayer."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 672,
    "reference": "SDAH672",
    "title": "Spirit of the Living God",
    "hasMidi": true,
    "numberOfVerses": 1,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Spirit of the living God,",
          "Fall afresh on me!",
          "Spirit of the living God,",
          "Fall afresh on me!",
          "Break me, melt me,",
          "Mold me, fill me!",
          "Spirit of the living God,",
          "Fall afresh on me!"
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 673,
    "reference": "SDAH673",
    "title": "May God Be With You",
    "hasMidi": true,
    "numberOfVerses": 2,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "May God be with you",
          "Till we meet again,",
          "May God be with you,",
          "Keep you safe till then;",
          "And may His blessings",
          "Be within your heart,",
          "May God be with you",
          "While we're apart,",
          "May God be with you."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "May God be with you,",
          "Watch you from above,",
          "May God protect you",
          "In His tender love;",
          "And with the dawning",
          "Of each bright, new day,",
          "May God be with you,",
          "To guide your way,",
          "May God be with you."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 674,
    "reference": "SDAH674",
    "title": "Shalom",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Shalom, my friends, shalom, my friends,",
          "Shalom, shalom.",
          "May peace be with you, God's peace be with you.",
          "Shalom, shalom."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "May blessings attend you, angels defend,",
          "Shalom, shalom.",
          "God's mercies befriend you unto the end.",
          "Shalom, shalom."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Till we meet again, till we meet again,",
          "Shalom, shalom.",
          "May God be with you, His peace be with you.",
          "Shalom, shalom."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 675,
    "reference": "SDAH675",
    "title": "May the Lord Bless and Keep You",
    "hasMidi": true,
    "numberOfVerses": 1,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "May the Lord bless and keep you both now and evermore.",
          "Amen, Amen."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 676,
    "reference": "SDAH676",
    "title": "Thy Word Is A Lantern",
    "hasMidi": true,
    "numberOfVerses": 1,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Thy Word is a lantern unto my feet,",
          "And a light unto my path."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 677,
    "reference": "SDAH677",
    "title": "Heavenly Father to Thee We Pray",
    "hasMidi": true,
    "numberOfVerses": 1,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Heavenly Father, to Thee we pray,",
          "On this holy Sabbath day;",
          "Through Thy Word Thy will make known;",
          "May each heart become Thy throne,",
          "Let Thy living water flow",
          "That we Thy boundless love may know.",
          "Amen."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 678,
    "reference": "SDAH678",
    "title": "God Be in My Head",
    "hasMidi": true,
    "numberOfVerses": 1,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "God be in my head, and in my understanding;",
          "God be in mine eyes, and in my looking;",
          "God be in my mouth, and in my speaking;",
          "God be in my heart, and in my thinking;",
          "God be at mine end, and at my departing."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 679,
    "reference": "SDAH679",
    "title": "God Be in My Head",
    "hasMidi": true,
    "numberOfVerses": 1,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "God be in my head,",
          "And in my thinking.",
          "God be in my eyes,",
          "And in my looking.",
          "God be in my mouth,",
          "And in my speaking.",
          "Oh, God be in my heart,",
          "And in my understanding."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 680,
    "reference": "SDAH680",
    "title": "Holy Spirit, Hear Us",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Holy Spirit, hear us;",
          "Help us while we sing;",
          "Breathe into the music",
          "Of the praise we bring."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Holy Spirit, prompt us",
          "When we kneel to pray;",
          "Nearer come, and teach us",
          "What we ought to say."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Holy Spirit, shine Thou",
          "On the Book we read;",
          "Gild its holy pages",
          "With the light we need."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 681,
    "reference": "SDAH681",
    "title": "This Is the Day the Lord Hath Made",
    "hasMidi": true,
    "numberOfVerses": 1,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "This is the day the Lord hath made;",
          "He calls the hours His own.",
          "Let heav'n rejoice, let earth be glad,",
          "And praise surround the throne."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 682,
    "reference": "SDAH682",
    "title": "As You Have Promised Lord",
    "hasMidi": true,
    "numberOfVerses": 1,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "As you have promised, Lord, today",
          "You are letting Your servant go",
          "away in peace.",
          "My eyes have seen You in broad daylight",
          "Before all nations, planning salvation.",
          "Light of revelation for the nations,",
          "And glory of Your people Israel."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 683,
    "reference": "SDAH683",
    "title": "Jesus, Stand Among Us",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Jesus, stand among us",
          "In Thy risen power;",
          "Let this time of worship",
          "Be a hallowed hour."
        ]
      },
      {
        "verseNumber": 2,
        "content": [
          "Breathe the Holy Spirit",
          "Into every heart;",
          "Bid the fears and sorrows",
          "From each soul depart."
        ]
      },
      {
        "verseNumber": 3,
        "content": [
          "Thus with quickened footsteps",
          "We pursue our way,",
          "Watching for the dawning",
          "Of eternal day."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 684,
    "reference": "SDAH684",
    "title": "Hear Our Prayer, O Lord",
    "hasMidi": true,
    "numberOfVerses": 1,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Hear our prayer, O Lord,",
          "Hear our prayer, O Lord;",
          "Incline Thine ear to us,",
          "And grant us Thy peace.",
          "Amen."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 685,
    "reference": "SDAH685",
    "title": "Cause Me to Hear",
    "hasMidi": true,
    "numberOfVerses": 1,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Cause me to hear Thy loving kindness in the morning, for in Thee do I trust.",
          "Cause me to know the way where in I shall walk for I lift up my soul to Thee.",
          "Amen."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 686,
    "reference": "SDAH686",
    "title": "Bless Thou the Gifts",
    "hasMidi": true,
    "numberOfVerses": 1,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Bless Thou the gifts our hands have brought;",
          "Bless Thou the work our hearts have planned;",
          "Ours is the faith, the will, the thought;",
          "The rest, O God, is in Thy hand.",
          "Amen."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 687,
    "reference": "SDAH687",
    "title": "The Lord Is in His Holy Temple",
    "hasMidi": true,
    "numberOfVerses": 1,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "The Lord is in His holy temple,",
          "The Lord is in His holy temple,",
          "Let all the earth be silent, be silent before Him."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 688,
    "reference": "SDAH688",
    "title": "Surely Surely",
    "hasMidi": true,
    "numberOfVerses": 1,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Surely, surely the Lord has been here,",
          "Surely angels still linger near;",
          "I hear music soft on my ear,",
          "I feel His Spirit, I have no fear."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 689,
    "reference": "SDAH689",
    "title": "Day By Day Dear Lord",
    "hasMidi": true,
    "numberOfVerses": 1,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Day by day, Dear Lord, of Thee three things I pray:",
          "To see Thee more clearly,",
          "Love Thee more dearly,",
          "Follow Thee more nearly,",
          "Day by day."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 690,
    "reference": "SDAH690",
    "title": "Dismiss Us, Lord, With Blessing",
    "hasMidi": true,
    "numberOfVerses": 1,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Dismiss us, Lord, with blessing, we pray;",
          "As from Thy worship we go our ways;",
          "Guide in life's conflicts, all through the day;",
          "Save in Thy kingdom, Thine be the praise.",
          "Amen."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 691,
    "reference": "SDAH691",
    "title": "Lead Me, Lord",
    "hasMidi": true,
    "numberOfVerses": 1,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Lead me, Lord, lead me in Thy righteousness;",
          "Make Thy way plain before my face.",
          "For it is Thou, Lord, Thou,",
          "Lord, only That makest me dwell in safety."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 692,
    "reference": "SDAH692",
    "title": "The Lord Is in His Holy Temple",
    "hasMidi": true,
    "numberOfVerses": 1,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "The Lord is in His holy temple,",
          "The Lord is in His holy temple,",
          "Let all the earth keep silence,",
          "Let all the earth keep silence before Him,",
          "Keep silence, keep silence before Him.",
          "Amen."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 693,
    "reference": "SDAH693",
    "title": "Almighty Father",
    "hasMidi": true,
    "numberOfVerses": 1,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Almighty Father, hear our prayer,",
          "and bless all souls that wait before Thee.",
          "Amen."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 694,
    "reference": "SDAH694",
    "title": "Praise God, From Whom All Blessings",
    "hasMidi": true,
    "numberOfVerses": 1,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Praise God, from whom all blessings flow;",
          "Praise Him, all creatures here below;",
          "Praise Him above, ye heavenly host;",
          "Praise Father, Son, and Holy Ghost."
        ]
      }
    ],
    "chorus": []
  },
  {
    "hymnNumber": 695,
    "reference": "SDAH695",
    "title": "Praise God, From Whom All Blessings",
    "hasMidi": true,
    "numberOfVerses": 1,
    "hasChorus": false,
    "verses": [
      {
        "verseNumber": 1,
        "content": [
          "Praise God from whom all blessings flow;",
          "Praise Him all creatures here below;",
          "Praise Him above, ye heavenly host;",
          "Praise Father, Son, and Holy Ghost."
        ]
      }
    ],
    "chorus": []
  }
];
